var dataQACommentSolid = {
  name: 'IconQACommentSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M22.5 12c0 5.799-4.701 10.5-10.5 10.5a10.45 10.45 0 0 1-4.886-1.204l-3.09.66a1 1 0 0 1-1.198-1.131l.462-2.962A10.451 10.451 0 0 1 1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12zm-8.587 1.585C13.97 13.4 14 13.203 14 13v-2a2 2 0 1 0-4 0v2a2 2 0 0 0 2.45 1.95l-.604-.604 1.414-1.414.653.653zM12 17c.72 0 1.394-.19 1.978-.522l.892.892 1.414-1.414-.87-.87A3.981 3.981 0 0 0 16 13v-2a4 4 0 0 0-8 0v2a4 4 0 0 0 4 4z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAbTest = {
  name: 'IconAbTest',
  content: '<mask id="dls-af297-a" width="23" height="23" x=".5" y=".5" fill="currentColor" maskUnits="userSpaceOnUse"><path d="M.5.5h23v23H.5z"/><path fill-rule="evenodd" d="m15.251 5.5-4.68 7.022L8.115 5.8h-1.04L4.6 12.603h1.385l.411-1.204h2.417l.402 1.204h1.302L7.25 17.5l1.498.998 8-12L15.25 5.5zM7.63 7.807l-.86 2.475h1.69l-.831-2.475zm10.815 9.958c.103-.245.155-.53.155-.852 0-.233-.032-.433-.097-.601a1.595 1.595 0 0 0-.223-.446 1.24 1.24 0 0 0-.31-.3 2.02 2.02 0 0 0-.32-.204c.085-.038.175-.1.272-.184a1.563 1.563 0 0 0 .494-.717c.058-.155.087-.33.087-.523 0-.594-.187-1.066-.562-1.415-.368-.349-.891-.523-1.57-.523h-2.77v6.9h2.887c.31 0 .594-.043.852-.127.259-.09.482-.22.669-.387.187-.168.333-.375.436-.62zm-1.415-1.511a.841.841 0 0 1 .223.591.876.876 0 0 1-.223.6c-.142.169-.368.253-.678.253h-1.405v-1.696h1.405c.31 0 .536.084.678.252zm-.106-2.83a.738.738 0 0 1 .232.572.769.769 0 0 1-.232.582c-.149.142-.369.213-.66.213h-1.317V13.2h1.318c.29 0 .51.075.659.223z" clip-rule="evenodd"/><path fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11z" clip-rule="evenodd"/></mask><path fill="currentColor" fill-rule="evenodd" d="m15.251 5.5-4.68 7.022L8.115 5.8h-1.04L4.6 12.603h1.385l.411-1.204h2.417l.402 1.204h1.302L7.25 17.5l1.498.998 8-12L15.25 5.5zM7.63 7.807l-.86 2.475h1.69l-.831-2.475zm10.815 9.958c.103-.245.155-.53.155-.852 0-.233-.032-.433-.097-.601a1.595 1.595 0 0 0-.223-.446 1.24 1.24 0 0 0-.31-.3 2.02 2.02 0 0 0-.32-.204c.085-.038.175-.1.272-.184a1.563 1.563 0 0 0 .494-.717c.058-.155.087-.33.087-.523 0-.594-.187-1.066-.562-1.415-.368-.349-.891-.523-1.57-.523h-2.77v6.9h2.887c.31 0 .594-.043.852-.127.259-.09.482-.22.669-.387.187-.168.333-.375.436-.62zm-1.415-1.511a.841.841 0 0 1 .223.591.876.876 0 0 1-.223.6c-.142.169-.368.253-.678.253h-1.405v-1.696h1.405c.31 0 .536.084.678.252zm-.106-2.83a.738.738 0 0 1 .232.572.769.769 0 0 1-.232.582c-.149.142-.369.213-.66.213h-1.317V13.2h1.318c.29 0 .51.075.659.223z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11z" clip-rule="evenodd"/><path fill="currentColor" d="m15.251 5.5.056-.082-.084-.056-.055.083.083.056zm-4.68 7.022-.094.034.067.185.11-.164-.084-.055zM8.115 5.8l.094-.034-.024-.066h-.07v.1zm-1.041 0v-.1h-.07l-.024.066.094.034zM4.6 12.603l-.094-.035-.049.135H4.6v-.1zm1.385 0v.1h.072l.023-.068-.095-.032zm.411-1.204v-.1h-.071l-.023.068.094.032zm2.417 0 .095-.032-.022-.068h-.073v.1zm.402 1.204-.095.031.023.069h.072v-.1zm1.302 0 .083.055.104-.155h-.187v.1zM7.25 17.5l-.083-.056-.056.084.084.055.055-.083zm1.498.998-.056.083.084.056.055-.083-.083-.056zm8-12 .083.056.055-.083-.083-.056-.055.083zm-9.12 1.307.095-.031-.094-.278-.096.277.095.032zm-.86 2.475-.095-.033-.046.133h.14v-.1zm1.691 0v.1h.139l-.044-.132-.095.032zm9.985 7.484.092.04-.092-.04zm.058-1.453-.095.032.002.004.093-.036zm-.223-.446.08-.059-.08.06zm-.31-.3-.06.08.005.003.055-.083zm-.32-.204-.041-.09-.19.087.187.093.044-.09zm.272-.184-.063-.077-.003.002.066.075zm.28-.3-.08-.06v.001l.08.059zm.214-.417-.094-.035v.004l.094.031zm-.475-1.938-.069.073h.001l.068-.073zM13.601 12v-.1h-.1v.1h.1zm0 6.9h-.1v.1h.1v-.1zm3.74-.127.03.095h.002l-.033-.095zm.668-.387-.067-.075.067.075zm-.979-2.132-.076.064.003.004.073-.068zm0 1.192-.075-.067-.001.002.076.065zm-2.083.252h-.1v.1h.1v-.1zm0-1.696v-.1h-.1v.1h.1zm1.977-2.578-.071.071.003.003.068-.074zm0 1.154.069.072-.07-.072zm-1.977.213h-.1v.1h.1v-.1zm0-1.59v-.1h-.1v.1h.1zM6.5 1.4a5.1 5.1 0 0 0-5.1 5.1h.2a4.9 4.9 0 0 1 4.9-4.9v-.2zM1.4 6.5v11h.2v-11h-.2zm0 11a5.1 5.1 0 0 0 5.1 5.1v-.2a4.9 4.9 0 0 1-4.9-4.9h-.2zm5.1 5.1h11v-.2h-11v.2zm11 0a5.1 5.1 0 0 0 5.1-5.1h-.2a4.9 4.9 0 0 1-4.9 4.9v.2zm5.1-5.1v-11h-.2v11h.2zm0-11a5.1 5.1 0 0 0-5.1-5.1v.2a4.9 4.9 0 0 1 4.9 4.9h.2zm-5.1-5.1h-11v.2h11v-.2zM3.6 6.5a2.9 2.9 0 0 1 2.9-2.9v-.2a3.1 3.1 0 0 0-3.1 3.1h.2zm2.9-2.9h11v-.2h-11v.2zm11 0a2.9 2.9 0 0 1 2.9 2.9h.2a3.1 3.1 0 0 0-3.1-3.1v.2zm2.9 2.9v11h.2v-11h-.2zm0 11a2.9 2.9 0 0 1-2.9 2.9v.2a3.1 3.1 0 0 0 3.1-3.1h-.2zm-2.9 2.9h-11v.2h11v-.2zm-11 0a2.9 2.9 0 0 1-2.9-2.9h-.2a3.1 3.1 0 0 0 3.1 3.1v-.2zm-2.9-2.9v-11h-.2v11h.2zM15.168 5.445l-4.68 7.021.166.111 4.68-7.02-.166-.112zm-4.503 7.042L8.21 5.766l-.188.068 2.455 6.722.188-.069zM8.116 5.7H7.075v.2h1.041v-.2zm-1.135.066-2.475 6.802.188.069L7.17 5.834l-.188-.068zM4.6 12.703h1.384v-.2H4.6v.2zm1.48-.068.41-1.204-.19-.064-.41 1.203.19.065zm.315-1.136h2.417v-.2H6.396v.2zm2.323-.069.4 1.204.19-.063-.4-1.204-.19.063zm.496 1.273h1.302v-.2H9.215v.2zm1.218-.156-3.265 4.898.166.111 3.266-4.898-.167-.11zm-3.237 5.037 1.497.998.111-.166-1.497-.998-.111.166zm1.636.97 8-12-.166-.11-8 12 .166.11zm7.972-12.138-1.497-.998-.111.166 1.497.998.111-.166zm-9.27 1.358-.86 2.474.19.066.86-2.475-.19-.065zM6.77 10.38h1.69v-.2H6.769v.2zm1.786-.132-.831-2.474-.19.063.831 2.475.19-.064zm9.982 7.555c.11-.26.163-.558.163-.891h-.2c0 .312-.05.583-.147.814l.184.077zm.163-.891c0-.242-.033-.455-.104-.637l-.186.072c.059.154.09.341.09.565h.2zm-.102-.633c-.06-.182-.14-.34-.237-.473l-.161.119a1.5 1.5 0 0 1 .208.418l.19-.064zm-.237-.473a1.338 1.338 0 0 0-.335-.324l-.111.166c.106.07.2.162.285.277l.16-.119zm-.33-.32a2.106 2.106 0 0 0-.336-.214l-.09.179c.098.048.199.113.305.193l.121-.159zm-.339-.034c.096-.044.194-.111.295-.2l-.13-.15c-.093.08-.176.135-.248.169l.083.181zm.293-.197c.11-.09.21-.197.299-.32l-.162-.117c-.08.11-.167.204-.263.282l.126.155zm.298-.319c.097-.131.173-.28.228-.444l-.19-.063a1.392 1.392 0 0 1-.199.389l.161.118zm.227-.44c.063-.169.093-.355.093-.559h-.2c0 .184-.027.346-.08.488l.187.07zm.093-.559c0-.617-.195-1.117-.594-1.488l-.136.146c.351.327.53.77.53 1.342h.2zm-.593-1.487c-.392-.372-.944-.551-1.639-.551v.2c.662 0 1.157.17 1.501.496l.138-.145zm-1.639-.551h-2.77v.2h2.77v-.2zm-2.87.1v6.9h.2V12h-.2zm.1 7h2.887v-.2H13.6v.2zm2.887 0c.319 0 .614-.044.883-.132l-.061-.19c-.248.08-.521.121-.822.121v.2zm.885-.132c.27-.095.505-.23.703-.408l-.134-.149a1.858 1.858 0 0 1-.635.368l.066.189zm.703-.408c.199-.178.352-.397.461-.656l-.184-.077a1.612 1.612 0 0 1-.41.584l.133.15zm-1.12-2.138a.74.74 0 0 1 .197.523h.2a.94.94 0 0 0-.25-.659l-.146.136zm.197.523c0 .21-.066.386-.198.535l.15.132a.976.976 0 0 0 .248-.667h-.2zm-.199.536c-.116.138-.309.217-.602.217v.2c.327 0 .587-.09.755-.288l-.153-.129zm-.602.217h-1.405v.2h1.405v-.2zm-1.305.1v-1.696h-.2v1.696h.2zm-.1-1.596h1.405v-.2h-1.405v.2zm1.405 0c.293 0 .486.079.602.216l.153-.129c-.168-.198-.428-.287-.755-.287v.2zm.504-2.604c.132.12.2.283.2.498h.2a.837.837 0 0 0-.265-.645l-.135.147zm.2.498a.67.67 0 0 1-.201.51l.138.144a.868.868 0 0 0 .263-.654h-.2zm-.201.51c-.124.117-.314.185-.59.185v.2c.306 0 .554-.075.728-.241l-.138-.145zm-.59.185h-1.318v.2h1.318v-.2zm-1.218.1V13.2h-.2v1.59h.2zm-.1-1.49h1.318v-.2h-1.318v.2zm1.318 0c.274 0 .464.07.588.194l.141-.141c-.173-.174-.422-.252-.73-.252v.2z" mask="url(#dls-af297-a)"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAbTestSolid = {
  name: 'IconAbTestSolid',
  content: '<path fill="currentColor" d="m5.769 10.28.86-2.474.831 2.475H5.769zm10.484 6.565a.841.841 0 0 0-.223-.591c-.142-.168-.368-.252-.678-.252h-1.405v1.696h1.405c.31 0 .536-.084.678-.252a.876.876 0 0 0 .223-.601zm-.097-2.849a.738.738 0 0 0-.232-.572c-.149-.148-.368-.222-.66-.222h-1.317v1.589h1.318c.29 0 .51-.071.659-.213a.769.769 0 0 0 .232-.582z"/><path fill="currentColor" fill-rule="evenodd" d="M.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm9.017 6.103L6.25 17.5l1.498.998 8-12L14.25 5.5l-4.68 7.02L7.116 5.8H6.075L3.6 12.603h1.385l.411-1.204h2.417l.402 1.204h1.302zm8.083 4.31c0 .323-.052.607-.155.852a1.712 1.712 0 0 1-.436.62c-.187.169-.41.298-.669.388a2.749 2.749 0 0 1-.852.126H12.6V12h2.771c.679 0 1.202.174 1.57.523.375.35.562.82.562 1.415 0 .194-.029.368-.087.523a1.563 1.563 0 0 1-.494.717 1.186 1.186 0 0 1-.271.184c.103.052.21.12.32.204.116.077.219.177.31.3.09.123.164.272.222.446.065.168.097.368.097.6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataAbstract = {
  name: 'IconAbstract',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-6 8a6 6 0 1 1 12 0 6 6 0 0 1-12 0z" clip-rule="evenodd"/><path fill="currentColor" d="M22 22v-2H2v2h20z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAbstractSolid = {
  name: 'IconAbstractSolid',
  content: '<path fill="currentColor" d="M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0zM0 20v2h20v-2H0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataAcademicCap = {
  name: 'IconAcademicCap',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M22.197 9.443c.865-.633.806-2.005-.195-2.532L13.34 2.346a3 3 0 0 0-2.787-.005L1.806 6.908c-1.087.568-1.07 2.13.028 2.674l8.776 4.347a3 3 0 0 0 2.673-.005l7.114-3.557v1.72h1.8V9.444zm-1.989-1.217-7.8-4.11a1 1 0 0 0-.93-.002L3.604 8.226l7.895 3.911a1 1 0 0 0 .89-.002l7.82-3.909z" clip-rule="evenodd"/><path fill="currentColor" d="M5.897 13.009v3.437c0 .545.139.962.385 1.233.806.89 2.569 2.33 5.615 2.33 2.602 0 4.462-1.331 5.452-2.275.351-.335.548-.862.548-1.507v-3.218h2v3.218c0 1.022-.313 2.14-1.168 2.955-1.185 1.13-3.514 2.827-6.832 2.827-3.762 0-6.027-1.806-7.097-2.987-.69-.76-.903-1.727-.903-2.576V13.01h2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAcademicCapSolid = {
  name: 'IconAcademicCapSolid',
  content: '<path fill="currentColor" d="M21.3 9.434c.865-.633.805-2.005-.195-2.532l-8.662-4.565a3 3 0 0 0-2.788-.005L.908 6.899c-1.087.568-1.07 2.13.029 2.674l8.775 4.348a3 3 0 0 0 2.674-.005l7.114-3.557v1.72h1.8V9.434z"/><path fill="currentColor" d="M4.437 13.1A1 1 0 0 0 3 14v2.438c0 .848.213 1.815.902 2.575C4.972 20.194 7.237 22 11 22c3.317 0 5.647-1.697 6.831-2.827.856-.815 1.169-1.932 1.169-2.955V14a1 1 0 0 0-1.437-.9l-5.252 2.552a3 3 0 0 1-2.622 0L4.437 13.1z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataAdDeliveryCircleSolid = {
  name: 'IconAdDeliveryCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zM7.453 10.712c-.685.266-.679 1.237.009 1.495l2.809 1.053a.8.8 0 0 1 .468.468l1.053 2.81c.258.688 1.229.694 1.495.01l3.054-7.854a.8.8 0 0 0-1.035-1.035l-7.853 3.053z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAddPauseSquare = {
  name: 'IconAddPauseSquare',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13 3.5h5.5a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H13V16h-2v4.5H5.5a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2H11V8h2V3.5zm-11.5 2a4 4 0 0 1 4-4h13a4 4 0 0 1 4 4v13a4 4 0 0 1-4 4h-13a4 4 0 0 1-4-4v-13zM19.25 12 16 8.75v2.167H8V8.75L4.75 12 8 15.25v-2.167h8v2.167L19.25 12z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAdjust = {
  name: 'IconAdjust',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11 2.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2V4h8.55c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H13v1.8a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V2.2zM2.2 4a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h6.6a.2.2 0 0 0 .2-.2V4.2a.2.2 0 0 0-.2-.2H2.2zm12 12a.2.2 0 0 0-.2.2v5.6c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2V20h5.55a.2.2 0 0 0 .2-.2v-1.6a.2.2 0 0 0-.2-.2H16v-1.8a.2.2 0 0 0-.2-.2h-1.6zm-12 2a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h9.6a.2.2 0 0 0 .2-.2v-1.6a.2.2 0 0 0-.2-.2H2.2zm5-9a.2.2 0 0 0-.2.2V11H2.2a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2H7v1.8c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2V9.2a.2.2 0 0 0-.2-.2H7.2zm3.5 2a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h10.6a.2.2 0 0 0 .2-.2v-1.6a.2.2 0 0 0-.2-.2H10.7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAfterSquare = {
  name: 'IconAfterSquare',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11zm5.23 4.414v-.091h9.191V9.497H8.73V8.041c3.146-.078 5.98-.351 8.502-.819L16.569 6c-2.678.52-5.746.793-9.178.819v4.095c-.065 2.548-.533 4.537-1.391 5.967l1.014 1.066c1.066-1.742 1.638-4.095 1.716-7.033zm8.242 7.059V12.24H9.627v5.733h1.365v-.494h4.615v.494h1.365zm-1.365-1.82h-4.615V13.54h4.615v2.613z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAfterSquareSolid = {
  name: 'IconAfterSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm2.23 9.414v-.091h9.191V9.497H8.73V8.041c3.146-.078 5.98-.351 8.502-.819L16.569 6c-2.678.52-5.746.793-9.178.819v4.095c-.065 2.548-.533 4.537-1.391 5.967l1.014 1.066c1.066-1.742 1.638-4.095 1.716-7.033zm8.242 7.059V12.24H9.627v5.733h1.365v-.494h4.615v.494h1.365zm-1.365-1.82h-4.615V13.54h4.615v2.613z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAi = {
  name: 'IconAi',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.298 17.98 7.565 3.989A1.312 1.312 0 0 1 8.73 3.28h5.152c.725 0 1.313.588 1.313 1.313v14.812c0 .725-.588 1.313-1.313 1.313h-2.109a1.313 1.313 0 0 1-1.312-1.313V8.296c0-.198-.265-.261-.355-.086l-3.935 7.692a.187.187 0 0 0 .167.273h2.294a.75.75 0 0 1 .672 1.084l-1.516 3.044a.75.75 0 0 1-.671.416H1.962a1.875 1.875 0 0 1-1.664-2.74zm18.346-14.7c-.725 0-1.313.588-1.313 1.313v14.78c0 .725.588 1.312 1.313 1.312h2.106c.725 0 1.313-.587 1.313-1.312V4.594c0-.725-.588-1.313-1.313-1.313h-2.106z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAiBubble = {
  name: 'IconAiBubble',
  content: '<path fill="currentColor" d="M11.08 7.471a.4.4 0 0 1 .327-.17H13.8a.4.4 0 0 1 .4.4v8.2a.4.4 0 0 1-.4.4h-1.2a.4.4 0 0 1-.4-.4V9.474a.1.1 0 0 0-.182-.058L8.71 14.143a.1.1 0 0 0 .082.157h2.099a.5.5 0 0 1 .447.724l-.5 1a.5.5 0 0 1-.447.276H6.819a1 1 0 0 1-.82-1.573l5.08-7.256zm4.418.329a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-8z"/><path fill="currentColor" fill-rule="evenodd" d="M22.998 21.999h-16a6 6 0 0 1-6-6v-8a6 6 0 0 1 6-6h10a6 6 0 0 1 6 6v14zm-2-2h-14a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v12z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAiBubbleSolid = {
  name: 'IconAiBubbleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7 21.999h16v-14a6 6 0 0 0-6-6H7a6 6 0 0 0-6 6v8a6 6 0 0 0 6 6zm4.076-14.53a.4.4 0 0 1 .327-.17h2.392a.4.4 0 0 1 .4.4v8.2a.4.4 0 0 1-.4.4h-1.2a.4.4 0 0 1-.4-.4V9.473a.1.1 0 0 0-.182-.057l-3.308 4.726a.1.1 0 0 0 .082.157h2.1a.5.5 0 0 1 .446.723l-.5 1a.5.5 0 0 1-.447.277h-3.57a1 1 0 0 1-.82-1.574l5.08-7.256zm4.418.33a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAlignBottom = {
  name: 'IconAlignBottom',
  content: '<path fill="currentColor" d="M6 17V2h3.6v15H6zm-4 2.9h20v2.2H2v-2.2zM14.2 8v9h3.6V8h-3.6z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAlignCenter = {
  name: 'IconAlignCenter',
  content: '<path fill="currentColor" d="M10.9 14.2V9.8H2.5V6.2h8.4V2h2.2v4.2h8.4v3.6h-8.4v4.4h5.4v3.6h-5.4V22h-2.2v-4.2H6v-3.6h4.9z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAlignLeft = {
  name: 'IconAlignLeft',
  content: '<path fill="currentColor" d="M1.9 22V2h2.2v20H1.9zM22 10H6V6.4h16V10zM6 17.8h10v-3.6H6v3.6z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAlignRight = {
  name: 'IconAlignRight',
  content: '<path fill="currentColor" d="M19.9 2v20h2.2V2h-2.2zM18 10H2V6.4h16V10zm0 7.8H8v-3.6h10v3.6z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAlignTop = {
  name: 'IconAlignTop',
  content: '<path fill="currentColor" d="M2 1.9h20v2.2H2V1.9zM6 22V7h3.6v15H6zm8.2-15v9h3.6V7h-3.6z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAndroid = {
  name: 'IconAndroid',
  content: '<g fill="currentColor" clip-path="url(#dls-41611-a)"><path d="M7 7.3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/><path fill-rule="evenodd" d="M0 10.5a8.96 8.96 0 0 1 1.715-5.285L0 3.5l1.414-1.414 1.65 1.65A8.966 8.966 0 0 1 9 1.5a8.97 8.97 0 0 1 5.937 2.235l1.65-1.65L18 3.5l-1.714 1.715A8.96 8.96 0 0 1 18 10.5V19a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-8.5zm15.983-.5a7 7 0 0 0-13.965 0h13.965zM2 12v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7H2z" clip-rule="evenodd"/></g><defs><clipPath id="dls-41611-a"><path fill="currentColor" d="M0 0h18v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 18 24'
  },
  width: 18,
  height: 24
};

var dataAnticlockwise = {
  name: 'IconAnticlockwise',
  content: '<path fill="currentColor" d="M12.093 1.2c6.037 0 10.938 4.877 10.938 10.9 0 6.024-4.9 10.9-10.938 10.9A10.94 10.94 0 0 1 1.9 16.06l1.862-.729A8.94 8.94 0 0 0 12.093 21c4.94 0 8.938-3.988 8.938-8.9 0-4.912-3.998-8.9-8.938-8.9-2.406 0-4.59.946-6.198 2.487l1.328.767a.5.5 0 0 1-.048.89L3.1 9.148a.5.5 0 0 1-.698-.391L1.8 4.253a.5.5 0 0 1 .746-.5l1.559.9A10.927 10.927 0 0 1 12.093 1.2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAppStore = {
  name: 'IconAppStore',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M2 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0zm9-11C4.925 1 0 5.925 0 12s4.925 11 11 11 11-4.925 11-11S17.075 1 11 1zM8.214 6.13l1.631 2.826-2.658 4.608H4.5v1.857h8.015l-1.072-1.857H9.496l4.29-7.435-1.732-1-1.136 1.969L9.822 5.2l-1.608.93zM15.18 18.2l-3.65-6.326 1.072-1.857 2.047 3.547H17.5v1.857h-1.78l1.067 1.85-1.608.929zm-7.286-1.857h-2.31l-.494.857 1.732 1 1.072-1.857z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataApps = {
  name: 'IconApps',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4.7 2.3a2.4 2.4 0 0 0-2.4 2.4v4.18a2.4 2.4 0 0 0 2.4 2.4h4.18a2.4 2.4 0 0 0 2.4-2.4V4.7a2.4 2.4 0 0 0-2.4-2.4H4.7zm-.6 2.4a.6.6 0 0 1 .6-.6h4.18a.6.6 0 0 1 .6.6v4.18a.6.6 0 0 1-.6.6H4.7a.6.6 0 0 1-.6-.6V4.7zm.6 7.922a2.4 2.4 0 0 0-2.4 2.4v4.18a2.4 2.4 0 0 0 2.4 2.4h4.18a2.4 2.4 0 0 0 2.4-2.4v-4.18a2.4 2.4 0 0 0-2.4-2.4H4.7zm-.6 2.4a.6.6 0 0 1 .6-.6h4.18a.6.6 0 0 1 .6.6v4.18a.6.6 0 0 1-.6.6H4.7a.6.6 0 0 1-.6-.6v-4.18zm8.52 0a2.4 2.4 0 0 1 2.4-2.4h4.18a2.4 2.4 0 0 1 2.4 2.4v4.18a2.4 2.4 0 0 1-2.4 2.4h-4.18a2.4 2.4 0 0 1-2.4-2.4v-4.18zm2.4-.6a.6.6 0 0 0-.6.6v4.18a.6.6 0 0 0 .6.6h4.18a.6.6 0 0 0 .6-.6v-4.18a.6.6 0 0 0-.6-.6h-4.18zM15.022 2.3a2.4 2.4 0 0 0-2.4 2.4v4.18a2.4 2.4 0 0 0 2.4 2.4h4.18a2.4 2.4 0 0 0 2.4-2.4V4.7a2.4 2.4 0 0 0-2.4-2.4h-4.18zm-.6 2.4a.6.6 0 0 1 .6-.6h4.18a.6.6 0 0 1 .6.6v4.18a.6.6 0 0 1-.6.6h-4.18a.6.6 0 0 1-.6-.6V4.7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAppsSettings = {
  name: 'IconAppsSettings',
  content: '<path fill="currentColor" d="M17.5 7.6a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/><path fill="currentColor" fill-rule="evenodd" d="m22.353 7.625-1.553 2.6a2 2 0 0 1-1.717.975h-3.165a2 2 0 0 1-1.717-.974l-1.553-2.6a2 2 0 0 1 0-2.051l1.553-2.6A2 2 0 0 1 15.918 2h3.165a2 2 0 0 1 1.717.975l1.553 2.6a2 2 0 0 1 0 2.05zM19.083 9.2l1.553-2.6L19.083 4h-3.165l-1.553 2.6 1.553 2.6h3.165zM2.1 4.5a2.4 2.4 0 0 1 2.4-2.4h4.4a2.4 2.4 0 0 1 2.4 2.4v4.4a2.4 2.4 0 0 1-2.4 2.4H4.5a2.4 2.4 0 0 1-2.4-2.4V4.5zm2.4-.6a.6.6 0 0 0-.6.6v4.4a.6.6 0 0 0 .6.6h4.4a.6.6 0 0 0 .6-.6V4.5a.6.6 0 0 0-.6-.6H4.5zM2.1 15.1a2.4 2.4 0 0 1 2.4-2.4h4.4a2.4 2.4 0 0 1 2.4 2.4v4.4a2.4 2.4 0 0 1-2.4 2.4H4.5a2.4 2.4 0 0 1-2.4-2.4v-4.4zm2.4-.6a.6.6 0 0 0-.6.6v4.4a.6.6 0 0 0 .6.6h4.4a.6.6 0 0 0 .6-.6v-4.4a.6.6 0 0 0-.6-.6H4.5zm10.6-1.8a2.4 2.4 0 0 0-2.4 2.4v4.4a2.4 2.4 0 0 0 2.4 2.4h4.4a2.4 2.4 0 0 0 2.4-2.4v-4.4a2.4 2.4 0 0 0-2.4-2.4h-4.4zm-.6 2.4a.6.6 0 0 1 .6-.6h4.4a.6.6 0 0 1 .6.6v4.4a.6.6 0 0 1-.6.6h-4.4a.6.6 0 0 1-.6-.6v-4.4z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAppsSettingsSolid = {
  name: 'IconAppsSettingsSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m18.8 10.226 1.552-2.6a2 2 0 0 0 0-2.051l-1.552-2.6A2 2 0 0 0 17.083 2h-3.165a2 2 0 0 0-1.717.975l-1.553 2.6a2 2 0 0 0 0 2.05l1.553 2.6a2 2 0 0 0 1.717.975h3.165a2 2 0 0 0 1.717-.974zM17 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" clip-rule="evenodd"/><path fill="currentColor" d="M.1 4.5a2.4 2.4 0 0 1 2.4-2.4h4.4a2.4 2.4 0 0 1 2.4 2.4v4.4a2.4 2.4 0 0 1-2.4 2.4H2.5A2.4 2.4 0 0 1 .1 8.9V4.5zm0 10.6a2.4 2.4 0 0 1 2.4-2.4h4.4a2.4 2.4 0 0 1 2.4 2.4v4.4a2.4 2.4 0 0 1-2.4 2.4H2.5a2.4 2.4 0 0 1-2.4-2.4v-4.4zm10.6 0a2.4 2.4 0 0 1 2.4-2.4h4.4a2.4 2.4 0 0 1 2.4 2.4v4.4a2.4 2.4 0 0 1-2.4 2.4h-4.4a2.4 2.4 0 0 1-2.4-2.4v-4.4z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataAppsSolid = {
  name: 'IconAppsSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M2.7 2.3A2.4 2.4 0 0 0 .3 4.7v4.18a2.4 2.4 0 0 0 2.4 2.4h4.18a2.4 2.4 0 0 0 2.4-2.4V4.7a2.4 2.4 0 0 0-2.4-2.4H2.7zm0 10.322a2.4 2.4 0 0 0-2.4 2.4v4.18a2.4 2.4 0 0 0 2.4 2.4h4.18a2.4 2.4 0 0 0 2.4-2.4v-4.18a2.4 2.4 0 0 0-2.4-2.4H2.7zm10.32 0a2.4 2.4 0 0 0-2.4 2.4v4.18a2.4 2.4 0 0 0 2.4 2.4h4.18a2.4 2.4 0 0 0 2.4-2.4v-4.18a2.4 2.4 0 0 0-2.4-2.4h-4.18zM13.022 2.3a2.4 2.4 0 0 0-2.4 2.4v4.18a2.4 2.4 0 0 0 2.4 2.4h4.18a2.4 2.4 0 0 0 2.4-2.4V4.7a2.4 2.4 0 0 0-2.4-2.4h-4.18z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataArrowCurveDownRightSolid = {
  name: 'IconArrowCurveDownRightSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7.219 21.822.323 13.136c-.592-.745.093-1.817 1.018-1.594l3.943.952c-.038-1.25-.137-3.322-.394-5.228-.363-2.684-1.546-4.474-2.435-5.478-.217-.244.023-.683.328-.568 1.665.627 4.437 2.065 6.1 5.05 1.516 2.719 2.081 4.855 2.292 6.114l3.488-.842c.925-.223 1.61.85 1.018 1.594L8.785 21.82a1 1 0 0 1-1.566 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 16 24'
  },
  width: 16,
  height: 24
};

var dataArrowCurveUpRightSolid = {
  name: 'IconArrowCurveUpRightSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7.217 1.378.321 10.063c-.591.745.093 1.817 1.018 1.594l3.943-.952c-.037 1.25-.136 3.322-.394 5.227-.363 2.684-1.545 4.475-2.435 5.48-.216.243.024.682.329.567 1.664-.627 4.437-2.065 6.1-5.05 1.515-2.72 2.08-4.855 2.291-6.114l3.489.842c.925.223 1.61-.85 1.018-1.594L8.784 1.378a1 1 0 0 0-1.567 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 16 24'
  },
  width: 16,
  height: 24
};

var dataArrowDown = {
  name: 'IconArrowDown',
  content: '<path fill="currentColor" d="m13 19.016 7.336-6.514 1.328 1.496-7.681 6.82a3 3 0 0 1-3.986-.003l-7.662-6.818 1.33-1.494L11 19.031V2h2v17.016z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowDownLeft = {
  name: 'IconArrowDownLeft',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 7.938v-1h-2V18.5a1 1 0 0 0 1 1h11.561v-2h-9.12L20.104 5.337 18.69 3.923 6.5 16.113V7.938z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowDownRight = {
  name: 'IconArrowDownRight',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.438 18h-1v2H19a1 1 0 0 0 1-1V7.438h-2v9.12L5.837 4.397 4.423 5.81 16.613 18H8.438z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowDownSolid = {
  name: 'IconArrowDownSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M9.2 13V1.2h5.6V13h4.096c.879 0 1.33 1.052.724 1.69l-6.896 7.248a1 1 0 0 1-1.449 0L4.38 14.69c-.606-.638-.155-1.69.724-1.69H9.2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowLeft = {
  name: 'IconArrowLeft',
  content: '<path fill="currentColor" d="m4.735 13 6.513 7.336-1.495 1.328-6.82-7.68a3 3 0 0 1 .002-3.987l6.818-7.662 1.494 1.33L4.72 11h17.03v2H4.735z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowLeftSolid = {
  name: 'IconArrowLeftSolid',
  content: '<path fill="currentColor" d="M1.862 11.025a1 1 0 0 0 0 1.45L9.11 19.37c.636.606 1.689.155 1.689-.724V14.55h11.8v-5.6H10.8V4.854c0-.879-1.053-1.33-1.69-.724l-7.248 6.895z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowRight = {
  name: 'IconArrowRight',
  content: '<path fill="currentColor" d="m19.165 13-6.513 7.336 1.495 1.328 6.82-7.68a3 3 0 0 0-.002-3.987l-6.819-7.662-1.494 1.33L19.18 11H2.15v2h17.015z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowRightSolid = {
  name: 'IconArrowRightSolid',
  content: '<path fill="currentColor" d="M22.238 12.475a1 1 0 0 0 0-1.45L14.99 4.13c-.637-.606-1.689-.155-1.689.724V8.95H1.5v5.6h11.8v4.096c0 .879 1.052 1.33 1.69.724l7.248-6.895z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowToBottom = {
  name: 'IconArrowToBottom',
  content: '<path fill="currentColor" d="M13.409 17.057c-.125.125-.263.23-.409.315V2h-2v15.378a2.003 2.003 0 0 1-.42-.321L3.51 9.986 2.094 11.4l7.071 7.071a4 4 0 0 0 5.657 0l7.071-7.071-1.414-1.414-7.071 7.07zM3.5 22.5h17v-2h-17v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowToTop = {
  name: 'IconArrowToTop',
  content: '<path fill="currentColor" d="M3.5 1.5h17v2h-17v-2zm18.394 11.1-7.07-7.071a4 4 0 0 0-5.658 0L2.096 12.6l1.413 1.414 7.072-7.07c.128-.129.269-.236.419-.322V22h2V6.628c.146.085.284.19.409.315l7.071 7.071 1.414-1.414z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowToTopSoild = {
  name: 'IconArrowToTopSoild',
  content: '<path fill="currentColor" d="M3 2h18v3H3V2zm11.5 12.411h4.963c.448 0 .698-.412.42-.694L12.42 6.162c-.213-.216-.624-.216-.84 0l-7.464 7.555c-.277.282-.027.694.42.694H9.5V22.5h5v-8.089z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowToTopSolid = {
  name: 'IconArrowToTopSolid',
  content: '<path fill="currentColor" d="M3 2h18v3H3V2zm11.5 12.411h4.963c.448 0 .698-.412.42-.694L12.42 6.162c-.213-.216-.624-.216-.84 0l-7.464 7.555c-.277.282-.027.694.42.694H9.5V22.5h5v-8.089z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowUUpLeft = {
  name: 'IconArrowUUpLeft',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m7.553 1.337-4.915 4.17a2 2 0 0 0-.024 3.03l4.927 4.315 1.318-1.504L5.036 8H15a6 6 0 1 1 0 12H6v2h9a8 8 0 1 0 0-16H5.149l3.698-3.138-1.294-1.525z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowUUpRight = {
  name: 'IconArrowUUpRight',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m16.447 1.337 4.915 4.17a2 2 0 0 1 .024 3.03l-4.927 4.315-1.318-1.504L18.964 8H9a6 6 0 1 0 0 12h9v2H9A8 8 0 1 1 9 6h9.851l-3.698-3.138 1.294-1.525z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowUp = {
  name: 'IconArrowUp',
  content: '<path fill="currentColor" d="m13 4.834 7.336 6.514 1.328-1.496-7.68-6.82a3 3 0 0 0-3.987.003L2.335 9.853l1.33 1.494L11 4.82v17.03h2V4.834z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataArrowUpSolid = {
  name: 'IconArrowUpSolid',
  content: '<path fill="currentColor" d="M12.724 1.762a1 1 0 0 0-1.449 0L4.38 9.01c-.605.637-.154 1.689.725 1.689H9.2v11.8h5.6V10.7h4.096c.879 0 1.33-1.052.724-1.69l-6.896-7.248z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAsterisk = {
  name: 'IconAsterisk',
  content: '<path fill="currentColor" d="M13.34 6h-2.666l.505 4.667L6.69 8.88 6 11.457l4.743.693-3.123 4.191 2.31 1.334L12 12.87l2.07 4.805 2.31-1.334-3.123-4.19L18 11.456l-.69-2.576-4.474 1.78.505-4.66z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAttribute = {
  name: 'IconAttribute',
  content: '<path fill="currentColor" d="M9.5 10.5h-3v-2h3v2zm2 0h6v-2h-6v2zm-2 5h-3v-2h3v2zm2 0h6v-2h-6v2z"/><path fill="currentColor" fill-rule="evenodd" d="M1.5 6.5a5 5 0 0 1 5-5h10.973a5 5 0 0 1 5 4.991l.02 11a5 5 0 0 1-5 5.009H6.5a5 5 0 0 1-5-5v-11zm5-3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h10.993a3 3 0 0 0 3-3.005l-.02-11a3 3 0 0 0-3-2.995H6.5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAttributeSolid = {
  name: 'IconAttributeSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.5 6.5a5 5 0 0 1 5-5h10.973a5 5 0 0 1 5 4.991l.02 11a5 5 0 0 1-5 5.009H5.5a5 5 0 0 1-5-5v-11zm8 4h-3v-2h3v2zm8 0h-6v-2h6v2zm-11 5h3v-2h-3v2zm11 0h-6v-2h6v2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataAudio = {
  name: 'IconAudio',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 1a5 5 0 0 0-5 5v5a5 5 0 0 0 10 0V6a5 5 0 0 0-5-5zm3 10V6a3 3 0 1 0-6 0v5a3 3 0 1 0 6 0z" clip-rule="evenodd"/><path fill="currentColor" d="M13 19.442a8.504 8.504 0 0 0 6.445-4.338l-1.642-1.173a6.5 6.5 0 0 1-11.697-.186L4.53 15.059A8.504 8.504 0 0 0 11 19.442V23h2v-3.558z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataAudioSolid = {
  name: 'IconAudioSolid',
  content: '<path fill="currentColor" d="M3 6a5 5 0 0 1 10 0v5a5 5 0 0 1-10 0V6z"/><path fill="currentColor" d="M9 19.442a8.504 8.504 0 0 0 6.445-4.338l-1.642-1.173a6.501 6.501 0 0 1-11.697-.186L.53 15.058A8.504 8.504 0 0 0 7 19.443V23h2v-3.558z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 16 24'
  },
  width: 16,
  height: 24
};

var dataBabyBottle = {
  name: 'IconBabyBottle',
  content: '<path fill="currentColor" d="m10.84 9.636 2.755 2.755 1.273-1.273-2.755-2.755-1.272 1.273zm-2.601 2.602 2.754 2.755 1.273-1.273-2.755-2.755-1.272 1.273zm.152 5.357L5.637 14.84l1.272-1.272 2.755 2.754-1.273 1.273z"/><path fill="currentColor" fill-rule="evenodd" d="M21.803 2.592a2.28 2.28 0 0 0-3.224 0l-.67.67a2.51 2.51 0 0 0-4.048 1.275A4.9 4.9 0 0 0 8.92 5.746l-5.657 5.657a4.9 4.9 0 0 0 0 6.93L6.09 21.16a4.9 4.9 0 0 0 6.93 0l5.657-5.657a4.9 4.9 0 0 0 1.198-4.974 2.51 2.51 0 0 0 1.257-4.042l.67-.672a2.28 2.28 0 0 0 0-3.224zm-1.951 1.273a.48.48 0 1 1 .678.679l-.664.664-.679-.678.665-.665zm-3.062.813a.71.71 0 0 0-1.004 1.004l2.927 2.928a.71.71 0 0 0 1.004-1.005L16.79 4.678zm-6.597 2.34a3.1 3.1 0 0 1 4.383 0l2.829 2.829a3.1 3.1 0 0 1 0 4.384l-5.657 5.657a3.1 3.1 0 0 1-4.384 0l-2.828-2.829a3.1 3.1 0 0 1 0-4.384l5.657-5.656z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBabyBottleSolid = {
  name: 'IconBabyBottleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M17.579 2.592a2.28 2.28 0 0 1 3.224 3.225l-.67.67a2.51 2.51 0 0 1-1.257 4.043 4.9 4.9 0 0 1-1.198 4.974l-5.657 5.657a4.9 4.9 0 0 1-6.93 0l-2.828-2.829a4.9 4.9 0 0 1 0-6.93L7.92 5.747a4.9 4.9 0 0 1 4.941-1.209 2.51 2.51 0 0 1 4.047-1.274l.67-.67zm.125 6.008a4.25 4.25 0 0 0-.026-.026L14.85 5.746l-.027-.026-.037-.038a.71.71 0 1 1 1.004-1.004l2.927 2.928a.71.71 0 1 1-1.004 1.004l-.01-.01zm-5.109 3.79L9.841 9.636l1.273-1.273 2.754 2.755-1.273 1.272zm-2.602 2.603-2.754-2.755 1.272-1.273 2.755 2.755-1.273 1.273zm-5.357-.153 2.755 2.755 1.273-1.273-2.755-2.754-1.273 1.272z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataBackground = {
  name: 'IconBackground',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm5-3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3h-11z" clip-rule="evenodd"/><mask id="dls-00582-a" width="16" height="16" x="4" y="4" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="currentColor" d="M4.5 4.5h15v15h-15v-15z"/></mask><g fill="currentColor" mask="url(#dls-00582-a)"><path d="M18.91 3.16a1.071 1.071 0 0 0-1.515-1.515L2.66 16.38a1.071 1.071 0 1 0 1.516 1.515L18.91 3.16zm-7.045-.985a1.071 1.071 0 0 1 0 1.515L.88 14.675A1.071 1.071 0 1 1-.635 13.16L10.349 2.175a1.071 1.071 0 0 1 1.516 0zm10.303 4.243a1.071 1.071 0 0 0-1.515-1.515L5.918 19.638a1.071 1.071 0 1 0 1.516 1.515L22.168 6.418zm-.53 7.046a1.071 1.071 0 1 0-1.515-1.515L9.138 22.933a1.071 1.071 0 1 0 1.515 1.516l10.985-10.985z"/></g>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBackgroundSolid = {
  name: 'IconBackgroundSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 22.5a5 5 0 0 1-5-5v-11a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11zM5.973 3.667 3.467 6.173c-.223.222-.223.612 0 .78l.78.779a.538.538 0 0 0 .78 0l2.505-2.506a.538.538 0 0 0 0-.78l-.78-.779a.538.538 0 0 0-.78 0zm5.846.613-8.074 8.073a.538.538 0 0 0 0 .78l.78.78a.538.538 0 0 0 .78 0l8.074-8.074a.538.538 0 0 0 0-.78l-.78-.78a.538.538 0 0 0-.78 0zM4.024 19.258l.78.78a.606.606 0 0 0 .835 0l14.143-14.2a.538.538 0 0 0 0-.779l-.78-.78a.538.538 0 0 0-.78 0L4.025 18.48a.538.538 0 0 0 0 .779zm5.902.445.78.78a.538.538 0 0 0 .78 0l8.463-8.464a.538.538 0 0 0 0-.78l-.78-.779a.538.538 0 0 0-.78 0l-8.463 8.464a.538.538 0 0 0 0 .78zm8.185.446 2.34-2.339c.222-.223.222-.612 0-.78l-.78-.779a.538.538 0 0 0-.78 0l-2.339 2.339a.538.538 0 0 0 0 .78l.78.779a.538.538 0 0 0 .78 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBackgroundSwitchSolid = {
  name: 'IconBackgroundSwitchSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.324 2A4.324 4.324 0 0 0 2 6.324v10.352A4.324 4.324 0 0 0 6.324 21h6.448A6.213 6.213 0 0 1 21 12.06V6.324A4.324 4.324 0 0 0 16.676 2H6.324zM4 7.443v2.53L9.964 4H7.443L4 7.443zM13.041 4 4 13.041v2.522L15.548 4h-2.507zm.556 12.416a.89.89 0 0 1 0-1.259l2.417-2.416 1.259 1.26-.897.895h5.637v1.781H14.24a.888.888 0 0 1-.643-.26zm7.566 1.513h.024a.89.89 0 0 1 .678 1.519l-2.416 2.416-1.26-1.26.896-.895H14v-1.78h7.163z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBarChart = {
  name: 'IconBarChart',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.5 17.5v-16h2v16A3 3 0 0 0 6 20.459V14a3 3 0 1 1 6 0v6.5h2V10a3 3 0 1 1 6 0v10.5h2.5v2h-16a5 5 0 0 1-5-5zm16.5 3V10a1 1 0 1 0-2 0v10.5h2zM10 14v6.5H8V14a1 1 0 1 1 2 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBarChartAlt = {
  name: 'IconBarChartAlt',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M18.405 2.1a2.3 2.3 0 0 0-2.3 2.308l.045 12.2a2.3 2.3 0 0 0 2.3 2.292h1.145a2.3 2.3 0 0 0 2.3-2.308l-.045-12.2a2.3 2.3 0 0 0-2.3-2.292h-1.145zm-.5 2.302a.5.5 0 0 1 .5-.502h1.145a.5.5 0 0 1 .5.498l.045 12.2a.5.5 0 0 1-.5.502H18.45a.5.5 0 0 1-.5-.498l-.045-12.2zM4.4 8.1a2.3 2.3 0 0 0-2.3 2.3v6.2a2.3 2.3 0 0 0 2.3 2.3h1.2a2.3 2.3 0 0 0 2.3-2.3v-6.2a2.3 2.3 0 0 0-2.3-2.3H4.4zm-.5 2.3a.5.5 0 0 1 .5-.5h1.2a.5.5 0 0 1 .5.5v6.2a.5.5 0 0 1-.5.5H4.4a.5.5 0 0 1-.5-.5v-6.2zm5.2-4a2.3 2.3 0 0 1 2.3-2.3h1.2a2.3 2.3 0 0 1 2.3 2.3v10.2a2.3 2.3 0 0 1-2.3 2.3h-1.2a2.3 2.3 0 0 1-2.3-2.3V6.4zm2.3-.5a.5.5 0 0 0-.5.5v10.2a.5.5 0 0 0 .5.5h1.2a.5.5 0 0 0 .5-.5V6.4a.5.5 0 0 0-.5-.5h-1.2z" clip-rule="evenodd"/><path fill="currentColor" d="M2 21.9h20v-1.8H2v1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBarChartAltSolid = {
  name: 'IconBarChartAltSolid',
  content: '<g fill="currentColor" clip-path="url(#dls-f44ff-a)"><path d="M15.153 4.206a2.05 2.05 0 0 1 2.05-2.056h.756a2.05 2.05 0 0 1 2.05 2.044l.037 12.6a2.05 2.05 0 0 1-2.05 2.056h-.756a2.05 2.05 0 0 1-2.05-2.044l-.037-12.6zM.35 10.2A2.05 2.05 0 0 1 2.4 8.15h.8a2.05 2.05 0 0 1 2.05 2.05v6.6a2.05 2.05 0 0 1-2.05 2.05h-.8A2.05 2.05 0 0 1 .35 16.8v-6.6zm7.4-4A2.05 2.05 0 0 1 9.8 4.15h.8a2.05 2.05 0 0 1 2.05 2.05v10.6a2.05 2.05 0 0 1-2.05 2.05h-.8a2.05 2.05 0 0 1-2.05-2.05V6.2zM0 21.9h20v-1.8H0v1.8z"/></g><defs><clipPath id="dls-f44ff-a"><path fill="currentColor" d="M0 0h20v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataBarChartSolid = {
  name: 'IconBarChartSolid',
  content: '<path fill="currentColor" d="M.5 17.5v-16h2v16a3 3 0 0 0 2.75 2.99V14a2.75 2.75 0 1 1 5.5 0v6.5h2.5V10a2.75 2.75 0 1 1 5.5 0v10.5h2.75v2h-16a5 5 0 0 1-5-5z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataBarChartSquare = {
  name: 'IconBarChartSquare',
  content: '<rect width="20" height="20" x="1" y="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" rx="4"/><path stroke="currentColor" stroke-width="2.2" d="M11 6.5v11m5.2-5.5v5.5M5.8 10v7.5"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataBarChartSquareSolid = {
  name: 'IconBarChartSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7.357 1h7.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C22 6.4 22 7.273 22 8.357v7.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487C16.6 23 15.727 23 14.643 23H7.357c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.961-.487A5 5 0 0 1 .545 20.27c-.302-.592-.428-1.232-.487-1.961C0 17.6 0 16.727 0 15.643V8.357C0 7.273 0 6.4.058 5.691c.06-.728.185-1.369.487-1.961A5 5 0 0 1 2.73 1.545c.592-.302 1.233-.428 1.961-.487C5.4 1 6.273 1 7.357 1zM9.9 17.5v-11h2.2v11H9.9zm5.2 0V12h2.2v5.5h-2.2zm-10.4 0V10h2.2v7.5H4.7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataBeforeSquare = {
  name: 'IconBeforeSquare',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11zm11.808-.032L13.995 6a10.628 10.628 0 0 1-.949 1.56h-2.275a15.846 15.846 0 0 0-.767-1.43l-1.43.234c.273.364.52.767.728 1.196H6v1.326h11.765V7.56h-3.198c.26-.338.507-.702.741-1.092zm-5.746 11.57h1.014c.845 0 1.274-.533 1.274-1.586V9.588H6.819v8.554h1.326v-2.717h2.392v.728c0 .403-.143.611-.403.611l-.936-.052.364 1.326zm.975-3.809H8.145v-1.092h2.392v1.092zm0-2.288H8.145v-1.092h2.392v1.092zm3.354 6.058h1.755c.884 0 1.326-.455 1.326-1.365V9.341H15.62v6.942c0 .338-.156.507-.442.507-.507 0-1.027-.026-1.573-.078l.286 1.287zm.377-7.683h-1.326v5.525h1.326v-5.525z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBeforeSquareSolid = {
  name: 'IconBeforeSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm8.808 4.968L13.995 6a10.628 10.628 0 0 1-.949 1.56h-2.275a15.846 15.846 0 0 0-.767-1.43l-1.43.234c.273.364.52.767.728 1.196H6v1.326h11.765V7.56h-3.198c.26-.338.507-.702.741-1.092zm-5.746 11.57h1.014c.845 0 1.274-.533 1.274-1.586V9.588H6.819v8.554h1.326v-2.717h2.392v.728c0 .403-.143.611-.403.611l-.936-.052.364 1.326zm.975-3.809H8.145v-1.092h2.392v1.092zm0-2.288H8.145v-1.092h2.392v1.092zm3.354 6.058h1.755c.884 0 1.326-.455 1.326-1.365V9.341H15.62v6.942c0 .338-.156.507-.442.507-.507 0-1.027-.026-1.573-.078l.286 1.287zm.377-7.683h-1.326v5.525h1.326v-5.525z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBell = {
  name: 'IconBell',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.793 2.534a1.207 1.207 0 0 1 2.413 0v.473a6.71 6.71 0 0 1 5.563 6.61v3.068a11.677 11.677 0 0 1 2.209 3.132c.265.551.485 1.122.657 1.705.176.596-.297 1.16-.919 1.16H1.284c-.622 0-1.095-.564-.92-1.16.172-.583.393-1.154.658-1.705a11.676 11.676 0 0 1 2.331-3.253V9.617a6.71 6.71 0 0 1 5.44-6.588v-.495zM2.823 16.68a9.555 9.555 0 0 1 2.036-2.793c.16-.15.325-.295.494-.432V9.617a4.708 4.708 0 0 1 9.416-.003v1.559h-.007v2.378a9.058 9.058 0 0 1 1.126 1.13 9.555 9.555 0 0 1 1.288 2H2.824z" clip-rule="evenodd"/><path fill="currentColor" d="M10 22.411a3 3 0 0 1-2.98-2.645h5.96A3 3 0 0 1 10 22.41z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataBellSolid = {
  name: 'IconBellSolid',
  content: '<path fill="currentColor" d="M10 1.327c-.666 0-1.207.54-1.207 1.207v.439a6.71 6.71 0 0 0-5.44 6.588v2.65a10.055 10.055 0 0 0-3.169 5.335c-.13.581.337 1.101.933 1.101h17.766c.596 0 1.064-.52.933-1.1a10.052 10.052 0 0 0-3.047-5.226v-2.76a6.71 6.71 0 0 0-5.563-6.61v-.417c0-.666-.54-1.207-1.206-1.207zM7.02 19.766a3 3 0 0 0 5.96 0H7.02z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataBold = {
  name: 'IconBold',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6 2.4v19.3h8.3a5.45 5.45 0 0 0 2.913-10.057A5.45 5.45 0 0 0 13.3 2.4H6zm2.5 2.5v5.9h4.806a2.95 2.95 0 0 0-.006-5.9H8.5zm0 8.4v5.9h5.8a2.95 2.95 0 0 0 0-5.9H8.5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBook = {
  name: 'IconBook',
  content: '<path fill="currentColor" d="M16 7.9H7V6.1h9v1.8zm-9 4h7v-1.8H7v1.8z"/><path fill="currentColor" fill-rule="evenodd" d="M2.6 5.58a3.9 3.9 0 0 1 3.9-3.9h11a3.9 3.9 0 0 1 3.9 3.9v6.92a3.9 3.9 0 0 1-3.9 3.9h-11a2.1 2.1 0 1 0 0 4.2h14v1.8h-14a3.9 3.9 0 0 1-3.878-4.32H2.6V5.58zm1.8 9.633a3.882 3.882 0 0 1 2.1-.613h11a2.1 2.1 0 0 0 2.1-2.1V5.58a2.1 2.1 0 0 0-2.1-2.1h-11a2.1 2.1 0 0 0-2.1 2.1v9.633z" clip-rule="evenodd"/><path fill="currentColor" d="M20.5 19.4h-14v-1.8h14v1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBookBookmark = {
  name: 'IconBookBookmark',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5H7zM4 6a3 3 0 0 1 3-3h4v5.687a1.2 1.2 0 0 0 1.704 1.09l1.795-.831 1.798.83A1.2 1.2 0 0 0 18 8.688V3.171c1.165.412 2 1.523 2 2.829v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V6zm12-3h-3v4.436l.995-.46a1.2 1.2 0 0 1 1.007-.001l.998.461V3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBookBookmarkCheckSolid = {
  name: 'IconBookBookmarkCheckSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h6.81A6.5 6.5 0 0 1 22 13.022V6a5 5 0 0 0-5-5H7zm6 6.436V3h-2v5.687a1.2 1.2 0 0 0 1.704 1.09l1.795-.831 1.798.83A1.2 1.2 0 0 0 18 8.688V3h-2v4.436l-.998-.461a1.2 1.2 0 0 0-1.007 0l-.995.46z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M18.5 23.375a4.875 4.875 0 1 0 0-9.75 4.875 4.875 0 0 0 0 9.75zm3.78-6.345-1.06-1.06L18 19.19l-1.72-1.72-1.06 1.06L18 21.31l4.28-4.28z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBookBookmarkSolid = {
  name: 'IconBookBookmarkSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 6a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V6zm11-3v4.436l.995-.46a1.2 1.2 0 0 1 1.007-.001l.998.461V3h2v5.687a1.2 1.2 0 0 1-1.703 1.09l-1.798-.831-1.795.83A1.2 1.2 0 0 1 9 8.687V3h2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataBookOpen = {
  name: 'IconBookOpen',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4 5.5h4a3 3 0 0 1 3 3v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1zm8 14.236a2.989 2.989 0 0 1-2 .764H4a3 3 0 0 1-3-3v-11a3 3 0 0 1 3-3h4a4.99 4.99 0 0 1 4 2 4.992 4.992 0 0 1 4-2h4a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-6c-.768 0-1.47-.289-2-.764zM13 8.5v9a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1h-4a3 3 0 0 0-3 3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBookSolid = {
  name: 'IconBookSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.6 5.58a3.9 3.9 0 0 1 3.9-3.9h11a3.9 3.9 0 0 1 3.9 3.9v6.92a3.9 3.9 0 0 1-3.9 3.9H4.486a2.1 2.1 0 0 0 .014 4.2h14v1.8h-14a3.9 3.9 0 0 1-3.878-4.32H.6V5.58zM14 7.9H5V6.1h9v1.8zm-2 4H5v-1.8h7v1.8z" clip-rule="evenodd"/><path fill="currentColor" d="M4.5 19.4h14v-1.8h-14v1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataBookmark = {
  name: 'IconBookmark',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12.86 5.954a1 1 0 0 0-1.763-.007L9.699 8.53l-2.741.476a1 1 0 0 0-.515 1.713l1.911 1.798-.477 2.964a1 1 0 0 0 1.448 1.046l2.664-1.38 2.78 1.382a1 1 0 0 0 1.422-1.112l-.616-2.77 2.11-2.096a1 1 0 0 0-.587-1.702l-2.881-.342-1.357-2.553zm-1.938 3.679 1.05-1.94L13 9.626a.8.8 0 0 0 .612.42l2.064.244-1.542 1.53a.8.8 0 0 0-.217.742l.439 1.974-2.018-1.004a.8.8 0 0 0-.724.006l-1.968 1.02.355-2.207a.8.8 0 0 0-.242-.71l-1.345-1.265 1.941-.337a.8.8 0 0 0 .567-.407z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M20.915 4.37a3 3 0 0 0-3.022-2.854l-11.836.1a3 3 0 0 0-2.97 2.852l-.74 15.02c-.105 2.125 1.974 3.68 3.983 2.98l5.4-1.88a1 1 0 0 1 .661.001l5.266 1.861c2.011.71 4.1-.845 3.996-2.975L20.915 4.37zm-3.005-.854a1 1 0 0 1 1.007.951l.739 15.106a1 1 0 0 1-1.332.991l-5.266-1.86a3 3 0 0 0-1.987-.005l-5.399 1.88a1 1 0 0 1-1.327-.993l.739-15.02a1 1 0 0 1 .99-.95l11.836-.1z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBookmarkSolid = {
  name: 'IconBookmarkSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.138 4.666a3 3 0 0 1 2.971-2.848l11.586-.095a3 3 0 0 1 3.021 2.85l.788 15.674a2 2 0 0 1-2.648 1.992l-6.215-2.136A2 2 0 0 0 9.35 20.1l-6.361 2.155a2 2 0 0 1-2.64-1.995l.79-15.594zm4.264 4.685a.6.6 0 0 0-.307 1.032l1.79 1.653-.458 2.795a.6.6 0 0 0 .865.632l2.555-1.301 2.637 1.288a.6.6 0 0 0 .848-.671l-.581-2.57 2.002-1.953a.6.6 0 0 0-.35-1.025l-2.712-.317-1.325-2.448a.6.6 0 0 0-1.054-.004l-1.35 2.452-2.56.437z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataBooksBookmark = {
  name: 'IconBooksBookmark',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6 2.15a3.85 3.85 0 0 0-2.83 6.461 3.85 3.85 0 0 0 0 6.778A3.85 3.85 0 0 0 6 21.85h15.35a1.217 1.217 0 0 0 1.043-1.846L21.183 18l1.21-2.004a1.217 1.217 0 0 0-1.043-1.846h-.862a1.247 1.247 0 0 0-.048-.092L19.265 12l1.045-1.83c.06-.105.104-.212.134-.32h.67a1.35 1.35 0 0 0 1.156-2.047L21.183 6l1.21-2.004A1.217 1.217 0 0 0 21.35 2.15H6zm-.4 5.963V7a1.8 1.8 0 0 1 1.8-1.8h3A1.8 1.8 0 0 1 12.2 7v1.15h8.295l-.89-1.476a1.306 1.306 0 0 1 0-1.348l.89-1.476H6a2.15 2.15 0 0 0-.4 4.263zm0 1.737H5a2.15 2.15 0 0 0 0 4.3h13.535l-.856-1.499a1.315 1.315 0 0 1 0-1.302l.856-1.499H12.2v2.85a1 1 0 0 1-1.387.921L8.9 12.818l-1.913.803A1 1 0 0 1 5.6 12.7V9.85zM3.85 18A2.15 2.15 0 0 1 6 15.85h14.495l-.77 1.274a1.695 1.695 0 0 0 0 1.752l.77 1.274H6A2.15 2.15 0 0 1 3.85 18zM10.4 6.8c.11 0 .2.09.2.2v4.796l-1.7-.714-1.7.714V7c0-.11.09-.2.2-.2h3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBooksBookmarkSolid = {
  name: 'IconBooksBookmarkSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 2.15a3.85 3.85 0 0 0-2.83 6.461 3.85 3.85 0 0 0 0 6.778A3.85 3.85 0 0 0 5 21.85h15.35a1.217 1.217 0 0 0 1.043-1.846L20.183 18l1.21-2.004a1.217 1.217 0 0 0-1.043-1.846h-.862a1.267 1.267 0 0 0-.048-.092L18.265 12l1.045-1.83c.06-.104.104-.212.134-.32h.67a1.35 1.35 0 0 0 1.156-2.047L20.183 6l1.21-2.004A1.217 1.217 0 0 0 20.35 2.15H5zM9.4 5.2A1.8 1.8 0 0 1 11.2 7v5.699a1 1 0 0 1-1.387.922L7.9 12.818l-1.913.803a1 1 0 0 1-1.387-.922V7a1.8 1.8 0 0 1 1.8-1.8h3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataBox = {
  name: 'IconBox',
  content: '<path fill="currentColor" d="M12.5 17.5h6v-2h-6v2z"/><path fill="currentColor" fill-rule="evenodd" d="M7.765 2a5 5 0 0 0-4.288 2.428L1.642 7.486a.995.995 0 0 0-.142.53V17a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5V8.016a.996.996 0 0 0-.143-.53l-1.834-3.058A5 5 0 0 0 16.235 2h-8.47zm12.569 6-1.526-2.543A3 3 0 0 0 16.235 4H13v4h7.334zM11 8V4H7.765a3 3 0 0 0-2.573 1.457L3.666 8H11zm-7.5 9v-7h17v7a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBoxSolid = {
  name: 'IconBoxSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.835 2h8.332a4 4 0 0 1 3.482 2.03l2.803 4.955a.01.01 0 0 1-.01.015h.015v9a4 4 0 0 1-4 4H4.544a4 4 0 0 1-4-4V9h.02a.01.01 0 0 1-.009-.015l2.797-4.952A4 4 0 0 1 6.835 2zM6.53 4a1.5 1.5 0 0 0-1.33.805L3.949 7.202a.5.5 0 0 0 .444.731h5.624V4H6.531zm5.454 0v3.933h5.896a.5.5 0 0 0 .442-.733l-1.27-2.401A1.5 1.5 0 0 0 15.729 4h-3.743zM11.5 17.5h6v-2h-6v2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataBrush = {
  name: 'IconBrush',
  content: '<path fill="currentColor" d="m22.49 21.69-1.437-8.144h.485c.39 0 .705-.31.705-.693V7.736a.697.697 0 0 0-.705-.693h-6.666v-4.85a.697.697 0 0 0-.704-.693H9.832c-.39 0-.704.31-.704.693v4.85H2.462c-.39 0-.705.31-.705.693v5.117c0 .384.315.693.705.693h.485L1.511 21.69a.697.697 0 0 0 .694.81h19.59a.691.691 0 0 0 .694-.81zM3.653 8.909h7.37V3.366h1.952v5.543h7.37v2.771H3.654V8.91zm12.681 11.726v-4.158a.216.216 0 0 0-.216-.213h-1.3a.216.216 0 0 0-.218.213v4.158H9.4v-4.158a.216.216 0 0 0-.217-.213h-1.3a.216.216 0 0 0-.217.213v4.158H3.622l1.222-6.93h14.31l1.222 6.93h-4.04z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBuilding = {
  name: 'IconBuilding',
  content: '<path fill="currentColor" d="M13.575 14.1h-7.35v2h7.35v-2zm-7.35-5.5h7.35v2h-7.35v-2z"/><path fill="currentColor" fill-rule="evenodd" d="M1.5 5.5a4 4 0 0 1 4-4h8.8a4 4 0 0 1 4 4v17H5.5a4 4 0 0 1-4-4v-13zm4-2h8.8a2 2 0 0 1 2 2v15H5.5a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2z" clip-rule="evenodd"/><path fill="currentColor" d="M18.3 11.95h1.15a1 1 0 0 1 1 1v6.5a1 1 0 0 1-1 1H18.3v2h1.15a3 3 0 0 0 3-3v-6.5a3 3 0 0 0-3-3H18.3v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBuildingSolid = {
  name: 'IconBuildingSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4.5 1.5a4 4 0 0 0-4 4v13a4 4 0 0 0 4 4h12.8v-17a4 4 0 0 0-4-4H4.5zm8.075 7.1h-7.35v2h7.35v-2zm0 5.5h-7.35v2h7.35v-2z" clip-rule="evenodd"/><path fill="currentColor" d="M17.3 11.95h1.15a1 1 0 0 1 1 1v6.5a1 1 0 0 1-1 1H17.3v2h1.15a3 3 0 0 0 3-3v-6.5a3 3 0 0 0-3-3H17.3v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataBulb = {
  name: 'IconBulb',
  content: '<path fill="currentColor" d="M12.253 5.536 8.548 9.703c-.687.774-.138 1.997.897 1.997h3.478l-2.455 3.076 1.564 1.248 3.49-4.376c.628-.785.068-1.948-.937-1.948h-3.358l2.52-2.836-1.494-1.328z"/><path fill="currentColor" fill-rule="evenodd" d="M2.5 10.5a9.5 9.5 0 1 1 14.556 8.044c-.029.018-.088.07-.15.211-.064.142-.11.33-.13.544l-.1 1A3 3 0 0 1 13.69 23h-3.38a3 3 0 0 1-2.985-2.701l-.1-1a1.822 1.822 0 0 0-.13-.544c-.063-.14-.122-.193-.152-.211A9.494 9.494 0 0 1 2.5 10.5zM12 3a7.5 7.5 0 0 0-3.99 13.852c.575.362.882.922 1.046 1.448h5.888c.164-.526.471-1.086 1.047-1.448A7.5 7.5 0 0 0 12 3zm-1.69 18a1 1 0 0 1-.995-.9h5.37a1 1 0 0 1-.995.9h-3.38z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBulbDash = {
  name: 'IconBulbDash',
  content: '<path fill="currentColor" d="m7.678 20.392-.98.196.98-.196zm6.644 0 .98.196-.98-.196zm-7.066-.995-.411.911.411-.911zm.297.367.98-.196-.98.196zm7.19-.367-.411-.912.412.912zm-.296.367-.98-.196.98.196zM19.1 11.1a8.102 8.102 0 0 1-4.768 7.385l.823 1.823A10.102 10.102 0 0 0 21.1 11.1h-2zM11 3a8.1 8.1 0 0 1 8.1 8.1h2C21.1 5.522 16.578 1 11 1v2zm-8.1 8.1A8.1 8.1 0 0 1 11 3V1C5.422 1 .9 5.522.9 11.1h2zm4.768 7.385A8.102 8.102 0 0 1 2.9 11.1h-2c0 4.098 2.441 7.625 5.945 9.208l.823-1.823zm.991 1.711-.126-.628-1.96.392.125.628 1.961-.392zm.98.804a1 1 0 0 1-.98-.804l-1.961.392A3 3 0 0 0 9.64 23v-2zm2.721 0H9.64v2h2.72v-2zm.981-.804a1 1 0 0 1-.98.804v2a3 3 0 0 0 2.941-2.412l-1.961-.392zm.126-.628-.126.628 1.961.392.126-.628-1.961-.392zm-6.622.74a.484.484 0 0 1-.273-.348l1.961-.392a1.516 1.516 0 0 0-.865-1.083l-.823 1.823zm7.487-1.823a1.52 1.52 0 0 0-.865 1.083l1.96.392a.484.484 0 0 1-.271.348l-.824-1.823z"/><path stroke="currentColor" stroke-width="2" d="M11 8v7"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataBulbDashSolid = {
  name: 'IconBulbDashSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.9 11.1C.9 5.522 5.422 1 11 1c5.578 0 10.1 4.522 10.1 10.1a10.1 10.1 0 0 1-5.721 9.104l-.077.384A3 3 0 0 1 12.36 23H9.64a3 3 0 0 1-2.942-2.412l-.077-.384A10.1 10.1 0 0 1 .9 11.1zM10 8v7h2V8h-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataBulbSolid = {
  name: 'IconBulbSolid',
  content: '<path fill="currentColor" d="M7.861 20.11c2.687.89 5.591.89 8.278 0l-.109 1.09a2 2 0 0 1-1.99 1.8H9.96a2 2 0 0 1-1.99-1.801l-.109-1.088z"/><path fill="currentColor" fill-rule="evenodd" d="M16.931 18.296a9.35 9.35 0 1 0-9.862 0 11.781 11.781 0 0 0 9.862 0zm-4.678-12.76L8.548 9.703c-.687.774-.138 1.997.897 1.997h3.478l-2.455 3.076 1.564 1.248 3.49-4.376c.628-.786.068-1.948-.937-1.948h-3.358l2.52-2.836-1.494-1.328z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBulbTrendSolid = {
  name: 'IconBulbTrendSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M21.35 10.35a9.344 9.344 0 0 1-4.42 7.946 11.781 11.781 0 0 1-9.861 0 9.35 9.35 0 1 1 14.28-7.946zM17.128 6.6h-4.873a.347.347 0 0 0-.264.573l1.265 1.476-1.486 1.467-.67-.703a1.247 1.247 0 0 0-1.797-.01L6.5 12.283v2.58l3.694-3.793.661.695a1.247 1.247 0 0 0 1.78.028l2.851-2.814 1.881-1.78a.347.347 0 0 0-.238-.599z" clip-rule="evenodd"/><path fill="currentColor" d="M16.138 20.11a13.183 13.183 0 0 1-8.278 0l.11 1.089A2 2 0 0 0 9.96 23h4.08a2 2 0 0 0 1.99-1.801l.108-1.088z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBullseye = {
  name: 'IconBullseye',
  content: '<path fill="currentColor" d="M3 13a9 9 0 1 1 14.503 7.122l1.223 1.583A10.982 10.982 0 0 0 23 13c0-6.075-4.925-11-11-11S1 6.925 1 13c0 3.542 1.674 6.693 4.274 8.705l1.223-1.583A8.985 8.985 0 0 1 3 13z"/><path fill="currentColor" d="M6.5 13a5.5 5.5 0 1 1 8.863 4.352l1.223 1.583a7.5 7.5 0 1 0-9.172 0l1.223-1.583A5.49 5.49 0 0 1 6.5 13z"/><path fill="currentColor" d="M12 11.5a1.5 1.5 0 0 0-.917 2.687L9.86 15.77a3.5 3.5 0 1 1 4.28 0l-1.223-1.583A1.5 1.5 0 0 0 12 11.5z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBullseyeHit = {
  name: 'IconBullseyeHit',
  content: '<path fill-rule="evenodd" d="M12 0c.495 0 .994.037 1.52.107l.401.06-.319 1.974A9.971 9.971 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10a9.4 9.4 0 0 0-.09-1.262l-.051-.34 1.974-.32c.11.678.167 1.303.167 1.922 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12S5.372 0 12 0ZM9.88 5.617l.535 1.927a4.905 4.905 0 0 0 1.316 9.627 4.905 4.905 0 0 0 4.648-3.34l.066-.213 1.923.55A6.903 6.903 0 1 1 9.636 5.69l.245-.073Zm7.398-4.189a1.1 1.1 0 0 1 1.86.582l.437 2.413 2.414.438a1.1 1.1 0 0 1 .902 1.159l-.015.12a1.1 1.1 0 0 1-.305.58l-3.942 3.942-4.185.307-2.006 2.006-1.414-1.414 2.004-2.005.309-4.186Zm.199 2.629-2.2 2.2-.196 2.66 2.66-.196 2.2-2.2-2.086-.377-.378-2.087Z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataBullseyeHitSolid = {
  name: 'IconBullseyeHitSolid',
  content: '<path fill="currentColor" d="m15.609 5.543-1.65 1.65-.121 1.645.325.325 1.643-.121 1.65-1.65-1.564-.284-.283-1.565z"/><path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm12.504-5.472L12.3 9.285l-2.008 2.008 1.414 1.414 2.008-2.008 2.758-.202 2.922-2.923a.85.85 0 0 0-.449-1.437l-1.763-.32-.32-1.763a.85.85 0 0 0-1.437-.45l-2.922 2.924zm-3.04-.492A6.095 6.095 0 0 0 5 11.907 6.095 6.095 0 0 0 11.098 18a6.1 6.1 0 0 0 5.863-4.416l-1.922-.55A4.1 4.1 0 0 1 7 11.907a4.095 4.095 0 0 1 2.998-3.943l-.535-1.928z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCalendar = {
  name: 'IconCalendar',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M9 1.5H7V3h-.5a5 5 0 0 0-5 5v9.4a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5H17V1.5h-2V3H9V1.5zM15 5H9v1.5H7V5h-.5a3 3 0 0 0-3 3v.5h17V8a3 3 0 0 0-3-3H17v1.5h-2V5zm5.5 5.5h-17v6.9a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-6.9z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCalendarCny = {
  name: 'IconCalendarCny',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M9 3V1.5H7V3h-.5a5 5 0 0 0-5 5v9.4a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5H17V1.5h-2V3H9zm6 3.5V5H9v1.5H7V5h-.5a3 3 0 0 0-3 3v9.4a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H17v1.5h-2zm-4.15 5.2-2.4-3.2h2L12 10.567 13.55 8.5h2l-2.4 3.2h2.55v1.6h-2.9v.9h2.9v1.6h-2.9v2h-1.6v-2H8.3v-1.6h2.9v-.9H8.3v-1.6h2.55z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCalendarCnySolid = {
  name: 'IconCalendarCnySolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.5 3H6V1.5h2V3h6V1.5h2V3h.5a5 5 0 0 1 5 5v9.4a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5zm4.35 8.7-2.4-3.2h2L11 10.567 12.55 8.5h2l-2.4 3.2h2.55v1.6h-2.9v.9h2.9v1.6h-2.9v2h-1.6v-2H7.3v-1.6h2.9v-.9H7.3v-1.6h2.55z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCalendarHeart = {
  name: 'IconCalendarHeart',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M15.648 12.316c-.631-.728-1.378-.951-2.031-.912a2.49 2.49 0 0 0-1.316.471 3.716 3.716 0 0 0-.31.284 5.765 5.765 0 0 0-.281-.26c-.372-.327-.94-.503-1.506-.48-.613.024-1.282.28-1.823.89-.808.911-.993 2.595-.03 3.816.712.903 1.781 1.945 2.45 2.571a1.752 1.752 0 0 0 2.397.002c.675-.63 1.76-1.68 2.47-2.568.323-.402.562-1.035.619-1.683.058-.664-.067-1.472-.639-2.131zm-2.983 1.461c.207-.23.513-.556.62-.64-.001 0 0 0 0 0a.957.957 0 0 1 .428-.135c.18-.011.436.028.727.363.204.235.286.565.253.943-.035.394-.183.71-.273.822-.633.79-1.64 1.77-2.313 2.399a.152.152 0 0 1-.212 0c-.665-.623-1.657-1.594-2.287-2.394-.468-.593-.341-1.413-.03-1.764.237-.266.487-.346.69-.354a.818.818 0 0 1 .28.036c.063.02.094.04.101.045l.002.001.014.013.017.014c.124.101.368.358.57.57l.095.1a.898.898 0 0 0 1.318-.019z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M8.9 1.1v1.5h6.2V1.1h1.8v1.5h.6a4.9 4.9 0 0 1 4.9 4.9v10a4.9 4.9 0 0 1-4.9 4.9h-11a4.9 4.9 0 0 1-4.9-4.9v-10a4.9 4.9 0 0 1 4.9-4.9h.6V1.1h1.8zm6.2 3.3v1.5h1.8V4.4h.6a3.1 3.1 0 0 1 3.1 3.1v.4H3.4v-.4a3.1 3.1 0 0 1 3.1-3.1h.6v1.5h1.8V4.4h6.2zM3.4 9.7h17.2v7.8a3.1 3.1 0 0 1-3.1 3.1h-11a3.1 3.1 0 0 1-3.1-3.1V9.7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCalendarHeartSolid = {
  name: 'IconCalendarHeartSolid',
  content: '<path fill="currentColor" d="M7.9 2.6V1.1H6.1v1.5h-.6A4.9 4.9 0 0 0 .6 7.5h20.8a4.9 4.9 0 0 0-4.9-4.9h-.6V1.1h-1.8v1.5H7.9zm4.385 10.537c-.107.084-.413.41-.62.64a.898.898 0 0 1-1.317.02l-.095-.1c-.203-.213-.446-.47-.57-.57l-.018-.015-.014-.013h-.002a.416.416 0 0 0-.1-.046.818.818 0 0 0-.28-.036c-.204.008-.454.088-.69.354-.312.351-.438 1.171.029 1.764.63.8 1.622 1.77 2.287 2.394.06.057.15.058.212 0 .673-.63 1.68-1.61 2.313-2.4.09-.111.239-.427.273-.821.033-.378-.048-.708-.253-.943-.29-.335-.546-.374-.726-.364a.958.958 0 0 0-.428.136h-.001z"/><path fill="currentColor" fill-rule="evenodd" d="M21.4 9.3H.6v8.2a4.9 4.9 0 0 0 4.9 4.9h11a4.9 4.9 0 0 0 4.9-4.9V9.3zm-8.783 2.104c.654-.04 1.4.184 2.032.912.571.659.696 1.466.638 2.13-.057.65-.296 1.281-.618 1.684-.712.889-1.795 1.938-2.47 2.568a1.752 1.752 0 0 1-2.398-.002c-.669-.626-1.738-1.668-2.45-2.57-.962-1.223-.777-2.906.03-3.817.542-.61 1.21-.866 1.824-.89.566-.023 1.134.152 1.505.48.082.069.18.161.28.26.113-.112.223-.215.311-.284a2.49 2.49 0 0 1 1.316-.47z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCalendarSolid = {
  name: 'IconCalendarSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6 3h-.5a5 5 0 0 0-5 5v.5h21V8a5 5 0 0 0-5-5H16V1.5h-2V3H8V1.5H6V3zM.5 17.4v-6.9h21v6.9a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCamera = {
  name: 'IconCamera',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7.2 12a4.8 4.8 0 1 1 9.6 0 4.8 4.8 0 0 1-9.6 0zM12 9.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6z" clip-rule="evenodd"/><path fill="currentColor" d="M18.1 8.5a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2z"/><path fill="currentColor" fill-rule="evenodd" d="M8.357 2.5h7.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C23 7.9 23 8.773 23 9.857v4.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487-.708.058-1.582.058-2.666.058H8.357c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.961-.487a5 5 0 0 1-2.185-2.185c-.302-.592-.428-1.232-.487-1.961C1 16.1 1 15.227 1 14.143V9.857c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 3.73 3.044c.592-.302 1.233-.428 1.961-.487C6.4 2.5 7.273 2.5 8.357 2.5zM5.854 4.551c-.605.05-.953.142-1.216.276a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216C3.001 7.971 3 8.764 3 9.9v4.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h7.2c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546V9.9c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311c-.263-.134-.611-.226-1.216-.276-.617-.05-1.41-.051-2.546-.051H8.4c-1.137 0-1.929 0-2.546.051z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCameraAdd = {
  name: 'IconCameraAdd',
  content: '<path fill="currentColor" d="M7.842 3.753a1 1 0 0 1 .894-.553h4.528a1 1 0 0 1 .894.553l.671 1.341A2 2 0 0 0 16.618 6.2H18a2 2 0 0 1 2 2v5.4a5.524 5.524 0 0 1 2 1.737V8.2a4 4 0 0 0-4-4h-1.382l-.67-1.342A3 3 0 0 0 13.263 1.2H8.736a3 3 0 0 0-2.683 1.658L5.382 4.2H4a4 4 0 0 0-4 4v9a4 4 0 0 0 4 4h8.707a5.466 5.466 0 0 1-.663-2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h1.382a2 2 0 0 0 1.789-1.106l.67-1.341z"/><path fill="currentColor" d="M16.585 17.585V14.63h1.8v2.955H21.4v1.8h-3.015V22.4h-1.8v-3.015H13.63v-1.8h2.955z"/><path fill="currentColor" fill-rule="evenodd" d="M11 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCameraAddSolid = {
  name: 'IconCameraAddSolid',
  content: '<path fill="currentColor" d="M6.053 2.858A3 3 0 0 1 8.736 1.2h4.528a3 3 0 0 1 2.683 1.658l.671 1.342H18a4 4 0 0 1 4 4v7.137A5.493 5.493 0 0 0 17.5 13a5.48 5.48 0 0 0-2.96.863 4 4 0 1 0-1.677 1.677A5.474 5.474 0 0 0 12 18.5c0 .981.257 1.902.707 2.7H4a4 4 0 0 1-4-4v-9a4 4 0 0 1 4-4h1.382l.67-1.342z"/><path fill="currentColor" d="M11 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm5.585 4.63v2.955H13.63v1.8h2.955V22.4h1.8v-3.015H21.4v-1.8h-3.015V14.63h-1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCameraSolid = {
  name: 'IconCameraSolid',
  content: '<path fill="currentColor" d="M11 9.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6z"/><path fill="currentColor" fill-rule="evenodd" d="M7.357 2.5h7.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C22 7.9 22 8.773 22 9.857v4.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487-.708.058-1.582.058-2.666.058H7.357c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.961-.487A5 5 0 0 1 .545 18.77c-.302-.592-.428-1.232-.487-1.961C0 16.1 0 15.227 0 14.143V9.857C0 8.773 0 7.9.058 7.191c.06-.728.185-1.369.487-1.96A5 5 0 0 1 2.73 3.044c.592-.302 1.233-.428 1.961-.487C5.4 2.5 6.273 2.5 7.357 2.5zM18.2 7.4a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0zM6.2 12a4.8 4.8 0 1 1 9.6 0 4.8 4.8 0 0 1-9.6 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCar = {
  name: 'IconCar',
  content: '<path fill="currentColor" d="M9 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm7.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/><path fill="currentColor" fill-rule="evenodd" d="M4.337 3.877A3 3 0 0 1 7.118 2h9.704a3 3 0 0 1 2.771 1.851L20.898 7H23v2h-1.273l.273.658V17a3.001 3.001 0 0 1-2 2.83V22h-2v-2H6v2H4v-2.17A3.001 3.001 0 0 1 2 17V9.663L2.268 9H1V7h2.075l1.262-3.123zM7.118 4a1 1 0 0 0-.927.626L4.425 9h15.137l-1.816-4.383A1 1 0 0 0 16.822 4H7.118zM20 11H4v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCarSolid = {
  name: 'IconCarSolid',
  content: '<path fill="currentColor" d="M3.337 3.877A3 3 0 0 1 6.118 2h9.704a3 3 0 0 1 2.771 1.851L19.898 7H22v2H0V7h2.075l1.262-3.123z"/><path fill="currentColor" fill-rule="evenodd" d="M1 11v6c0 1.306.835 2.418 2 2.83V22h2v-2h12v2h2v-2.17A3.001 3.001 0 0 0 21 17v-6H1zm5.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCardSolid = {
  name: 'IconCardSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M18 2H6a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h12a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5zM5 16.762c0-.42.341-.762.762-.762h12.476c.42 0 .762.341.762.762v.476c0 .42-.341.762-.762.762H5.762A.762.762 0 0 1 5 17.238v-.476zM5.762 11a.762.762 0 0 0-.762.762v.476c0 .42.341.762.762.762h3.81c.42 0 .761-.341.761-.762v-.476A.762.762 0 0 0 9.571 11h-3.81z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCaretDown = {
  name: 'IconCaretDown',
  content: '<path fill="currentColor" d="M4.688 7.5a.8.8 0 0 0-.619 1.307l7.002 8.558a1.2 1.2 0 0 0 1.858 0l7.002-8.558a.8.8 0 0 0-.62-1.307H4.689z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCaretLeft = {
  name: 'IconCaretLeft',
  content: '<path fill="currentColor" d="M16.5 4.688a.8.8 0 0 0-1.307-.619l-8.558 7.002a1.2 1.2 0 0 0 0 1.858l8.558 7.002a.8.8 0 0 0 1.307-.62V4.689z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCaretRight = {
  name: 'IconCaretRight',
  content: '<path fill="currentColor" d="M7.5 4.688a.8.8 0 0 1 1.307-.619l8.558 7.002a1.2 1.2 0 0 1 0 1.858L8.807 19.93a.8.8 0 0 1-1.307-.62V4.689z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCaretUp = {
  name: 'IconCaretUp',
  content: '<path fill="currentColor" d="M4.688 16.5a.8.8 0 0 1-.619-1.307l7.002-8.558a1.2 1.2 0 0 1 1.858 0l7.002 8.558a.8.8 0 0 1-.62 1.307H4.689z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCaretsOpposite = {
  name: 'IconCaretsOpposite',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.054 12.774a1 1 0 0 0 0-1.548l-8.42-6.89A1 1 0 0 0 1 5.11v13.78a1 1 0 0 0 1.633.774l8.421-6.89zm1.892 0a1 1 0 0 1 0-1.548l8.42-6.89A1 1 0 0 1 23 5.11v13.78a1 1 0 0 1-1.633.774l-8.421-6.89z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 25 24'
  },
  width: 25,
  height: 24
};

var dataCellphone = {
  name: 'IconCellphone',
  content: '<path fill="currentColor" d="M12 20a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4z"/><path fill="currentColor" fill-rule="evenodd" d="M3.7 6a5 5 0 0 1 5-5h6.6a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5H8.7a5 5 0 0 1-5-5V6zm5-3a3 3 0 0 0-3 3v8.8h12.6V6a3 3 0 0 0-3-3H8.7zm-3 15v-1.4h12.6V18a3 3 0 0 1-3 3H8.7a3 3 0 0 1-3-3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCellphoneSolid = {
  name: 'IconCellphoneSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.7 1a5 5 0 0 0-5 5v8.2h16.596V16H.7v2a5 5 0 0 0 5 5h6.6a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5H5.7zM9 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 18 24'
  },
  width: 18,
  height: 24
};

var dataChat = {
  name: 'IconChat',
  content: '<path fill="currentColor" d="M6.5 7.2h11v2h-11v-2zm0 4.8v2h6v-2h-6z"/><path fill="currentColor" fill-rule="evenodd" d="M8.357 1.3c-1.084 0-1.958 0-2.666.058-.728.06-1.369.185-1.961.487A5 5 0 0 0 1.545 4.03c-.302.592-.428 1.233-.487 1.961C1 6.7 1 7.573 1 8.657v3.286c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.96a5 5 0 0 0 2.185 2.186c.659.336 1.398.46 2.278.51V20.7c0 1.582 1.75 2.538 3.081 1.682l4.794-3.082h1.76c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961C23 13.9 23 13.027 23 11.943V8.657c0-1.084 0-1.958-.058-2.666-.06-.728-.185-1.369-.487-1.961a5 5 0 0 0-2.185-2.185c-.592-.302-1.232-.428-1.961-.487C17.6 1.3 16.727 1.3 15.643 1.3H8.357zM4.638 3.627c.263-.134.611-.226 1.216-.276.617-.05 1.41-.051 2.546-.051h7.2c1.137 0 1.929 0 2.546.051.605.05.953.142 1.216.276a3 3 0 0 1 1.311 1.311c.134.263.226.611.276 1.216.05.617.051 1.41.051 2.546v3.2c0 1.137 0 1.929-.051 2.546-.05.605-.142.953-.276 1.216a3 3 0 0 1-1.311 1.311c-.263.134-.611.226-1.216.276-.617.05-1.41.051-2.546.051h-2.01a1 1 0 0 0-.54.159l-5.042 3.24v-2.405a1 1 0 0 0-.987-1c-1.374-.018-1.96-.106-2.383-.321a3 3 0 0 1-1.311-1.311c-.134-.263-.226-.611-.276-1.216C3.001 13.829 3 13.036 3 11.9V8.7c0-1.137 0-1.929.051-2.546.05-.605.142-.953.276-1.216a3 3 0 0 1 1.311-1.311z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChatSolid = {
  name: 'IconChatSolid',
  content: '<g clip-path="url(#dls-018be-a)"><path fill="currentColor" fill-rule="evenodd" d="M7.357 1.3h7.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C22 6.7 22 7.573 22 8.657v3.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487-.708.058-1.583.058-2.666.058h-1.76L8.09 22.382c-1.33.856-3.081-.1-3.081-1.682v-1.436c-.88-.049-1.62-.173-2.278-.509A5 5 0 0 1 .545 16.57c-.302-.592-.428-1.232-.487-1.961C0 13.9 0 13.027 0 11.943V8.657C0 7.573 0 6.7.058 5.991c.06-.728.185-1.369.487-1.96A5 5 0 0 1 2.73 1.844c.592-.302 1.233-.428 1.961-.487C5.4 1.3 6.273 1.3 7.357 1.3zM5.5 7.2h11v2h-11v-2zm0 4.8h6v2h-6v-2z" clip-rule="evenodd"/></g><defs><clipPath id="dls-018be-a"><path fill="currentColor" d="M0 0h22v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCheck = {
  name: 'IconCheck',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m21.042 6.855-11.34 11.17-6.398-7.178L5.096 9.25l4.72 5.294 9.542-9.399 1.684 1.71z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCheckCircle = {
  name: 'IconCheckCircle',
  content: '<path fill="currentColor" d="m17.91 9.203-1.42-1.406-5.663 5.726-2.889-3.15-1.474 1.351 4.308 4.698 7.14-7.219z"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCheckCircleSolid = {
  name: 'IconCheckCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1.229-5.578 7.14-7.219-1.422-1.406-5.663 5.726-2.89-3.15-1.473 1.351 4.308 4.698z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCheckDesktop = {
  name: 'IconCheckDesktop',
  content: '<path fill="currentColor" d="M6 8h12V6H6v2zm12 5.5h-4v-2h4v2zm-9.653 1.762 3.983-3.904-1.26-1.285-2.674 2.62-1.242-1.312-1.308 1.237 2.501 2.644z"/><path fill="currentColor" fill-rule="evenodd" d="M7.462 2.3h9.076c.808 0 1.468 0 2.006.044.555.045 1.058.142 1.526.381a3.9 3.9 0 0 1 1.705 1.704c.239.47.335.971.38 1.527.045.537.045 1.198.045 2.006v4.476c0 .808 0 1.469-.044 2.006-.046.556-.142 1.058-.381 1.526a3.9 3.9 0 0 1-1.705 1.705c-.468.239-.97.336-1.526.381-.538.044-1.198.044-2.006.044H7.462c-.808 0-1.469 0-2.006-.044-.556-.045-1.058-.142-1.527-.381a3.9 3.9 0 0 1-1.704-1.705c-.239-.468-.336-.97-.381-1.526-.044-.537-.044-1.198-.044-2.006V7.962c0-.808 0-1.469.044-2.006.045-.556.142-1.058.38-1.527A3.9 3.9 0 0 1 3.93 2.725c.47-.239.971-.336 1.527-.381C5.993 2.3 6.654 2.3 7.462 2.3zm-1.86 1.838c-.444.036-.683.103-.856.19a2.1 2.1 0 0 0-.917.919c-.088.172-.155.411-.191.856C3.6 6.558 3.6 7.145 3.6 8v4.4c0 .855 0 1.442.038 1.897.036.445.103.683.19.856a2.1 2.1 0 0 0 .918.918c.173.088.412.155.857.191.455.037 1.042.038 1.897.038h9c.855 0 1.442 0 1.897-.038.445-.036.683-.103.856-.19a2.1 2.1 0 0 0 .918-.919c.088-.173.155-.411.19-.856.038-.455.039-1.042.039-1.897V8c0-.855 0-1.442-.038-1.897-.036-.445-.103-.684-.191-.856a2.1 2.1 0 0 0-.918-.918c-.173-.088-.412-.155-.856-.191C17.942 4.1 17.355 4.1 16.5 4.1h-9c-.855 0-1.442 0-1.897.038z" clip-rule="evenodd"/><path fill="currentColor" d="M20.9 21.7H3.1v-1.8h17.8v1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCheckDesktopSolid = {
  name: 'IconCheckDesktopSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.462 2.3h9.076c.808 0 1.468 0 2.006.044.555.045 1.058.142 1.526.381a3.9 3.9 0 0 1 1.705 1.704c.239.47.335.971.38 1.527.045.537.045 1.198.045 2.006v4.476c0 .808 0 1.469-.044 2.006-.046.556-.142 1.058-.381 1.526a3.899 3.899 0 0 1-1.705 1.705c-.468.239-.97.336-1.526.381-.538.044-1.198.044-2.006.044H6.462c-.808 0-1.469 0-2.006-.044-.556-.045-1.058-.142-1.527-.381a3.9 3.9 0 0 1-1.704-1.705c-.239-.468-.336-.97-.381-1.526C.8 13.907.8 13.246.8 12.438V7.962c0-.808 0-1.469.044-2.006.045-.556.142-1.058.38-1.527A3.9 3.9 0 0 1 2.93 2.725c.47-.239.971-.336 1.527-.38C4.993 2.3 5.654 2.3 6.462 2.3zM5 8h12V6H5v2zm12 5.5h-4v-2h4v2zm-9.653 1.762 3.983-3.904-1.26-1.285-2.674 2.62-1.242-1.312-1.308 1.237 2.5 2.644z" clip-rule="evenodd"/><path fill="currentColor" d="M2.1 21.7h17.8v-1.8H2.1v1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCheckSquare = {
  name: 'IconCheckSquare',
  content: '<path fill="currentColor" d="m17.91 9.203-1.42-1.406-5.663 5.726-2.889-3.15-1.474 1.351 4.308 4.698 7.14-7.219z"/><path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCheckSquareSolid = {
  name: 'IconCheckSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.5 1.5a4 4 0 0 0-4 4v13a4 4 0 0 0 4 4h13a4 4 0 0 0 4-4v-13a4 4 0 0 0-4-4h-13zm5.271 14.922 7.14-7.219-1.422-1.406-5.663 5.726-2.89-3.15-1.473 1.351 4.308 4.698z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChevronDoubleDown = {
  name: 'IconChevronDoubleDown',
  content: '<path fill="currentColor" d="M11.293 19.707a1 1 0 0 0 1.414 0l7-7-1.414-1.414L12 17.586l-6.293-6.293-1.414 1.414 7 7z"/><path fill="currentColor" d="M11.293 12.707a1 1 0 0 0 1.414 0l7-7-1.414-1.414L12 10.586 5.707 4.293 4.293 5.707l7 7z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChevronDoubleLeft = {
  name: 'IconChevronDoubleLeft',
  content: '<path fill="currentColor" d="M4.293 11.293a1 1 0 0 0 0 1.414l7 7 1.414-1.414L6.414 12l6.293-6.293-1.414-1.414-7 7z"/><path fill="currentColor" d="m18.293 4.293-7 7a1 1 0 0 0 0 1.414l7 7 1.414-1.414L13.414 12l6.293-6.293-1.414-1.414z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChevronDoubleRight = {
  name: 'IconChevronDoubleRight',
  content: '<path fill="currentColor" d="M19.707 12.707a1 1 0 0 0 0-1.414l-7-7-1.414 1.414L17.586 12l-6.293 6.293 1.414 1.414 7-7z"/><path fill="currentColor" d="m5.707 19.707 7-7a1 1 0 0 0 0-1.414l-7-7-1.414 1.414L10.586 12l-6.293 6.293 1.414 1.414z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChevronDoubleUp = {
  name: 'IconChevronDoubleUp',
  content: '<path fill="currentColor" d="M12.707 3.793a1 1 0 0 0-1.414 0l-7 7 1.414 1.414L12 5.914l6.293 6.293 1.414-1.414-7-7z"/><path fill="currentColor" d="m19.707 17.793-7-7a1 1 0 0 0-1.414 0l-7 7 1.414 1.414L12 12.914l6.293 6.293 1.414-1.414z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChevronDown = {
  name: 'IconChevronDown',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13.709 16.406a2 2 0 0 1-2.918 0L4.02 9.184l1.458-1.368 6.771 7.222 6.77-7.222 1.46 1.368-6.771 7.222z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChevronLeft = {
  name: 'IconChevronLeft',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m2.462 12 7.222-6.77-1.368-1.46-8 7.5a1 1 0 0 0 0 1.46l8 7.5 1.368-1.46L2.462 12z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 10 24'
  },
  width: 10,
  height: 24
};

var dataChevronLeftCircle = {
  name: 'IconChevronLeftCircle',
  content: '<path fill="currentColor" d="m14.708 15.794-3.794-3.802 3.792-3.784-1.412-1.416-5.208 5.197 5.206 5.217 1.416-1.412z"/><path fill="currentColor" fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm9-11a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChevronLeftCircleSolid = {
  name: 'IconChevronLeftCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm2.708 14.794-3.794-3.802 3.793-3.784-1.413-1.416-5.208 5.197 5.206 5.217 1.416-1.412z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChevronRight = {
  name: 'IconChevronRight',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10 12a1 1 0 0 1-.316.73l-8 7.5-1.368-1.46L7.538 12 .316 5.23l1.368-1.46 8 7.5A1 1 0 0 1 10 12z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 10 24'
  },
  width: 10,
  height: 24
};

var dataChevronRightCircle = {
  name: 'IconChevronRightCircle',
  content: '<path fill="currentColor" d="m9.292 8.206 3.794 3.802-3.792 3.784 1.412 1.416 5.208-5.197-5.206-5.217-1.416 1.412z"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChevronRightCircleSolid = {
  name: 'IconChevronRightCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zM9.292 8.206l3.794 3.802-3.792 3.784 1.412 1.416 5.208-5.197-5.206-5.217-1.416 1.412z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataChevronUp = {
  name: 'IconChevronUp',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12.25 7.25a1 1 0 0 1 .73.316l7.5 8-1.46 1.368-6.77-7.222-6.77 7.222-1.46-1.368 7.5-8a1 1 0 0 1 .73-.316z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCircleExtend = {
  name: 'IconCircleExtend',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.7 5a3.4 3.4 0 1 1 6.37 1.656l1.173 1.172A4.977 4.977 0 0 1 12 7c1.02 0 1.967.305 2.757.828l1.304-1.303a3.4 3.4 0 1 1 1.383 1.445l-1.272 1.273c.523.79.828 1.738.828 2.757 0 1.02-.305 1.967-.828 2.757l1.303 1.304a3.4 3.4 0 1 1-1.445 1.383l-1.273-1.272A4.977 4.977 0 0 1 12 17a4.977 4.977 0 0 1-2.757-.828L7.97 17.444a3.4 3.4 0 1 1-1.445-1.383l1.303-1.304A4.976 4.976 0 0 1 7 12c0-1.02.305-1.967.828-2.757L6.625 8.039A3.4 3.4 0 0 1 1.7 5zm3.4-1.4a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM3.6 19.1a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0zM19.1 3.6a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8zm-1.5 15.5a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCircleExtendSolid = {
  name: 'IconCircleExtendSolid',
  content: '<path fill="currentColor" d="M4.1 1.6a3.4 3.4 0 1 0 1.525 6.44l1.203 1.203A4.977 4.977 0 0 0 6 12c0 1.02.305 1.967.828 2.757L5.525 16.06a3.4 3.4 0 1 0 1.445 1.384l1.273-1.272C9.033 16.695 9.98 17 11 17s1.967-.305 2.758-.828l1.272 1.272a3.4 3.4 0 1 0 1.445-1.383l-1.303-1.304c.523-.79.828-1.738.828-2.757 0-1.02-.305-1.967-.828-2.757l1.272-1.273a3.4 3.4 0 1 0-1.384-1.445l-1.303 1.303A4.977 4.977 0 0 0 11 7a4.977 4.977 0 0 0-2.757.828L7.07 6.656A3.4 3.4 0 0 0 4.1 1.6z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCircleRotation = {
  name: 'IconCircleRotation',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 8.6a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8zM10.4 12a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 .3a3.6 3.6 0 0 1 3.348 2.275 10.002 10.002 0 0 1 6.338 11.92 3.6 3.6 0 0 1-4.075 5.783A9.958 9.958 0 0 1 12 22a9.958 9.958 0 0 1-5.343-1.545 3.6 3.6 0 0 1-4.294-5.775A10.01 10.01 0 0 1 2 12c0-4.35 2.777-8.049 6.652-9.425A3.601 3.601 0 0 1 12 .3zm0 2a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM4 12a8.001 8.001 0 0 1 4.513-7.202 3.601 3.601 0 0 0 6.974 0 8.001 8.001 0 0 1 4.376 8.683 3.6 3.6 0 0 0-3.82 5.423A7.96 7.96 0 0 1 12.001 20a7.958 7.958 0 0 1-4.076-1.115 3.6 3.6 0 0 0-3.692-4.967A8.02 8.02 0 0 1 4 12zm15.1 3.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM3 17.5a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCircleRotationSolid = {
  name: 'IconCircleRotationSolid',
  content: '<path fill="currentColor" d="M9.596 9.596a3.4 3.4 0 1 1 4.808 4.808 3.4 3.4 0 0 1-4.808-4.808z"/><path fill="currentColor" fill-rule="evenodd" d="M15.348 2.575a3.6 3.6 0 0 0-6.696 0C4.777 3.951 2 7.65 2 12c0 .906.121 1.807.363 2.68a3.6 3.6 0 0 0 4.294 5.775A9.956 9.956 0 0 0 12 22a9.95 9.95 0 0 0 5.61-1.722 3.6 3.6 0 0 0 4.076-5.783 10.002 10.002 0 0 0-6.338-11.92zM5.22 7.75a8.001 8.001 0 0 0-.988 6.168 3.6 3.6 0 0 1 3.692 4.967A7.957 7.957 0 0 0 12 20a7.958 7.958 0 0 0 4.042-1.096 3.6 3.6 0 0 1 3.82-5.423 8 8 0 0 0-4.376-8.683 3.6 3.6 0 0 1-6.974 0A8.001 8.001 0 0 0 5.22 7.75z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataClock = {
  name: 'IconClock',
  content: '<path fill="currentColor" d="M11 6.5v5.246c0 .428.17.838.473 1.14l4.32 4.321 1.414-1.414L13 11.586V6.5h-2z"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataClockSolid = {
  name: 'IconClockSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5zm-1-16v5.246c0 .428.17.838.473 1.14l4.32 4.321 1.414-1.414L13 11.586V6.5h-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataClockwise = {
  name: 'IconClockwise',
  content: '<path fill="currentColor" d="M12.138 1.2C6.1 1.2 1.2 6.076 1.2 12.1S6.1 23 12.138 23a10.94 10.94 0 0 0 10.193-6.94l-1.863-.729A8.94 8.94 0 0 1 12.138 21C7.198 21 3.2 17.012 3.2 12.1c0-4.912 3.998-8.9 8.938-8.9 2.406 0 4.59.946 6.197 2.487l-1.327.767a.5.5 0 0 0 .047.89l4.076 1.804a.5.5 0 0 0 .698-.391l.6-4.504a.5.5 0 0 0-.745-.5l-1.559.9A10.927 10.927 0 0 0 12.138 1.2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCloudUploadSolid = {
  name: 'IconCloudUploadSolid',
  content: '<g clip-path="url(#dls-44b52-a)"><path fill="currentColor" fill-rule="evenodd" d="M18.5 20c-.169 0-.335-.008-.5-.022V20H5a5 5 0 0 1-1-9.9V10a8 8 0 0 1 15.96-.804A5.5 5.5 0 0 1 18.5 20zm-1.088-9.574-3.935-3.544a2 2 0 0 0-2.73.05l-3.661 3.545 1.391 1.437 2.66-2.576V16.5h2V9.268l2.937 2.644 1.338-1.486z" clip-rule="evenodd"/></g><defs><clipPath id="dls-44b52-a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCnyCircle = {
  name: 'IconCnyCircle',
  content: '<path fill="currentColor" d="m12 9.481-2.747-3.14L7.747 7.66 9.797 10H7.5v2H11v1.5H7.5v2H11v2.4h2v-2.4h3.5v-2H13V12h3.5v-2h-2.296l2.049-2.341-1.506-1.317L12 9.482z"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCnyCircleSolid = {
  name: 'IconCnyCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm11-2.519-2.747-3.14L6.747 7.66 8.797 10H6.5v2H10v1.5H6.5v2H10v2.4h2v-2.4h3.5v-2H12V12h3.5v-2h-2.296l2.049-2.341-1.506-1.317L11 9.482z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCnyRefund = {
  name: 'IconCnyRefund',
  content: '<g clip-path="url(#dls-b21bf-a)"><path stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M2.74 11.241c.135-3.278 1.861-6.362 4.854-8.024 4.652-2.584 10.605-.753 13.294 4.09 2.69 4.842 1.1 10.863-3.554 13.447-3.573 1.985-7.913 1.365-10.952-1.223"/><path fill="currentColor" fill-rule="evenodd" d="M2.274 14.472a.5.5 0 0 0 .8-.01l1.946-2.667A.5.5 0 0 0 4.616 11h-4a.5.5 0 0 0-.396.805l2.054 2.667z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="2" d="m15.8 7-3.5 4-3.5-4m-1 4h9m-4.5-.6v7.5m-4.5-3.4h9"/></g><defs><clipPath id="dls-b21bf-a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCnyWallet = {
  name: 'IconCnyWallet',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.4 2a4 4 0 0 0-4 4v13a4 4 0 0 0 4 4h11.5a4 4 0 0 0 4-4V9.5a4 4 0 0 0-2.176-3.561A5.302 5.302 0 0 0 14.6 2H6.4zm10.966 3.5A3.297 3.297 0 0 0 14.6 4H6.4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h11.5a2 2 0 0 0 2-2V9.5a2 2 0 0 0-2-2H8.364v-2h9.002zm-5.091 6.526L10.03 9.462l-1.229 1.076 1.673 1.912H8.6v1.633h2.859v1.224H8.6v1.633h2.859v1.96h1.633v-1.96h2.857v-1.633h-2.857v-1.224h2.857V12.45h-1.875l1.673-1.912-1.23-1.076-2.242 2.564z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCnyWalletSolid = {
  name: 'IconCnyWalletSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.4 6a4 4 0 0 1 4-4h8.2a5.302 5.302 0 0 1 5.124 3.939A4 4 0 0 1 19.9 9.5V19a4 4 0 0 1-4 4H4.4a4 4 0 0 1-4-4V6zM2 6a2.5 2.5 0 0 1 2.5-2.5h9A2.5 2.5 0 0 1 16 6H2zm6.031 3.462 2.243 2.564 2.244-2.564 1.229 1.076-1.673 1.912h1.875v1.633H11.09v1.224h2.858v1.633H11.09v1.96H9.458v-1.96H6.6v-1.633h2.858v-1.224H6.6V12.45h1.875l-1.673-1.912 1.229-1.076z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataCoin = {
  name: 'IconCoin',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11.008-5.76a1 1 0 0 1 .707.293l4.809 4.809a1 1 0 0 1 0 1.414l-4.809 4.808a1 1 0 0 1-1.414 0l-4.808-4.808a1 1 0 0 1 0-1.414L11.3 6.533a1 1 0 0 1 .707-.293zm-3.394 5.81 3.394 3.394 3.394-3.394-3.394-3.394-3.394 3.394z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCoinDiamond = {
  name: 'IconCoinDiamond',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0zm9-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM9.434 7a1.3 1.3 0 0 0-1.083.58l-2.053 3.092a1.3 1.3 0 0 0 .13 1.604l4.62 4.968a1.3 1.3 0 0 0 1.903 0l4.62-4.968a1.3 1.3 0 0 0 .131-1.604L15.65 7.58A1.3 1.3 0 0 0 14.566 7H9.434zm-1.165 4.319L9.81 9h4.382l1.54 2.319L12 15.331l-3.73-4.012z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCoinDiamondSolid = {
  name: 'IconCoinDiamondSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM9.659 8a.72.72 0 0 0-.6.322l-1.745 2.627a.72.72 0 0 0 .072.889l4.086 4.395a.72.72 0 0 0 1.055 0l4.086-4.395a.72.72 0 0 0 .073-.889L14.94 8.322a.72.72 0 0 0-.6-.322H9.66z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCoinSolid = {
  name: 'IconCoinSolid',
  content: '<path fill="currentColor" d="m11.008 15.443-3.394-3.394 3.394-3.394 3.395 3.394-3.395 3.394z"/><path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm5.493-.658a1 1 0 0 0 0 1.414l4.808 4.808a1 1 0 0 0 1.415 0l4.808-4.808a1 1 0 0 0 0-1.414l-4.809-4.809a1 1 0 0 0-1.414 0l-4.808 4.809z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataColorPalette = {
  name: 'IconColorPalette',
  content: '<path fill="currentColor" d="M10.7 8.5a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2zm-3.6 2.2a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2zm.6 2.9a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0z"/><path fill="currentColor" fill-rule="evenodd" d="M17.202 3.709c-1.63-.825-3.62-1.212-5.547-1.209-1.923.003-3.875.395-5.42 1.219C.585 6.732-.862 13.765 3.716 18.27c2.429 2.39 5.417 3.139 7.832 3.221a13.106 13.106 0 0 0 3.136-.263c.42-.09.79-.196 1.092-.31.253-.095.599-.245.839-.479a1.24 1.24 0 0 0 .36-.663 1.238 1.238 0 0 0-.088-.723c-.13-.296-.365-.534-.487-.656-.08-.08-.16-.157-.241-.236-.254-.246-.523-.506-.814-.879a1.577 1.577 0 0 1-.311-.975c.013-.327.156-.766.798-1.2.463-.313 1.485-.454 2.234.417.333.387.349.736.346 1.069v.036c-.002.076-.003.198.004.298.004.065.014.171.047.29.032.115.104.31.278.488.438.447.984.319 1.158.262.194-.063.374-.17.504-.253.931-.594 1.72-1.74 2.172-3.061.46-1.35.609-3 .132-4.688-.487-1.726-2.286-4.627-5.505-6.257zM7.176 5.484c1.187-.634 2.797-.981 4.482-.984 1.683-.003 3.349.34 4.64.993 2.682 1.358 4.137 3.785 4.484 5.016a5.906 5.906 0 0 1-.1 3.5 5.28 5.28 0 0 1-.531 1.122 3.418 3.418 0 0 0-.568-.91 3.72 3.72 0 0 0-4.871-.77c-1.135.768-1.634 1.774-1.676 2.773-.04.94.327 1.771.733 2.29.217.279.44.523.638.728l-.142.032c-.687.147-1.611.255-2.649.22-2.079-.072-4.528-.71-6.497-2.649-3.503-3.447-2.547-8.907 2.057-11.361z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataColorPaletteSolid = {
  name: 'IconColorPaletteSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.655 2.5c1.926-.003 3.917.384 5.547 1.209 3.22 1.63 5.018 4.531 5.505 6.257a7.907 7.907 0 0 1-.132 4.688c-.451 1.322-1.24 2.467-2.172 3.06-.13.084-.31.191-.504.254-.174.057-.72.185-1.158-.262a1.127 1.127 0 0 1-.278-.489 1.437 1.437 0 0 1-.047-.289 3.885 3.885 0 0 1-.005-.298v-.036c.003-.333-.012-.682-.345-1.069-.748-.87-1.771-.73-2.234-.417-.642.434-.785.873-.798 1.2-.017.388.147.765.311.975.291.373.56.633.814.879.082.079.162.156.24.236.123.122.359.36.488.656.078.177.143.43.089.724a1.24 1.24 0 0 1-.361.663c-.24.233-.586.384-.84.479a7.8 7.8 0 0 1-1.09.31c-.84.18-1.928.303-3.137.262-2.415-.082-5.403-.831-7.832-3.221C-.862 13.765.584 6.73 6.235 3.719c1.545-.824 3.497-1.216 5.42-1.219zm-.955 6a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2zm-3.6 2.2a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2zm.6 2.9a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 23 24'
  },
  width: 23,
  height: 24
};

var dataCompass = {
  name: 'IconCompass',
  content: '<path fill="currentColor" d="M13.25 12.05a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0z"/><path fill="currentColor" fill-rule="evenodd" d="M9.176 8.52a1 1 0 0 0-.656.656l-2.25 7.202a1 1 0 0 0 1.252 1.253l7.202-2.251a1 1 0 0 0 .656-.656l2.25-7.202a1 1 0 0 0-1.252-1.253L9.176 8.52zm1.097 1.753-1.525 4.88 4.88-1.526 1.524-4.88-4.88 1.526z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCompassSolid = {
  name: 'IconCompassSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M22 12c0 6.075-4.925 11-11 11S0 18.075 0 12 4.925 1 11 1s11 4.925 11 11zM7.7 9.357a1 1 0 0 1 .657-.656l6.82-2.132a1 1 0 0 1 1.254 1.253l-2.132 6.82a1 1 0 0 1-.656.657l-6.82 2.132a1 1 0 0 1-1.254-1.253l2.132-6.82zM11 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataComponent = {
  name: 'IconComponent',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 2a3 3 0 0 0-3 3v4.8a3 3 0 0 0 3 3h6.101L11.086 2H5zM4 5a1 1 0 0 1 1-1h4.089l.01 6.8H5a1 1 0 0 1-1-1V5zm15.5-3A2.5 2.5 0 0 1 22 4.5v1.8a2.5 2.5 0 0 1-2.5 2.5h-7.003l.02-6.8H19.5zm.5 2.5a.5.5 0 0 0-.5-.5h-4.99l-.007 2.8H19.5a.5.5 0 0 0 .5-.5V4.5zm2 8.5a3 3 0 0 0-3-3h-6.485l-.016 12H19a3 3 0 0 0 3-3v-6zm-3-1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-4.499l.011-8H19zM5 14a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h6.102l-.017-8H5zm-1 3a1 1 0 0 1 1-1h4.09l.008 4H5a1 1 0 0 1-1-1v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataComponentSolid = {
  name: 'IconComponentSolid',
  content: '<path fill="currentColor" d="M3 2a3 3 0 0 0-3 3v4.8a3 3 0 0 0 3 3h6.101L9.086 2H3zm14.5 0A2.5 2.5 0 0 1 20 4.5v1.8a2.5 2.5 0 0 1-2.5 2.5h-7.003l.02-6.8H17.5zm-.5 8a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-6.501l.016-12H17zM3 14a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h6.102l-.017-8H3z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataCopy = {
  name: 'IconCopy',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.2 1.7a4 4 0 0 0-4 4v.7a4 4 0 0 0-4 4V18a4 4 0 0 0 4 4h7.6a4 4 0 0 0 4-4v-.7a4 4 0 0 0 4-4V5.7a4 4 0 0 0-4-4h-7.6zm7.6 13.6a2 2 0 0 0 2-2V5.7a2 2 0 0 0-2-2h-7.6a2 2 0 0 0-2 2v.7h5.6a4 4 0 0 1 4 4v4.9zM4.2 10.4a2 2 0 0 1 2-2h7.6a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H6.2a2 2 0 0 1-2-2v-7.6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCopySolid = {
  name: 'IconCopySolid',
  content: '<path fill="currentColor" d="M8 2a4.001 4.001 0 0 0-3.929 3.246A3.986 3.986 0 0 1 5.7 4.9h7.6a4 4 0 0 1 4 4v7.6c0 .258-.024.51-.071.754A4 4 0 0 0 19.6 13.6V6a4 4 0 0 0-4-4H8z"/><path fill="currentColor" d="M.2 10.4a4 4 0 0 1 4-4h7.6a4 4 0 0 1 4 4V18a4 4 0 0 1-4 4H4.2a4 4 0 0 1-4-4v-7.6z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataCouponMinus = {
  name: 'IconCouponMinus',
  content: '<path stroke="currentColor" stroke-width="2" d="M5.5 12h9"/><path fill="currentColor" d="m7.207 2 .998-.07A1 1 0 0 0 7.207 1v1zm5.586 0V1a1 1 0 0 0-.998.93l.998.07zm0 20-.998-.07a1 1 0 0 0 .998 1.07v-1zm-5.586 0v1a1 1 0 0 0 .998-1.07l-.998.07zm0-21H5v2h2.207V1zM10 3.6a1.8 1.8 0 0 1-1.795-1.67l-1.995.14A3.8 3.8 0 0 0 10 5.6v-2zm1.795-1.67A1.8 1.8 0 0 1 10 3.6v2a3.8 3.8 0 0 0 3.79-3.53l-1.995-.14zM15 1h-2.207v2H15V1zm5 5a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3h2zm0 12V6h-2v12h2zm-5 5a5 5 0 0 0 5-5h-2a3 3 0 0 1-3 3v2zm-2.207 0H15v-2h-2.207v2zm-.993-1.2c0 .044-.002.087-.005.13l1.995.14c.007-.09.01-.18.01-.27h-2zM10 20a1.8 1.8 0 0 1 1.8 1.8h2A3.8 3.8 0 0 0 10 18v2zm-1.8 1.8A1.8 1.8 0 0 1 10 20v-2a3.8 3.8 0 0 0-3.8 3.8h2zm.005.13a1.843 1.843 0 0 1-.005-.13h-2c0 .09.003.18.01.27l1.995-.14zM5 23h2.207v-2H5v2zm-5-5a5 5 0 0 0 5 5v-2a3 3 0 0 1-3-3H0zM0 6v12h2V6H0zm5-5a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3V1z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataCouponMinusSolid = {
  name: 'IconCouponMinusSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 6a5 5 0 0 1 5-5h2.207a1 1 0 0 1 .998.93 1.8 1.8 0 0 0 3.59 0 1 1 0 0 1 .998-.93H15a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5h-2.207a1 1 0 0 1-.998-1.07 1.8 1.8 0 1 0-3.59 0A1 1 0 0 1 7.207 23H5a5 5 0 0 1-5-5V6zm5.5 7v-2h9v2h-9z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataCouponPercent = {
  name: 'IconCouponPercent',
  content: '<path fill="currentColor" d="m21 9.207.07.998a1 1 0 0 0 .93-.998h-1zm0 5.586h1a1 1 0 0 0-.93-.998l-.07.998zM1 17H0h1zm0-2.207.07-.998a1 1 0 0 0-1.07.998h1zm0-5.586H0a1 1 0 0 0 1.07.998L1 9.207zm21 0V7h-2v2.207h2zM19.4 12a1.8 1.8 0 0 1 1.67-1.795l-.14-1.995A3.8 3.8 0 0 0 17.4 12h2zm1.67 1.795A1.8 1.8 0 0 1 19.4 12h-2a3.8 3.8 0 0 0 3.53 3.79l.14-1.995zM22 17v-2.207h-2V17h2zm-5 5a5 5 0 0 0 5-5h-2a3 3 0 0 1-3 3v2zM5 22h12v-2H5v2zm-5-5a5 5 0 0 0 5 5v-2a3 3 0 0 1-3-3H0zm0-2.207V17h2v-2.207H0zm1.2-.993c-.044 0-.087-.002-.13-.005L.93 15.79c.09.007.18.01.27.01v-2zM3 12a1.8 1.8 0 0 1-1.8 1.8v2A3.8 3.8 0 0 0 5 12H3zm-1.8-1.8A1.8 1.8 0 0 1 3 12h2a3.8 3.8 0 0 0-3.8-3.8v2zm-.13.005c.043-.004.086-.005.13-.005v-2c-.09 0-.18.003-.27.01l.14 1.995zM0 7v2.207h2V7H0zm5-5a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3V2zm12 0H5v2h12V2zm5 5a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3h2z"/><path stroke="currentColor" stroke-width="2" d="m8.33 16.763 5.5-9.527"/><circle cx="9.049" cy="8.518" r="1.5" fill="currentColor" transform="rotate(30 9.049 8.518)"/><circle cx="13.111" cy="15.482" r="1.5" fill="currentColor" transform="rotate(30 13.111 15.482)"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCouponPercentSolid = {
  name: 'IconCouponPercentSolid',
  content: '<g clip-path="url(#dls-c3aef-a)"><path fill="currentColor" fill-rule="evenodd" d="M0 7a5 5 0 0 1 5-5h12a5 5 0 0 1 5 5v2.207a1 1 0 0 1-.93.998 1.8 1.8 0 0 0 0 3.59 1 1 0 0 1 .93.998V17a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5v-2.207a1 1 0 0 1 1.07-.998 1.8 1.8 0 1 0 0-3.59A1 1 0 0 1 0 9.207V7zm10.348 2.268a1.5 1.5 0 1 1-2.598-1.5 1.5 1.5 0 0 1 2.598 1.5zm2.616-2.531-5.5 9.526 1.732 1 5.5-9.526-1.732-1zm1.447 9.495a1.5 1.5 0 1 1-2.599-1.5 1.5 1.5 0 0 1 2.599 1.5z" clip-rule="evenodd"/></g><defs><clipPath id="dls-c3aef-a"><path fill="currentColor" d="M0 0h22v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCrop = {
  name: 'IconCrop',
  content: '<path fill="currentColor" d="M5 1v15a3 3 0 0 0 3 3h9.5v2H8a5 5 0 0 1-5-5V5H1V3h2V1h2z"/><path fill="currentColor" d="M23 21h-2v2h-2V8a3 3 0 0 0-3-3H6.5V3H16a5 5 0 0 1 5 5v11h2v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCropSolid = {
  name: 'IconCropSolid',
  content: '<path fill="currentColor" d="M4 1v15a3 3 0 0 0 3 3h9.5v2H7a5 5 0 0 1-5-5V5H0V3h2V1h2z"/><path fill="currentColor" d="M22 21h-2v2h-2V8a3 3 0 0 0-3-3H5.5V3H15a5 5 0 0 1 5 5v11h2v2z"/><path fill="currentColor" d="M7.2 6.2a2 2 0 0 0-2 2v7.5a2 2 0 0 0 2 2h7.5a2 2 0 0 0 2-2V8.2a2 2 0 0 0-2-2H7.2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCrown = {
  name: 'IconCrown',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M9.6 4a2.4 2.4 0 1 1 4.085 1.709l2.66 2.493 1.807-.703a2.4 2.4 0 1 1 3.302 1.705l-1.09 6.822a2 2 0 0 1-1.975 1.684H5.611a2 2 0 0 1-1.975-1.684l-1.09-6.823a2.4 2.4 0 1 1 3.271-1.576l.39-.08 1.851.656 2.314-2.44A2.394 2.394 0 0 1 9.6 4zm2.4-.6a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2zM4.564 9.152a2.41 2.41 0 0 0 .074-.038l3.087 1.092a1.455 1.455 0 0 0 1.54-.37l2.777-2.927 3.186 2.987a1.456 1.456 0 0 0 1.523.294l2.677-1.042.008.004-1.047 6.558H5.611L4.564 9.152zM2.9 7a.6.6 0 1 1 1.2 0 .6.6 0 0 1-1.2 0zm17 0a.6.6 0 1 1 1.2 0 .6.6 0 0 1-1.2 0z" clip-rule="evenodd"/><path fill="currentColor" d="M4 22h16v-2H4v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCrownSolid = {
  name: 'IconCrownSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M19 22H3v-2h16v2z" clip-rule="evenodd"/><path fill="currentColor" d="M8.6 4a2.4 2.4 0 1 1 4.085 1.709l2.66 2.493 1.807-.703a2.4 2.4 0 1 1 3.301 1.705l-1.089 6.822a2 2 0 0 1-1.975 1.684H4.611a2 2 0 0 1-1.975-1.684l-1.09-6.823a2.4 2.4 0 1 1 3.316-1.777l2.196.777 2.314-2.44A2.394 2.394 0 0 1 8.6 4z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCube = {
  name: 'IconCube',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M9.764 1.5a5 5 0 0 1 4.472 0l5 2.5A5 5 0 0 1 22 8.472v7.056A5 5 0 0 1 19.236 20l-5 2.5a5 5 0 0 1-4.472 0l-5-2.5A5 5 0 0 1 2 15.528V8.472A5 5 0 0 1 4.764 4l5-2.5zm3.578 1.789a3 3 0 0 0-2.684 0l-5 2.5c-.307.153-.58.355-.81.593L12 10.356l7.153-3.974a2.997 2.997 0 0 0-.811-.593l-5-2.5zM4 8.472c0-.09.004-.178.012-.266L11 12.088v8.768a3.025 3.025 0 0 1-.342-.145l-5-2.5A3 3 0 0 1 4 15.528V8.472zm9 12.384c.116-.04.23-.09.342-.145l5-2.5A3 3 0 0 0 20 15.528V8.472c0-.09-.004-.178-.012-.266L13 12.088v8.768z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCubeEye = {
  name: 'IconCubeEye',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13.43 1.727a4.52 4.52 0 0 0-4.52 0L3.58 4.805a4.52 4.52 0 0 0-2.26 3.914v6.154a4.52 4.52 0 0 0 2.26 3.915l7.08 4.087.006-.01a1.02 1.02 0 0 0 1.554-.869V12.4l6.751-3.897c.006.071.01.144.01.217V14h2.039V8.719a4.52 4.52 0 0 0-2.26-3.914l-5.33-3.078zm-3.25 10.488v8.029L4.6 17.02a2.48 2.48 0 0 1-1.24-2.148V8.72c0-.143.012-.283.035-.421l6.786 3.917zm-5.638-5.61.058-.034 5.33-3.078a2.48 2.48 0 0 1 2.48 0l5.33 3.078c.081.046.159.097.233.152l-6.613 3.818-6.818-3.936zm8.84 10.95C14.972 15.49 16.848 15.1 18 15.1c1.925 0 3.481 1.175 4.483 2.35.762.894.764 2.177.082 3.09-.6.803-1.26 1.408-2.037 1.805-.78.398-1.618.555-2.528.555-2.324 0-3.859-1.481-4.617-2.449a2.353 2.353 0 0 1 0-2.895zM18 16.9c-.716 0-2.01.219-3.191 1.753a.553.553 0 0 0-.01.688c.628.8 1.7 1.759 3.201 1.759.697 0 1.24-.119 1.71-.359.472-.24.932-.635 1.413-1.28a.676.676 0 0 0-.01-.844c-.84-.984-1.94-1.717-3.113-1.717zm-.04 3.625c.805 0 1.458-.662 1.458-1.478s-.653-1.478-1.459-1.478-1.459.662-1.459 1.478.653 1.478 1.46 1.478z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCubeEyeSolid = {
  name: 'IconCubeEyeSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.91 1.727a4.52 4.52 0 0 1 4.52 0l5.33 3.078a4.52 4.52 0 0 1 2.26 3.914V14h-2.04V8.719a2.63 2.63 0 0 0-.009-.218L12.22 12.4v9.597a1.02 1.02 0 0 1-1.554.869l-.006.01-7.08-4.087a4.52 4.52 0 0 1-2.26-3.915V8.72a4.52 4.52 0 0 1 2.26-3.914l5.33-3.078zm1.27 18.517v-8.029L3.396 8.298a2.481 2.481 0 0 0-.035.42v6.155a2.48 2.48 0 0 0 1.24 2.149l5.58 3.222zM4.6 6.57a.551.551 0 0 0-.058.034l6.817 3.936 6.614-3.818a2.492 2.492 0 0 0-.233-.152l-5.33-3.078a2.48 2.48 0 0 0-2.48 0L4.6 6.571z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M18 15.1c-1.152 0-3.028.39-4.618 2.456a2.353 2.353 0 0 0 0 2.895c.759.968 2.294 2.449 4.618 2.449.91 0 1.747-.157 2.527-.555.778-.397 1.437-1.002 2.038-1.806.681-.912.68-2.195-.083-3.09-1-1.174-2.558-2.349-4.482-2.349zm1.418 3.947c0 .816-.653 1.478-1.459 1.478s-1.459-.662-1.459-1.478.653-1.478 1.46-1.478c.805 0 1.458.662 1.458 1.478z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCubeSolid = {
  name: 'IconCubeSolid',
  content: '<path fill="currentColor" d="M7.764 1.5a5 5 0 0 1 4.472 0l5 2.5c.616.308 1.15.733 1.58 1.24L10 10.345 1.184 5.241c.43-.508.964-.933 1.58-1.241l5-2.5zM.223 6.995A4.995 4.995 0 0 0 0 8.472v7.056A5 5 0 0 0 2.764 20l5 2.5c.396.198.812.34 1.236.427v-10.85L.223 6.994zM11 22.927c.424-.087.84-.229 1.236-.427l5-2.5A5 5 0 0 0 20 15.528V8.472c0-.509-.077-1.006-.223-1.477L11 12.076v10.85z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataCurveSquare = {
  name: 'IconCurveSquare',
  content: '<path stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" stroke-width="2" d="M1.5 18V6a4 4 0 0 1 4-4h11a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-11a4 4 0 0 1-4-4z"/><path stroke="currentColor" stroke-width="2" d="M6 14.5c.333-.833 1.5-2.6 3.5-3 2.5-.5 5 0 6.5-3"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCurveSquareSolid = {
  name: 'IconCurveSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.5 6a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5V6zm9.196 6.48c.497-.099.994-.155 1.528-.216l.25-.028c.61-.07 1.273-.156 1.919-.335 1.368-.38 2.612-1.175 3.501-2.954l-1.788-.894c-.611 1.22-1.367 1.676-2.249 1.92-.48.134-1.003.205-1.612.276l-.237.027c-.529.06-1.117.126-1.704.243-1.247.25-2.21.92-2.894 1.619-.677.692-1.124 1.454-1.338 1.99l1.856.743c.12-.297.423-.835.912-1.334.483-.493 1.103-.906 1.856-1.057z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCustomer = {
  name: 'IconCustomer',
  content: '<circle cx="9.875" cy="6.875" r="4.125" stroke="currentColor" stroke-width="2"/><path stroke="currentColor" stroke-width="2" d="m14.275 13.982 1.431.234c.736.12 1.337.327 1.823.621a2.93 2.93 0 0 1 1.1 1.14c.226.425.35 1.58.368 2.153l.003.177c0 1.598-1.511 2.893-3.375 2.893H4.375c-1.827 0-3.316-1.245-3.373-2.799L1 18.288c0-.641.125-1.848.37-2.312a2.929 2.929 0 0 1 1.1-1.139c.487-.294 1.088-.501 1.824-.621l1.431-.234c3.122-.51 5.428-.51 8.55 0z"/><path fill="currentColor" d="M9.414 14.507a.684.684 0 0 1 1.322 0l.838 3.13a.528.528 0 0 1-.124.497l-.99 1.056a.527.527 0 0 1-.77 0l-.99-1.056a.527.527 0 0 1-.124-.497l.838-3.13z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataCustomerService = {
  name: 'IconCustomerService',
  content: '<path fill="currentColor" d="M6 10.672c0-.994-.682-1.828-1.604-2.06C5.446 5.345 8.463 3 12 3c3.52 0 6.527 2.325 7.59 5.568A2.126 2.126 0 0 0 18 10.625v2.75c0 .748.386 1.405.97 1.784a8.082 8.082 0 0 1-4.023 3.579A1.99 1.99 0 0 0 14 18.5h-3a2 2 0 1 0 0 4h3a2 2 0 0 0 2-2v-.037a10.111 10.111 0 0 0 5.138-5.18c.488-.22.88-.584 1.166-.99C22.76 13.64 23 12.81 23 12s-.24-1.64-.696-2.292a3.103 3.103 0 0 0-.5-.56C20.89 4.512 16.86 1 12 1 7.121 1 3.079 4.54 2.184 9.205a3.16 3.16 0 0 0-.488.55C1.24 10.407 1 11.236 1 12.047c0 .81.24 1.64.696 2.292.462.66 1.206 1.208 2.179 1.208A2.125 2.125 0 0 0 6 13.422v-2.75z"/><path fill="currentColor" d="M15.758 14.652a1 1 0 1 0-1.516-1.304 3.021 3.021 0 0 1-2.298 1.054 3.02 3.02 0 0 1-2.214-.96 1 1 0 0 0-1.46 1.365 5.019 5.019 0 0 0 3.674 1.595c1.525 0 2.893-.68 3.814-1.75z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCustomerSettings = {
  name: 'IconCustomerSettings',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.8 6.8a4.8 4.8 0 1 1 9.6 0 4.8 4.8 0 0 1-9.6 0zM10.6 4a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6zm9.073 11.41L21 17.688c.11.19.107.413.006.588l-1.31 2.268a.584.584 0 0 1-.512.289l-2.636-.01a.631.631 0 0 1-.541-.313l-1.328-2.278a.584.584 0 0 1-.006-.588l1.31-2.268c.1-.175.292-.29.512-.289l2.637.01c.222.001.43.121.54.313zm1.728-1.007 1.327 2.279c.469.804.472 1.793.01 2.594l-1.31 2.268a2.584 2.584 0 0 1-2.251 1.289l-2.637-.01a2.631 2.631 0 0 1-2.262-1.306l-1.327-2.279a2.584 2.584 0 0 1-.01-2.594l1.31-2.268a2.584 2.584 0 0 1 2.252-1.289l2.636.01a2.635 2.635 0 0 1 2.262 1.306zM17.8 19.4a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8zm-4.735 3.1H4.5a3.5 3.5 0 0 1-3.49-3.768l.142-1.844a3.694 3.694 0 0 1 2.837-3.313 29.738 29.738 0 0 1 9.33-.683c-.054.079-.106.16-.155.244l-.972 1.684a27.37 27.37 0 0 0-.779-.028l.644 2.404a.528.528 0 0 1-.125.497l-.756.806a.527.527 0 0 1-.77 0l-.755-.806a.527.527 0 0 1-.125-.497l.644-2.404a27.74 27.74 0 0 0-5.723.73 1.694 1.694 0 0 0-1.301 1.52l-.142 1.843A1.5 1.5 0 0 0 4.5 20.5h7.4l1.166 2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCustomerSettingsSolid = {
  name: 'IconCustomerSettingsSolid',
  content: '<g fill="currentColor" clip-path="url(#dls-a767a-a)"><path d="M9.6 2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6zm2.008 19.715H3.5a3.5 3.5 0 0 1-3.49-3.768l.142-1.844a3.694 3.694 0 0 1 2.837-3.313 29.74 29.74 0 0 1 10.002-.618 3.45 3.45 0 0 0-.827.964l-1.34 2.32-.44-1.655a.606.606 0 0 0-1.172 0L8.47 16.59a.49.49 0 0 0 .114.46l.856.917a.49.49 0 0 0 .507.133c.03.543.186 1.082.47 1.57l1.191 2.045zM18.2 18a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z"/><path fill-rule="evenodd" d="m21.728 16.682-1.327-2.279a2.632 2.632 0 0 0-2.262-1.306l-2.636-.01a2.584 2.584 0 0 0-2.252 1.289l-1.31 2.268a2.588 2.588 0 0 0 .01 2.595l1.327 2.278a2.631 2.631 0 0 0 2.262 1.306l2.637.01a2.585 2.585 0 0 0 2.251-1.289l1.31-2.268a2.584 2.584 0 0 0-.01-2.594zM20 17.688l-1.327-2.278a.631.631 0 0 0-.541-.313l-2.637-.01a.584.584 0 0 0-.512.289l-1.31 2.268a.584.584 0 0 0 .007.588l1.327 2.278a.63.63 0 0 0 .54.313l2.637.01c.22 0 .412-.114.512-.289l1.31-2.268a.585.585 0 0 0-.006-.588z" clip-rule="evenodd"/></g><defs><clipPath id="dls-a767a-a"><path fill="currentColor" d="M0 0h22v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataCustomerSolid = {
  name: 'IconCustomerSolid',
  content: '<path fill="currentColor" d="M4.75 6.875a5.125 5.125 0 1 1 10.25 0 5.125 5.125 0 0 1-10.25 0z"/><path fill="currentColor" fill-rule="evenodd" d="M14.436 12.995c-3.229-.527-5.643-.527-8.872 0l-1.432.234c-.827.135-1.558.377-2.18.753a3.932 3.932 0 0 0-1.465 1.526c-.214.403-.323.981-.384 1.418-.068.481-.103.99-.103 1.362v.008l.002.131v.011C.085 20.66 2.15 22.2 4.375 22.2h11.25c2.266 0 4.375-1.604 4.375-3.893V18.3l-.003-.194v-.01c-.01-.325-.05-.795-.117-1.245-.06-.402-.164-.96-.367-1.343a3.927 3.927 0 0 0-1.466-1.526c-.621-.377-1.352-.618-2.18-.753l-1.43-.234zm-5.022 1.512a.684.684 0 0 1 1.322 0l.838 3.13a.528.528 0 0 1-.124.497l-.99 1.056a.527.527 0 0 1-.77 0l-.99-1.056a.527.527 0 0 1-.124-.497l.838-3.13z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataCut = {
  name: 'IconCut',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m12.11 15.352 2.369 4.32c.107.261.243.508.404.736l.04.073.01-.005a3.75 3.75 0 1 0-.097-4.314l-1.523-2.774L19.575 3.17 17.87 2.125l-5.665 9.243-5.128-9.349-1.754.962 5.678 10.35-1.833 2.992a3.75 3.75 0 1 0 .139 3.6l2.802-4.571zM7.326 19.33a1.75 1.75 0 1 1 .22-.36l-.222.359.002.001zM17.95 20c-.56 0-1.057-.262-1.378-.671l-.273-.499A1.75 1.75 0 1 1 17.95 20z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataCutSolid = {
  name: 'IconCutSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m10.11 15.351 2.367 4.317c.108.264.246.513.408.743l.038.07.009-.005a3.75 3.75 0 1 0-.097-4.315l-1.522-2.774L17.575 3.17 15.87 2.125l-5.665 9.242L5.077 2.02l-1.754.962 5.678 10.35-1.833 2.992a3.75 3.75 0 1 0 .139 3.6l2.802-4.572z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataData = {
  name: 'IconData',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v6.795l-2.601-2.278a3.222 3.222 0 1 0-5.687-.643l-1.181 1.18A3.208 3.208 0 0 0 9.222 11a3.21 3.21 0 0 0-2.063.747L3.5 8.087V6.5zm0 4.415V17.5a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-1.546l-4.213-3.69a3.22 3.22 0 0 1-2.807-.33l-1.217 1.218a3.222 3.222 0 1 1-6.18.347L3.5 10.915zm12.945-1.693a1.222 1.222 0 1 0-2.445 0 1.222 1.222 0 0 0 2.445 0zM9.222 13a1.222 1.222 0 1 1 0 2.445 1.222 1.222 0 0 1 0-2.445z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataDataMarket = {
  name: 'IconDataMarket',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3.064 2.838A2 2 0 0 1 4.952 1.5h14.097a2 2 0 0 1 1.887 1.338l1.299 3.703c.965 2.753-.852 5.959-3.84 5.959-1.253 0-2.337-.593-3.07-1.503-.731.91-1.811 1.503-3.066 1.503h-.52c-1.255 0-2.335-.593-3.066-1.503-.733.91-1.817 1.503-3.07 1.503C2.616 12.5.8 9.295 1.765 6.544l1.3-3.706zm6.611 5.287c0 1.405 1.013 2.375 2.064 2.375h.52c1.05 0 2.063-.97 2.063-2.375a1 1 0 1 1 2 0c0 1.4 1.02 2.375 2.074 2.375 1.351 0 2.55-1.592 1.951-3.297L19.05 3.5H4.951L3.653 7.205c-.598 1.705.6 3.295 1.95 3.295 1.054 0 2.072-.974 2.072-2.375a1 1 0 0 1 2 0z" clip-rule="evenodd"/><path fill="currentColor" d="M5.5 13.5v5a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-5h2v5a4 4 0 0 1-4 4h-9a4 4 0 0 1-4-4v-5h2z"/><path fill="currentColor" d="m13.267 18.706 3.57-3.57-1.274-1.272-2.43 2.43-2.5-2-3.57 3.57 1.273 1.272 2.43-2.43 2.5 2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataDataMarketSolid = {
  name: 'IconDataMarketSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3.951 1.5a2 2 0 0 0-1.887 1.338L.765 6.544C.057 8.564.848 10.829 2.5 11.89v6.61a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4v-6.611c1.652-1.062 2.443-3.327 1.735-5.348l-1.299-3.703A2 2 0 0 0 18.05 1.5H3.95zm13.445 9c1.35 0 2.55-1.592 1.951-3.297L18.05 3.5H3.95L2.653 7.205c-.598 1.705.6 3.295 1.95 3.295 1.054 0 2.072-.974 2.072-2.375a1 1 0 0 1 2 0c0 1.405 1.013 2.375 2.064 2.375h.52c1.05 0 2.063-.97 2.063-2.375a1 1 0 1 1 2 0c0 1.4 1.019 2.375 2.074 2.375zm-1.56 4.636-3.57 3.57-2.5-2-2.43 2.43-1.273-1.272 3.57-3.57 2.5 2 2.43-2.43 1.273 1.272z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataDataSolid = {
  name: 'IconDataSolid',
  content: '<path fill="currentColor" d="M.516 6.101A5 5 0 0 1 5.5 1.5h11a5 5 0 0 1 5 5v8.586l-4.404-4.404a3.222 3.222 0 1 0-5.884-.308l-1.181 1.18A3.208 3.208 0 0 0 8.222 11a3.21 3.21 0 0 0-2.062.746L.516 6.101z"/><path fill="currentColor" d="M.5 8.914V17.5a5 5 0 0 0 5 5h11a5 5 0 0 0 4.984-4.602l-5.802-5.802a3.209 3.209 0 0 1-1.46.349c-.641 0-1.24-.188-1.742-.511l-1.217 1.218a3.222 3.222 0 1 1-6.18.345L.5 8.913zm14.945.308a1.222 1.222 0 1 0-2.445 0 1.222 1.222 0 0 0 2.445 0z"/><path fill="currentColor" d="M8.222 13a1.222 1.222 0 1 1 0 2.445 1.222 1.222 0 0 1 0-2.445z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataDatabase = {
  name: 'IconDatabase',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 2c-2.592 0-4.986.465-6.77 1.258-.89.396-1.674.893-2.247 1.496C2.404 5.362 2 6.122 2 7c0 .878.404 1.639.983 2.246.106.111.218.219.338.323C2.538 10.285 2 11.184 2 12.25c0 1.064.53 1.96 1.321 2.682C2.547 15.607 2 16.465 2 17.5c0 .878.404 1.639.983 2.246.573.603 1.356 1.1 2.247 1.496C7.014 22.035 9.408 22.5 12 22.5c2.592 0 4.986-.465 6.77-1.258.89-.396 1.674-.893 2.247-1.496.579-.607.983-1.368.983-2.246 0-1.035-.547-1.893-1.322-2.568C21.47 14.21 22 13.314 22 12.25c0-1.069-.547-1.973-1.32-2.682.119-.103.232-.21.337-.322C21.596 8.64 22 7.878 22 7c0-.878-.404-1.638-.983-2.246-.573-.603-1.356-1.1-2.247-1.496C16.986 2.465 14.592 2 12 2zM4 7c0-.227.1-.518.432-.868.337-.354.872-.719 1.61-1.047C7.516 4.431 9.622 4 12 4c2.379 0 4.484.43 5.958 1.085.738.328 1.273.693 1.61 1.047.333.35.432.641.432.868 0 .227-.1.518-.432.868-.337.354-.872.719-1.61 1.047C16.484 9.569 14.378 10 12 10c-2.379 0-4.484-.43-5.958-1.085-.738-.328-1.273-.693-1.61-1.047C4.099 7.518 4 7.227 4 7zm14.904 3.681-.134.061C16.986 11.535 14.592 12 12 12c-2.592 0-4.986-.465-6.77-1.258a8.562 8.562 0 0 1-.116-.052C4.282 11.269 4 11.83 4 12.25c0 .56.518 1.371 2.063 2.1 1.468.694 3.566 1.15 5.937 1.15 2.371 0 4.47-.456 5.937-1.15 1.545-.729 2.063-1.54 2.063-2.1 0-.39-.235-.9-.966-1.452a1.012 1.012 0 0 1-.13-.117zm-.113 5.478.124-.06C19.751 16.649 20 17.16 20 17.5c0 .227-.1.518-.432.868-.337.354-.872.719-1.61 1.047-1.474.655-3.58 1.085-5.958 1.085-2.379 0-4.484-.43-5.958-1.085-.738-.328-1.273-.693-1.61-1.047-.333-.35-.432-.641-.432-.868 0-.34.249-.852 1.085-1.4l.124.06c1.79.845 4.192 1.34 6.791 1.34 2.6 0 5.001-.495 6.791-1.34z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataDatabaseSolid = {
  name: 'IconDatabaseSolid',
  content: '<path fill="currentColor" d="M10 2c-2.592 0-4.986.465-6.77 1.258-.89.396-1.674.893-2.247 1.496C.404 5.362 0 6.122 0 7c0 .85.368 1.58.93 2.188.269.149.566.292.89.43C3.744 10.434 6.55 11 10 11c3.452 0 6.127-.566 7.919-1.377.637-.289 1.143-.598 1.532-.911C19.792 8.209 20 7.638 20 7c0-.878-.404-1.638-.983-2.246-.573-.603-1.356-1.1-2.247-1.496C14.986 2.465 12.592 2 10 2z"/><path fill="currentColor" d="M0 12.25c0-.768.279-1.449.728-2.037.222.113.456.222.702.326C3.506 11.42 6.45 12 10 12c3.548 0 6.373-.58 8.331-1.466.3-.136.585-.282.851-.436.501.614.818 1.334.818 2.152a3.1 3.1 0 0 1-.17 1.014c-.295.69-.99 1.455-2.198 2.128C15.974 16.314 13.438 17 10 17c-3.438 0-5.974-.686-7.632-1.608C1.16 14.719.465 13.953.17 13.264A3.101 3.101 0 0 1 0 12.25z"/><path fill="currentColor" d="M.753 15.515C.293 16.08 0 16.742 0 17.5c0 .878.404 1.639.983 2.246.573.603 1.356 1.1 2.247 1.496C5.014 22.035 7.408 22.5 10 22.5c2.592 0 4.986-.465 6.77-1.258.89-.396 1.674-.893 2.247-1.496.579-.607.983-1.368.983-2.246 0-.758-.292-1.42-.753-1.985a8.19 8.19 0 0 1-1.129.75C16.276 17.291 13.562 18 10 18c-3.562 0-6.276-.71-8.118-1.735a8.195 8.195 0 0 1-1.129-.75z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataDecreaseWidth = {
  name: 'IconDecreaseWidth',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.55 2.25h-1.8v19.5h1.8V2.25zm4.7 0h-1.8v19.5h1.8V2.25zM4.05 7.8 2.99 8.86l2.431 2.432h-4.37v1.5h4.37L2.99 15.225l1.06 1.06 3.707-3.707.006-.005a.75.75 0 0 0 0-1.06L4.05 7.8zm16.96 1.06L19.95 7.8l-3.712 3.712a.75.75 0 0 0 0 1.061l.005.006 3.707 3.706 1.06-1.06-2.432-2.432h4.372v-1.5h-4.371L21.01 8.86z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataDesktop = {
  name: 'IconDesktop',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.857 2C7.773 2 6.9 2 6.191 2.058c-.728.06-1.369.185-1.96.487A5 5 0 0 0 2.044 4.73c-.302.592-.428 1.233-.487 1.961C1.5 7.4 1.5 8.273 1.5 9.357v1.286c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.233.428 1.961.487C6.9 18 7.773 18 8.857 18h6.286c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961.058-.708.058-1.582.058-2.666V9.357c0-1.084 0-1.958-.058-2.666-.06-.728-.185-1.369-.487-1.96a5 5 0 0 0-2.185-2.186c-.592-.302-1.232-.428-1.961-.487C17.1 2 16.227 2 15.143 2H8.857zM5.138 4.327c.263-.134.611-.226 1.216-.276C6.971 4.001 7.764 4 8.9 4h6.2c1.137 0 1.929 0 2.546.051.605.05.953.142 1.216.276a3 3 0 0 1 1.311 1.311c.134.263.226.611.276 1.216.05.617.051 1.41.051 2.546v1.2c0 1.137 0 1.929-.051 2.546-.05.605-.142.953-.276 1.216a3 3 0 0 1-1.311 1.311c-.263.134-.611.226-1.216.276-.617.05-1.41.051-2.546.051H8.9c-1.137 0-1.929 0-2.546-.051-.605-.05-.953-.142-1.216-.276a3 3 0 0 1-1.311-1.311c-.134-.263-.226-.611-.276-1.216-.05-.617-.051-1.41-.051-2.546V9.4c0-1.137 0-1.929.051-2.546.05-.605.142-.953.276-1.216a3 3 0 0 1 1.311-1.311z" clip-rule="evenodd"/><path fill="currentColor" d="M22 21.8v-2H2v2h20z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataDesktopSolid = {
  name: 'IconDesktopSolid',
  content: '<path fill="currentColor" d="M7.857 2h6.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961.058.708.058 1.582.058 2.666v1.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487C16.1 18 15.227 18 14.143 18H7.857c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.961-.487a5 5 0 0 1-2.185-2.185c-.302-.592-.428-1.232-.487-1.961C.5 12.6.5 11.727.5 10.643V9.357C.5 8.273.5 7.4.558 6.691c.06-.728.185-1.369.487-1.96A5 5 0 0 1 3.23 2.544c.592-.302 1.233-.428 1.961-.487C5.9 2 6.773 2 7.857 2zM21 21.8v-2H1v2h20z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataDetailList = {
  name: 'IconDetailList',
  content: '<rect width="7.3" height="7.4" x="1" y="3.1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" rx="1.5"/><rect width="7.4" height="7.3" x="1" y="13.522" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" rx="1.5"/><path stroke="currentColor" stroke-width="2" d="M11 4.5h9m-9 4h9m-9 6.7h9m-9 4h9"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataDetailListSolid = {
  name: 'IconDetailListSolid',
  content: '<path fill="currentColor" d="M.1 4.6a2.4 2.4 0 0 1 2.4-2.4h4.3a2.4 2.4 0 0 1 2.4 2.4V9a2.4 2.4 0 0 1-2.4 2.4H2.5A2.4 2.4 0 0 1 .1 9V4.6zm0 10.422a2.4 2.4 0 0 1 2.4-2.4h4.4a2.4 2.4 0 0 1 2.4 2.4v4.3a2.4 2.4 0 0 1-2.4 2.4H2.5a2.4 2.4 0 0 1-2.4-2.4v-4.3zM20 5.5h-9v-2h9v2zm0 4h-9v-2h9v2zm-9 6.7h9v-2h-9v2zm9 4h-9v-2h9v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataDiamond = {
  name: 'IconDiamond',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.613 21.265a1.85 1.85 0 0 0 2.957 0l8.456-11.244a2.85 2.85 0 0 0 .122-3.25l-1.905-2.973a3.85 3.85 0 0 0-1.961-1.554l-2.48-.875a3.85 3.85 0 0 0-1.281-.219H9.315c-.482 0-.96.09-1.407.266l-2.103.826a3.85 3.85 0 0 0-1.834 1.506L2.034 6.771a2.85 2.85 0 0 0 .122 3.25l8.457 11.244zm-2.796-9.481 2.53 6.299-5.948-7.908 3.418 1.609zm6.907-1.543H9.458l.702-4.21h3.862l.702 4.21zm-.254 1.7-2.379 5.924-2.379-5.924h4.758zm1.94-.27 3.286-1.38-5.86 7.792 2.574-6.411zm-.03-1.83-.677-4.07 3.19-.93 1.824 2.847c.056.088.099.18.129.277L16.38 9.84zm-8.587.052.664-3.987a2.815 2.815 0 0 1-.052-.016l-3.13-1.027-1.81 2.825a1.153 1.153 0 0 0-.073.134l4.4 2.071zM8.529 3l-1.585.622 1.991.653c.116.038.237.058.359.058h5.109c.109 0 .217-.016.322-.046l2.318-.676-1.807-.638a2.15 2.15 0 0 0-.715-.122H9.315c-.27 0-.536.05-.786.149z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataDiamondSolid = {
  name: 'IconDiamondSolid',
  content: '<path fill="currentColor" d="M10.415 21.876a1.837 1.837 0 0 1-.803-.611L1.156 10.02a2.846 2.846 0 0 1-.554-1.39l6.272 3.069 3.573 10.078-.032.1zm1.621-.131c.2-.119.382-.279.533-.48l8.457-11.244c.287-.382.467-.82.538-1.272l-6.203 2.819-3.325 10.177zM21.37 7.19a2.848 2.848 0 0 0-.222-.42l-1.604-2.502-4.954 1.434.707 4.247 6.072-2.76zm-2.816-4.197-4.802 1.39a1.25 1.25 0 0 1-.347.049h-5.13a1.25 1.25 0 0 1-.368-.055L3.555 3.039a3.85 3.85 0 0 1 1.25-.797l2.102-.826a3.85 3.85 0 0 1 1.407-.266h5.207c.436 0 .869.074 1.28.22l2.48.874a3.85 3.85 0 0 1 1.273.749zM2.606 4.317 1.034 6.771a2.856 2.856 0 0 0-.175.315l6.013 2.94.698-4.186a2.742 2.742 0 0 1-.103-.03L2.606 4.318zm6.469 1.615h4.032l.735 4.409H8.34l.735-4.41zm-.559 5.909h5.177l-2.482 7.599-2.695-7.599z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataDollarCircle = {
  name: 'IconDollarCircle',
  content: '<path fill="currentColor" d="M13 5v1.157c.51.128 1.015.338 1.463.633C15.297 7.34 16 8.246 16 9.5v1h-2v-1c0-.413-.208-.757-.638-1.04-.45-.297-1.061-.46-1.593-.46-.52 0-.977.156-1.284.403C10.203 8.631 10 8.97 10 9.5c0 .284.1.47.46.69.415.255.99.434 1.747.67l.091.03c.725.226 1.63.513 2.341 1.016.782.552 1.361 1.383 1.361 2.594 0 1.403-.65 2.356-1.588 2.897-.446.258-.936.41-1.412.498V19h-2v-1.086a4.053 4.053 0 0 1-1.815-.955C8.523 16.36 8 15.483 8 14.5v-1h2v1c0 .267.158.641.529.978.364.33.825.522 1.24.522.638 0 1.237-.1 1.644-.335.325-.188.587-.485.587-1.165 0-.456-.171-.718-.514-.96-.413-.292-1.009-.5-1.784-.742l-.174-.054c-.668-.207-1.476-.457-2.113-.849C8.649 11.425 8 10.675 8 9.5c0-1.137.478-2.047 1.229-2.653A3.868 3.868 0 0 1 11 6.067V5h2z"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataDollarCircleSolid = {
  name: 'IconDollarCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm12-5.843c.51.128 1.015.338 1.463.633C14.297 7.34 15 8.246 15 9.5v1h-2v-1c0-.412-.208-.756-.638-1.04-.45-.297-1.061-.46-1.593-.46-.52 0-.977.156-1.284.403C9.203 8.631 9 8.97 9 9.5c0 .284.1.47.46.69.415.255.99.434 1.747.67l.091.03c.725.226 1.63.513 2.341 1.016C14.421 12.458 15 13.29 15 14.5c0 1.403-.65 2.356-1.588 2.897-.446.258-.936.41-1.412.498V19h-2v-1.086a4.053 4.053 0 0 1-1.815-.955C7.523 16.36 7 15.483 7 14.5v-1h2v1c0 .267.158.642.529.978.364.33.825.522 1.24.522.638 0 1.237-.1 1.644-.335.325-.188.587-.485.587-1.165 0-.456-.171-.718-.514-.96-.413-.292-1.009-.5-1.784-.742l-.174-.054c-.668-.207-1.476-.457-2.113-.849C7.649 11.426 7 10.675 7 9.5c0-1.137.478-2.047 1.229-2.653A3.868 3.868 0 0 1 10 6.067V5h2v1.157z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataDoubleCircle = {
  name: 'IconDoubleCircle',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-11C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataDoubleCircleSolid = {
  name: 'IconDoubleCircleSolid',
  content: '<path fill="currentColor" d="M8 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0z"/><path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm11-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataDownload = {
  name: 'IconDownload',
  content: '<path fill="currentColor" d="M7.17 8.258 11 11.72V1.3h2v10.46l3.825-3.498 1.35 1.476-4.798 4.387a2 2 0 0 1-2.691.007l-4.857-4.39 1.342-1.484z"/><path fill="currentColor" d="M22.2 13v4a5 5 0 0 1-5 5H6.8a5 5 0 0 1-5-5v-4h2v4a3 3 0 0 0 3 3h10.4a3 3 0 0 0 3-3v-4h2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataDragIndicator = {
  name: 'IconDragIndicator',
  content: '<path fill="currentColor" d="M8.8 5.9a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6zm0 7.9a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6zm0 7.9a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6zm6.8-15.8a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6zm0 7.9a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6zm0 7.9a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEdit = {
  name: 'IconEdit',
  content: '<path fill="currentColor" d="M13 2v2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-6h2v6a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5h6z"/><path fill="currentColor" d="M21.407 2.593a1 1 0 0 1 0 1.414L11.414 14H10v-1.414l9.993-9.993a1 1 0 0 1 1.414 0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEditSolid = {
  name: 'IconEditSolid',
  content: '<path fill="currentColor" d="M19.607 1.94a1 1 0 0 1 0 1.414l-9.993 9.992H8.2v-1.414l9.993-9.993a1 1 0 0 1 1.414 0z"/><path fill="currentColor" d="M4 2h11.988L7.1 10.889l-.384 3.814 3.92-.279L19.91 5.15c.059.274.09.558.09.85v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataElement = {
  name: 'IconElement',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12.191 2.658c-.703-1.586-2.954-1.586-3.657 0L1.208 19.19A2 2 0 0 0 3.037 22h10.459a6.5 6.5 0 1 0 1.747-12.456L12.19 2.658zm1.105 7.43-2.933-6.62L3.037 20h7.84a6.501 6.501 0 0 1 2.42-9.912zM11.5 16a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataElementSolid = {
  name: 'IconElementSolid',
  content: '<path fill="currentColor" d="M11.191 2.658c-.703-1.586-2.954-1.586-3.657 0L.208 19.19A2 2 0 0 0 2.037 22h10.459a6.502 6.502 0 0 1 1.746-12.456l-3.051-6.886z"/><path fill="currentColor" d="M10 16a5 5 0 1 1 10 0 5 5 0 0 1-10 0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 23 24'
  },
  width: 23,
  height: 24
};

var dataEllipsis = {
  name: 'IconEllipsis',
  content: '<path fill="currentColor" d="M6.9 12a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0zm6.9 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0zm6.9 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEllipsisCircle = {
  name: 'IconEllipsisCircle',
  content: '<path fill="currentColor" d="M6.8 13.4a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8zm5.2 0a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8zm6.6-1.4a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEllipsisCircleSolid = {
  name: 'IconEllipsisCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5zm-5-9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEllipsisVertical = {
  name: 'IconEllipsisVertical',
  content: '<path fill="currentColor" d="M12 5.9a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6zm0 7.9a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6zm-1.8 6.1a1.8 1.8 0 1 0 3.6 0 1.8 1.8 0 0 0-3.6 0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEnglishComment = {
  name: 'IconEnglishComment',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m10.292 14.032.504 1.512h1.74L9.416 7H8.108L5 15.544h1.74l.516-1.512h3.036zm-2.568-1.404 1.08-3.108 1.044 3.108H7.724zm8.948 2.376v.54h1.524v-4.116c0-.736-.224-1.288-.672-1.656-.448-.368-1.112-.552-1.992-.552-.52 0-.952.06-1.296.18-.336.12-.656.348-.96.684l.996.972c.08-.096.16-.176.24-.24.08-.064.164-.116.252-.156.096-.04.2-.068.312-.084a1.91 1.91 0 0 1 .396-.036c.416 0 .712.08.888.24.184.152.276.4.276.744v.312H15.16c-.36 0-.676.048-.948.144a1.863 1.863 0 0 0-.66.396c-.176.16-.308.352-.396.576a1.827 1.827 0 0 0-.132.696c0 .28.044.54.132.78.088.24.216.448.384.624.368.368.9.552 1.596.552.36 0 .652-.048.876-.144.232-.096.452-.248.66-.456zm-1.272-2.1h1.236v.336c0 .384-.076.648-.228.792a.867.867 0 0 1-.432.252 2.723 2.723 0 0 1-.552.048c-.304 0-.532-.064-.684-.192a.693.693 0 0 1-.216-.528c0-.224.076-.396.228-.516.152-.128.368-.192.648-.192z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="m22.438 15.373-.04.157.835 4.068A2 2 0 0 1 21.273 22h-4.74a26.935 26.935 0 0 1-1.495.463c-.896.25-2.105.537-3.038.537-6.075 0-11-4.925-11-11S5.925 1 12 1s11 4.925 11 11c0 .735-.18 1.704-.338 2.425-.081.374-.163.708-.224.948zM3 12a9 9 0 0 1 18 0c0 .497-.134 1.277-.292 1.998a27.087 27.087 0 0 1-.277 1.144l-.018.07-.005.016-.001.005-.065.232.932 4.535H16.19l-.164.058-.005.002-.02.008-.086.03-.324.108c-.277.09-.662.21-1.092.33-.895.25-1.868.464-2.5.464a9 9 0 0 1-9-9z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEnglishCommentSolid = {
  name: 'IconEnglishCommentSolid',
  content: '<path fill="currentColor" d="m6.724 12.628 1.08-3.108 1.044 3.108H6.724zm7.676.276h1.236v.336c0 .384-.076.648-.228.792a.867.867 0 0 1-.432.252 2.723 2.723 0 0 1-.552.048c-.304 0-.532-.064-.684-.192a.693.693 0 0 1-.216-.528c0-.224.076-.396.228-.516.152-.128.368-.192.648-.192z"/><path fill="currentColor" fill-rule="evenodd" d="M21.397 15.53a26.48 26.48 0 0 0 .265-1.105c.158-.721.338-1.69.338-2.425 0-6.075-4.925-11-11-11S0 5.925 0 12s4.925 11 11 11c.933 0 2.142-.287 3.038-.537A28.696 28.696 0 0 0 15.533 22h4.74a2 2 0 0 0 1.96-2.402l-.836-4.068zM9.292 14.032l.504 1.512h1.74L8.416 7H7.108L4 15.544h1.74l.516-1.512h3.036zm6.38.972v.54h1.524v-4.116c0-.736-.224-1.288-.672-1.656-.448-.368-1.112-.552-1.992-.552-.52 0-.952.06-1.296.18-.336.12-.656.348-.96.684l.996.972c.08-.096.16-.176.24-.24.08-.064.164-.116.252-.156.096-.04.2-.068.312-.084a1.91 1.91 0 0 1 .396-.036c.416 0 .712.08.888.24.184.152.276.4.276.744v.312H14.16c-.36 0-.676.048-.948.144a1.863 1.863 0 0 0-.66.396c-.176.16-.308.352-.396.576a1.827 1.827 0 0 0-.132.696c0 .28.044.54.132.78.088.24.216.448.384.624.368.368.9.552 1.596.552.36 0 .652-.048.876-.144.232-.096.452-.248.66-.456z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 23 24'
  },
  width: 23,
  height: 24
};

var dataEnvelope = {
  name: 'IconEnvelope',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.357 2.5c-1.084 0-1.958 0-2.666.058-.728.06-1.369.185-1.961.487A5 5 0 0 0 1.545 5.23c-.302.592-.428 1.233-.487 1.961C1 7.9 1 8.773 1 9.857v4.286c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.233.428 1.961.487.708.058 1.582.058 2.666.058h7.286c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961C23 16.1 23 15.227 23 14.143V9.857c0-1.084 0-1.958-.058-2.666-.06-.728-.185-1.369-.487-1.96a5 5 0 0 0-2.185-2.186c-.592-.302-1.232-.428-1.961-.487C17.6 2.5 16.727 2.5 15.643 2.5H8.357zM4.71 4.792c.255-.115.593-.196 1.144-.24C6.471 4.5 7.264 4.5 8.4 4.5h7.2c1.137 0 1.929 0 2.546.051.552.045.89.126 1.144.241L12 11.172l-7.29-6.38zM3.293 6.208c-.116.255-.197.593-.242 1.146C3.001 7.971 3 8.764 3 9.9v4.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h7.2c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546V9.9c0-1.137 0-1.929-.051-2.546-.045-.553-.126-.891-.242-1.146l-.049.045-7.341 6.423a2 2 0 0 1-2.634 0L3.342 6.253a1.012 1.012 0 0 1-.049-.045z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEnvelopeOpen = {
  name: 'IconEnvelopeOpen',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13.072 1.281a5 5 0 0 0-2.144 0c-.802.176-1.534.616-2.593 1.252L2.94 5.769c-.47.28-.882.528-1.194.882a3 3 0 0 0-.605 1.069C1 8.17 1 8.65 1 9.198v5.945c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.232.428 1.961.487.708.058 1.582.058 2.666.058h7.286c1.083 0 1.958 0 2.666-.058.728-.06 1.369-.185 1.96-.487a5 5 0 0 0 2.186-2.185c.302-.592.428-1.232.487-1.961C23 17.1 23 16.227 23 15.143V9.198c0-.547.001-1.029-.142-1.478a3 3 0 0 0-.605-1.069c-.312-.354-.725-.601-1.194-.882l-5.394-3.236c-1.06-.636-1.791-1.076-2.593-1.252zm-1.715 1.954a3 3 0 0 1 1.286 0c.442.096.878.344 2.135 1.098l5.154 3.092.192.116-8.063 6.271a.1.1 0 0 1-.123 0l-8.062-6.27.192-.117 5.154-3.092c1.257-.754 1.693-1.002 2.135-1.098zM3 9.14v5.96c0 1.137 0 1.929.051 2.546.015.18.033.336.055.475l5.005-5.005-5.11-3.976zm1.638 11.033a2.997 2.997 0 0 1-.619-.42l5.524-5.524 1.29 1.004a1.9 1.9 0 0 0 2.333 0l1.29-1.004 5.524 5.524a2.998 2.998 0 0 1-.618.42c-.263.134-.611.226-1.216.276-.617.05-1.41.051-2.546.051H8.4c-1.137 0-1.929 0-2.546-.051-.605-.05-.953-.142-1.216-.276zm16.256-2.052c.022-.139.04-.296.055-.475.05-.617.05-1.41.05-2.546V9.14l-5.11 3.976 5.005 5.005z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEnvelopeOpenSolid = {
  name: 'IconEnvelopeOpenSolid',
  content: '<g clip-path="url(#dls-b943c-a)"><path fill="currentColor" fill-rule="evenodd" d="M9.928 1.281a5 5 0 0 1 2.144 0c.802.176 1.534.616 2.593 1.252l.142.085 5.154 3.092.098.059c.47.28.882.528 1.194.882a3 3 0 0 1 .605 1.069c.143.45.143.93.142 1.478v5.945c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.233.428-1.961.487-.708.058-1.582.058-2.666.058H7.357c-1.084 0-1.958 0-2.666-.058-.729-.06-1.369-.185-1.961-.487A5 5 0 0 1 .545 19.77c-.302-.592-.428-1.232-.487-1.961C0 17.1 0 16.227 0 15.143V9.198C0 8.65-.001 8.169.142 7.72a3 3 0 0 1 .605-1.07c.312-.354.725-.601 1.194-.882l.098-.059 5.154-3.092.142-.085c1.059-.636 1.791-1.076 2.593-1.252zm1.01 12.531L2.486 7.237 1.38 8.657l5.732 4.459L1.227 19 2.5 20.273l6.043-6.043 1.29 1.003a1.9 1.9 0 0 0 2.333 0l1.29-1.004 6.044 6.044L20.773 19l-5.884-5.884 5.731-4.458-1.105-1.42-8.454 6.574a.1.1 0 0 1-.122 0z" clip-rule="evenodd"/></g><defs><clipPath id="dls-b943c-a"><path fill="currentColor" d="M0 0h22v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataEnvelopeSolid = {
  name: 'IconEnvelopeSolid',
  content: '<g clip-path="url(#dls-15d68-a)"><path fill="currentColor" fill-rule="evenodd" d="M7.357 2.5h7.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C22 7.9 22 8.773 22 9.857v4.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487-.708.058-1.582.058-2.666.058H7.357c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.961-.487A5 5 0 0 1 .545 18.77c-.302-.592-.428-1.232-.487-1.961C0 16.1 0 15.227 0 14.143V9.857C0 8.773 0 7.9.058 7.191c.06-.728.185-1.369.487-1.96A5 5 0 0 1 2.73 3.044c.592-.302 1.233-.428 1.961-.487C5.4 2.5 6.273 2.5 7.357 2.5zM11 11.171 3.477 4.59 2.16 6.094l7.523 6.582a2 2 0 0 0 2.634 0l7.523-6.582-1.317-1.505L11 11.17z" clip-rule="evenodd"/></g><defs><clipPath id="dls-15d68-a"><path fill="currentColor" d="M0 0h22v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataExcellentBookmark = {
  name: 'IconExcellentBookmark',
  content: '<path fill="currentColor" d="m10.414 6.907-1.3-.616-.051.164c-.512 1.633-1.311 3.05-2.375 4.255l-.056.063.446 1.438.177-.187c.25-.267.496-.534.733-.807v5.433H9.41v-.735l.89.777.098-.094c1.52-1.435 2.41-3.556 2.687-6.341h.07v5.023c0 .366.086.671.286.885.202.216.496.312.856.312h1.391c.344-.024.632-.145.847-.384l.006-.009a.918.918 0 0 0 .132-.286c.037-.118.07-.266.102-.44.063-.35.12-.819.175-1.404l.01-.118-1.306-.436-.007.2c-.016.447-.038.795-.063 1.044a3.721 3.721 0 0 1-.04.295.985.985 0 0 1-.026.11.507.507 0 0 1-.085.085c-.023.017-.033.017-.035.017H14.6a.167.167 0 0 1-.052-.006c-.009-.003-.012-.006-.012-.006a.03.03 0 0 1-.007-.013.167.167 0 0 1-.006-.051v-4.818h2.136v-1.38h-1.17l.831-.832-.103-.106a10.8 10.8 0 0 0-1.74-1.413l-.1-.066-.939.898.145.106c.689.5 1.23.979 1.619 1.413h-2.036l.003-.08c.003-.08.005-.167.005-.256V6.393h-1.39v2.148c0 .078-.002.157-.004.238v.001a14.03 14.03 0 0 0-.003.097H9.66v1.38h2.034c-.25 2.373-1.024 4.141-2.284 5.334V9.207c.395-.69.716-1.422.963-2.174l.041-.126z"/><path fill="currentColor" fill-rule="evenodd" d="M17.837 1.949a3 3 0 0 1 3.02 2.845l.728 14.154c.109 2.113-1.945 3.672-3.951 2.998l-5.32-1.786a1 1 0 0 0-.633-.001l-5.453 1.805c-2.003.663-4.047-.896-3.938-3.004l.729-14.072A3 3 0 0 1 5.99 2.043l11.846-.094zm1.022 2.948a1 1 0 0 0-1.007-.949l-11.845.095a1 1 0 0 0-.99.948l-.73 14.073a1 1 0 0 0 1.313 1l5.453-1.804a3 3 0 0 1 1.897.004l5.32 1.786a1 1 0 0 0 1.317-1L18.86 4.898z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataExcellentBookmarkSolid = {
  name: 'IconExcellentBookmarkSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M15.836 1.949a3 3 0 0 1 3.02 2.845l.729 14.154c.109 2.113-1.945 3.672-3.951 2.998l-5.32-1.786a1 1 0 0 0-.633-.001l-5.453 1.805C2.225 22.627.181 21.067.29 18.96l.729-14.072A3 3 0 0 1 3.99 2.043l11.845-.094zM6.138 16.5v-5.691c-.313.378-.648.745-.993 1.112L4.8 10.81C5.879 9.589 6.688 8.152 7.206 6.5l1.024.486c-.248.756-.571 1.49-.97 2.181V16.5H6.138zm1.672-6.393v-1.08h2.114c0-.081.003-.162.006-.243.002-.081.005-.162.005-.243V6.543h1.09v1.998c0 .09-.004.176-.006.26a5.851 5.851 0 0 0-.005.226h3.495v1.08h-2.136v4.968c0 .15.075.226.226.226h.799c.086 0 .162-.065.248-.172.064-.12.118-.627.15-1.523l1.004.335c-.108 1.166-.227 1.857-.378 2.051-.183.206-.431.314-.744.335h-1.38c-.67 0-.993-.356-.993-1.047v-5.173h-.356c-.259 2.83-1.144 4.957-2.654 6.382l-.841-.734c1.359-1.253 2.168-3.132 2.405-5.648H7.81zm3.862-2.765.722-.69c.68.453 1.252.917 1.716 1.392l-.766.767c-.4-.454-.96-.95-1.672-1.469z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataExclamationCircle = {
  name: 'IconExclamationCircle',
  content: '<path fill="currentColor" d="M13.25 16.15a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0zM11 13.6v-7h2v7h-2z"/><path fill="currentColor" fill-rule="evenodd" d="M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12zm11 9a9 9 0 1 1 0-18 9 9 0 0 1 0 18z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataExclamationCircleSolid = {
  name: 'IconExclamationCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12zm10-5.4v7h2v-7h-2zm2.25 9.55a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataExclamationTriangle = {
  name: 'IconExclamationTriangle',
  content: '<path fill="currentColor" d="M11 7.9v7h2v-7h-2zm2.25 9.55a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0z"/><path fill="currentColor" fill-rule="evenodd" d="M14.783 3.08c-1.226-2.162-4.34-2.162-5.566 0L1.194 17.22c-1.21 2.134.33 4.78 2.783 4.78h16.046c2.452 0 3.993-2.646 2.783-4.779L14.783 3.08zm-3.827.986a1.2 1.2 0 0 1 2.088 0l8.022 14.142A1.2 1.2 0 0 1 20.023 20H3.977a1.2 1.2 0 0 1-1.043-1.792l8.022-14.142z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataExclamationTriangleSolid = {
  name: 'IconExclamationTriangleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M14.598 3.298c-1.155-2-4.041-2-5.196 0L1.2 17.5c-1.155 2 .289 4.5 2.598 4.5h16.406c2.31 0 3.753-2.5 2.598-4.5L14.598 3.298zM11 7.4v8h2v-8h-2zm2.25 10.55a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataExpand = {
  name: 'IconExpand',
  content: '<path fill="currentColor" d="M14.453 2h5.66C21.155 2 22 2.845 22 3.887v5.66h-1.887V5.221l-5.36 5.36-1.333-1.335 5.36-5.36h-4.327V2zM5.22 20.113h4.327V22h-5.66A1.887 1.887 0 0 1 2 20.113v-5.66h1.887v4.326l5.36-5.36 1.334 1.335-5.36 5.36z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataExpandAlt = {
  name: 'IconExpandAlt',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M2.5 14.9v4.8a1.8 1.8 0 0 0 1.8 1.8h4.8v-2H5.924l4.619-4.618-1.415-1.415L4.5 18.096V14.9h-2zM5.924 4.523l4.619 4.619-1.415 1.414L4.5 5.927v3.196h-2v-4.8a1.8 1.8 0 0 1 1.8-1.8h4.8v2H5.924zm15.576 4.6v-4.8a1.8 1.8 0 0 0-1.8-1.8h-4.8v2h3.176l-4.619 4.619 1.415 1.414L19.5 5.927v3.196h2zm0 5.777v4.8a1.8 1.8 0 0 1-1.8 1.8h-4.8v-2h3.176l-4.619-4.618 1.415-1.415 4.628 4.629V14.9h2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataExpandSquare = {
  name: 'IconExpandSquare',
  content: '<path fill="currentColor" d="M10.353 8.054H9.169l2.456 2.596-1.235 1.169L8.122 9.42v1.04h-1.7V7.42c0-.544.429-1.067 1.055-1.067h2.876v1.7zm5.597 6.637v-.975h1.7v3.04c0 .544-.429 1.067-1.056 1.067H13.72v-1.7h1.246l-2.457-2.597 1.235-1.168 2.207 2.333zm0-6.637h-2.231v-1.7h2.875c.627 0 1.056.523 1.056 1.067v3.04h-1.7V8.054zm-5.674 8.096H8.045v-2.407h-1.7v3.04c0 .544.428 1.067 1.055 1.067h2.876v-1.7z"/><path fill="currentColor" fill-rule="evenodd" d="M1.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm5-3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3h-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataExpandSquareSolid = {
  name: 'IconExpandSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm7.669 1.554h1.184v-1.7H6.477c-.627 0-1.055.523-1.055 1.067v3.04h1.7v-1.04l2.268 2.398 1.235-1.169-2.456-2.596zm6.781 5.662v.975l-2.207-2.333-1.235 1.168 2.457 2.597h-1.246v1.7h2.876c.626 0 1.055-.523 1.055-1.067v-3.04h-1.7zm0-5.662h-2.231v-1.7h2.876c.626 0 1.055.523 1.055 1.067v3.04h-1.7V8.054zM7.045 16.15h2.23v1.7H6.4c-.627 0-1.055-.523-1.055-1.067v-3.04h1.7v2.407z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataExternalLink = {
  name: 'IconExternalLink',
  content: '<path fill="currentColor" d="M7 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-5h2v5a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5h5v2H7z"/><path fill="currentColor" d="m18.386 4.243-3.24-.003.002-2 4.663.005a2 2 0 0 1 1.997 2.002l-.005 4.65-2-.001.004-3.245-6.428 6.428-1.415-1.415 6.422-6.42z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEye = {
  name: 'IconEye',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 7.438a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm-2.5 4.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 3c-1.337 0-3.172.275-5.137 1.394C4.896 5.515 2.858 7.45 1.067 10.68a2.726 2.726 0 0 0-.022 2.636c.59 1.076 1.772 2.972 3.564 4.61C6.407 19.568 8.875 21 12 21c2.296 0 4.298-.518 6.11-1.778 1.79-1.245 3.317-3.16 4.776-5.814a2.839 2.839 0 0 0-.047-2.834c-1.098-1.817-2.592-3.69-4.404-5.12C16.623 4.024 14.441 3 12 3zm-9.184 8.65c1.638-2.955 3.431-4.603 5.037-5.518C9.462 5.215 10.941 5 12 5c1.861 0 3.62.78 5.197 2.024 1.578 1.246 2.923 2.918 3.93 4.584a.839.839 0 0 1 .006.837c-1.381 2.513-2.726 4.134-4.165 5.135C15.552 18.565 13.97 19 12 19c-2.471 0-4.48-1.124-6.042-2.551-1.567-1.431-2.625-3.118-3.158-4.093a.727.727 0 0 1 .016-.706z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEyeBright = {
  name: 'IconEyeBright',
  content: '<path fill="currentColor" d="M13 6V2h-2v4h2z"/><path fill="currentColor" fill-rule="evenodd" d="M9 15a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M4.414 9.9C6.404 8.706 9.09 8 12 8c2.912 0 5.596.706 7.586 1.9C21.556 11.082 23 12.854 23 15c0 2.146-1.445 3.918-3.414 5.1C17.596 21.294 14.912 22 12 22s-5.596-.706-7.586-1.9C2.444 18.918 1 17.146 1 15c0-2.146 1.445-3.918 3.414-5.1zm1.03 1.715C3.793 12.605 3 13.832 3 15c0 1.168.794 2.395 2.443 3.385C7.073 19.363 9.39 20 12 20s4.927-.637 6.557-1.615C20.206 17.395 21 16.168 21 15c0-1.168-.794-2.396-2.443-3.385C16.927 10.637 14.61 10 12 10s-4.927.637-6.557 1.615z" clip-rule="evenodd"/><path fill="currentColor" d="M5.143 3.152 7.41 6.604 5.737 7.702 3.471 4.25l1.672-1.098zm11.612 3.214 2.266-3.452 1.672 1.098-2.266 3.452-1.672-1.098z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEyeBrightSolid = {
  name: 'IconEyeBrightSolid',
  content: '<path fill="currentColor" d="M12 6V2h-2v4h2zm-5.59.604L4.142 3.152 2.471 4.25l2.266 3.452L6.41 6.604zm11.61-3.69-2.265 3.453 1.672 1.097 2.266-3.452-1.672-1.098z"/><path fill="currentColor" fill-rule="evenodd" d="M11 8c-2.912 0-5.596.706-7.586 1.9C1.444 11.082 0 12.854 0 15c0 2.146 1.445 3.918 3.414 5.1C5.404 21.294 8.09 22 11 22c2.912 0 5.596-.706 7.586-1.9C20.556 18.918 22 17.146 22 15c0-2.146-1.445-3.918-3.414-5.1C16.596 8.706 13.912 8 11 8zm0 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataEyeSlash = {
  name: 'IconEyeSlash',
  content: '<path fill="currentColor" d="M21.414 4 20 2.586 2.586 20 4 21.414 21.414 4zM6.892 19.608C8.334 20.435 10.037 21 12 21c2.296 0 4.298-.518 6.11-1.778 1.79-1.245 3.317-3.16 4.776-5.814a2.838 2.838 0 0 0-.047-2.834c-.805-1.332-1.823-2.695-3.023-3.89l-1.414 1.414c1.063 1.059 1.985 2.286 2.724 3.51a.839.839 0 0 1 .007.837c-1.381 2.513-2.726 4.134-4.165 5.135C15.552 18.565 13.97 19 12 19a8.066 8.066 0 0 1-3.631-.869l-1.477 1.477zM15.531 5.93C14.414 5.34 13.23 5 12.001 5c-1.06 0-2.54.215-4.148 1.132-1.606.915-3.399 2.563-5.037 5.518a.727.727 0 0 0-.016.706c.47.86 1.347 2.27 2.62 3.573l-1.422 1.406c-1.453-1.484-2.434-3.07-2.953-4.019a2.726 2.726 0 0 1 .022-2.636c1.79-3.23 3.83-5.165 5.796-6.286C8.828 3.274 10.663 3 12 3c1.831 0 3.517.576 5.01 1.468L15.53 5.93z"/><path fill="currentColor" d="M10.368 16.132a4.5 4.5 0 0 0 5.827-5.827l-1.696 1.696a2.5 2.5 0 0 1-2.436 2.436l-1.695 1.695zm1.617-6.694A2.5 2.5 0 0 0 9.5 11.894L7.805 13.57a4.5 4.5 0 0 1 5.874-5.809l-1.694 1.677z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEyeSlashSolid = {
  name: 'IconEyeSlashSolid',
  content: '<path fill="currentColor" d="M3 21.414 20.414 4 19 2.586 1.586 20 3 21.414zM11 20c-1.653 0-3.11-.446-4.373-1.127l2.74-2.74a4.5 4.5 0 0 0 5.827-5.827L18.11 7.39c1.132 1.127 2.102 2.422 2.873 3.7.34.561.343 1.261.027 1.836C18.17 18.093 15.265 20 11 20z"/><path fill="currentColor" d="M11.063 14.437A2.5 2.5 0 0 0 13.5 12l-2.436 2.436zM11 4c1.527 0 2.963.454 4.273 1.196L12.68 7.761a4.5 4.5 0 0 0-5.874 5.809l-3.097 3.062C2.346 15.238 1.417 13.74.922 12.836a1.726 1.726 0 0 1 .02-1.67C4.37 4.98 8.604 4 11 4z"/><path fill="currentColor" d="M10.985 9.438A2.5 2.5 0 0 0 8.5 11.894l2.485-2.456z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataEyeSolid = {
  name: 'IconEyeSolid',
  content: '<path fill="currentColor" d="M9.5 11.938a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0z"/><path fill="currentColor" fill-rule="evenodd" d="M6.863 4.394C8.828 3.274 10.663 3 12 3c2.44 0 4.623 1.024 6.435 2.454 1.812 1.43 3.306 3.303 4.404 5.12.53.878.528 1.958.047 2.834-1.459 2.654-2.986 4.569-4.776 5.814C16.298 20.482 14.296 21 12 21c-3.125 0-5.593-1.432-7.39-3.074-1.793-1.638-2.976-3.534-3.565-4.61a2.726 2.726 0 0 1 .022-2.636c1.79-3.23 3.83-5.165 5.796-6.286zM12 7.437a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEyeTracking = {
  name: 'IconEyeTracking',
  content: '<path fill="currentColor" d="M1.6 8V5.5a4 4 0 0 1 4-4h2.9v2H5.6a2 2 0 0 0-2 2V8h-2zm20.9 0V5.5a4 4 0 0 0-4-4h-2.9v2h2.9a2 2 0 0 1 2 2V8h2zM1.6 18.5V16h2v2.5a2 2 0 0 0 2 2h2.9v2H5.6a4 4 0 0 1-4-4zM22.5 16v2.5a4 4 0 0 1-4 4h-2.9v-2h2.9a2 2 0 0 0 2-2V16h2z"/><path fill="currentColor" fill-rule="evenodd" d="M8.5 12.17a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0zm3.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 5.5c-.977 0-2.308.197-3.733.99-1.428.794-2.895 2.154-4.186 4.396a2.658 2.658 0 0 0-.014 2.66c.487.845 1.37 2.169 2.663 3.291 1.3 1.129 3.06 2.093 5.27 2.093 1.645 0 3.105-.363 4.432-1.256 1.307-.88 2.408-2.221 3.441-4.042a2.777 2.777 0 0 0-.055-2.855C18.253 8.296 15.506 5.5 12 5.5zm-6.186 6.384c1.134-1.968 2.353-3.05 3.425-3.646A5.646 5.646 0 0 1 12 7.5c2.43 0 4.655 2.013 6.128 4.344.144.23.155.537.006.8-.95 1.673-1.863 2.727-2.819 3.37-.935.629-1.986.915-3.315.915-1.589 0-2.904-.686-3.96-1.602-1.061-.922-1.813-2.039-2.24-2.78a.659.659 0 0 1 .014-.663z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataEyeTrackingSolid = {
  name: 'IconEyeTrackingSolid',
  content: '<path fill="currentColor" d="M.6 6.4v1.5h2V6.4a3 3 0 0 1 3-3h1.9v-2H5.6a5 5 0 0 0-5 5zm20.9 0v1.5h-2V6.4a3 3 0 0 0-3-3h-1.9v-2h1.9a5 5 0 0 1 5 5zM.6 17.8v-1.5h2v1.5a3 3 0 0 0 3 3h1.9v2H5.6a5 5 0 0 1-5-5zm20.9 0v-1.5h-2v1.5a3 3 0 0 1-3 3h-1.9v2h1.9a5 5 0 0 0 5-5z"/><path fill="currentColor" fill-rule="evenodd" d="M11 5.5c-.977 0-2.308.197-3.733.99-1.428.794-2.895 2.154-4.186 4.396a2.658 2.658 0 0 0-.014 2.66c.487.845 1.37 2.169 2.663 3.291 1.3 1.129 3.062 2.092 5.27 2.092 1.645 0 3.105-.363 4.432-1.256 1.307-.88 2.408-2.221 3.441-4.042a2.78 2.78 0 0 0-.054-2.855C17.252 8.296 14.505 5.5 11 5.5zm0 3.67a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataEyedropper = {
  name: 'IconEyedropper',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m14.74 4.903 1.767-1.767a3 3 0 1 1 4.243 4.242l-1.768 1.768 2.121 2.121-1.414 1.415-1.414-1.415-7.677 7.677a4.467 4.467 0 0 1-4.048 1.22l-1.003 1.003a2 2 0 0 1-2.829-2.829l1.004-1.003a4.468 4.468 0 0 1 1.219-4.048l7.677-7.677-1.414-1.414 1.414-1.414 2.121 2.121zm3.181-.353a1 1 0 0 1 1.415 1.414l-1.768 1.768-1.415-1.414 1.768-1.768zm-3.889 2.475-4.95 4.95h5.657l2.122-2.122-2.829-2.828z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFastForward = {
  name: 'IconFastForward',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3.267 3.912A.8.8 0 0 0 2 4.562v14.876a.8.8 0 0 0 1.267.65L11.5 14.16v5.278a.8.8 0 0 0 1.267.65l9.88-7.114a1.2 1.2 0 0 0 0-1.948l-9.88-7.114a.8.8 0 0 0-1.267.65V9.84L3.267 3.912z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFastRewind = {
  name: 'IconFastRewind',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.232 3.912a.8.8 0 0 1 1.268.65V9.84l8.232-5.928a.8.8 0 0 1 1.268.65v14.876a.8.8 0 0 1-1.268.65L12.5 14.16v5.278a.8.8 0 0 1-1.268.65l-9.88-7.114a1.2 1.2 0 0 1 0-1.948l9.88-7.114z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFeed = {
  name: 'IconFeed',
  content: '<path fill="currentColor" d="M17 11.35H7v-1.7h10v1.7zm-10 3h6.5v-1.7H7v1.7z"/><path fill="currentColor" fill-rule="evenodd" d="M9.8 1.3a4.9 4.9 0 0 0-4.9 4.9v.1h-.2a2.9 2.9 0 0 0-2.9 2.9v5.6a2.9 2.9 0 0 0 2.9 2.9h.2v.1a4.9 4.9 0 0 0 4.9 4.9h4.4a4.9 4.9 0 0 0 4.9-4.9v-.1h.2a2.9 2.9 0 0 0 2.9-2.9V9.2a2.9 2.9 0 0 0-2.9-2.9h-.2v-.1a4.9 4.9 0 0 0-4.9-4.9H9.8zm7.5 5v-.1a3.1 3.1 0 0 0-3.1-3.1H9.8a3.1 3.1 0 0 0-3.1 3.1v.1h10.6zm0 11.4H6.7v.1a3.1 3.1 0 0 0 3.1 3.1h4.4a3.1 3.1 0 0 0 3.1-3.1v-.1zM3.6 9.2a1.1 1.1 0 0 1 1.1-1.1h14.6a1.1 1.1 0 0 1 1.1 1.1v5.6a1.1 1.1 0 0 1-1.1 1.1H4.7a1.1 1.1 0 0 1-1.1-1.1V9.2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFeedSolid = {
  name: 'IconFeedSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3.9 6.2a4.9 4.9 0 0 1 4.9-4.9h4.4a4.9 4.9 0 0 1 4.9 4.9v.1h.2a2.9 2.9 0 0 1 2.9 2.9v5.6a2.9 2.9 0 0 1-2.9 2.9h-.2v.1a4.9 4.9 0 0 1-4.9 4.9H8.8a4.9 4.9 0 0 1-4.9-4.9v-.1h-.2a2.9 2.9 0 0 1-2.9-2.9V9.2a2.9 2.9 0 0 1 2.9-2.9h.2v-.1zm12.4 0v.1H5.7v-.1a3.1 3.1 0 0 1 3.1-3.1h4.4a3.1 3.1 0 0 1 3.1 3.1zM5.7 17.8v-.1h10.6v.1a3.1 3.1 0 0 1-3.1 3.1H8.8a3.1 3.1 0 0 1-3.1-3.1zM16 11.35H6v-1.7h10v1.7zm-3.5 3H6v-1.7h6.5v1.7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataFeedbackSolid = {
  name: 'IconFeedbackSolid',
  content: '<path fill="currentColor" d="M20.304 4.927a1.121 1.121 0 0 1 0 1.57l-.001-.002-2.147 2.18-4.108-4.171 2.148-2.18a1.083 1.083 0 0 1 1.544 0l2.564 2.603zM2.751 16.114a.5.5 0 0 1 .138-.273L12.953 5.615l4.109 4.174L6.999 20.011a.5.5 0 0 1-.277.143l-4.042.653a.5.5 0 0 1-.573-.57l.644-4.123zm9.906.886h8.355a1 1 0 1 0 0-2h-6.355l-2 2zm8.354 4H8.657l2-2H21.01a1 1 0 0 1 0 2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFile = {
  name: 'IconFile',
  content: '<path fill="currentColor" d="M7 13h6v2H7v-2zm0-5h10v2H7V8z"/><path fill="currentColor" fill-rule="evenodd" d="M9.357 2h5.286c1.083 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C22 7.4 22 8.273 22 9.357v4.4c0 .408 0 .767-.083 1.115a3 3 0 0 1-.36.867c-.186.306-.44.56-.728.846l-4.244 4.244c-.287.288-.54.542-.846.729a3 3 0 0 1-.867.36c-.348.083-.707.082-1.114.082h-4.4c-1.085 0-1.959 0-2.667-.058-.728-.06-1.369-.185-1.96-.487a5 5 0 0 1-2.186-2.185c-.302-.592-.428-1.232-.487-1.961C2 16.6 2 15.727 2 14.643V9.357c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 4.73 2.544c.592-.302 1.233-.428 1.961-.487C7.4 2 8.273 2 9.357 2zM6.854 4.051c-.605.05-.953.142-1.216.276a3 3 0 0 0-1.311 1.311c-.134.263-.226.611-.276 1.216C4.001 7.471 4 8.264 4 9.4v5.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h4.534v-3.142a2.919 2.919 0 0 1 2.92-2.919h3.145l.001-.264V9.4c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216a3 3 0 0 0-1.311-1.311c-.263-.134-.611-.226-1.216-.276-.617-.05-1.41-.05-2.546-.05H9.4c-1.137 0-1.929 0-2.546.05zM18.81 15.777l-3.037 3.037v-1.956c0-.597.484-1.082 1.082-1.082h1.955z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFileAdd = {
  name: 'IconFileAdd',
  content: '<path fill="currentColor" d="M7 20a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6h2V7a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h6.125v-2H7z"/><path fill="currentColor" d="M13 13H7v2h6v-2zM7 8h10v2H7V8zm7.1 9.211h3.111V14.1h1.8v3.111h3.111v1.8h-3.11v3.111h-1.8v-3.11H14.1v-1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFileAddSolid = {
  name: 'IconFileAddSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 17a5 5 0 0 0 5 5h8.092A5.25 5.25 0 0 1 20 14.093V7a5 5 0 0 0-5-5H5a5 5 0 0 0-5 5v10zm10.5-4H5v2h5.5v-2zM15 8H5v2h10V8z" clip-rule="evenodd"/><path fill="currentColor" d="M15.611 14.1v3.111H12.5v1.8h3.111v3.111h1.8v-3.11h3.111v-1.8h-3.11V14.1h-1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataFileEdit = {
  name: 'IconFileEdit',
  content: '<g fill="currentColor" clip-path="url(#dls-85a26-a)"><path d="m20.114 3.3-7 7H11.8V8.786l6.9-6.9L20.114 3.3z"/><path d="m16.553 2-2 2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7.625l2-2V17a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5h11.553z"/><path d="M5 11h4.3V9H5v2zm0 5v-2h10v2H5z"/></g><defs><clipPath id="dls-85a26-a"><path fill="currentColor" d="M0 0h20v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataFileEditSolid = {
  name: 'IconFileEditSolid',
  content: '<g fill="currentColor" clip-path="url(#dls-70440-a)"><path d="m20.114 3.3-7 7H11.8V8.786l6.9-6.9L20.114 3.3z"/><path fill-rule="evenodd" d="m10.308 8.246 6.057-6.057A5.004 5.004 0 0 0 15 2H5a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7c0-.422-.052-.833-.151-1.224l-6.006 6.005-3.535-.106v-3.43zM9.3 11H5V9h4.3v2zm5.7 5H5v-2h10v2z" clip-rule="evenodd"/></g><defs><clipPath id="dls-70440-a"><path fill="currentColor" d="M0 0h20v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataFileError = {
  name: 'IconFileError',
  content: '<path fill="currentColor" d="m27 3.47 3.667 3.666 3.666-3.666 1.697 1.697-3.666 3.666L36.03 12.5l-1.697 1.697-3.667-3.667L27 14.197 25.303 12.5l3.667-3.667-3.667-3.666L27 3.47z"/><path fill="currentColor" d="M11 6.2A4.8 4.8 0 0 0 6.2 11v18a4.8 4.8 0 0 0 4.8 4.8h18a4.8 4.8 0 0 0 4.8-4.8V18.333h2.4V29a7.2 7.2 0 0 1-7.2 7.2H11A7.2 7.2 0 0 1 3.8 29V11A7.2 7.2 0 0 1 11 3.8h10.875v2.4H11z"/><path fill="currentColor" d="M28.333 23.8H11.666v2.4h16.667v-2.4zM11.666 15h11.667v2.4H11.667V15z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 40 40'
  },
  width: 40,
  height: 40
};

var dataFileErrorSolid = {
  name: 'IconFileErrorSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M18.72 9.697A5 5 0 1 1 15.28.304a5 5 0 0 1 3.438 9.393zm-2.92-7.04 1.3 1.3 1.3-1.3L19.744 4l-1.3 1.3 1.3 1.3L18.4 7.944l-1.3-1.3-1.3 1.3L14.457 6.6l1.3-1.3-1.3-1.3L15.8 2.656z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M17 11.667A6.667 6.667 0 0 1 11.666 1H5a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5v-7.045a6.639 6.639 0 0 1-3 .712zM5 13h5v-2H5v2zm0 3v2h10v-2H5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataFileSolid = {
  name: 'IconFileSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7 2a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5H7zm10.854 11.939a2.919 2.919 0 0 0-2.919 2.919V22h1.838v-5.142c0-.598.484-1.082 1.08-1.082H22V13.94h-4.146zM13 13H7v2h6v-2zM7 8h10v2H7V8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFilm = {
  name: 'IconFilm',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1 5.9a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4v-12zm4-2a2 2 0 0 0-2 2V7h4.6V3.9H5zM21 7h-4.1V3.9H19a2 2 0 0 1 2 2V7zm-5.9 0H9.4V3.9h5.7V7zM3 14.5V9h18v5.5H3zm0 2v1.4a2 2 0 0 0 2 2h2.6v-3.4H3zm6.4 0v3.4h5.7v-3.4H9.4zm7.5 0v3.4H19a2 2 0 0 0 2-2v-1.4h-4.1z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFilmSolid = {
  name: 'IconFilmSolid',
  content: '<g fill="currentColor" clip-path="url(#dls-f37fa-a)"><path d="M6.6 1.9H4a4 4 0 0 0-4 4V7h6.6V1.9zM0 9v5.5h22V9H0zm22-2V5.9a4 4 0 0 0-4-4h-2.1V7H22zm-7.9-5.1H8.4V7h5.7V1.9zM22 16.5h-6.1v5.4H18a4 4 0 0 0 4-4v-1.4zm-7.9 5.4v-5.4H8.4v5.4h5.7zm-7.5 0v-5.4H0v1.4a4 4 0 0 0 4 4h2.6z"/></g><defs><clipPath id="dls-f37fa-a"><path fill="currentColor" d="M0 0h22v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataFilter = {
  name: 'IconFilter',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4.801 4.5a.3.3 0 0 0-.229.494l5.625 6.653v7.994l2.973-2.153a2 2 0 0 0 .827-1.62v-4.45l5.43-6.424a.3.3 0 0 0-.229-.494H4.801zM3.045 6.285C1.78 4.79 2.844 2.5 4.8 2.5h14.397c1.958 0 3.02 2.29 1.757 3.785l-4.958 5.864v3.72a4 4 0 0 1-1.654 3.24L11.37 21.26c-1.322.958-3.173.013-3.173-1.62v-7.26L3.045 6.285z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFilterSolid = {
  name: 'IconFilterSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4.057 2.5c-1.173 0-1.807 1.376-1.044 2.268L8.7 11.415v8.833c0 1.024 1.21 1.568 1.976.888l4.174-3.71c.413-.368.65-.894.65-1.447v-4.694l5.576-6.517c.763-.892.13-2.268-1.044-2.268H4.057z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFireSolid = {
  name: 'IconFireSolid',
  content: '<g clip-path="url(#dls-87b20-a)"><path fill="currentColor" d="M14.789 13c3.2-9.2-4-11.833-8-12 0 4-2 5-2.5 5.5-8 6.4-3 13 .5 15.5-2-4.5 2-7 2.5-7-1 6.5 3.5 8.5 4 8.5 10.5-5.5 7-13.5 6.5-14 0 1.6-2 3-3 3.5z"/></g><defs><clipPath id="dls-87b20-a"><path fill="currentColor" d="M0 0h19v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 19 24'
  },
  width: 19,
  height: 24
};

var dataFitWidth = {
  name: 'IconFitWidth',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.7 1.5H.5v13h1.2v-13zm13.8 0h-1.2v13h1.2v-13zM5.321 5.2l.707.707-1.62 1.621H7.32v1H4.407l1.621 1.622-.707.707-2.475-2.475a.5.5 0 0 1 0-.707L5.321 5.2zm4.65.707.708-.707 2.475 2.475a.5.5 0 0 1 0 .707l-2.475 2.475-.707-.707 1.621-1.622H8.679v-1h2.914l-1.621-1.62z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 16 16'
  },
  width: 16,
  height: 16
};

var dataFlag = {
  name: 'IconFlag',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6 14h11.838c.528 0 .982 0 1.357-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A17.9 17.9 0 0 0 17.839 2H5a1 1 0 0 0-1 1v17.8H1.5v2h7v-2H6V14zm13.032-9.976C18.75 4 18.377 4 17.8 4H6v8h11.8c.577 0 .949 0 1.232-.024.272-.022.372-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.085-.422C20 10.75 20 10.377 20 9.8V6.2c0-.577 0-.949-.024-1.232-.022-.272-.06-.373-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFlagSolid = {
  name: 'IconFlagSolid',
  content: '<path fill="currentColor" d="M19.362 2.327c-.378-.193-.772-.264-1.167-.296C17.82 2 17.365 2 16.839 2H4a1 1 0 0 0-1 1v17.8H.5v2h7v-2H5V14h11.838c.528 0 .982 0 1.357-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167.031-.375.031-.83.031-1.356V6.16c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataFolder = {
  name: 'IconFolder',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.336 4A1.836 1.836 0 0 0 3.5 5.836V17.5a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3V9.982a2.152 2.152 0 0 0-2.152-2.152h-4.983a1.8 1.8 0 0 1-1.359-.62L9.514 4.345A1 1 0 0 0 8.76 4H5.336zM1.5 5.836A3.836 3.836 0 0 1 5.336 2H8.76a3 3 0 0 1 2.264 1.032l2.432 2.798h4.892A4.152 4.152 0 0 1 22.5 9.982V17.5a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5V5.836z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFolderDownload = {
  name: 'IconFolderDownload',
  content: '<path stroke="currentColor" stroke-width="2" d="M20.5 17.5a4 4 0 0 1-4 4h-11a4 4 0 0 1-4-4V5.836A2.836 2.836 0 0 1 4.336 3h3.567a2 2 0 0 1 1.339.514l2.473 2.229a1 1 0 0 0 .67.257h4.133A3.982 3.982 0 0 1 20.5 9.982V17.5z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="2" d="m14.6 13.3-2.809 2.883a1 1 0 0 1-1.414.019L7.4 13.3M11.052 9v7.46"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataFolderDownloadSolid = {
  name: 'IconFolderDownloadSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.5 5.836A3.836 3.836 0 0 1 4.336 2h3.567a3 3 0 0 1 2.008.771L12.384 5h4.134A4.982 4.982 0 0 1 21.5 9.982V17.5a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5V5.836zm13.384 6.766-1.832 1.88V9h-2v5.489l-1.954-1.905-1.396 1.432 2.977 2.902a2 2 0 0 0 2.829-.037l2.809-2.883-1.433-1.396z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataFolderOpen = {
  name: 'IconFolderOpen',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.6 1.8a4 4 0 0 0-4 4v12.5a4 4 0 0 0 4 4h12.262a4 4 0 0 0 3.942-3.322l1.18-6.854a3.001 3.001 0 0 0-2.333-3.443v-.96a3 3 0 0 0-3-3h-5.868L9.74 2.678A3 3 0 0 0 7.62 1.8H5.6zm13.051 6.816V7.72a1 1 0 0 0-1-1h-6.075a1.5 1.5 0 0 1-1.06-.439l-2.19-2.19a1 1 0 0 0-.708-.292H5.6a2 2 0 0 0-2 2v9.707l1.432-4.756a3 3 0 0 1 2.873-2.135H18.65zM17.862 20.3a2 2 0 0 0 1.971-1.66l1.18-6.855a1 1 0 0 0-.986-1.17H7.905a1 1 0 0 0-.958.713l-1.926 6.396a2 2 0 0 0 1.91 2.576h10.931z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFolderOpenSolid = {
  name: 'IconFolderOpenSolid',
  content: '<path fill="currentColor" d="M4.6 1.8a4 4 0 0 0-4 4v12.5a4 4 0 0 0 4 4h12.315a4 4 0 0 0 3.927-3.24l1.391-7.18A2 2 0 0 0 20.27 9.5H5.802a1 1 0 0 0-.976.783L3 18.5V8a1 1 0 0 1 1-1h15.564a3.001 3.001 0 0 0-2.913-2.279h-5.868L8.74 2.678A3 3 0 0 0 6.62 1.8H4.6z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 23 24'
  },
  width: 23,
  height: 24
};

var dataFolderSolid = {
  name: 'IconFolderSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.5 5.836A3.836 3.836 0 0 1 4.336 2H7.76a3 3 0 0 1 2.264 1.032l2.432 2.798h4.892A4.152 4.152 0 0 1 21.5 9.982V17.5a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5V5.836z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataFont = {
  name: 'IconFont',
  content: '<path fill="currentColor" d="M10.663 2.4 4.5 21.7h2.6l1.5-4.974h6.88l1.501 4.974h2.622L13.442 2.4h-2.78zM9.34 14.294l2.666-8.731h.09l2.644 8.73h-5.4z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFontSize = {
  name: 'IconFontSize',
  content: '<path fill="currentColor" d="M1.127 5 2.4 6.273l1.6-1.6v14.454l-1.6-1.6L1.127 18.8l2.783 2.783a1.4 1.4 0 0 0 1.98 0L8.673 18.8 7.4 17.527l-1.6 1.6V4.673l1.6 1.6L8.673 5 5.89 2.217a1.4 1.4 0 0 0-1.98 0L1.127 5z"/><path fill="currentColor" fill-rule="evenodd" d="m8.6 21.2 5.875-18.4h2.65L23 21.2h-2.5l-1.431-4.742h-6.56L11.08 21.2H8.6zm7.157-15.385-2.542 8.324h5.149l-2.521-8.324h-.086z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFourDots = {
  name: 'IconFourDots',
  content: '<path fill="currentColor" d="M3.9 6.3a2.3 2.3 0 1 0 4.6 0 2.3 2.3 0 0 0-4.6 0zm0 11.2a2.3 2.3 0 1 0 4.6 0 2.3 2.3 0 0 0-4.6 0zm14.105-8.9a2.3 2.3 0 1 1 0-4.6 2.3 2.3 0 0 1 0 4.6zm-2.3 8.9a2.3 2.3 0 1 0 4.6 0 2.3 2.3 0 0 0-4.6 0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFourQuarterCircles = {
  name: 'IconFourQuarterCircles',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.8 11.135A9.535 9.535 0 0 1 11.335 1.6a.31.31 0 0 1 .309.309v7.615c0 1.06-.86 1.92-1.92 1.92H2.109a.309.309 0 0 1-.31-.31zm2.09-1.611A7.625 7.625 0 0 1 9.725 3.69v5.833H3.89zm9.066-7.731c0-.107.087-.193.193-.193a9.65 9.65 0 0 1 9.65 9.65.193.193 0 0 1-.192.194h-7.73a1.92 1.92 0 0 1-1.92-1.92V1.793zm1.92 1.92a7.742 7.742 0 0 1 5.81 5.81h-5.81v-5.81zM1.993 12.756a.193.193 0 0 0-.193.193 9.65 9.65 0 0 0 9.65 9.651.193.193 0 0 0 .194-.193v-7.73a1.92 1.92 0 0 0-1.92-1.92H1.993zm1.92 1.92a7.742 7.742 0 0 0 5.81 5.81v-5.81h-5.81zm18.741-.093c-.005.03-.01.062-.017.093-.832 4.492-4.763 7.924-9.488 7.924a.193.193 0 0 1-.193-.193v-7.73c0-1.061.86-1.92 1.92-1.92h7.778c.08 0 .146.065.146.145a9.74 9.74 0 0 1-.146 1.68zm-7.778.093h5.8c-.671 2.875-2.937 5.146-5.8 5.808v-5.808z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFourQuarterCirclesSolid = {
  name: 'IconFourQuarterCirclesSolid',
  content: '<path fill="currentColor" d="M3.593 4.393A9.535 9.535 0 0 0 .8 11.135v-.001a.31.31 0 0 0 .31.31h7.614c1.06 0 1.92-.86 1.92-1.92V1.909a.31.31 0 0 0-.309-.309 9.535 9.535 0 0 0-6.742 2.793zM12.15 1.6a.193.193 0 0 0-.194.193l.001 7.731a1.92 1.92 0 0 0 1.92 1.92h7.73a.195.195 0 0 0 .178-.12.195.195 0 0 0 .014-.074 9.65 9.65 0 0 0-9.65-9.65zM.857 12.813a.193.193 0 0 1 .136-.057v.001h7.731c1.06 0 1.92.859 1.92 1.92v7.73a.193.193 0 0 1-.194.193A9.65 9.65 0 0 1 .8 12.949c0-.051.02-.1.057-.136zm20.795 1.782.002-.012v-.001a9.745 9.745 0 0 0 .146-1.68.146.146 0 0 0-.146-.145h-7.778a1.92 1.92 0 0 0-1.92 1.92v7.73a.193.193 0 0 0 .193.193c4.725 0 8.656-3.432 9.488-7.924l.015-.081z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataFrowningFace = {
  name: 'IconFrowningFace',
  content: '<path fill="currentColor" d="M7.3 11.4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-8.315 7.58a1 1 0 1 1-1.788-.893C6.815 15.35 8.31 13.7 11 13.7c2.643 0 4.342 1.601 4.985 2.887a1 1 0 1 1-1.79.894C13.838 16.766 12.774 15.7 11 15.7c-1.729 0-2.634 1.018-3.016 1.78z"/><path fill="currentColor" fill-rule="evenodd" d="M11 1C4.925 1 0 5.925 0 12s4.925 11 11 11 11-4.925 11-11S17.075 1 11 1zM2 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataFrowningFaceSolid = {
  name: 'IconFrowningFaceSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm8.8-2.1a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm7.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-9.656 8.028a1 1 0 0 0 1.341-.447c.382-.763 1.287-1.781 3.016-1.781 1.774 0 2.838 1.067 3.196 1.78a1 1 0 0 0 1.789-.893C15.342 15.3 13.643 13.7 11 13.7c-2.69 0-4.185 1.65-4.803 2.887a1 1 0 0 0 .447 1.341z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataFullCircle = {
  name: 'IconFullCircle',
  content: '<path fill="currentColor" d="M12.432 8.158v.728h-1.326v-.728H9.312V6.884h1.794V6h1.326v.884h1.781V6h1.313v.884h1.924v1.274h-1.924v.715h-1.313v-.715h-1.781zm-3.53-.221-.962.975c-.468-.598-1.144-1.248-2.002-1.95l.962-.936a14.968 14.968 0 0 1 2.002 1.911zm-.142 3.172-.963.962c-.507-.598-1.235-1.248-2.197-1.937l.962-.936a15.764 15.764 0 0 1 2.197 1.911zm.22 2.067a40.36 40.36 0 0 1-1.885 4.68l-1.26-.559a39.171 39.171 0 0 0 1.95-4.589l1.195.468z"/><path fill="currentColor" fill-rule="evenodd" d="M15.5 15.49c-.208-.494-.39-.897-.546-1.234l-.093.334a7.76 7.76 0 0 1-1.246 2.447l-.884-.767a6.084 6.084 0 0 0 1.3-3.588h-1.352l-.039.364c.312.364.624.767.949 1.209l-.598.897c-.208-.442-.39-.819-.546-1.105a7.143 7.143 0 0 1-1.066 2.275l-.754-.65v2.249H9.403v-6.409h2.184v-1.027H9V9.237h8.645v1.248h-2.483v1.027h2.197v5.005c0 .884-.416 1.326-1.248 1.326h-1.027l-.338-1.183.988.065c.26 0 .403-.169.403-.481v-3.562h-.975l-.039.559c.325.416.65.858.975 1.352l-.598.897zm-2.795-3.978h1.339v-1.027h-1.339v1.027zm-2.08 1.17v2.678a6 6 0 0 0 .923-2.678h-.923z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFullCircleSolid = {
  name: 'IconFullCircleSolid',
  content: '<path fill="currentColor" d="M14.987 12.832v1.328a21.107 21.107 0 0 0-.71-.966l.025-.362h.685zm-2.114 0c-.027.44-.097.864-.21 1.272a20.85 20.85 0 0 0-.867-1.106l.018-.166h1.06zm-1.018-1.47v-.727h1.039v.727h-1.039zm-2.08 3.436v-1.966h.606a5.806 5.806 0 0 1-.606 1.966z"/><path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm5.994-6.091-.103-.083-1.178 1.146.13.106c.854.699 1.52 1.34 1.979 1.926l.105.135 1.179-1.195-.09-.105a15.117 15.117 0 0 0-2.022-1.93zm5.588-.059H9.956v.884H8.162v1.574h1.794v.728h1.626v-.728h1.481v.715h1.613v-.715H16.6V6.734h-1.924V5.85h-1.613v.884h-1.481V5.85zM5.548 9.002l.103.075a15.915 15.915 0 0 1 2.217 1.93l.1.105-1.18 1.18-.105-.124c-.497-.586-1.215-1.228-2.17-1.912l-.146-.104 1.181-1.15zm11.247.085H7.85v1.548h2.587v.727H8.253v6.709h1.522v-2.072l.631.545.096-.136a7.276 7.276 0 0 0 .981-1.963c.113.223.237.482.372.77l.113.241.483-.724a6.02 6.02 0 0 1-.838 1.446l-.088.112 1.113.966.097-.129c.565-.749.98-1.56 1.252-2.438.114.252.239.536.375.86l.108.256.517-.775v1.214c0 .136-.031.216-.069.261-.033.04-.087.069-.18.07l-1.195-.079.428 1.497h1.14c.441 0 .8-.118 1.045-.379.244-.259.353-.634.353-1.097v-5.155h-2.197v-.727h2.483V9.087zM6.694 12.512l1.474.576-.046.136A40.508 40.508 0 0 1 6.23 17.92l-.063.131-1.537-.682.07-.14a39.02 39.02 0 0 0 1.942-4.572l.052-.146z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataFullscreen = {
  name: 'IconFullscreen',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M2.5 19.7v-4.8h2v4.6h4.6v2H4.3a1.8 1.8 0 0 1-1.8-1.8zm0-15.377v4.8h2v-4.6h4.6v-2H4.3a1.8 1.8 0 0 0-1.8 1.8zm19 4.8v-4.8a1.8 1.8 0 0 0-1.8-1.8h-4.8v2h4.6v4.6h2zm0 10.577v-4.8h-2v4.6h-4.6v2h4.8a1.8 1.8 0 0 0 1.8-1.8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataFullscreenExit = {
  name: 'IconFullscreenExit',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M9.6 16.8v4.8h-2V17H3v-2h4.8a1.8 1.8 0 0 1 1.8 1.8zm-.5-9.477v-4.8h-2v4.6H2.5v2h4.8a1.8 1.8 0 0 0 1.8-1.8zm5.8-4.8v4.8a1.8 1.8 0 0 0 1.8 1.8h4.8v-2h-4.6v-4.6h-2zM15 16.8v4.8h2V17h4.6v-2h-4.8a1.8 1.8 0 0 0-1.8 1.8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataGallery = {
  name: 'IconGallery',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m14.714 18.797-4.757 1.052a.6.6 0 0 1-.73-.586V4.738a.6.6 0 0 1 .73-.586l4.757 1.052a.4.4 0 0 1 .313.39v12.812a.4.4 0 0 1-.313.391zm-4.325 3.005a2.6 2.6 0 0 1-3.162-2.54V4.739A2.6 2.6 0 0 1 10.389 2.2l4.756 1.052a2.4 2.4 0 0 1 1.882 2.343v12.812a2.4 2.4 0 0 1-1.882 2.344l-4.756 1.052zm-6.49-3.95-.938-.774a.167.167 0 0 1-.061-.128V7.623c0-.043.016-.083.045-.114L3.9 6.494v11.359zm-.453 2.218c.978.807 2.454.11 2.454-1.157V5.233c0-1.358-1.661-2.017-2.592-1.027l-1.82 1.932A2.167 2.167 0 0 0 .9 7.623v9.327c0 .647.29 1.26.789 1.672l1.757 1.448zM21.039 8.863l-.939-.762v8.298l.938-.762a.167.167 0 0 0 .062-.13V8.993a.167.167 0 0 0-.062-.13zM18.1 7.051c0-1.264 1.466-1.961 2.446-1.165L22.3 7.311c.506.412.8 1.03.8 1.682v6.514c0 .653-.294 1.27-.8 1.682l-1.754 1.425c-.98.796-2.446.099-2.446-1.165V7.05z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataGallerySolid = {
  name: 'IconGallerySolid',
  content: '<path fill="currentColor" d="M7.227 19.278a2.6 2.6 0 0 0 3.15 2.541l4.98-1.076a2.4 2.4 0 0 0 1.893-2.346V5.604a2.4 2.4 0 0 0-1.893-2.346l-4.98-1.077a2.6 2.6 0 0 0-3.15 2.541v14.556zM1.5 17.017c0 .33.14.646.386.867L3.65 19.47c.644.579 1.67.122 1.67-.744V4.891c0-.866-1.026-1.323-1.67-.744L1.886 5.734a1.167 1.167 0 0 0-.386.867v10.416zm21-8.886c0-.38-.185-.736-.496-.954l-1.747-1.229a1 1 0 0 0-1.575.818v10.467a1 1 0 0 0 1.575.818l1.747-1.228c.311-.219.496-.575.496-.955V8.131z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataGamepad = {
  name: 'IconGamepad',
  content: '<path fill="currentColor" d="M7.1 11.5v2.1H5v1.8h2.1v2.1h1.8v-2.1H11v-1.8H8.9v-2.1H7.1z"/><path fill="currentColor" fill-rule="evenodd" d="M16 11.6a2.9 2.9 0 1 0 0 5.8 2.9 2.9 0 0 0 0-5.8zm-1.1 2.9a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M16.9 1.2v2.857a.9.9 0 0 1-.9.9h-3.1V7.1h3.06c3.852 0 6.84 3.391 6.84 7.4s-2.988 7.4-6.84 7.4H8.04c-3.852 0-6.84-3.391-6.84-7.4s2.988-7.4 6.84-7.4h3.06V4.057a.9.9 0 0 1 .9-.9h3.1V1.2h1.8zM8.04 8.9C5.331 8.9 3 11.33 3 14.5c0 3.17 2.331 5.6 5.04 5.6h7.92c2.71 0 5.04-2.43 5.04-5.6 0-3.17-2.33-5.6-5.04-5.6H8.04z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataGamepadSolid = {
  name: 'IconGamepadSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M15.9 4.057V1.2h-1.8v1.957H11a.9.9 0 0 0-.9.9V7.1H7.04C3.188 7.1.2 10.491.2 14.5s2.988 7.4 6.84 7.4h7.92c3.852 0 6.84-3.391 6.84-7.4s-2.988-7.4-6.84-7.4H11.9V4.957H15a.9.9 0 0 0 .9-.9zM6.1 17.5v-2.1H4v-1.8h2.1v-2.1h1.8v2.1H10v1.8H7.9v2.1H6.1zm11.9-3a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataGateway = {
  name: 'IconGateway',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.355 20A3.502 3.502 0 0 1 1.5 19 3.502 3.502 0 0 1 4 15.645v-7.29A3.502 3.502 0 0 1 5 1.5 3.502 3.502 0 0 1 8.355 4h7.29A3.502 3.502 0 0 1 22.5 5 3.502 3.502 0 0 1 20 8.355v7.29a3.502 3.502 0 0 1-1 6.855 3.502 3.502 0 0 1-3.355-2.5h-7.29zM6.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM6 8.355A3.508 3.508 0 0 0 8.355 6h7.29A3.508 3.508 0 0 0 18 8.355v7.29A3.508 3.508 0 0 0 15.645 18h-7.29A3.508 3.508 0 0 0 6 15.645v-7.29zM6.5 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM19 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM20.5 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataGatewaySolid = {
  name: 'IconGatewaySolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7.355 4A3.502 3.502 0 0 0 .5 5 3.502 3.502 0 0 0 3 8.355v7.29A3.502 3.502 0 0 0 4 22.5 3.502 3.502 0 0 0 7.355 20h7.29a3.502 3.502 0 0 0 6.855-1 3.502 3.502 0 0 0-2.5-3.355v-7.29A3.502 3.502 0 0 0 18 1.5 3.502 3.502 0 0 0 14.645 4h-7.29zM5 8.355v7.29A3.508 3.508 0 0 1 7.355 18h7.29A3.508 3.508 0 0 1 17 15.645v-7.29A3.508 3.508 0 0 1 14.645 6h-7.29A3.508 3.508 0 0 1 5 8.355z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataGift = {
  name: 'IconGift',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.706.789 7.389 2.294 9.339 4H4.3a3 3 0 0 0-3 3v2A3 3 0 0 0 3 11.704V20a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8.296A3 3 0 0 0 22.7 9V7a3 3 0 0 0-3-3h-5.038l1.95-1.706L15.293.79 12 3.67 8.706.79zM4.3 6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h15.4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H4.3zM19 12h-6v9h5a1 1 0 0 0 1-1v-8zm-8 9v-9H5v8a1 1 0 0 0 1 1h5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataGiftSolid = {
  name: 'IconGiftSolid',
  content: '<path fill="currentColor" d="M11 3.671 7.706.79 6.389 2.294 8.339 4h-5.04a3 3 0 0 0-3 3v2A3 3 0 0 0 2 11.705v.005h18v-.006A3 3 0 0 0 21.7 9V7a3 3 0 0 0-3-3h-5.04l1.95-1.706L14.294.79 11 3.67zm9 10.039h-8V23h5a3 3 0 0 0 3-3v-6.29zm-10 0V23H5a3 3 0 0 1-3-3v-6.29h8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataGirl = {
  name: 'IconGirl',
  content: '<path fill="currentColor" d="M2 11C2 5.477 6.477 1 12 1s10 4.477 10 10v11.5h-2V11a8 8 0 1 0-16 0v11.5H2V11z"/><path fill="currentColor" fill-rule="evenodd" d="M5.62 14.112C5.413 12.342 6.88 11 8.5 11h7c1.62 0 3.087 1.341 2.88 3.112-.247 2.116-.88 4.048-1.923 5.48C15.397 21.045 13.888 22 12 22c-1.889 0-3.397-.954-4.458-2.409-1.043-1.43-1.676-3.363-1.922-5.479zM8.5 13c-.59 0-.943.457-.894.88.221 1.895.773 3.464 1.552 4.533C9.92 19.457 10.871 20 12 20c1.128 0 2.08-.543 2.841-1.587.78-1.069 1.332-2.638 1.553-4.532.049-.424-.305-.881-.894-.881h-7z" clip-rule="evenodd"/><path fill="currentColor" d="M7.4 10.5a4.005 4.005 0 0 1 4.402-3.981l.173-1.792A5.805 5.805 0 0 0 5.6 10.5h1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataGirlSolid = {
  name: 'IconGirlSolid',
  content: '<path fill="currentColor" d="M11 1C5.477 1 1 5.477 1 11v11.5h2V11a8 8 0 0 1 16 0v11.5h2V11c0-5.523-4.477-10-10-10z"/><path fill="currentColor" d="M10.41 6.5a4.005 4.005 0 0 0-4.01 4H4.6a5.805 5.805 0 0 1 6.375-5.773l-.173 1.792a4.082 4.082 0 0 0-.392-.02zM7.5 11c-1.62 0-3.087 1.341-2.88 3.112.247 2.116.88 4.048 1.923 5.48C7.603 21.045 9.112 22 11 22c1.889 0 3.397-.954 4.457-2.409 1.044-1.43 1.677-3.363 1.923-5.479.207-1.77-1.26-3.112-2.88-3.112h-7z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataGradeCircle = {
  name: 'IconGradeCircle',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M15.606 6.37h-7.2v4.584h7.2V6.37zm-5.64 3.108V7.846h4.08v1.632h-4.08zm1.644 1.968H6.786v5.772H8.31v-.564h1.788v.564h1.512v-5.772zm-3.3 3.744v-2.268h1.788v2.268H8.31zm8.904-3.744h-4.968v5.772h1.524v-.564h1.896v.564h1.548v-5.772zM13.77 15.19v-2.268h1.896v2.268H13.77z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11-9a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataGradeCircleSolid = {
  name: 'IconGradeCircleSolid',
  content: '<path fill="currentColor" d="M8.966 9.478V7.846h4.08v1.632h-4.08zM7.31 15.19v-2.268h1.788v2.268H7.31zm5.46-2.268v2.268h1.896v-2.268H12.77z"/><path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm14.606-5.63h-7.2v4.584h7.2V6.37zm-3.996 5.076H5.786v5.772H7.31v-.564h1.788v.564h1.512v-5.772zm.636 0h4.968v5.772h-1.548v-.564H12.77v.564h-1.524v-5.772z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataHamburger = {
  name: 'IconHamburger',
  content: '<path fill-rule="evenodd" d="M20.57 16.4v2h-17v-2h17Zm0-5.475v2h-17v-2h17Zm0-5.475v2h-17v-2h17Z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHammerSolid = {
  name: 'IconHammerSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m20.908 14.709-9.072-4.404 1.597-3.166.002.001a.626.626 0 0 0 .84-.277l.017-.031a.628.628 0 0 0-.278-.841L8.04 2.979a.628.628 0 0 0-.842.277l-.017.032a.625.625 0 0 0 .278.841h.001l-4.208 8.349-.002-.001a.628.628 0 0 0-.841.277l-.014.03a.628.628 0 0 0 .277.842l5.976 3.013a.628.628 0 0 0 .841-.277l.016-.033a.626.626 0 0 0-.277-.84h-.002l1.544-3.067 8.987 4.573a1.278 1.278 0 0 0 1.76-.547 1.279 1.279 0 0 0-.608-1.74zM3 19.5a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHeadphones = {
  name: 'IconHeadphones',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12.401 1.5c3.62 0 6.57 2.924 6.901 6.638l.018.237h.93a2.75 2.75 0 0 1 2.745 2.588l.005.162v2.292a2.75 2.75 0 0 1-2.588 2.745l-.162.005h-.917v.458a5.502 5.502 0 0 1-3.836 5.244 1.372 1.372 0 0 1-1.205.714h-2.75a1.375 1.375 0 1 1 0-2.75h2.75c.29 0 .558.09.78.243a3.665 3.665 0 0 0 2.424-3.268l.004-.183V8.833c0-2.979-2.191-5.385-4.904-5.496l-.195-.004h-.802c-2.737 0-4.992 2.337-5.095 5.289l-.004.211v7.334H3.75a2.75 2.75 0 0 1-2.745-2.589L1 13.417v-2.292A2.75 2.75 0 0 1 3.588 8.38l.162-.005h.93c.221-3.751 3.106-6.753 6.698-6.871L11.6 1.5h.802zm7.849 8.708h-.917v4.125h.917c.47 0 .858-.354.91-.81l.007-.106v-2.292a.917.917 0 0 0-.81-.91l-.107-.007zm-15.583 0H3.75a.917.917 0 0 0-.91.81l-.007.107v2.292c0 .47.354.857.81.91l.107.006h.917v-4.125z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHeadphonesSolid = {
  name: 'IconHeadphonesSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.401 1.5c3.62 0 6.57 2.924 6.901 6.638l.018.237h.93a2.75 2.75 0 0 1 2.745 2.588l.005.162v2.292a2.75 2.75 0 0 1-2.588 2.745l-.162.005h-.917v.458a5.502 5.502 0 0 1-3.836 5.244 1.372 1.372 0 0 1-1.205.714h-2.75a1.375 1.375 0 1 1 0-2.75h2.75c.29 0 .558.09.78.243a3.665 3.665 0 0 0 2.424-3.268l.004-.183V8.833c0-2.979-2.191-5.385-4.904-5.496l-.195-.004h-.802c-2.737 0-4.992 2.337-5.095 5.289l-.004.211v7.334H2.75a2.75 2.75 0 0 1-2.745-2.589L0 13.417v-2.292A2.75 2.75 0 0 1 2.588 8.38l.162-.005h.93c.221-3.751 3.106-6.753 6.698-6.871L10.6 1.5h.802z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataHeart = {
  name: 'IconHeart',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M16.819 4.207c-.96.058-1.721.487-1.939.657-.218.17-.627.576-1.077 1.05a2.502 2.502 0 0 1-3.623.03c-.445-.46-.87-.88-1.131-1.094l-.022-.017-.02-.019c-.3-.273-1.048-.603-2.006-.565-.91.036-1.961.406-2.882 1.444-1.288 1.452-1.696 4.489.037 6.688 1.837 2.33 4.668 5.108 6.572 6.896.72.676 1.825.677 2.548 0 1.927-1.803 4.802-4.605 6.642-6.902.444-.554.941-1.71 1.057-3.04.115-1.311-.153-2.637-1.032-3.65-1.104-1.272-2.23-1.533-3.124-1.478zm-.121-1.997c1.487-.09 3.225.401 4.756 2.164 1.338 1.542 1.66 3.466 1.514 5.134-.144 1.648-.755 3.2-1.49 4.117-1.937 2.42-4.906 5.307-6.836 7.113a3.853 3.853 0 0 1-5.283-.003c-1.909-1.793-4.837-4.658-6.774-7.116-2.353-2.985-1.871-7.101.038-9.253C3.924 2.898 5.498 2.307 6.92 2.251c1.363-.055 2.647.382 3.412 1.066.366.302.859.797 1.284 1.236a.502.502 0 0 0 .735-.014c.431-.456.942-.975 1.299-1.253.486-.379 1.625-.99 3.047-1.076z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHeartCancel = {
  name: 'IconHeartCancel',
  content: '<path fill="currentColor" d="M16.819 4.207c-.96.058-1.721.487-1.939.657-.218.17-.627.576-1.077 1.05a2.502 2.502 0 0 1-3.623.03c-.445-.46-.87-.88-1.131-1.094l-.022-.017-.02-.019c-.3-.273-1.048-.603-2.006-.565-.91.036-1.961.406-2.882 1.444-1.288 1.452-1.696 4.489.037 6.688 1.837 2.33 4.668 5.108 6.572 6.896a1.85 1.85 0 0 0 2.074.325l1.454 1.454a3.852 3.852 0 0 1-4.897-.321c-1.909-1.793-4.837-4.658-6.774-7.116-2.353-2.985-1.871-7.101.038-9.253C3.924 2.898 5.498 2.307 6.92 2.251c1.363-.055 2.647.382 3.412 1.066.366.302.859.797 1.284 1.237a.502.502 0 0 0 .735-.015c.431-.456.942-.975 1.299-1.252.486-.38 1.625-.99 3.047-1.077 1.487-.09 3.225.401 4.756 2.164 1.338 1.542 1.66 3.466 1.514 5.134-.119 1.362-.556 2.658-1.12 3.584l-1.475-1.476a6.892 6.892 0 0 0 .602-2.282c.115-1.31-.153-2.636-1.032-3.649-1.104-1.272-2.23-1.533-3.124-1.478z"/><path fill="currentColor" d="m15.2 12.786 2.3 2.3 2.3-2.3 1.414 1.414-2.3 2.3 2.3 2.3-1.414 1.414-2.3-2.3-2.3 2.3-1.414-1.414 2.3-2.3-2.3-2.3 1.414-1.414z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHeartCancelSolid = {
  name: 'IconHeartCancelSolid',
  content: '<g clip-path="url(#dls-b9aad-a)"><path fill="currentColor" fill-rule="evenodd" d="M8.899 5.249c.6.62 1.584.605 2.178-.023.441-.464.901-.927 1.188-1.15.705-.55 3.799-2.082 6.433.954 1.946 2.242 1.384 5.556.42 7.327a5.5 5.5 0 0 0-7.568 7.97 2.851 2.851 0 0 1-3.507-.321C6.137 18.216 3.257 15.394 1.371 13c-2.044-2.592-1.599-6.168 0-7.97 2.222-2.506 5.248-1.923 6.31-.955.314.257.778.72 1.218 1.174zm4.301 7.537 2.3 2.3 2.3-2.3 1.415 1.414-2.3 2.3 2.3 2.3-1.415 1.414-2.3-2.3-2.3 2.3-1.414-1.414 2.3-2.3-2.3-2.3 1.414-1.414z" clip-rule="evenodd"/></g><defs><clipPath id="dls-b9aad-a"><path fill="currentColor" d="M0 0h20v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataHeartHandshakeSolid = {
  name: 'IconHeartHandshakeSolid',
  content: '<path fill="currentColor" d="M14.121 10.48a1 1 0 0 0-1.414 0l-.707.707a2 2 0 0 1-2.828-2.829l5.63-5.632a6.5 6.5 0 0 1 6.377 10.568l-2.108 2.135-4.95-4.95zM3.161 4.468a6.503 6.503 0 0 1 8.009-.938L7.757 6.944a4 4 0 0 0 5.513 5.794l.144-.137 4.243 4.242-4.243 4.243a2 2 0 0 1-2.828 0L3.16 13.661a6.5 6.5 0 0 1 0-9.192z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHeartSolid = {
  name: 'IconHeartSolid',
  content: '<path fill="currentColor" d="M21.192 4.32c-1.49-1.718-3.186-2.198-4.637-2.11-1.386.084-2.496.68-2.972 1.05-.34.265-.82.752-1.23 1.182a.504.504 0 0 1-.737.015c-.403-.416-.866-.88-1.214-1.166-.748-.67-2.002-1.095-3.33-1.042-1.388.055-2.922.632-4.19 2.062-1.861 2.098-2.33 6.107-.038 9.014 1.861 2.362 4.664 5.11 6.516 6.852a3.848 3.848 0 0 0 5.28.003c1.873-1.754 4.715-4.524 6.578-6.849.717-.895 1.31-2.406 1.45-4.01.142-1.623-.17-3.498-1.476-5.002z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHeteronymSquare = {
  name: 'IconHeteronymSquare',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11zm13.89 6.397v.732c-.033 1.173-.603 1.792-1.71 1.857-1.073-.033-1.627-.733-1.66-2.1.066-1.434.636-2.183 1.71-2.248 1.073.033 1.627.619 1.66 1.759zM19 9.624h-1.61v.781c-.457-.52-1.059-.781-1.807-.781-2.018.163-3.092 1.433-3.222 3.81.098 2.247 1.107 3.436 3.027 3.566.878 0 1.545-.277 2.001-.83v.683H19v-7.23zM13.093 6.4l1.855 2.442h1.465L18.268 6.4H16.51l-.83 1.514-.83-1.514h-1.757zm-6.482 7.278v-.83c.065-1.107.586-1.677 1.562-1.71 1.074.033 1.61.782 1.61 2.247 0 1.433-.536 2.15-1.61 2.15-1.041 0-1.562-.62-1.562-1.857zM5 16.853h1.61v-.635c.456.521 1.075.782 1.856.782 1.952-.065 2.945-1.27 2.978-3.615-.066-2.41-1.058-3.663-2.978-3.761-.684-.033-1.302.244-1.855.83V7.328H5v9.525z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHexagonSolid = {
  name: 'IconHexagonSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13 2.578a2 2 0 0 0-2 0L4.34 6.423a2 2 0 0 0-1 1.732v7.69a2 2 0 0 0 1 1.732L11 21.424a2 2 0 0 0 2 0l6.66-3.845a2 2 0 0 0 1-1.732V8.154a2 2 0 0 0-1-1.732L13 2.578zM11.983 17.7l5.242-2.958L16.242 13 11 15.958l.983 1.742z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHierarchy = {
  name: 'IconHierarchy',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7.5 4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H13v2h5a1 1 0 0 1 1 1v3h1.5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2H17v-2H7v2h1.5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2H5v-3a1 1 0 0 1 1-1h5V9H9.5a2 2 0 0 1-2-2V4zm-4 13v3h5v-3h-5zm12 0v3h5v-3h-5zm-1-13h-5v3h5V4z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHierarchySolid = {
  name: 'IconHierarchySolid',
  content: '<path fill="currentColor" d="M8.5 2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2H10v2H5a1 1 0 0 0-1 1v3H2.5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H6v-2h10v2h-1.5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H18v-3a1 1 0 0 0-1-1h-5V9h1.5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-5z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataHighSquare = {
  name: 'IconHighSquare',
  content: '<path fill="currentColor" d="m10.921 6.096 1.521-.26c.104.312.221.663.325 1.04h5.018v1.248H6.202V6.876h5.083a7.31 7.31 0 0 0-.364-.78zm6.331 10.465c0 .897-.533 1.352-1.586 1.352H14.6l-.325-1.196 1.001.039c.455 0 .689-.156.689-.468v-3.185h-7.93v4.849H6.748v-6.019h10.504v4.628z"/><path fill="currentColor" fill-rule="evenodd" d="M8.204 11.413V8.657h7.605v2.756H8.204zm1.3-1.014h5.005v-.728H9.504v.728zm-.169 6.032v-2.808h5.356v2.808H9.335zm1.196-1.001h2.964v-.806h-2.964v.806z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHighSquareSolid = {
  name: 'IconHighSquareSolid',
  content: '<path fill="currentColor" d="M8.654 10.249V9.82h4.705v.428H8.654zm1.027 4.525v.506h2.664v-.506H9.681z"/><path fill="currentColor" fill-rule="evenodd" d="M.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm11.085-.71-.041-.124-1.857.318.103.185c.094.17.182.355.27.557H5.051v1.548h11.883V6.726H11.88c-.097-.34-.203-.655-.296-.936zm3.374 2.717H7.054v3.056h7.905V8.507zm-9.361 3.276h10.804v4.778c0 .479-.143.864-.45 1.126-.304.259-.741.376-1.286.376h-1.18l-.403-1.482H8.185v-3.108h5.656v3.108h-.204l.642.025c.213 0 .35-.038.428-.091.07-.047.108-.114.108-.227v-3.035h-7.63v4.849H5.598v-6.32z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataHome = {
  name: 'IconHome',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m21 10.252 1.09.96 1.32-1.502-8.105-7.135a5 5 0 0 0-6.606 0L.589 9.71l1.32 1.501L3 10.252V17.4a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5v-7.148zm-7.016-6.176a3 3 0 0 0-3.963 0L5 8.493V17.4a3 3 0 0 0 3 3h.6v-5a3.4 3.4 0 1 1 6.8 0v5h.6a3 3 0 0 0 3-3V8.491l-5.016-4.415zM13.4 20.4v-5a1.4 1.4 0 1 0-2.8 0v5h2.8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHomeAltSolid = {
  name: 'IconHomeAltSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.174 2.011 3.087 7.733A4 4 0 0 0 1.6 10.845v8.089a4 4 0 0 0 4 4h12.8a4 4 0 0 0 4-4v-8.737a4 4 0 0 0-1.511-3.131l-6.38-5.07a3.467 3.467 0 0 0-4.335.015zM14.667 12A2.667 2.667 0 0 0 12 14.667v4c0 .736.597 1.333 1.333 1.333H16c.736 0 1.333-.597 1.333-1.333v-4A2.667 2.667 0 0 0 14.667 12z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHomeSolid = {
  name: 'IconHomeSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.91 11.211 3 10.252V17.4a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5v-7.148l1.09.96 1.32-1.502-8.105-7.135a5 5 0 0 0-6.606 0L.589 9.71l1.32 1.501zM10.6 15.4a1.4 1.4 0 1 1 2.8 0V21h2v-5.6a3.4 3.4 0 0 0-6.8 0V21h2v-5.6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHospital = {
  name: 'IconHospital',
  content: '<path fill="currentColor" d="M8.9 8.325V11H6.225v2H8.9v2.675h2V13h2.675v-2H10.9V8.325h-2z"/><path fill="currentColor" fill-rule="evenodd" d="M1.5 5.5a4 4 0 0 1 4-4h8.8a4 4 0 0 1 4 4v17H5.5a4 4 0 0 1-4-4v-13zm4-2h8.8a2 2 0 0 1 2 2v15H5.5a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2z" clip-rule="evenodd"/><path fill="currentColor" d="M18.3 11.95h1.15a1 1 0 0 1 1 1v6.5a1 1 0 0 1-1 1H18.3v2h1.15a3 3 0 0 0 3-3v-6.5a3 3 0 0 0-3-3H18.3v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHospitalSolid = {
  name: 'IconHospitalSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4.5 1.5a4 4 0 0 0-4 4v13a4 4 0 0 0 4 4h12.8v-17a4 4 0 0 0-4-4H4.5zm3.4 14.175V13H5.225v-2H7.9V8.325h2V11h2.675v2H9.9v2.675h-2z" clip-rule="evenodd"/><path fill="currentColor" d="M18.45 11.95H17.3v-2h1.15a3 3 0 0 1 3 3v6.5a3 3 0 0 1-3 3H17.3v-2h1.15a1 1 0 0 0 1-1v-6.5a1 1 0 0 0-1-1z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataHourglass = {
  name: 'IconHourglass',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m7.062 13.37 1.3-1.375-1.3-1.374L2.5 5.803V4.2a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1.605l-4.548 4.818-1.29 1.367 1.285 1.373 4.525 4.832.01 1.599a1 1 0 0 1-1 1.006H3.5a1 1 0 0 1-1-1v-1.604l4.562-4.826zM17.5 5.805a2 2 0 0 1-.546 1.373l-4.547 4.818 4.525 4.832a2 2 0 0 1 .54 1.355l.01 1.599a3 3 0 0 1-3 3.018H3.5a3 3 0 0 1-3-3v-1.604a2 2 0 0 1 .547-1.374l4.562-4.826-4.561-4.818A2 2 0 0 1 .5 5.803V4.2a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v1.605zM13 17.6H5v2h8v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 18 24'
  },
  width: 18,
  height: 24
};

var dataHourglassSolid = {
  name: 'IconHourglassSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.2h11a3 3 0 0 1 3 3v1.605a2 2 0 0 1-.546 1.373l-4.547 4.818 4.525 4.832a2 2 0 0 1 .54 1.355l.01 1.599a3 3 0 0 1-3 3.018H6.5a3 3 0 0 1-3-3v-1.604a2 2 0 0 1 .547-1.374l4.562-4.826-4.561-4.818A2 2 0 0 1 3.5 5.803V4.2a3 3 0 0 1 3-3zM16 19.6v-2H8v2h8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHouse = {
  name: 'IconHouse',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m21 10.252 1.09.96 1.322-1.502-8.106-7.135a5 5 0 0 0-6.606 0L.589 9.71l1.32 1.501L3 10.252V17.4a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5v-7.148zm-7.015-6.176a3 3 0 0 0-3.964 0L5 8.493V17.4a3 3 0 0 0 3 3V14a4 4 0 0 1 8 0v6.4a3 3 0 0 0 3-3V8.491l-5.015-4.415zM14 20.4V18h-4v2.4h4zm0-4.4v-2a2 2 0 1 0-4 0v2h4z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataHouseSolid = {
  name: 'IconHouseSolid',
  content: '<path fill="currentColor" d="M1.91 11.211 3 10.252V17.4a5 5 0 0 0 5 5V15a4 4 0 0 1 8 0v7.4a5 5 0 0 0 5-5v-7.148l1.09.96 1.32-1.502-8.105-7.135a5 5 0 0 0-6.606 0L.589 9.71l1.32 1.501z"/><path fill="currentColor" d="M14 22.4V19h-4v3.4h4zm0-7.4v2h-4v-2a2 2 0 1 1 4 0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataIdCard = {
  name: 'IconIdCard',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M31.7 16.893a4.69 4.69 0 0 1-2.173 3.96 7.253 7.253 0 0 1 4.673 6.779h-2a5.25 5.25 0 1 0-10.5 0h-2a7.253 7.253 0 0 1 4.745-6.806 4.693 4.693 0 1 1 7.255-3.933zM27.006 14.2a2.693 2.693 0 1 0 0 5.386 2.693 2.693 0 0 0 0-5.386z" clip-rule="evenodd"/><path fill="currentColor" d="M6.7 13.7v2h12.5v-2H6.7zm0 5.8h10v2h-10v-2zm0 5.8v2h7.5v-2H6.7z"/><path fill="currentColor" fill-rule="evenodd" d="M8.5 5.3a7.2 7.2 0 0 0-7.2 7.2v15a7.2 7.2 0 0 0 7.2 7.2h23a7.2 7.2 0 0 0 7.2-7.2v-15a7.2 7.2 0 0 0-7.2-7.2h-23zm-4.8 7.2a4.8 4.8 0 0 1 4.8-4.8h23a4.8 4.8 0 0 1 4.8 4.8v15a4.8 4.8 0 0 1-4.8 4.8h-23a4.8 4.8 0 0 1-4.8-4.8v-15z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 40 40'
  },
  width: 40,
  height: 40
};

var dataIdCardBack = {
  name: 'IconIdCardBack',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.3 12.5a7.2 7.2 0 0 1 7.2-7.2h23a7.2 7.2 0 0 1 7.2 7.2v15a7.2 7.2 0 0 1-7.2 7.2h-23a7.2 7.2 0 0 1-7.2-7.2v-15zm7.2-4.8a4.8 4.8 0 0 0-4.8 4.8v15a4.8 4.8 0 0 0 4.8 4.8h23a4.8 4.8 0 0 0 4.8-4.8v-15a4.8 4.8 0 0 0-4.8-4.8h-23z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12.667 13.667a5.667 5.667 0 0 0-3.869 9.807l.43.402-.412 1.65c.661.332 1.943.807 3.85.807 1.908 0 3.19-.475 3.851-.806l-.412-1.65.43-.403a5.667 5.667 0 0 0-3.868-9.808zm3.978 12.368zM5 19.333a7.667 7.667 0 1 1 13.324 5.174l.26 1.043a1.3 1.3 0 0 1-.547 1.411c-.638.415-2.433 1.372-5.37 1.372-2.938 0-4.733-.957-5.37-1.372a1.301 1.301 0 0 1-.549-1.411l.26-1.043A7.642 7.642 0 0 1 5 19.333z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M16.523 22.232c-3.236 2.312-6.394.964-7.6-.04l1.153-1.383c.795.662 3.037 1.647 5.4-.041l1.047 1.464zM23 14h10v2H23v-2zm0 10h10v2H23v-2zm10-5h-7v2h7v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 38 40'
  },
  width: 38,
  height: 40
};

var dataIdCardBackSolid = {
  name: 'IconIdCardBackSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4 3a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H4zm5.73 10.923a4 4 0 1 0-5.461 0l-.238.953a.181.181 0 0 0 .074.198c.304.197 1.27.726 2.895.726 1.626 0 2.59-.529 2.895-.726a.181.181 0 0 0 .074-.198l-.238-.953zm-4.91-.55L5 13.2l.18-.174.004.005.022.02a2.751 2.751 0 0 0 .459.332c.32.185.776.367 1.335.367a2.67 2.67 0 0 0 1.335-.367 2.75 2.75 0 0 0 .48-.352l.005-.005.18.174.18.174-.002.001-.003.003-.009.01a1.717 1.717 0 0 1-.147.13c-.1.083-.247.19-.434.299A3.171 3.171 0 0 1 7 14.25a3.173 3.173 0 0 1-1.585-.433 3.261 3.261 0 0 1-.581-.43l-.01-.009-.002-.003H4.82v-.001zM21 8h-8v2h8V8zm-6 5h6v2h-6v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataIdCardSolid = {
  name: 'IconIdCardSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4 3a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H4zm15.571 6.45c0-1.353-1.15-2.45-2.57-2.45-1.421 0-2.572 1.097-2.572 2.45 0 1.353 1.15 2.45 2.571 2.45 1.42 0 2.571-1.097 2.571-2.45zm-6.714 6.861h8v-1.089c0-1.503-1.279-2.722-2.857-2.722h-2.286c-1.578 0-2.857 1.219-2.857 2.722v1.09zM12 8H4v2h8V8zm-8 5h6v2H4v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataIdCircle = {
  name: 'IconIdCircle',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9zm4.931-4.782h-1.52V16.5h1.52V7.218zm5.211 0H9.749V16.5h3.393c1.508 0 2.639-.416 3.419-1.248.741-.793 1.118-1.924 1.118-3.393 0-1.482-.377-2.613-1.118-3.393-.78-.832-1.911-1.248-3.419-1.248zM11.27 15.2V8.518h1.586c1.157 0 2.002.26 2.535.793.52.52.78 1.378.78 2.548 0 1.144-.26 1.989-.78 2.535-.533.533-1.378.806-2.535.806H11.27z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataIdSquare = {
  name: 'IconIdSquare',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M2 7a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7zm5-3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7z" clip-rule="evenodd"/><path fill="currentColor" d="M8.916 16H6.9V7.6h2.016V16zm4.972-1.608c.672 0 1.132-.156 1.38-.468.296-.368.444-1.076.444-2.124 0-1.032-.152-1.736-.456-2.112-.264-.32-.72-.48-1.368-.48h-1.152v5.184h1.152zm.096-6.792c1.416 0 2.416.344 3 1.032.544.64.816 1.692.816 3.156.016 1.544-.272 2.64-.864 3.288-.584.64-1.568.948-2.952.924H10.72V7.6h3.264z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataImage = {
  name: 'IconImage',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.85 5.6a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5zM5.9 8.35a.95.95 0 1 1 1.9 0 .95.95 0 0 1-1.9 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M5 2a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h12a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5H5zm12 2H5a3 3 0 0 0-3 3v10c0 .095.004.19.013.282l2.49-3.424a2 2 0 0 1 3.032-.238l1.427 1.428 3.007-3.341a2 2 0 0 1 3.048.088l4.856 6.07A3 3 0 0 0 20 17V7a3 3 0 0 0-3-3zM5 20c-.75 0-1.435-.275-1.96-.73l3.08-4.235 1.428 1.427a2 2 0 0 0 2.9-.076l3.007-3.341 5.178 6.472A2.98 2.98 0 0 1 17 20H5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataImageAdd = {
  name: 'IconImageAdd',
  content: '<path fill="currentColor" d="M31.277 1.845v4.432h-4.432v2.4h4.432V13.2h2.4V8.677H38.2v-2.4h-4.523V1.845h-2.4z"/><path fill="currentColor" d="M4.2 11A4.8 4.8 0 0 1 9 6.2h13.5V3.8H9A7.2 7.2 0 0 0 1.8 11v18A7.2 7.2 0 0 0 9 36.2h22a7.2 7.2 0 0 0 7.2-7.2V17h-2.4v12a4.8 4.8 0 0 1-4.8 4.8H9A4.8 4.8 0 0 1 4.2 29V11z"/><path fill="currentColor" d="M14.522 22.99a.567.567 0 0 1 .864-.023l6.13 6.866 1.642-1.466-3.391-3.797 4.618-5.747a.567.567 0 0 1 .864-.023l6.13 6.866L33.02 24.2l-6.13-6.866a2.767 2.767 0 0 0-4.22.11l-4.389 5.46-1.254-1.404a2.767 2.767 0 0 0-4.22.11l-5.464 6.8 1.715 1.378 5.464-6.8z"/><path fill="currentColor" fill-rule="evenodd" d="M13 9.9a4.1 4.1 0 1 0 0 8.2 4.1 4.1 0 0 0 0-8.2zM11.1 14a1.9 1.9 0 1 1 3.8 0 1.9 1.9 0 0 1-3.8 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 40 40'
  },
  width: 40,
  height: 40
};

var dataImageDesktopSolid = {
  name: 'IconImageDesktopSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.59 2C3.333 2 1.5 3.79 1.5 6v8c0 2.21 1.832 4 4.09 4h12.82c2.258 0 4.09-1.79 4.09-4V6c0-2.21-1.832-4-4.09-4H5.59zm.6 12.391 1.744-2.867a.829.829 0 0 1 1.348-.084L10.527 13a.829.829 0 0 0 1.34-.072l2.17-3.436a.828.828 0 0 1 1.39-.006l4.147 4.888c.343.532-.049 1.226-.692 1.226H6.893c-.635 0-1.028-.676-.703-1.209zM9.546 6c0 .884-.733 1.6-1.637 1.6S6.273 6.884 6.273 6c0-.884.732-1.6 1.636-1.6.904 0 1.637.716 1.637 1.6zm11.356 15.7h-17.8v-1.8h17.8v1.8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataImageSolid = {
  name: 'IconImageSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1 7a5 5 0 0 1 5-5h12a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V7zm6.03 6.905L4.9 17.489A1 1 0 0 0 5.759 19h13.43a1 1 0 0 0 .846-1.533l-3.847-6.11a1 1 0 0 0-1.697.008l-2.653 4.295a1 1 0 0 1-1.639.09L8.678 13.8a1 1 0 0 0-1.648.104zM7 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataImageStar = {
  name: 'IconImageStar',
  content: '<path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13.713 3.5h-3.692c-2.217 0-4.512 0-5.359.412-.745.362-1.35.94-1.73 1.65C2.5 6.37 2.5 7.43 2.5 9.544v4.912c0 2.115 0 3.174.433 3.98a3.86 3.86 0 0 0 1.73 1.652c.846.412 3.141.412 5.358.412h5.872c1.535 0 2.303 0 2.92-.2a3.99 3.99 0 0 0 1.527-.907c.43-.41.755-.908.95-1.457.21-.59.21-2.78.21-4.245 0-.922 0-1.384-.143-1.671a1.445 1.445 0 0 0-.622-.632 1.543 1.543 0 0 0-.89-.168c-.333.036-.742.28-1.561.77l-2.831 1.687a3.2 3.2 0 0 1-3.58-.211 3.185 3.185 0 0 0-2.166-.651 3.144 3.144 0 0 0-2.046.94l-1.004 1.038"/><path fill="currentColor" stroke="currentColor" stroke-width="1.373" d="M18.528 3.018c.004-.024.04-.024.044 0a3.22 3.22 0 0 0 2.51 2.51c.024.004.024.04 0 .045a3.22 3.22 0 0 0-2.51 2.509c-.004.024-.04.024-.045 0a3.22 3.22 0 0 0-2.509-2.51c-.024-.004-.024-.04 0-.044a3.22 3.22 0 0 0 2.51-2.51z"/><path fill="currentColor" fill-rule="evenodd" d="M8 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataImageStarSolid = {
  name: 'IconImageStarSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M2 6.324A4.324 4.324 0 0 1 6.324 2h10.352A4.324 4.324 0 0 1 21 6.324v3.835l.019.01v1.896L21 12.053v.007a6.179 6.179 0 0 0-2.92-.853 5.721 5.721 0 0 0-.385.018c-1.453 0-2.886.642-3.949 1.524-.33.291-.63.617-.894.972a4.508 4.508 0 0 0-.011-.031l-.078.106.016.026c-.3.423-.55.886-.738 1.379a6.903 6.903 0 0 0-.383 2.3c0 .626.095 1.23.272 1.797h-.005A6.19 6.19 0 0 0 12.772 21H6.324A4.324 4.324 0 0 1 2 16.676V11.75c1.735-.279 4.645-.273 6.897.778.711.332 1.285.617 1.78 1.027.272-.483.592-.934.954-1.348a9.607 9.607 0 0 0-2.003-1.247C6.978 9.724 3.97 9.67 2 9.985v-3.66zm11.858 1.314c0-1.01.83-1.813 1.834-1.813s1.833.803 1.833 1.813c0 1.01-.83 1.814-1.833 1.814a1.824 1.824 0 0 1-1.834-1.814zm4.548 13.641.436-.999a3.847 3.847 0 0 1 1.958-1.983l1.2-.533v-.894l-1.163-.516a3.849 3.849 0 0 1-1.986-2.05l-.442-1.064h-.873l-.442 1.064a3.85 3.85 0 0 1-1.986 2.05l-1.163.516v.894l1.2.533a3.846 3.846 0 0 1 1.958 1.983l.436 1h.867z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataImageUpload = {
  name: 'IconImageUpload',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M18.185 1.83v-1h2v2.955H23.2v2h-3.015V8.8h-2V5.785H15.23v-2h2.955V1.83zM6 4a3 3 0 0 0-3 3v9.413l2.607-2.867a2 2 0 0 1 2.781-.173l2.022 1.732 3.059-3.398a2 2 0 0 1 3.048.088l4.46 5.576c.015-.122.023-.245.023-.371v-6h2v6a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5h7v2H6zm0 16c-1 0-1.885-.489-2.43-1.24l3.517-3.869 2.021 1.733a2 2 0 0 0 2.788-.18l3.06-3.4 4.99 6.24A2.988 2.988 0 0 1 18 20H6zM7 8.4a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0zm.8-2.8a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataImport = {
  name: 'IconImport',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4 7a3 3 0 0 1 3-3h1V2H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5h-1.5v2H17a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7zm11.294.792L13 10.081V2h-2v8.09L8.708 7.795 7.292 9.206l3.285 3.293a2 2 0 0 0 2.829.002l3.3-3.293-1.412-1.416z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataIndent = {
  name: 'IconIndent',
  content: '<path fill="currentColor" d="M22 3H2v2h20V3zm-6 5.5H2v2h14v-2zm0 5.5v2H2v-2h14zm6 5.5H2v2h20v-2zm.033-7.638a.6.6 0 0 1 0 .876l-3.323 3.115a.6.6 0 0 1-1.01-.438v-6.23a.6.6 0 0 1 1.01-.438l3.323 3.115z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataInfoCircle = {
  name: 'IconInfoCircle',
  content: '<path fill="currentColor" d="M13.25 7.85a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0zM11 10.4v7h2v-7h-2z"/><path fill="currentColor" fill-rule="evenodd" d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataInfoCircleSolid = {
  name: 'IconInfoCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm12.25-4.15a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0zM11 17.4v-7h2v7h-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataInfoflow = {
  name: 'IconInfoflow',
  content: '<path fill="currentColor" d="M16.837 13.273c.683 0 1.268.039 1.747.091 1.111.123 1.876.342 2.275.481.003.003.008.006.01.006.094.028.375.128.364.42-.008.26-.393 1.32-.497 1.496-.244.413-.493.336-.716.256-.348-.13-2.277-.76-5.662-.342-.791.12-1.54.717-1.96 1.098 0 0-4.954 4.123-5.069 4.214a.857.857 0 0 1-.529.182h-.013c-.472-.005-.934-.376-.724-1.123l.75-2.444c.136-.421.045-.763-.435-.836-2.116-.074-3.446-.555-3.998-.805-.302-.14-.377-.32-.38-.47v-.011c0-.098.032-.182.053-.234.172-.434.41-1.086.447-1.16.194-.391.404-.457.862-.258.074.033 2.762 1.431 8.072.135 2.189-.533 4.004-.696 5.403-.696zm.45-4.819c.68 0 1.265.04 1.745.092 1.11.123 1.875.341 2.274.48.002.004.008.004.01.007.094.028.375.128.364.42-.008.26-.392 1.32-.497 1.496-.244.413-.493.34-.715.255-.43-.16-3.26-1.08-8.264.14-1.69.41-3.315.62-4.82.62-2.442 0-3.957-.545-4.557-.816-.506-.236-.38-.58-.327-.715l.127-.325.086-.226c.114-.298.213-.563.235-.608.194-.391.404-.457.862-.258.073.032 2.762 1.43 8.072.135 2.188-.534 4.004-.697 5.406-.697h-.001zm.319-4.779c.681 0 1.266.04 1.745.092 1.11.124 1.876.341 2.275.481.002.003.006.003.01.005.094.03.375.13.364.421-.008.26-.393 1.32-.498 1.496-.244.412-.492.337-.715.255-.43-.16-3.26-1.08-8.264.14-1.69.41-3.311.62-4.82.62-2.442 0-3.956-.544-4.556-.815-.506-.237-.38-.582-.328-.715.106-.267.238-.617.331-.863l.063-.163c.016-.045.034-.09.054-.133.194-.392.403-.459.862-.259.074.032 2.761 1.43 8.072.135 2.187-.534 4.003-.697 5.405-.697z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataIntelligence = {
  name: 'IconIntelligence',
  content: '<path fill="currentColor" d="M17.748 12.336 15.67 9.997l2.076-2.332-1.494-1.33L13.882 9a1.5 1.5 0 0 0-.001 1.993l2.371 2.67 1.496-1.327zM9 7v6H7V7h2z"/><path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v7a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-7a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-7z" clip-rule="evenodd"/><path fill="currentColor" d="M6 22.5h12v-2H6v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataIntelligenceSolid = {
  name: 'IconIntelligenceSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.5 1.5a5 5 0 0 0-5 5v7a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-7a5 5 0 0 0-5-5h-11zm11.248 10.836L14.67 9.997l2.076-2.332-1.494-1.33L12.882 9a1.5 1.5 0 0 0-.001 1.993l2.371 2.67 1.496-1.327zM8 13V7H6v6h2z" clip-rule="evenodd"/><path fill="currentColor" d="M5 22.5h12v-2H5v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataIntelligentPrompt = {
  name: 'IconIntelligentPrompt',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m17.561 12.539 1.101 3.048L21.5 16.77l-2.838 1.182-1.1 3.048-1.102-3.048-2.838-1.183 2.838-1.182 1.101-3.048zM16.84 3c.443 0 .802.386.802.861a.91.91 0 0 1-.123.46L8.834 19.118c-.294.5-.806.804-1.357.804H5.742c-.443 0-.802-.386-.802-.861a.91.91 0 0 1 .123-.46l8.684-14.797c.293-.5.806-.804 1.357-.804h1.735zm-11.276.803.857 2.37 2.207.92-2.207.92-.856 2.37-.857-2.37-2.207-.92 2.207-.92.856-2.37z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataInvoice = {
  name: 'IconInvoice',
  content: '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 2a4 4 0 0 0-4 4v14.45a1.5 1.5 0 0 0 2.228 1.312l1.4-.778a2 2 0 0 1 1.784-.079l2.776 1.234a2 2 0 0 0 1.624 0l2.776-1.234a2 2 0 0 1 1.784.08l1.4.777A1.5 1.5 0 0 0 19 20.451V6a4 4 0 0 0-4-4H5z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="2" d="M5.5 14.6h6m-6-5h9"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataInvoiceSolid = {
  name: 'IconInvoiceSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 6a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v14.45c0 1.907-2.048 3.112-3.714 2.186l-1.4-.777a1 1 0 0 0-.891-.04l-2.777 1.234a3 3 0 0 1-2.436 0l-2.777-1.234a1 1 0 0 0-.891.04l-1.4.777C2.048 23.562 0 22.356 0 20.451V6zm14.5 2.6h-9v2h9v-2zm-3 5h-6v2h6v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataItalic = {
  name: 'IconItalic',
  content: '<path fill="currentColor" d="M20 4.4h-4.693l-4.194 15.2H16v2H4v-2h4.831l4.193-15.2H8v-2h12v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataKeyCommand = {
  name: 'IconKeyCommand',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.447 3.988a1.857 1.857 0 0 1 2.22 1.822v1.857H5.808a1.857 1.857 0 0 1-.362-3.679zm1.838-1.742a3.857 3.857 0 1 0-1.476 7.42h1.857v4.667H5.81a3.857 3.857 0 1 0 3.857 3.857v-1.857h4.667v1.858a3.857 3.857 0 1 0 3.857-3.858h-1.857V9.667h1.857a3.857 3.857 0 1 0-3.857-3.857v1.857H9.666V5.81a3.857 3.857 0 0 0-2.38-3.564zm2.381 12.087h4.667V9.667H9.666v4.666zm8.887 5.679a1.858 1.858 0 0 1-2.22-1.822v-1.857h1.857a1.858 1.858 0 0 1 .363 3.679zM17.48 4.094a1.857 1.857 0 1 1 .71 3.573h-1.857V5.81a1.857 1.857 0 0 1 1.147-1.716zM5.447 20.012a1.857 1.857 0 0 0 2.22-1.822v-1.857H5.808a1.858 1.858 0 0 0-.362 3.679z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataKeyDelete = {
  name: 'IconKeyDelete',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.534 5H20a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H8.534a1 1 0 0 1-.81-.415L2.966 12l4.756-6.585A1 1 0 0 1 8.534 5zm-2.432-.756A3 3 0 0 1 8.534 3H20a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H8.534a3 3 0 0 1-2.432-1.244l-4.756-6.585a2 2 0 0 1 0-2.342l4.756-6.585zm10.269 3.513-2.828 2.829-2.829-2.829L9.3 9.172 12.128 12 9.3 14.828l1.414 1.415 2.829-2.829 2.828 2.829 1.414-1.415L14.957 12l2.828-2.828-1.414-1.415z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataKeyShift = {
  name: 'IconKeyShift',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.525 2.13a2 2 0 0 1 2.95 0l9.295 10.147c.882.962.2 2.513-1.106 2.513H17v4.46a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-4.46H2.34c-1.305 0-1.988-1.55-1.106-2.513L10.525 2.13zm10.003 10.66-8.527-9.31-8.525 9.31H9v6.46a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-6.46h5.528z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataKeyboard = {
  name: 'IconKeyboard',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1 7a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V7zm4-2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5zm4.5 4H12v2H9.5V9zm-2 0H5v2h2.5V9zM14 9h5v2h-5V9zm5 6v-2H5v2h14z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLandingPageSolid = {
  name: 'IconLandingPageSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.5 5.5a4 4 0 0 1 4-4h9a4 4 0 0 1 4 4v4.45h3.955l-.045 9.564a3 3 0 0 1-3 2.986H5.5a4 4 0 0 1-4-4v-13zm17 15h.91a1 1 0 0 0 1-.995l.035-7.555H18.5v8.55zM4.5 16H15v2H4.5v-2zM15 12H4.5v2H15v-2zM4.5 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLayer = {
  name: 'IconLayer',
  content: '<path stroke="currentColor" stroke-width="2" d="M12.855 3.172a4 4 0 0 0-3.71 0l-7.52 3.937a1 1 0 0 0-.03 1.756l7.431 4.215a4 4 0 0 0 3.948 0l7.43-4.215a1 1 0 0 0-.029-1.756l-7.52-3.937z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="2" d="m6.875 12-1.375.72-3.875 2.03a1 1 0 0 0-.03 1.755l7.431 4.215a4 4 0 0 0 3.948 0l7.43-4.215a1 1 0 0 0-.029-1.756L16.5 12.72 15.125 12"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataLayerSolid = {
  name: 'IconLayerSolid',
  content: '<path fill="currentColor" d="M8.68 2.286a5 5 0 0 1 4.64 0l7.52 3.937c1.402.735 1.435 2.73.058 3.512l-7.43 4.215a5 5 0 0 1-4.935 0L1.102 9.735c-1.377-.781-1.344-2.777.059-3.512l7.52-3.937z"/><path fill="currentColor" d="m1.16 13.823 2.215-1.159 5.158 2.926a5 5 0 0 0 4.934 0l5.158-2.926 2.214 1.16c1.403.734 1.436 2.73.06 3.51l-7.432 4.216a5 5 0 0 1-4.934 0l-7.431-4.215c-1.377-.781-1.344-2.777.059-3.512z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataLayout = {
  name: 'IconLayout',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.5 6.5a5 5 0 0 1 5-5h10.973a5 5 0 0 1 5 4.991l.02 11a5 5 0 0 1-5 5.009H6.5a5 5 0 0 1-5-5v-11zm5-3a3 3 0 0 0-3 3V15H11V3.5H6.5zM13 15h7.488l-.015-8.505a3 3 0 0 0-3-2.995H13V15zm7.492 2H3.5v.5a3 3 0 0 0 3 3h10.993a3 3 0 0 0 3-3.005L20.492 17z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLayoutSolid = {
  name: 'IconLayoutSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.5 6.5a5 5 0 0 1 5-5h10.973a5 5 0 0 1 5 4.991l.02 11a5 5 0 0 1-5 5.009H5.5a5 5 0 0 1-5-5v-11zM10 15V3h2v12h8v2H2v-2h8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataLetterSpacing = {
  name: 'IconLetterSpacing',
  content: '<path fill="currentColor" d="M4.2 21.873 5.473 20.6l-1.6-1.6h16.254l-1.6 1.6 1.273 1.273 2.783-2.783a1.4 1.4 0 0 0 0-1.98L19.8 14.327 18.527 15.6l1.6 1.6H3.873l1.6-1.6L4.2 14.327 1.417 17.11a1.4 1.4 0 0 0 0 1.98L4.2 21.873z"/><path fill="currentColor" fill-rule="evenodd" d="M8.98 2.2H6.865L2.4 13.8h2.066l1.069-2.938h4.759l1.07 2.938h2.081L8.98 2.2zM6.135 9.225l1.787-4.854 1.773 4.854h-3.56z" clip-rule="evenodd"/><path fill="currentColor" d="M13.336 2.2h-2.095l4.156 11.6h2.247L21.8 2.2h-2.096l-3.176 9.314L13.336 2.2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLightning = {
  name: 'IconLightning',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M9.543 3.026c-.432 0-.817.27-.965.676l-3.113 8.56h4.973L8.67 21.019l9.97-11.393h-6.004l2.4-6.6H9.543zM6.649 3A3.079 3.079 0 0 1 9.543.974h5.492a2.052 2.052 0 0 1 1.929 2.754l-1.399 3.846h3.074c1.763 0 2.706 2.077 1.544 3.404L10.215 22.37c-1.386 1.584-3.973.305-3.557-1.757l1.272-6.299H5.465a2.052 2.052 0 0 1-1.929-2.754L6.65 3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLightningSolid = {
  name: 'IconLightningSolid',
  content: '<path fill="currentColor" d="M9.543.974A3.08 3.08 0 0 0 6.649 3l-3.113 8.56a2.052 2.052 0 0 0 1.93 2.754H7.93l-1.272 6.299c-.416 2.062 2.171 3.341 3.557 1.757l9.968-11.392c1.162-1.327.22-3.404-1.544-3.404h-3.074l1.399-3.846A2.052 2.052 0 0 0 15.035.974H9.543z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLineChart = {
  name: 'IconLineChart',
  content: '<path fill="currentColor" d="M1.5 1.5v16a5 5 0 0 0 5 5h16v-2h-16a3 3 0 0 1-3-3v-16h-2z"/><path fill="currentColor" d="m15.441 14.465 6.528-7.824-1.536-1.282-6.309 7.563-2.727-2.392a1.667 1.667 0 0 0-2.353.155l-3.797 4.34 1.506 1.316 3.576-4.088 2.734 2.398a1.667 1.667 0 0 0 2.378-.186z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLineChartAlt = {
  name: 'IconLineChartAlt',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M2 17V2h2v11.62l1.603-1.572a3.2 3.2 0 1 1 5.972-.431l1.03 1.03a3.185 3.185 0 0 1 1.994-.698c.456 0 .89.095 1.282.267l.757-.857a3.2 3.2 0 1 1 1.794.99l-1.06 1.2a3.2 3.2 0 1 1-5.875.817l-1.089-1.087a3.184 3.184 0 0 1-1.9.625 3.185 3.185 0 0 1-1.54-.394L4 16.42V17a3 3 0 0 0 3 3h14.803v2H7a5 5 0 0 1-5-5zm5.308-6.296a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0zM14.6 13.95a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4zm3.2-4.75a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLineChartAltSolid = {
  name: 'IconLineChartAltSolid',
  content: '<path fill="currentColor" d="M0 2v15a5 5 0 0 0 5 5h14.803v-2H5a3 3 0 0 1-3-3v-.58l3.345-3.279a2.693 2.693 0 0 0 2.705-.22l1.873 1.873a2.7 2.7 0 1 0 5.095-.845l1.815-2.054a2.7 2.7 0 1 0-1.862-.913l-1.441 1.631a2.695 2.695 0 0 0-.93-.164c-.617 0-1.185.206-1.64.554l-1.799-1.8a2.7 2.7 0 1 0-5.174.469L2 13.62V2H0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataLineChartSolid = {
  name: 'IconLineChartSolid',
  content: '<path fill="currentColor" d="M0 1.5v16A5.5 5.5 0 0 0 5.5 23h16v-3h-16A2.5 2.5 0 0 1 3 17.5v-16H0z"/><path fill="currentColor" d="m14.825 14.785 6.528-7.824-2.304-1.922-5.98 7.169-2.342-2.054c-.9-.79-2.271-.7-3.06.202l-3.796 4.339L6.13 16.67l3.247-3.71 2.357 2.066a2.166 2.166 0 0 0 3.092-.24z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataLineHeight = {
  name: 'IconLineHeight',
  content: '<path fill="currentColor" d="M1.127 5 3.91 2.217a1.4 1.4 0 0 1 1.98 0L8.673 5 7.4 6.273l-1.6-1.6v14.454l1.6-1.6L8.673 18.8 5.89 21.583a1.4 1.4 0 0 1-1.98 0L1.127 18.8 2.4 17.527l1.6 1.6V4.673l-1.6 1.6L1.127 5zM10 3.2h12.5v2H10v-2zm0 5.2v2h9.5v-2H10zm0 5.2h12.5v2H10v-2zm0 5.2v2h9.5v-2H10z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLink = {
  name: 'IconLink',
  content: '<path fill="currentColor" d="M19.316 4.58a4.194 4.194 0 0 0-5.932 0L10.3 7.665 8.885 6.251l3.085-3.085a6.194 6.194 0 1 1 8.76 8.76l-3.085 3.085-1.415-1.414 3.086-3.085a4.194 4.194 0 0 0 0-5.932zM4.466 19.43a4.194 4.194 0 0 0 5.932 0l3.085-3.086 1.414 1.414-3.085 3.085a6.194 6.194 0 1 1-8.76-8.76l3.085-3.085 1.415 1.415-3.086 3.085a4.194 4.194 0 0 0 0 5.931z"/><path fill="currentColor" d="M15.057 7.622 7.149 15.53l1.414 1.414 7.908-7.908-1.414-1.414z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLinkAlt = {
  name: 'IconLinkAlt',
  content: '<path fill="currentColor" d="M2.3 6.1a4 4 0 0 1 4-4h5.6a4 4 0 0 1 4 4v6.6a3 3 0 0 1-3 3h-.8v-2h.8a1 1 0 0 0 1-1V6.1a2 2 0 0 0-2-2H6.3a2 2 0 0 0-2 2v5.6a2 2 0 0 0 1.8 1.99v2.005A4 4 0 0 1 2.3 11.7V6.1z"/><path fill="currentColor" d="M21.7 18a4 4 0 0 1-4 4h-5.6a4 4 0 0 1-4-4v-5.6a4 4 0 0 1 3.8-3.995v2.005a2 2 0 0 0-1.8 1.99V18a2 2 0 0 0 2 2h5.6a2 2 0 0 0 2-2v-5.6a2 2 0 0 0-1.8-1.99V8.405a4 4 0 0 1 3.8 3.995V18z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLinkAltSolid = {
  name: 'IconLinkAltSolid',
  content: '<path fill="currentColor" d="M.8 6.1a4.5 4.5 0 0 1 4.5-4.5h5.6a4.5 4.5 0 0 1 4.5 4.5v6.6a3.5 3.5 0 0 1-3.5 3.5h-.8v-3h.8a.5.5 0 0 0 .5-.5V6.1a1.5 1.5 0 0 0-1.5-1.5H5.3a1.5 1.5 0 0 0-1.5 1.5v5.6a1.5 1.5 0 0 0 1.3 1.487v3.009A4.5 4.5 0 0 1 .8 11.7V6.1z"/><path fill="currentColor" d="M21.2 18a4.5 4.5 0 0 1-4.5 4.5h-5.6A4.5 4.5 0 0 1 6.6 18v-5.6a4.5 4.5 0 0 1 4.3-4.496v3.01A1.5 1.5 0 0 0 9.6 12.4V18a1.5 1.5 0 0 0 1.5 1.5h5.6a1.5 1.5 0 0 0 1.5-1.5v-5.6a1.5 1.5 0 0 0-1.3-1.487V7.904a4.5 4.5 0 0 1 4.3 4.496V18z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataListChecked = {
  name: 'IconListChecked',
  content: '<path fill="currentColor" d="M7.76 3.771 6.64 2.63 3.893 5.32 2.58 3.934l-1.162 1.1 2.43 2.57L7.76 3.77zM22.6 5.5H9.2v-2h13.4v2zM9.2 13h13.4v-2H9.2v2zm0 7.5h13.4v-2H9.2v2zM7.76 10.371l-3.91 3.832-2.431-2.569 1.162-1.1 1.312 1.387L6.64 9.229l1.12 1.142zm0 6.8L6.64 16.03l-2.747 2.69-1.313-1.386-1.162 1.1 2.43 2.57L7.76 17.17z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataListOrdered = {
  name: 'IconListOrdered',
  content: '<path fill="currentColor" d="M3.075 4.038V7.3H4.26V2.4h-1l-1 .888v1.486l.815-.736zM7 3.5h15v2H7v-2zM7 11v2h15v-2H7zm0 7.5v2h15v-2H7zm-4.922-4.2v-.954l1.711-2.079a.95.95 0 0 0 .13-.203.474.474 0 0 0 .031-.178c0-.133-.036-.212-.085-.267-.038-.043-.102-.081-.239-.081a.47.47 0 0 0-.144.022.27.27 0 0 0-.093.051.304.304 0 0 0-.063.1.483.483 0 0 0-.03.187v.3H2.084v-.3c0-.214.036-.417.112-.605l.002-.003c.078-.186.186-.35.326-.484l.004-.004a1.645 1.645 0 0 1 1.098-.41c.215 0 .418.033.608.102a1.38 1.38 0 0 1 .816.787c.077.19.112.394.112.611 0 .224-.04.434-.134.62l-.001.003c-.08.157-.194.321-.335.491l-.937 1.148h1.407V14.3H2.078zm1.866 3.598c0 .14-.036.222-.081.275-.027.03-.094.073-.267.073h-.402v1.134h.402c.19 0 .272.05.311.094l.007.007c.053.054.096.142.096.301 0 .166-.046.254-.102.308-.07.062-.16.1-.294.1a.635.635 0 0 1-.174-.024.322.322 0 0 1-.103-.053.515.515 0 0 1-.087-.116.429.429 0 0 1-.032-.165l-.01-.29H2l.006.306c.005.24.049.464.143.663l.002.005c.093.186.216.346.37.475l.005.003c.15.12.32.21.505.268l.01.003a2.1 2.1 0 0 0 .573.077c.209 0 .409-.03.598-.093a1.44 1.44 0 0 0 .518-.294c.155-.134.273-.3.358-.492.092-.202.134-.425.134-.663 0-.303-.062-.58-.212-.807a1.294 1.294 0 0 0-.174-.212c.048-.053.092-.11.13-.172.133-.21.19-.46.19-.729a1.47 1.47 0 0 0-.12-.597 1.342 1.342 0 0 0-.326-.477 1.362 1.362 0 0 0-.491-.31 1.646 1.646 0 0 0-.605-.11 1.645 1.645 0 0 0-1.07.388 1.432 1.432 0 0 0-.341.462 1.557 1.557 0 0 0-.143.6l-.014.314h1.202l.023-.275c.011-.137.053-.213.101-.259.045-.043.114-.078.242-.078a.33.33 0 0 1 .24.087l.003.004c.044.04.087.111.087.269z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataListUnordered = {
  name: 'IconListUnordered',
  content: '<path fill="currentColor" d="M3.8 6.3a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6zM7 3.5h15v2H7v-2zM7 11v2h15v-2H7zm0 7.5v2h15v-2H7zM5.6 12A1.8 1.8 0 1 1 2 12a1.8 1.8 0 0 1 3.6 0zm-1.8 9.3a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLoading = {
  name: 'IconLoading',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11 1h1a11 11 0 0 1 11 11v1h-2v-1a9 9 0 0 0-9-9h-1V1z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLocation = {
  name: 'IconLocation',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 6.398a4.202 4.202 0 1 0 0 8.404 4.202 4.202 0 0 0 0-8.404zM9.802 10.6a2.198 2.198 0 1 1 4.396 0 2.198 2.198 0 0 1-4.396 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 1c-5.32 0-9.7 4.159-9.7 9.37 0 2.395.799 4.457 2.39 6.65.905 1.247 2.951 3.43 4.492 5.03a3.906 3.906 0 0 0 5.636 0c1.54-1.6 3.587-3.784 4.491-5.03 1.592-2.193 2.391-4.255 2.391-6.65C21.7 5.159 17.32 1 12 1zm-7.7 9.37C4.3 6.336 7.71 3 12 3s7.7 3.336 7.7 7.37c0 1.876-.601 3.536-2.01 5.476-.805 1.11-2.743 3.188-4.312 4.817-.756.785-2 .785-2.755 0-1.57-1.63-3.508-3.707-4.314-4.817-1.408-1.94-2.009-3.6-2.009-5.476z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLocationCopy = {
  name: 'IconLocationCopy',
  content: '<path fill-rule="evenodd" d="M8.124 1.075c4.484 0 8.123 3.756 8.123 8.396 0 4.396-2.415 8.815-7.16 13.268a.946.946 0 0 1-1.235.06C2.652 18.774 0 14.324 0 9.471c0-4.638 3.64-8.396 8.124-8.396ZM14.382 1C18.16 1 21 4.376 21 8.221c0 3.735-1.792 8.743-4.828 12.539l-.297.363-1.47-1.342c2.906-3.467 4.642-8.202 4.642-11.56 0-2.701-1.921-5.056-4.458-5.178l-.207-.005V1ZM8.124 3.113c-3.41 0-6.17 2.85-6.17 6.358 0 3.917 2.087 7.619 6.352 11.125l.07.056.434-.433c3.57-3.628 5.376-7.112 5.48-10.445l.004-.303c0-3.509-2.76-6.358-6.17-6.358Zm0 2.933c2.118 0 3.835 1.792 3.835 4.003 0 2.21-1.717 4.002-3.835 4.002-2.119 0-3.836-1.792-3.836-4.002s1.717-4.003 3.836-4.003Zm0 2.039c-1.04 0-1.882.879-1.882 1.964 0 1.084.842 1.963 1.882 1.963s1.882-.879 1.882-1.963c0-1.085-.843-1.964-1.882-1.964Z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataLocationCopySolid = {
  name: 'IconLocationCopySolid',
  content: '<path fill="currentColor" d="M8.624 8.046c.934 0 1.835.816 1.835 2.003 0 1.187-.901 2.002-1.835 2.002-.935 0-1.836-.816-1.836-2.002 0-1.187.901-2.003 1.836-2.003z"/><path fill="currentColor" fill-rule="evenodd" d="M16.747 9.471c0-4.64-3.64-8.396-8.123-8.396C4.14 1.075.5 4.833.5 9.47c0 4.853 2.653 9.303 7.852 13.328a.946.946 0 0 0 1.236-.06c4.744-4.453 7.16-8.872 7.16-13.268zm-4.288.578c0-2.21-1.717-4.003-3.835-4.003-2.119 0-3.836 1.792-3.836 4.003 0 2.21 1.717 4.002 3.836 4.002 2.118 0 3.835-1.792 3.835-4.002z" clip-rule="evenodd"/><path fill="currentColor" d="M21.5 8.221C21.5 4.376 18.66 1 14.882 1v2.038l.207.005c2.537.122 4.458 2.477 4.458 5.178 0 3.358-1.736 8.093-4.643 11.56l1.47 1.342.298-.363c3.036-3.796 4.828-8.804 4.828-12.54z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataLocationPin = {
  name: 'IconLocationPin',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12.25 1A4.25 4.25 0 0 0 11 9.313V12.5h2V9.434A4.251 4.251 0 0 0 12.25 1zM10 5.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0z" clip-rule="evenodd"/><path fill="currentColor" d="M5.1 10.898a1.432 1.432 0 0 1 1.23-.698h2.82v2H6.652l-2.39 4h15.54l-2.216-4H14.85v-2h3.07c.521 0 1 .282 1.253.738l2.38 4.292c.738 1.334-.226 2.97-1.75 2.97H4.263c-1.553 0-2.514-1.693-1.718-3.026L5.1 10.898zM2.2 22h19.6v-2H2.2v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLocationPinSolid = {
  name: 'IconLocationPinSolid',
  content: '<path fill="currentColor" d="M10.25 1A4.25 4.25 0 0 0 9 9.313V12.5h2V9.434A4.251 4.251 0 0 0 10.25 1z"/><path fill="currentColor" d="M4.33 10.2H7V14h6v-3.8h2.92c.521 0 1 .282 1.253.738l2.379 4.292c.739 1.334-.226 2.97-1.75 2.97H2.262C.71 18.2-.25 16.507.545 15.174L3.1 10.898a1.432 1.432 0 0 1 1.23-.698zM.2 22h19.6v-2H.2v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataLocationSolid = {
  name: 'IconLocationSolid',
  content: '<path fill="currentColor" d="M7.802 10.6a2.198 2.198 0 1 1 4.396 0 2.198 2.198 0 0 1-4.396 0z"/><path fill="currentColor" fill-rule="evenodd" d="M.3 10.37C.3 5.159 4.68 1 10 1c5.32 0 9.7 4.159 9.7 9.37 0 2.395-.799 4.457-2.39 6.65-.905 1.246-2.951 3.43-4.492 5.03a3.906 3.906 0 0 1-5.636 0c-1.54-1.6-3.587-3.784-4.491-5.03C1.099 14.828.3 12.766.3 10.37zM10 6.398a4.202 4.202 0 1 0 0 8.404 4.202 4.202 0 0 0 0-8.404z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataLock = {
  name: 'IconLock',
  content: '<path fill="currentColor" d="M11 18.5v-5h2v5h-2z"/><path fill="currentColor" fill-rule="evenodd" d="M5 9V8a7 7 0 0 1 14 0v1a3 3 0 0 1 3 3v7a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4v-7a3 3 0 0 1 3-3zm2-1a5 5 0 0 1 10 0v1H7V8zm13 4a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLockSolid = {
  name: 'IconLockSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3 9V8a7 7 0 0 1 14 0v1a3 3 0 0 1 3 3v7a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-7a3 3 0 0 1 3-3zm2-1a5 5 0 0 1 10 0v1H5V8zm4 10.5v-5h2v5H9z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataLongVideo = {
  name: 'IconLongVideo',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4zm18 0H4v2h16V4z" clip-rule="evenodd"/><path fill="currentColor" d="M4 9v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9h2v8a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V9h2z"/><path fill="currentColor" fill-rule="evenodd" d="M11.037 10.38A1.3 1.3 0 0 0 9 11.45v5.1a1.3 1.3 0 0 0 2.037 1.07l3.708-2.549a1.3 1.3 0 0 0 0-2.142l-3.708-2.55zM13.479 14 10.6 15.98v-3.96L13.479 14z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLongVideoSolid = {
  name: 'IconLongVideoSolid',
  content: '<path fill="currentColor" d="M.2 3.6a1.4 1.4 0 0 1 1.4-1.4h16.8a1.4 1.4 0 0 1 1.4 1.4v1.8a1.4 1.4 0 0 1-1.4 1.4H1.6A1.4 1.4 0 0 1 .2 5.4V3.6zm8.4 13.08 2.879-1.98L8.6 12.72v3.96z"/><path fill="currentColor" fill-rule="evenodd" d="M2 8a2 2 0 0 0-2 2v7a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5v-7a2 2 0 0 0-2-2H2zm5 4.15a1.3 1.3 0 0 1 2.036-1.07l3.709 2.549a1.3 1.3 0 0 1 0 2.142l-3.709 2.55A1.3 1.3 0 0 1 7 17.249v-5.098z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataLowSquare = {
  name: 'IconLowSquare',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13.976 12.055h-2.587v4.03c.286-.13.572-.26.858-.403l.221 1.17c-.741.286-1.599.598-2.587.923l-.351-1.157c.364-.117.546-.351.546-.689V7.635c2.717-.403 4.875-.858 6.474-1.378l.741 1.079a31.49 31.49 0 0 1-2.223.624 52.81 52.81 0 0 0 .104 2.808h2.574v1.287h-2.47c.039.468.091.858.169 1.196.208 1.131.429 1.937.676 2.418.234.494.416.754.52.754.091 0 .195-.65.299-1.937l1.118.611c-.26 1.937-.663 2.912-1.196 2.912-.442 0-.897-.351-1.378-1.027-.481-.676-.884-1.755-1.222-3.211a16.823 16.823 0 0 1-.286-1.716zm-.117-1.287a48.454 48.454 0 0 1-.104-2.522c-.728.143-1.521.286-2.366.416v2.106h2.47z" clip-rule="evenodd"/><path fill="currentColor" d="m12.533 15.76.923-.663c.702.884 1.235 1.677 1.612 2.353l-1.014.702c-.39-.715-.897-1.508-1.521-2.392zm-6.63-4.55C7.177 9.754 8.126 8.038 8.75 6.062l1.235.585a14.992 14.992 0 0 1-1.196 2.73v8.801H7.463v-6.825c-.351.442-.728.871-1.118 1.287l-.442-1.43z"/><path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataLowSquareSolid = {
  name: 'IconLowSquareSolid',
  content: '<path fill="currentColor" d="M10.539 8.79v1.828h2.16a48.616 48.616 0 0 1-.091-2.19c-.644.124-1.337.248-2.07.363z"/><path fill="currentColor" fill-rule="evenodd" d="M5.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm2.159 4.353 1.51.715-.042.126c-.31.945-.698 1.852-1.188 2.722v8.912H6.313v-6.553c-.275.33-.564.653-.859.968l-.176.188-.543-1.757.055-.063c1.26-1.44 2.199-3.137 2.817-5.094l.052-.164zm7.951.227.918 1.336-.19.063c-.613.2-1.319.399-2.119.598.014.964.048 1.811.094 2.541h2.583v1.587H14.44c.037.392.084.723.151 1.012l.002.007c.207 1.13.425 1.917.661 2.377l.003.004a4.035 4.035 0 0 0 .329.586 3.87 3.87 0 0 0 .051-.277c.05-.318.101-.798.153-1.44l.019-.23 1.411.77-.013.103c-.131.972-.299 1.716-.506 2.22-.104.251-.22.453-.356.593-.137.143-.299.229-.483.229-.522 0-1.017-.41-1.5-1.09-.499-.7-.907-1.803-1.246-3.264a16.39 16.39 0 0 1-.272-1.6h-2.305v3.647c.215-.098.428-.198.64-.304l.178-.089.04.213 1.088-.78.088.112c.706.889 1.244 1.688 1.626 2.373l.066.119-1.263.874-.08-.146a24.642 24.642 0 0 0-1.484-2.338l.2 1.06-.116.046c-.743.287-1.604.6-2.594.925l-.146.048-.438-1.445.14-.045a.68.68 0 0 0 .338-.212.52.52 0 0 0 .104-.334V7.506l.128-.02c2.713-.402 4.862-.855 6.45-1.372l.106-.034z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataMagicWand = {
  name: 'IconMagicWand',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.814 3.212c-1.593-.575-3.136.967-2.56 2.56l1.565 4.335-2.67 3.634c-.965 1.312-.042 3.165 1.586 3.185l4.709.058 2.784 3.87c.975 1.355 3.084.99 3.546-.615l1.231-4.276 4.276-1.231c1.604-.462 1.97-2.57.614-3.546l-3.87-2.784-.057-4.709c-.02-1.627-1.873-2.55-3.185-1.587L10.15 4.777 5.814 3.212zm-.68 1.881 5.34 1.928 4.494-3.303.07 5.718 4.69 3.374-5.339 1.537-1.537 5.339-3.374-4.69-5.718-.07 3.303-4.495-1.928-5.338z" clip-rule="evenodd"/><path fill="currentColor" d="m20.5 21.914-4.007-4.007 1.414-1.414 4.007 4.007-1.414 1.414z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMagicWandSolid = {
  name: 'IconMagicWandSolid',
  content: '<path fill="currentColor" d="M3.254 5.772c-.576-1.593.967-3.135 2.56-2.56l4.335 1.565 3.634-2.67c1.312-.965 3.165-.041 3.185 1.586l.058 4.709 3.87 2.784c1.355.976.99 3.084-.615 3.546l-4.276 1.231-1.231 4.276c-.462 1.604-2.57 1.97-3.546.615l-2.784-3.87-4.709-.058c-1.628-.02-2.55-1.873-1.587-3.185l2.671-3.634-1.565-4.335z"/><path fill="currentColor" d="m20.5 21.914-4.007-4.007 1.414-1.414 4.007 4.007-1.414 1.414z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMagnet = {
  name: 'IconMagnet',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13 1h-2v4h2V1zM5 7a4 4 0 0 0-4 4v2a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v-2a4 4 0 0 0-4-4H5zm6 2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h6V9zm2 6h6a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-6v6zm5.809-13L20.2 3.437 17.686 5.87l-1.391-1.436L18.809 2zM3.799 3.44l1.392-1.437 2.514 2.435-1.391 1.437L3.8 3.44zM13 23h-2v-4h2v4zm-9.2-2.436L5.19 22l2.514-2.435-1.391-1.436L3.8 20.563zm15.009 1.433L20.2 20.56l-2.514-2.435-1.391 1.437 2.514 2.435z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMagnetSolid = {
  name: 'IconMagnetSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13 1h-2v4h2V1zM5 7h14a4 4 0 0 1 4 4v2a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4v-2a4 4 0 0 1 4-4zm8 2h-2v6h2V9zm5.809-7L20.2 3.437 17.686 5.87l-1.391-1.436L18.809 2zM3.799 3.44l1.392-1.437 2.514 2.435-1.391 1.437L3.8 3.44zM13 23h-2v-4h2v4zm-9.2-2.436L5.19 22l2.514-2.435-1.391-1.436L3.8 20.563zm15.009 1.433L20.2 20.56l-2.514-2.435-1.391 1.437 2.514 2.435z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMarket = {
  name: 'IconMarket',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4.952 1.5a2 2 0 0 0-1.888 1.338L1.765 6.544C.801 9.295 2.616 12.5 5.603 12.5c1.253 0 2.337-.593 3.07-1.503.731.91 1.811 1.503 3.066 1.503h.52c1.255 0 2.335-.593 3.066-1.503.733.91 1.817 1.503 3.07 1.503 2.988 0 4.805-3.206 3.84-5.959l-1.299-3.703A2 2 0 0 0 19.05 1.5H4.951zm6.787 9c-1.05 0-2.064-.97-2.064-2.375a1 1 0 0 0-2 0c0 1.4-1.018 2.375-2.072 2.375-1.35 0-2.548-1.59-1.95-3.295L4.952 3.5h14.097l1.299 3.703c.597 1.705-.6 3.297-1.952 3.297-1.055 0-2.074-.974-2.074-2.375a1 1 0 0 0-2 0c0 1.405-1.012 2.375-2.063 2.375h-.52z" clip-rule="evenodd"/><path fill="currentColor" d="M5.5 18.5v-5h-2v5a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4v-5h-2v5a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMarketSolid = {
  name: 'IconMarketSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3.951 1.5a2 2 0 0 0-1.887 1.338L.765 6.544C.057 8.564.848 10.829 2.5 11.89v6.61a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4v-6.611c1.652-1.062 2.443-3.327 1.735-5.348l-1.299-3.703A2 2 0 0 0 18.05 1.5H3.95zm13.445 9c1.35 0 2.55-1.592 1.951-3.297L18.05 3.5H3.95L2.653 7.205c-.598 1.705.6 3.295 1.95 3.295 1.054 0 2.072-.974 2.072-2.375a1 1 0 0 1 2 0c0 1.405 1.013 2.375 2.064 2.375h.52c1.05 0 2.063-.97 2.063-2.375a1 1 0 1 1 2 0c0 1.4 1.019 2.375 2.074 2.375z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataMediaAdd = {
  name: 'IconMediaAdd',
  content: '<path fill="currentColor" d="M31.277 1.845v4.432h-4.432v2.4h4.432V13.2h2.4V8.677H38.2v-2.4h-4.523V1.845h-2.4z"/><path fill="currentColor" fill-rule="evenodd" d="M30.693 26.597c-.93-.639-2.193.026-2.193 1.153v4.425c0 1.127 1.264 1.792 2.193 1.153l3.217-2.212a1.4 1.4 0 0 0 0-2.307l-3.217-2.212zm1.718 3.365L30.3 31.414v-2.903l2.111 1.451z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M4.2 11A4.8 4.8 0 0 1 9 6.2h14V3.8H9A7.2 7.2 0 0 0 1.8 11v18A7.2 7.2 0 0 0 9 36.2h16.944A8 8 0 0 0 37.2 24.944V17h-2.4v5.958A8 8 0 0 0 23.958 33.8H9A4.8 4.8 0 0 1 4.2 29V11zM31 36a5.988 5.988 0 0 1-4.625-2.178V33.8h-.019A6 6 0 1 1 31 36z" clip-rule="evenodd"/><path fill="currentColor" d="M14.522 22.99a.567.567 0 0 1 .864-.023l4.27 4.782 1.642-1.465-1.531-1.714 4.618-5.747a.567.567 0 0 1 .864-.023l2.41 2.7 1.641-1.466-2.41-2.7a2.767 2.767 0 0 0-4.22.11l-4.389 5.462-1.254-1.405a2.767 2.767 0 0 0-4.22.11l-5.464 6.8 1.715 1.378 5.464-6.8z"/><path fill="currentColor" fill-rule="evenodd" d="M13 9.9a4.1 4.1 0 1 0 0 8.2 4.1 4.1 0 0 0 0-8.2zM11.1 14a1.9 1.9 0 1 1 3.8 0 1.9 1.9 0 0 1-3.8 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 40 40'
  },
  width: 40,
  height: 40
};

var dataMedicalKit = {
  name: 'IconMedicalKit',
  content: '<path fill="currentColor" d="M11.016 17.35v-2.675H8.385v-2h2.63V10h1.968v2.675h2.631v2h-2.63v2.675h-1.968z"/><path fill="currentColor" fill-rule="evenodd" d="M18 6h.5a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-13a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4H6V5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1zm-3-2H9a1 1 0 0 0-1 1v1h8V5a1 1 0 0 0-1-1zm3.5 4h-13a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMedicalKitSolid = {
  name: 'IconMedicalKitSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6 6V5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1h.5a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-13a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4H6zm2-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1H8V5zm3.016 12.35v-2.675H8.385v-2h2.631V10h1.967v2.675h2.631v2h-2.63v2.675h-1.968z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMediumSquare = {
  name: 'IconMediumSquare',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.298 8.285V6.062h1.404v2.223h4.615v6.344h-1.365v-.715h-3.25v4.342h-1.404v-4.342H8.061v.715H6.696V8.285h4.602zM8.061 9.611v2.977h3.237V9.611H8.061zm4.641 0v2.977h3.25V9.611h-3.25z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMediumSquareSolid = {
  name: 'IconMediumSquareSolid',
  content: '<path fill="currentColor" d="M7.061 9.611v2.977h3.237V9.611H7.061zm4.641 0v2.977h3.25V9.611h-3.25z"/><path fill="currentColor" fill-rule="evenodd" d="M.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm9.798 1.785V6.062h1.404v2.223h4.615v6.344h-1.365v-.715h-3.25v4.342h-1.404v-4.342H7.061v.715H5.696V8.285h4.602z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataMenu = {
  name: 'IconMenu',
  content: '<path fill="currentColor" d="M16 21H3v-2h13v2zm5-8H3v-2h18v2zM3 5h13V3H3v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMigrate = {
  name: 'IconMigrate',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7.5 6.2c-.722 0-1.315.392-1.7.906-.385.513-.6 1.185-.6 1.894 0 .709.215 1.381.6 1.894.385.514.978.906 1.7.906.723 0 1.316-.392 1.7-.906.386-.513.6-1.185.6-1.894 0-.709-.214-1.381-.6-1.894-.384-.514-.977-.906-1.7-.906zM6.8 9c0-.396.122-.724.28-.934.157-.21.314-.266.42-.266.106 0 .263.055.42.266.159.21.28.538.28.934s-.121.724-.28.934c-.157.21-.314.266-.42.266-.106 0-.263-.055-.42-.266-.158-.21-.28-.538-.28-.934z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M1 10c0-4.18 2.699-8 6.5-8S14 5.82 14 10s-2.699 8-6.5 8S1 14.18 1 10zm6.5-6C5.226 4 3 6.448 3 10s2.226 6 4.5 6 4.5-2.448 4.5-6-2.226-6-4.5-6z" clip-rule="evenodd"/><path fill="currentColor" d="M20 6.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5.448-1.5 1-1.5 1 .672 1 1.5z"/><path fill="currentColor" fill-rule="evenodd" d="M16.047 3.763C16.709 2.77 17.733 2 19 2s2.291.77 2.953 1.763C22.62 4.763 23 6.087 23 7.5c0 1.413-.38 2.737-1.047 3.737C21.291 12.23 20.267 13 19 13s-2.291-.77-2.953-1.763C15.38 10.237 15 8.913 15 7.5c0-1.413.38-2.737 1.047-3.737zm1.664 1.11C17.29 5.5 17 6.427 17 7.5c0 1.073.292 1.999.71 2.627.424.636.9.873 1.29.873s.866-.237 1.29-.873C20.707 9.5 21 8.573 21 7.5c0-1.073-.292-1.999-.71-2.627C19.865 4.237 19.39 4 19 4s-.866.237-1.29.873z" clip-rule="evenodd"/><path fill="currentColor" d="M17.952 14.252a8.371 8.371 0 0 0-.023.257c-.018.235-.025.553.076.914.204.73.768 1.345 1.705 2.002.32.243.297.407.281.47-.036.147-.252.543-1.133.977-1.74.857-5.39 1.499-11.762.884l-.192 1.99c6.483.627 10.59.027 12.838-1.08 1.113-.548 1.95-1.314 2.191-2.292.262-1.06-.26-1.98-1.038-2.56l-.012-.008-.012-.01c-.828-.579-.925-.856-.94-.913a.647.647 0 0 1-.008-.226l.009-.093c.013-.138.036-.37.036-.564h-2c0 .096-.007.158-.016.252z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMigrateSolid = {
  name: 'IconMigrateSolid',
  content: '<path fill="currentColor" d="M5.8 9c0-.396.121-.724.28-.934.157-.21.314-.266.42-.266.106 0 .263.055.42.266.159.21.28.538.28.934s-.121.724-.28.934c-.157.21-.314.266-.42.266-.106 0-.263-.055-.42-.266-.159-.21-.28-.538-.28-.934z"/><path fill="currentColor" fill-rule="evenodd" d="M0 10c0-4.18 2.699-8 6.5-8S13 5.82 13 10s-2.699 8-6.5 8S0 14.18 0 10zm6.5-3.8c-.723 0-1.316.392-1.7.906-.386.513-.6 1.185-.6 1.894 0 .709.214 1.38.6 1.894.384.514.977.906 1.7.906.722 0 1.316-.392 1.7-.906.386-.513.6-1.185.6-1.894 0-.709-.214-1.381-.6-1.894-.384-.514-.978-.906-1.7-.906zm8.547-2.437C15.709 2.77 16.733 2 18 2s2.291.77 2.953 1.763C21.62 4.763 22 6.087 22 7.5c0 1.413-.38 2.737-1.047 3.737C20.291 12.23 19.267 13 18 13s-2.291-.77-2.953-1.763C14.38 10.237 14 8.913 14 7.5c0-1.413.38-2.737 1.047-3.737zM18 8c.552 0 1-.672 1-1.5S18.552 5 18 5s-1 .672-1 1.5.448 1.5 1 1.5z" clip-rule="evenodd"/><path fill="currentColor" d="M16.952 14.252a8.371 8.371 0 0 0-.023.257c-.018.235-.025.553.076.914.204.73.768 1.345 1.705 2.002.32.243.297.407.281.47-.036.147-.252.543-1.133.977-1.74.857-5.39 1.499-11.762.884l-.192 1.99c6.483.627 10.59.027 12.838-1.08 1.113-.548 1.95-1.314 2.191-2.292.262-1.06-.26-1.98-1.038-2.56l-.012-.008-.012-.01c-.828-.579-.925-.856-.94-.913a.647.647 0 0 1-.008-.226l.009-.093c.013-.138.036-.37.036-.564h-2c0 .096-.007.158-.016.252z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataMiniAppBaidu = {
  name: 'IconMiniAppBaidu',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M20.671 12.77a1.5 1.5 0 0 0 0-1.386L15.736 1.91c-.56-1.076-2.1-1.076-2.66 0L8.14 11.384a1.5 1.5 0 0 0 0 1.386l4.935 9.475c.56 1.076 2.1 1.076 2.66 0l4.935-9.475zm-6.265-9.085 4.371 8.392-4.371 8.393-4.371-8.393 4.371-8.392zM3.115 11.447 7.33 1.3h2.165L5.041 12.022l4.454 10.722H7.33L3.115 12.598a1.5 1.5 0 0 1 0-1.151z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMiniAppBaiduSolid = {
  name: 'IconMiniAppBaiduSolid',
  content: '<path fill="currentColor" d="M17.671 11.384a1.5 1.5 0 0 1 0 1.386l-4.935 9.475c-.56 1.076-2.1 1.076-2.66 0L5.14 12.77a1.5 1.5 0 0 1 0-1.386l4.935-9.474c.56-1.076 2.1-1.076 2.66 0l4.935 9.474z"/><path fill="currentColor" d="m2.041 12.022 4.454 10.722H4.33L.115 12.597a1.5 1.5 0 0 1 0-1.15L4.33 1.3h2.165L2.041 12.022z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 18 24'
  },
  width: 18,
  height: 24
};

var dataMiniAppWechat = {
  name: 'IconMiniAppWechat',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M2 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0zm9-11C4.925 1 0 5.925 0 12s4.925 11 11 11 11-4.925 11-11S17.075 1 11 1zm3.505 10.035-.771.464.929 1.542.77-.465A3.65 3.65 0 1 0 9.9 9.491l.01.867v3.248l-.01.865a1.85 1.85 0 1 1-2.682-1.674l.804-.404-.81-1.608-.803.405a3.65 3.65 0 1 0 5.29 3.302l.01-.792v-.083l.001-.025V9.7h-.007l-.003-.23a1.85 1.85 0 1 1 2.805 1.565z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataMinimize = {
  name: 'IconMinimize',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M21 19H3v2h18v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMinus = {
  name: 'IconMinus',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M21.3 13.2H2.8v-2.4h18.5v2.4z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMinusCircle = {
  name: 'IconMinusCircle',
  content: '<path fill="currentColor" d="M6.3 13h11.4v-2H6.3v2z"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMinusCircleSolid = {
  name: 'IconMinusCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm5.3 1h11.4v-2H5.3v2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataMobileApp = {
  name: 'IconMobileApp',
  content: '<path fill="currentColor" d="M15.8 18.2H8.2v1.6h7.6v-1.6z"/><path fill="currentColor" fill-rule="evenodd" d="M6.7 6.446c0-.688.558-1.246 1.246-1.246h2.108c.688 0 1.246.558 1.246 1.246v2.108c0 .688-.558 1.246-1.246 1.246H7.946A1.246 1.246 0 0 1 6.7 8.554V6.446zm1.6.354v1.4h1.4V6.8H8.3zm-.354 4.4c-.688 0-1.246.558-1.246 1.246v2.108c0 .688.558 1.246 1.246 1.246h2.108c.688 0 1.246-.558 1.246-1.246v-2.108c0-.688-.558-1.246-1.246-1.246H7.946zm.354 3v-1.4h1.4v1.4H8.3zm4.4-1.754c0-.688.558-1.246 1.246-1.246h2.108c.688 0 1.246.558 1.246 1.246v2.108c0 .688-.558 1.246-1.246 1.246h-2.108a1.246 1.246 0 0 1-1.246-1.246v-2.108zm1.6.354v1.4h1.4v-1.4h-1.4zm.7-7.6a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 0 0 0-4.6zm-.7 2.3a.7.7 0 1 1 1.4 0 .7.7 0 0 1-1.4 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M8.7 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h6.6a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5H8.7zm-3 5a3 3 0 0 1 3-3h6.6a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H8.7a3 3 0 0 1-3-3V6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMobileAppSolid = {
  name: 'IconMobileAppSolid',
  content: '<path fill="currentColor" d="M5.3 6.8v1.4h1.4V6.8H5.3zm0 6v1.4h1.4v-1.4H5.3zm6 0v1.4h1.4v-1.4h-1.4zm.7-6a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4z"/><path fill="currentColor" fill-rule="evenodd" d="M.7 6a5 5 0 0 1 5-5h6.6a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5H5.7a5 5 0 0 1-5-5V6zm3 .446c0-.688.558-1.246 1.246-1.246h2.108c.688 0 1.246.558 1.246 1.246v2.108c0 .688-.558 1.246-1.246 1.246H4.946A1.246 1.246 0 0 1 3.7 8.554V6.446zM5.2 18.2h7.6v1.6H5.2v-1.6zm-1.5-5.754c0-.688.558-1.246 1.246-1.246h2.108c.688 0 1.246.558 1.246 1.246v2.108c0 .688-.558 1.246-1.246 1.246H4.946A1.246 1.246 0 0 1 3.7 14.554v-2.108zm6 0c0-.688.558-1.246 1.246-1.246h2.108c.688 0 1.246.558 1.246 1.246v2.108c0 .688-.558 1.246-1.246 1.246h-2.108A1.246 1.246 0 0 1 9.7 14.554v-2.108zm0-4.946a2.3 2.3 0 1 1 4.6 0 2.3 2.3 0 0 1-4.6 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 18 24'
  },
  width: 18,
  height: 24
};

var dataMotionGraphics = {
  name: 'IconMotionGraphics',
  content: '<path fill="currentColor" d="M10.637 1.084a11.1 11.1 0 0 1 2.726 0l-.245 1.985a9.1 9.1 0 0 0-2.236 0l-.245-1.985zm4.281.307c.89.245 1.736.598 2.52 1.045l-.99 1.738a8.939 8.939 0 0 0-2.06-.854l.53-1.929zM6.562 2.436c.784-.447 1.63-.8 2.52-1.045l.53 1.93a8.912 8.912 0 0 0-2.06.853l-.99-1.738zm12.193.882c.72.56 1.367 1.208 1.927 1.927l-1.577 1.23a9.056 9.056 0 0 0-1.58-1.58l1.23-1.577zM3.318 5.245c.56-.72 1.208-1.367 1.927-1.927l1.23 1.577a9.06 9.06 0 0 0-1.58 1.58l-1.577-1.23zm18.246 1.317c.447.784.8 1.63 1.044 2.52l-1.928.53a8.942 8.942 0 0 0-.854-2.06l1.738-.99zM1.391 9.082a10.94 10.94 0 0 1 1.045-2.52l1.738.99a8.939 8.939 0 0 0-.854 2.06l-1.929-.53zm21.525 1.555a11.1 11.1 0 0 1 0 2.726l-1.985-.245a9.11 9.11 0 0 0 0-2.236l1.985-.245zM1 12c0-.461.028-.916.084-1.363l1.985.245a9.1 9.1 0 0 0 0 2.236l-1.985.245A11.1 11.1 0 0 1 1 12zm21.608 2.918c-.244.89-.597 1.736-1.044 2.52l-1.738-.99a8.942 8.942 0 0 0 .854-2.06l1.928.53zm-20.172 2.52a10.94 10.94 0 0 1-1.045-2.52l1.93-.53c.199.728.488 1.419.853 2.06l-1.738.99zm18.246 1.317c-.56.72-1.208 1.367-1.927 1.927l-1.23-1.577c.59-.46 1.12-.99 1.58-1.58l1.577 1.23zM5.245 20.682a11.058 11.058 0 0 1-1.927-1.927l1.577-1.23c.46.59.99 1.12 1.58 1.58l-1.23 1.577zm3.837 1.926a10.938 10.938 0 0 1-2.52-1.044l.99-1.738a8.942 8.942 0 0 0 2.06.854l-.53 1.928zm8.356-1.044c-.784.447-1.63.8-2.52 1.044l-.53-1.928a8.942 8.942 0 0 0 2.06-.854l.99 1.738zM12 23a11.1 11.1 0 0 1-1.363-.084l.245-1.985a9.11 9.11 0 0 0 2.236 0l.245 1.985A11.1 11.1 0 0 1 12 23zM6.1 12a5.9 5.9 0 0 1 11.8 0h-1.8a4.1 4.1 0 1 0-4.1 4.1v1.8A5.9 5.9 0 0 1 6.1 12z"/><path fill="currentColor" d="M15.5 17.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMove = {
  name: 'IconMove',
  content: '<path fill="currentColor" d="M7.326 4.83 8.74 6.244 11 3.984V9.5h2V3.999l2.245 2.245L16.66 4.83l-3.395-3.394a1.8 1.8 0 0 0-2.545 0L7.326 4.83zm0 14.34 3.394 3.394a1.8 1.8 0 0 0 2.545 0l3.395-3.394-1.415-1.414L13 20v-5.5h-2v5.516l-2.26-2.26-1.414 1.414zm11.84-11.84 3.394 3.393a1.8 1.8 0 0 1 0 2.546l-3.394 3.394-1.414-1.414 2.246-2.246-5.499-.004.001-2 5.51.004-2.258-2.26 1.414-1.414zm-14.34 0-3.394 3.393a1.8 1.8 0 0 0 0 2.546l3.394 3.394L6.24 15.25l-2.245-2.245H9.5v-2H3.98l2.26-2.26L4.826 7.33z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMovieSolid = {
  name: 'IconMovieSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M23 6.993a4.002 4.002 0 0 0-2.797-3.809L18 7h5v-.007zM2 8.8h21V17a4 4 0 0 1-4 4H6a4.002 4.002 0 0 1-4-4V8.8zM6 3a4 4 0 0 0-4 4h2.189l2.31-4H6zm2.5 0L6.19 7h3.808l2.31-4H8.5zm7.498 4H12l2.31-4h3.998l-2.31 4z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMusic = {
  name: 'IconMusic',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8 10.75v7.715a3.5 3.5 0 1 1-2-2.374V6.036a3 3 0 0 1 2.579-2.97l10.1-1.433a3 3 0 0 1 3.421 2.97V17.8a3.5 3.5 0 1 1-2-3.163V8.889L8 10.75zm10.96-7.136a1 1 0 0 1 1.14.99v2.261L8 8.727v-2.69a1 1 0 0 1 .86-.99l10.1-1.433zM18.6 16.3a1.5 1.5 0 0 1 1.5 1.483v.017a1.5 1.5 0 1 1-1.5-1.5zM6 18.76v1.04h.015A1.5 1.5 0 1 1 6 18.76z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMusicSolid = {
  name: 'IconMusicSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7 18.466V10.75l12.1-1.86v5.748a3.5 3.5 0 1 0 2 3.163V4.604a3 3 0 0 0-3.421-2.97l-10.1 1.432A3 3 0 0 0 5 6.036v10.055a3.5 3.5 0 1 0 2 2.374zM19.1 4.604a1 1 0 0 0-1.14-.99L7.86 5.046a1 1 0 0 0-.86.99v2.69l12.1-1.86V4.603z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataMute = {
  name: 'IconMute',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.612 3.263c1.604-1.468 4.188-.33 4.188 1.844v13.786c0 2.174-2.584 3.312-4.188 1.844l-2.7-2.473H4.8a3 3 0 0 1-3-3V8.735a3 3 0 0 1 3-3h3.111l2.7-2.472zM12.8 5.107a.5.5 0 0 0-.838-.369L8.69 7.735H4.8a1 1 0 0 0-1 1v6.53a1 1 0 0 0 1 1h3.89l3.273 2.997a.5.5 0 0 0 .838-.37V5.108z" clip-rule="evenodd"/><path fill="currentColor" d="m17 8.756 2.2 2.2 2.2-2.2 1.344 1.344-2.2 2.2 2.2 2.2-1.344 1.343-2.2-2.2-2.2 2.2-1.344-1.343 2.2-2.2-2.2-2.2L17 8.756z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataMuteSolid = {
  name: 'IconMuteSolid',
  content: '<path fill="currentColor" d="M9.612 3.263c1.604-1.468 4.188-.33 4.188 1.844v13.786c0 2.174-2.585 3.312-4.188 1.844l-2.7-2.472H3.8a3 3 0 0 1-3-3v-6.53a3 3 0 0 1 3-3h3.11l2.7-2.472zM20.4 8.756l-2.2 2.2-2.2-2.2-1.343 1.344 2.2 2.2-2.2 2.2L16 15.844l2.2-2.2 2.2 2.2 1.344-1.344-2.2-2.2 2.2-2.2L20.4 8.756z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataNeutralFace = {
  name: 'IconNeutralFace',
  content: '<path fill="currentColor" d="M7.3 11.4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-9 5.1a1 1 0 1 0 0 2h7.5a1 1 0 1 0 0-2H7.3z"/><path fill="currentColor" fill-rule="evenodd" d="M11 1C4.925 1 0 5.925 0 12s4.925 11 11 11 11-4.925 11-11S17.075 1 11 1zM2 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataNeutralFaceSolid = {
  name: 'IconNeutralFaceSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm7.3-.6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm7.5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM6.3 16a1 1 0 0 1 1-1h7.5a1 1 0 1 1 0 2H7.3a1 1 0 0 1-1-1z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataOneToOne = {
  name: 'IconOneToOne',
  content: '<path fill="currentColor" d="M8.016 7.518a5.796 5.796 0 0 1-1.17.91c-.468.26-.91.442-1.326.546v1.508c.858-.247 1.56-.624 2.119-1.131V16.8H9.16V7.518H8.016zm7.43 1.11a5.796 5.796 0 0 0 1.17-.91h1.144V17h-1.52V9.551c-.56.507-1.262.884-2.12 1.131V9.174a5.514 5.514 0 0 0 1.326-.546zM12.9 9.9a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0zm-.9 5.4a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8z"/><path fill="currentColor" fill-rule="evenodd" d="M1.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm5-3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3h-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataOneToOneSolid = {
  name: 'IconOneToOneSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm6.516 1.018a5.796 5.796 0 0 1-1.17.91c-.468.26-.91.442-1.326.546v1.508c.858-.247 1.56-.624 2.119-1.13V16.8H8.16V7.518H7.016zm8.6.2a5.796 5.796 0 0 1-1.17.91c-.468.26-.91.442-1.326.546v1.508c.858-.247 1.56-.624 2.12-1.131V17h1.52V7.718h-1.144zM11.9 9.9a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0zm0 4.5a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataOrder = {
  name: 'IconOrder',
  content: '<path fill="currentColor" d="M17 11.5H7v-2h10v2zm-10 5h10v-2H7v2z"/><path fill="currentColor" fill-rule="evenodd" d="M9 1v1.5h6V1h2v1.5h.5a5 5 0 0 1 5 5V18a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5V7.5a5 5 0 0 1 5-5H7V1h2zm6 3.5V6h2V4.5h.5a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H7V6h2V4.5h6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataOrderSolid = {
  name: 'IconOrderSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6 2.5h-.5a5 5 0 0 0-5 5V18a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5V7.5a5 5 0 0 0-5-5H16V1h-2v1.5H8V1H6v1.5zm10 9H6v-2h10v2zm0 5H6v-2h10v2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataOutdent = {
  name: 'IconOutdent',
  content: '<path fill="currentColor" d="M2 3h20v2H2V3zm6 5.5h14v2H8v-2zM8 14v2h14v-2H8zm-6 5.5h20v2H2v-2zm-.033-7.638a.6.6 0 0 0 0 .876l3.323 3.115a.6.6 0 0 0 1.01-.438v-6.23a.6.6 0 0 0-1.01-.438l-3.323 3.115z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataOutstanding = {
  name: 'IconOutstanding',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1 12C1 5.925 5.925 1 12 1c.614 0 1.202.062 1.761.153l-.318 1.974A9.014 9.014 0 0 0 12 3a9 9 0 0 0-9 9c0 1.48.357 2.877.99 4.108l2.633-4.278a3 3 0 1 1 1.679 1.088l-3.08 5.004A8.979 8.979 0 0 0 12 21c1.868 0 3.604-.57 5.042-1.544l-1.749-1.748a3 3 0 1 1-.692-5.647l1.08-2.158a3 3 0 1 1 1.718 1.037l-1.08 2.157c.426.518.681 1.18.681 1.903 0 .463-.105.902-.292 1.293l1.86 1.86A8.968 8.968 0 0 0 21 12c0-.48-.049-.956-.127-1.443l1.974-.319c.09.56.153 1.148.153 1.762 0 6.075-4.925 11-11 11S1 18.075 1 12zm17-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-3 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-6-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataOutstandingSolid = {
  name: 'IconOutstandingSolid',
  content: '<path fill="currentColor" d="M11 1C4.925 1 0 5.925 0 12s4.925 11 11 11 11-4.925 11-11c0-.614-.062-1.202-.153-1.761l-1.974.318c.078.487.127.963.127 1.443 0 2.38-.924 4.544-2.432 6.154l-1.86-1.86c.187-.392.292-.83.292-1.294a2.99 2.99 0 0 0-.68-1.903l1.078-2.157a3 3 0 1 0-1.718-1.037l-1.078 2.157a3 3 0 1 0 .692 5.647l1.748 1.75A8.958 8.958 0 0 1 11 21a8.979 8.979 0 0 1-6.778-3.078l3.08-5.004a3 3 0 1 0-1.679-1.088L2.99 16.108A8.962 8.962 0 0 1 2 12a9 9 0 0 1 9-9c.48 0 .956.049 1.443.127l.319-1.974A11.077 11.077 0 0 0 11 1z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataPackageUpload = {
  name: 'IconPackageUpload',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3.121 3.464A5 5 0 0 1 6.657 2h10.686a5 5 0 0 1 3.536 1.464l1.242 1.243A3 3 0 0 1 23 6.828V17a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V6.828a3 3 0 0 1 .879-2.12L3.12 3.463zM6.657 4a3 3 0 0 0-2.121.879L3.414 6h17.172l-1.121-1.121A3 3 0 0 0 17.343 4H6.657zM3 17V8h18v9a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm14.282-3.942-.743-.67-3.192-2.874a2 2 0 0 0-2.73.05l-2.943 2.85-.718.696 1.392 1.436.718-.696L11 11.977V19h2v-7.107l2.2 1.982.744.67 1.338-1.487z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPackageUploadSolid = {
  name: 'IconPackageUploadSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3.121 3.464A5 5 0 0 1 6.657 2h10.686a5 5 0 0 1 3.536 1.464l1.242 1.243A3 3 0 0 1 23 6.828V17a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V6.828a3 3 0 0 1 .879-2.12L3.12 3.463zM6.657 4a3 3 0 0 0-2.121.879L3.414 6h17.172l-1.121-1.121A3 3 0 0 0 17.343 4H6.657zm10.625 9.058-.743-.67-3.192-2.874a2 2 0 0 0-2.73.05l-2.943 2.85-.718.696 1.392 1.436.718-.696L11 11.977V19h2v-7.107l2.2 1.982.744.67 1.338-1.487z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPaintBucket = {
  name: 'IconPaintBucket',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M19.814 11.4 9.207.793 7.793 2.207l1.414 1.414-7.071 7.071a5 5 0 0 0 0 7.072l2.121 2.12a5 5 0 0 0 7.071 0l8.486-8.485zM3.55 16.35a3.001 3.001 0 0 1-.54-3.508l9.884 2.649-2.98 2.98a3 3 0 0 1-4.243 0l-2.12-2.122zm7.071-11.314L4.49 11.168l10.038 2.69 2.458-2.459-6.364-6.363z" clip-rule="evenodd"/><path fill="currentColor" d="M21.799 16.159 19.999 14l-1.798 2.159C16.93 17.684 18.014 20 20 20c1.985 0 3.07-2.316 1.799-3.841z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPaintBucketSolid = {
  name: 'IconPaintBucketSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7.793 2.207 9.207.793l10.607 10.606-8.486 8.486a5 5 0 0 1-7.07 0l-2.122-2.122a5 5 0 0 1 0-7.07L9.207 3.62 7.793 2.207zm6.986 11.718L3.188 10.819l-.518 1.932 11.591 3.106.518-1.932z" clip-rule="evenodd"/><path fill="currentColor" d="m20 14 1.799 2.159c1.271 1.525.186 3.841-1.8 3.841"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 23 24'
  },
  width: 23,
  height: 24
};

var dataPaperClip = {
  name: 'IconPaperClip',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.5 3.3A4.5 4.5 0 0 0 7 7.8v8.762H5V7.8a6.5 6.5 0 0 1 13 0v10.333a4.667 4.667 0 1 1-9.333 0V8.871a2.833 2.833 0 1 1 5.666 0v7.69h-2v-7.69a.833.833 0 1 0-1.666 0v9.262a2.667 2.667 0 1 0 5.333 0V7.8a4.5 4.5 0 0 0-4.5-4.5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPaperPlane = {
  name: 'IconPaperPlane',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M21.7 3.838c0-1.497-1.583-2.463-2.914-1.78L2.641 10.35c-1.695.87-1.328 3.394.545 3.745l6.4 1.2L19.7 4.647v11.961l-7.06-2.549-.68 1.882 2.17.783-4.44 3.584v-2.822h-2v2.822c0 1.68 1.947 2.612 3.255 1.556l5.386-4.346 2.69.971a2 2 0 0 0 2.679-1.88V3.837zm-18.145 8.29 12.26-6.295-6.93 7.295-5.33-1z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPaperPlaneSend = {
  name: 'IconPaperPlaneSend',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.433 1.8C3.86.94 2.037 2.424 2.56 4.139L4.96 12l-2.4 7.861c-.523 1.715 1.3 3.2 2.873 2.34l15.443-8.446c1.387-.759 1.387-2.751 0-3.51L5.433 1.8zm-.96 1.755L19.916 12 4.473 20.445 6.746 13H13.5v-2H6.746L4.473 3.555z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPaperPlaneSendSolid = {
  name: 'IconPaperPlaneSendSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.002 1.564C3.586.79 1.946 2.126 2.417 3.67L4.655 11H13.5v2H4.655l-2.238 7.33c-.471 1.544 1.17 2.88 2.585 2.106l16.194-8.857c1.249-.682 1.249-2.476 0-3.158L5.002 1.564z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPaperPlaneSolid = {
  name: 'IconPaperPlaneSolid',
  content: '<path fill="currentColor" d="M20.7 3.838c0-1.497-1.583-2.463-2.914-1.78L1.653 10.343c-1.698.872-1.326 3.4.55 3.746l3.699.682L18 5 9.36 15.56l3.663 1.25-4.334 3.498v-2.822h-2v2.822c0 1.68 1.948 2.612 3.257 1.556l5.315-4.29 2.793.953a2 2 0 0 0 2.646-1.892V3.838z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataPaste = {
  name: 'IconPaste',
  content: '<g fill="currentColor"><path d="M13.6 6.4H6a4 4 0 0 0-4 4V18a4 4 0 0 0 4 4h7.6a4 4 0 0 0 4-4v-7.6a4 4 0 0 0-4-4zM6 8.4h7.6a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.6a2 2 0 0 1 2-2z"/><path d="M8 7.946V6.2c0-.287.06-.563.174-.817l-1.825-.819A3.99 3.99 0 0 0 6 6.2v1.746h2zm.843-3.378A1.986 1.986 0 0 1 10 4.2h1.162v-2H10c-.84 0-1.644.26-2.316.738l1.16 1.63zm3.819-.368h3v-2h-3v2zm4.5 0h.49c.593 0 1.141.258 1.52.7l1.52-1.3a3.993 3.993 0 0 0-3.04-1.4h-.49v2zm2.447 1.586c.018.084.03.17.037.256l.006.164-.008 2.409 2 .006.007-2.468a4.027 4.027 0 0 0-.085-.778l-1.957.41zm.03 4.329-.009 3 2 .006.01-3-2-.006zm-.087 4.221a2.005 2.005 0 0 1-1.436 1.391l.486 1.94a4.005 4.005 0 0 0 2.874-2.783l-1.924-.548zm-2.662 1.45h-.314v2h.314v-2zM12.7 15.5v2h-6v-2zm0-4v2h-6v-2z"/></g>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPasteImageSolid = {
  name: 'IconPasteImageSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M18.234 3.4h-.539V1.2h.54a4.392 4.392 0 0 1 3.343 1.54l-1.672 1.43a2.193 2.193 0 0 0-1.672-.77zm-9.69.405A2.187 2.187 0 0 1 9.818 3.4h1.278V1.2H9.817c-.924 0-1.808.286-2.547.812l1.275 1.793zm7.501-.405h-3.3V1.2h3.3v2.2zm4.342 1.744c.02.093.033.187.04.282l.007.18-.009 2.65 2.2.007.008-2.715a4.427 4.427 0 0 0-.093-.856l-2.153.451v.001zm.033 4.762-.01 3.3 2.2.007.01-3.3-2.2-.007zm-.096 4.643a2.205 2.205 0 0 1-1.58 1.53l.535 2.134a4.407 4.407 0 0 0 3.162-3.061l-2.117-.603zM7.617 5.6h6.6a4.4 4.4 0 0 1 4.4 4.4v8.8a4.4 4.4 0 0 1-4.4 4.4h-8.8a4.4 4.4 0 0 1-4.4-4.4V10a4.4 4.4 0 0 1 4.4-4.4c0-.62.13-1.233.384-1.799l2.008.901c-.126.28-.192.583-.192.899zm6.076 14.079H6.518a2.2 2.2 0 0 1-2.2-2.2V13.15a8.489 8.489 0 0 1 9.375 6.529zm-.026-6.6a1.65 1.65 0 1 0 0-3.3 1.65 1.65 0 0 0 0 3.3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPasteSolid = {
  name: 'IconPasteSolid',
  content: '<path fill="currentColor" d="M15.162 4.2h.49c.593 0 1.141.258 1.52.7l1.52-1.3a3.993 3.993 0 0 0-3.04-1.4h-.49v2zM8 4.2a1.989 1.989 0 0 0-1.157.368l-1.159-1.63A3.984 3.984 0 0 1 8 2.2h1.162v2H8zm5.662 0h-3v-2h3v2zm3.984 1.842a1.998 1.998 0 0 0-.037-.256v-.001l1.957-.41c.054.256.082.516.085.778l-.007 2.468-2-.006.008-2.41-.006-.163zm-.006 4.073-.01 3 2 .006.01-3-2-.006zm-.62 5.108c.252-.244.435-.55.532-.887l1.924.548a4.005 4.005 0 0 1-2.874 2.783l-.486-1.94c.34-.086.652-.26.904-.504z"/><path fill="currentColor" fill-rule="evenodd" d="M6 6.2h6a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4c0-.564.118-1.121.349-1.636l1.825.819C6.06 5.637 6 5.913 6 6.2zM5 13h6v-2H5v2zm0 4.4h6v-2H5v2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataPath = {
  name: 'IconPath',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.502 2C6.05 2 4 3.923 4 6.373V15a.95.95 0 0 0 .01.142A3.501 3.501 0 0 0 5 22a3.5 3.5 0 0 0 .99-6.858A1.01 1.01 0 0 0 6 15V6.373C6 5.097 7.084 4 8.502 4c1.417 0 2.501 1.098 2.501 2.373l-.006 11.513c0 2.38 2.129 4.114 4.501 4.114C17.871 22 20 20.265 20 17.886v-4.542l1.328 1.328 1.344-1.344-3-3a.95.95 0 0 0-1.344 0l-3 3 1.344 1.344L18 13.343v4.543C18 18.946 16.994 20 15.498 20c-1.495 0-2.5-1.054-2.501-2.114l.006-11.513c0-2.45-2.05-4.373-4.501-4.373zM5 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M19 9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm1.5-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPathSolid = {
  name: 'IconPathSolid',
  content: '<path fill="currentColor" d="M7.502 2C5.05 2 3 3.923 3 6.373V15a.95.95 0 0 0 .01.142A3.501 3.501 0 0 0 4 22a3.5 3.5 0 0 0 .99-6.858A1.01 1.01 0 0 0 5 15V6.373C5 5.097 6.084 4 7.502 4c1.417 0 2.501 1.098 2.501 2.373l-.006 11.513c0 2.38 2.129 4.114 4.501 4.114C16.871 22 19 20.265 19 17.886v-4.542l1.328 1.328 1.344-1.344-3-3a.95.95 0 0 0-1.344 0l-3 3 1.344 1.344L17 13.343v4.543C17 18.946 15.994 20 14.498 20c-1.495 0-2.5-1.054-2.501-2.114l.006-11.513C12.003 3.923 9.953 2 7.502 2z"/><path fill="currentColor" d="M18 9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataPause = {
  name: 'IconPause',
  content: '<path fill-rule="evenodd" d="M19 4v16h-3V4h3ZM8.5 4v16h-3V4h3Z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPauseCircle = {
  name: 'IconPauseCircle',
  content: '<path fill="currentColor" d="M10.3 8v8h-2V8h2zm5.4 0v8h-2V8h2z"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPauseCircleSolid = {
  name: 'IconPauseCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zM8.3 8h2v8h-2V8zm5.4 0h2v8h-2V8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPenWrite = {
  name: 'IconPenWrite',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M16.25 9.151 5.926 19H4.025v-1.63l10.352-9.875.069-.065 1.804 1.72zm1.568-1.495.068-.065 1.618-1.543-1.805-1.722-1.686 1.609 1.805 1.721zm-3.254-3.103 2.351-2.243a1.147 1.147 0 0 1 1.568 0l3.135 2.99a1.023 1.023 0 0 1 0 1.495L8.944 18.885h13.03V21H2.025v-4.486L12.998 6.048l1.567-1.496z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPenWriteSolid = {
  name: 'IconPenWriteSolid',
  content: '<path fill="currentColor" d="M8.944 18.885h13.03V21H2.025v-4.486L12.998 6.048l4.702 4.485-8.755 8.352zm5.62-14.333 2.351-2.242a1.147 1.147 0 0 1 1.568 0l3.135 2.99a1.023 1.023 0 0 1 0 1.495l-2.351 2.243-4.703-4.486z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPencil = {
  name: 'IconPencil',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m21.784 4.096-1.08-1.08a3.8 3.8 0 0 0-5.374 0L2.911 15.436a1 1 0 0 0-.293.688l-.091 4.982a1 1 0 0 0 .989 1.018l5.13.058a1 1 0 0 0 .719-.293l12.42-12.42a3.8 3.8 0 0 0 0-5.373zM20.37 5.51l.1.109a1.8 1.8 0 0 1-.1 2.437l-.898.898-3.626-3.626.899-.898a1.8 1.8 0 0 1 2.545 0l1.08 1.08zm-5.938 1.233-9.821 9.821-.066 3.57 3.704.043 9.809-9.809-3.626-3.625z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPencilSolid = {
  name: 'IconPencilSolid',
  content: '<path fill="currentColor" d="m18.705 3.016 1.08 1.08a3.8 3.8 0 0 1 0 5.374l-.908.907-6.454-6.454.908-.907a3.8 3.8 0 0 1 5.374 0zm-7.696 2.322L.91 15.435a1 1 0 0 0-.292.689l-.092 4.982a1 1 0 0 0 .989 1.018l5.13.058a1 1 0 0 0 .72-.293l10.097-10.098-6.454-6.453z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataPhone = {
  name: 'IconPhone',
  content: '<path fill="currentColor" d="m10.793 9.707 4 4 1.414-1.414-4-4-1.414 1.414zm-.5 4.5-2-2 1.414-1.414 2 2-1.414 1.414zM9 18a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9z"/><path fill="currentColor" fill-rule="evenodd" d="M8.7 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h6.6a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5H8.7zm-3 5a3 3 0 0 1 3-3h6.6a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H8.7a3 3 0 0 1-3-3V6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPhoneCall = {
  name: 'IconPhoneCall',
  content: '<g stroke="currentColor" stroke-width="2" clip-path="url(#dls-a5088-a)"><path d="M3.422 5.244a2.854 2.854 0 0 1 4.15.171l.938 1.082c.781.9.733 2.25-.109 3.092a.547.547 0 0 0-.088.668c.359.598 1.129 1.803 2.006 2.68.877.878 2.082 1.648 2.68 2.006.217.13.49.09.669-.088a2.269 2.269 0 0 1 3.091-.109l1.082.94a2.855 2.855 0 0 1 .171 4.149l-.543.557c-1.312 1.343-3.294 1.799-4.96.932-1.81-.942-4.191-2.406-6.18-4.396-1.99-1.99-3.455-4.37-4.397-6.18-.866-1.666-.411-3.648.933-4.96l.557-.544z" clip-rule="evenodd"/><path d="M16.25 11.6c0-.52-.107-1.035-.314-1.515a3.952 3.952 0 0 0-.894-1.285 4.14 4.14 0 0 0-1.338-.859 4.275 4.275 0 0 0-1.579-.301M20 11.48a7.413 7.413 0 0 0-.609-2.939 7.667 7.667 0 0 0-1.734-2.492 8.03 8.03 0 0 0-2.595-1.664A8.29 8.29 0 0 0 12 3.8"/></g><defs><clipPath id="dls-a5088-a"><path fill="currentColor" d="M0 0h21v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataPhoneCallSolid = {
  name: 'IconPhoneCallSolid',
  content: '<g fill="currentColor" clip-path="url(#dls-f4dc5-a)"><path d="M12 2.8a9.29 9.29 0 0 1 3.43.655 9.03 9.03 0 0 1 2.92 1.873 8.667 8.667 0 0 1 1.96 2.817c.455 1.056.69 2.19.69 3.335h-2c0-.871-.179-1.735-.527-2.543a6.668 6.668 0 0 0-1.509-2.166 7.031 7.031 0 0 0-2.272-1.457A7.29 7.29 0 0 0 12 4.8v-2z"/><path d="M12.125 6.64c.667 0 1.33.126 1.948.372a5.14 5.14 0 0 1 1.661 1.066 4.953 4.953 0 0 1 1.12 1.61c.261.605.396 1.255.396 1.912h-2a2.84 2.84 0 0 0-.232-1.12 2.954 2.954 0 0 0-.669-.959 3.142 3.142 0 0 0-1.015-.65 3.275 3.275 0 0 0-1.21-.231v-2z"/><path d="M2.166 5.072C.554 6.646-.054 9.097 1.045 11.21c.967 1.859 2.487 4.337 4.576 6.426 2.09 2.09 4.568 3.61 6.426 4.576 2.112 1.099 4.563.492 6.137-1.12l.544-.558a3.855 3.855 0 0 0-.231-5.603l-1.082-.939a3.27 3.27 0 0 0-4.189-.082c-.616-.385-1.528-1.007-2.2-1.679-.671-.671-1.294-1.584-1.68-2.2a3.27 3.27 0 0 0-.08-4.189l-.94-1.081a3.854 3.854 0 0 0-5.603-.232l-.557.544z"/></g><defs><clipPath id="dls-f4dc5-a"><path fill="currentColor" d="M0 0h21v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataPhoneEye = {
  name: 'IconPhoneEye',
  content: '<g clip-path="url(#dls-7d5b9-a)"><path stroke="currentColor" stroke-width="2" d="M3.422 5.244a2.854 2.854 0 0 1 4.15.171l.938 1.082c.781.9.733 2.25-.109 3.092a.547.547 0 0 0-.088.668c.359.598 1.129 1.803 2.006 2.68.877.878 2.082 1.648 2.68 2.006.217.13.49.09.669-.088a2.269 2.269 0 0 1 3.091-.109l1.082.94a2.855 2.855 0 0 1 .171 4.149l-.543.557c-1.312 1.343-3.294 1.799-4.96.932-1.81-.942-4.191-2.406-6.18-4.396-1.99-1.99-3.455-4.37-4.397-6.18-.866-1.666-.411-3.648.933-4.96l.557-.544z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="1.8" d="M16.5 3.2c1.548 0 2.878.954 3.797 2.033.478.56.488 1.377.047 1.968C19.262 8.648 18.106 9.2 16.5 9.2c-1.913 0-3.216-1.22-3.91-2.104a1.453 1.453 0 0 1 .005-1.791C13.98 3.504 15.566 3.2 16.5 3.2z"/><ellipse cx="16.459" cy="6.247" fill="currentColor" rx="1.459" ry="1.478"/></g><defs><clipPath id="dls-7d5b9-a"><path fill="currentColor" d="M0 0h22v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataPhoneEyeSolid = {
  name: 'IconPhoneEyeSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M16.5 2.3c-1.152 0-3.028.39-4.618 2.456a2.353 2.353 0 0 0 0 2.895c.759.968 2.294 2.449 4.618 2.449.91 0 1.748-.157 2.527-.555.778-.397 1.437-1.002 2.038-1.806.681-.912.68-2.195-.082-3.09C19.98 3.475 18.424 2.3 16.5 2.3zm-.04 5.425c.805 0 1.458-.662 1.458-1.478S17.265 4.77 16.46 4.77 15 5.431 15 6.247s.653 1.478 1.46 1.478z" clip-rule="evenodd"/><path fill="currentColor" d="M1.045 11.209C-.054 9.097.554 6.646 2.166 5.072l.557-.544a3.854 3.854 0 0 1 5.603.232l.94 1.081a3.27 3.27 0 0 1 .08 4.189c.386.616 1.009 1.529 1.68 2.2.672.672 1.584 1.294 2.2 1.68a3.27 3.27 0 0 1 4.189.081l1.082.939a3.855 3.855 0 0 1 .231 5.603l-.544.557c-1.574 1.613-4.025 2.22-6.137 1.121-1.858-.966-4.336-2.486-6.426-4.576-2.09-2.09-3.61-4.567-4.576-6.426z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataPhoneSolid = {
  name: 'IconPhoneSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.7 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h6.6a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5H5.7zm2.093 8.707 4 4 1.414-1.414-4-4-1.414 1.414zm-2.5 2.5 2 2 1.414-1.414-2-2-1.414 1.414zM6 18a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 18 24'
  },
  width: 18,
  height: 24
};

var dataPieChart = {
  name: 'IconPieChart',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12.225 1.003a1 1 0 0 0-1.025 1v.525C6.145 2.738 2.11 6.896 2.1 12H2a1 1 0 0 0-.995 1.099C1.557 18.659 6.246 23 11.95 23c6.075 0 11-4.925 11-11 0-5.984-4.778-10.851-10.726-10.997zM4.1 12h5.1a2 2 0 0 0 2-2V4.53A7.5 7.5 0 0 0 4.1 12zm9.1-2V3.086A9 9 0 1 1 3.173 14H9.2a4 4 0 0 0 4-4z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPieChartSolid = {
  name: 'IconPieChartSolid',
  content: '<path fill="currentColor" d="M.045 13c-.05-.55.403-1 .955-1h6.6a3 3 0 0 0 3-3V2c0-.552.449-1.005.999-.956C17.247 1.548 22 6.26 22 12c0 6.075-4.925 11-11 11C5.262 23 .55 18.606.045 13z"/><path fill="currentColor" d="M.76 9.319c-.202.601.274 1.187.91 1.187h5.56a2 2 0 0 0 2-2V3.41c0-.609-.541-1.08-1.13-.928A10.545 10.545 0 0 0 .76 9.32z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataPinSlant = {
  name: 'IconPinSlant',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M21.718 7.285a2.01 2.01 0 0 1-.609 3.26l-1.866.826-3.5 3.504-.278 3.855a2.01 2.01 0 0 1-3.427 1.277l-3.4-3.403-5.083 5.107a1.005 1.005 0 0 1-1.425-1.418l5.087-5.11-3.517-3.52a2.01 2.01 0 0 1 1.273-3.426l3.965-.296 3.438-3.443.808-1.863a2.012 2.012 0 0 1 3.268-.621l5.266 5.271zm-7.927 6.699 4.295-4.3 2.21-.979-5.267-5.27-.96 2.213-4.235 4.243-4.712.35 8.338 8.345.331-4.602z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPinSolid = {
  name: 'IconPinSolid',
  content: '<path fill="currentColor" d="M7.36.904a2.01 2.01 0 0 1 .74-.14l7.452.003a2.01 2.01 0 0 1 1.874 2.735l-.735 1.904.003 4.953 2.53 2.922a2.01 2.01 0 0 1-1.521 3.326l-4.81-.002.015 5.639a1.005 1.005 0 1 1-2.01.005l-.016-5.644-4.975-.002a2.01 2.01 0 0 1-1.523-3.323l2.595-3.013-.003-4.865-.747-1.889A2.01 2.01 0 0 1 7.36.903z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPlay = {
  name: 'IconPlay',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4.5 5.443c0-2.363 2.604-3.798 4.602-2.536l10.382 6.557c1.864 1.177 1.864 3.895 0 5.072L9.102 21.093C7.104 22.355 4.5 20.92 4.5 18.557V5.443z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPlayCircle = {
  name: 'IconPlayCircle',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.582 7.65C10.25 6.793 8.5 7.75 8.5 9.331v5.336c0 1.583 1.75 2.538 3.082 1.683l4.15-2.669a2 2 0 0 0 0-3.364l-4.15-2.669zM10.5 9.331 14.65 12l-4.15 2.668V9.332z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPlayCircleSolid = {
  name: 'IconPlayCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm-.997-15.212A1.3 1.3 0 0 0 9 8.88v6.238a1.3 1.3 0 0 0 2.003 1.093l4.851-3.118a1.3 1.3 0 0 0 0-2.188l-4.851-3.118z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPlus = {
  name: 'IconPlus',
  content: '<path fill="currentColor" d="M10.8 12.9v8.8h2.4v-8.8h8.5v-2.4h-8.5V2.2h-2.4v8.3H2.2v2.4h8.6z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPlusCircle = {
  name: 'IconPlusCircle',
  content: '<path fill="currentColor" d="M11 13H6.3v-2H11V6.3h2V11h4.7v2H13v4.7h-2V13z"/><path fill="currentColor" fill-rule="evenodd" d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPlusCircleSolid = {
  name: 'IconPlusCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zm-12 1H6.3v-2H11V6.3h2V11h4.7v2H13v4.7h-2V13z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPlusSquare = {
  name: 'IconPlusSquare',
  content: '<path fill="currentColor" d="M11 11V6.5h2V11h4.5v2H13v4.5h-2V13H6.5v-2H11z"/><path fill="currentColor" fill-rule="evenodd" d="M1.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm5-3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3h-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPlusSquareSolid = {
  name: 'IconPlusSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm9.4 11v-4.4H6.5v-2.2h4.4V6.5h2.2v4.4h4.4v2.2h-4.4v4.4h-2.2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPowerOff = {
  name: 'IconPowerOff',
  content: '<path fill="currentColor" d="M13 1h-2v11h2V1z"/><path fill="currentColor" d="M1 12C1 7.336 3.903 3.35 8 1.75v2.186a9 9 0 1 0 8 0V1.75c4.097 1.6 7 5.586 7 10.25 0 6.075-4.925 11-11 11S1 18.075 1 12z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPrinterSolid = {
  name: 'IconPrinterSolid',
  content: '<path fill="currentColor" d="M5.5 5.5A3.5 3.5 0 0 1 9 2h6a3.5 3.5 0 0 1 3.5 3.5v1h-13v-1zm-4 4.9a2.9 2.9 0 0 1 2.9-2.9h15.2a2.9 2.9 0 0 1 2.9 2.9V16a2 2 0 0 1-2 2 .5.5 0 0 1-.5-.5V17a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v.5a.5.5 0 0 1-.5.5 2 2 0 0 1-2-2v-5.6z"/><path fill="currentColor" fill-rule="evenodd" d="M5.5 18a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-2zm7 1.5h-5v1h5v-1zm4-2h-9v1h9v-1z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPuzzlePiece = {
  name: 'IconPuzzlePiece',
  content: '<path fill="currentColor" d="M17.3 15.2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/><path fill="currentColor" fill-rule="evenodd" d="M9.36 1a4.584 4.584 0 0 0-4.473 3.582H3.09A2.79 2.79 0 0 0 .3 7.372v3.403a2.97 2.97 0 0 0 2.97 2.97h1.612a.79.79 0 0 1 0 1.582H3.27a2.97 2.97 0 0 0-2.97 2.97v1.612A2.79 2.79 0 0 0 3.091 22.7h12.536a2.79 2.79 0 0 0 2.791-2.79v-1.797a4.583 4.583 0 0 0 0-8.944V7.373a2.79 2.79 0 0 0-2.79-2.791h-1.796A4.584 4.584 0 0 0 9.358 1zM6.776 5.582a2.582 2.582 0 1 1 5.164 0v1h3.686a.79.79 0 0 1 .791.79V9.86c0 .677.54 1.17 1.145 1.204a2.582 2.582 0 0 1 0 5.156 1.209 1.209 0 0 0-1.145 1.204v2.486a.79.79 0 0 1-.79.791H3.09a.79.79 0 0 1-.791-.79v-1.613a.97.97 0 0 1 .97-.97h1.612a2.791 2.791 0 0 0 0-5.582H3.27a.97.97 0 0 1-.97-.97V7.373a.79.79 0 0 1 .791-.791h3.686v-1z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataPuzzlePieceSolid = {
  name: 'IconPuzzlePieceSolid',
  content: '<g clip-path="url(#dls-e407c-a)"><path fill="currentColor" fill-rule="evenodd" d="M9 1a4 4 0 0 1 4 4h3a2 2 0 0 1 2 2v3a4 4 0 0 1 0 8v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 1 0 0-4H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3a4 4 0 0 1 4-4zm8.6 14.7a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6z" clip-rule="evenodd"/></g><defs><clipPath id="dls-e407c-a"><path fill="currentColor" d="M0 0h22v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataPvShield = {
  name: 'IconPvShield',
  content: '<path fill="currentColor" d="M17 7.85H7v-1.7h10v1.7z"/><path fill="currentColor" fill-rule="evenodd" d="M9.389 9.75H6.75v6.5h1.444v-2.303h1.178c.734 0 1.33-.161 1.745-.527.421-.372.611-.915.611-1.58 0-.661-.19-1.2-.609-1.568-.413-.362-1.005-.522-1.73-.522zm-1.195 2.857V11.09h1.122c.391 0 .626.074.753.179l.005.004c.112.088.202.253.202.567 0 .319-.084.492-.197.587-.131.101-.372.18-.763.18H8.194z" clip-rule="evenodd"/><path fill="currentColor" d="M12.97 9.75h-1.556l2.22 6.5h1.495l2.22-6.5h-1.556l-1.411 4.366L12.97 9.75z"/><path fill="currentColor" fill-rule="evenodd" d="M12.235 1.092a2 2 0 0 0-.996.007l-7.75 2.05A2 2 0 0 0 2 5.083v10.016c0 .831.344 1.635.978 2.201.856.764 2.451 2.15 4.073 3.349.81.598 1.646 1.166 2.413 1.589.72.396 1.545.762 2.279.762.725 0 1.567-.36 2.313-.752.797-.419 1.676-.983 2.534-1.579 1.717-1.194 3.427-2.575 4.349-3.34A2.949 2.949 0 0 0 22 15.054v-9.96a2 2 0 0 0-1.515-1.94l-8.25-2.062zm-.485 1.94L20 5.095v9.96c0 .293-.126.56-.338.735-.907.752-2.566 2.092-4.214 3.238-.826.575-1.63 1.087-2.322 1.451-.744.39-1.197.522-1.383.522-.178 0-.609-.126-1.314-.514-.657-.362-1.413-.872-2.189-1.445-1.548-1.146-3.09-2.483-3.93-3.233A.944.944 0 0 1 4 15.1V5.083l7.75-2.05z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataPvShieldSolid = {
  name: 'IconPvShieldSolid',
  content: '<path fill="currentColor" d="M6.194 11.09v1.517h1.122c.391 0 .632-.079.763-.18.113-.095.197-.268.197-.587 0-.314-.09-.48-.202-.567l-.005-.004c-.127-.105-.362-.179-.753-.179H6.194z"/><path fill="currentColor" fill-rule="evenodd" d="M2.478 2.022c-1.077 0-1.956.87-1.956 1.953v10.646c0 2.99 2.038 4.983 4.015 6.21 1.996 1.24 4.164 1.854 4.94 2.05.407.102.816.057 1.17-.085 4.258-1.711 6.487-3.797 7.643-5.552.575-.873.873-1.648 1.027-2.224.076-.287.117-.524.138-.698a3.356 3.356 0 0 0 .022-.28v-.025l.001-.01v-.005s0-.002-.978-.002h.978V3.978c0-1.08-.876-1.956-1.956-1.956H2.479zM5 7.85h10v-1.7H5v1.7zm-.25 1.9h2.638c.726 0 1.318.16 1.731.522.419.368.61.907.61 1.568 0 .665-.191 1.208-.612 1.58-.414.366-1.011.527-1.745.527H6.194v2.303H4.75v-6.5zm6.22 0H9.413l2.22 6.5h1.496l2.22-6.5h-1.556l-1.411 4.366L10.97 9.75z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataQrcode = {
  name: 'IconQrcode',
  content: '<path fill="currentColor" d="M5.7 6.3a.5.5 0 0 1 .5-.5h.825a.5.5 0 0 1 .5.5v.825a.5.5 0 0 1-.5.5H6.2a.5.5 0 0 1-.5-.5V6.3z"/><path fill="currentColor" fill-rule="evenodd" d="M2.1 4.6a2.4 2.4 0 0 1 2.4-2.4h4.3a2.4 2.4 0 0 1 2.4 2.4V9a2.4 2.4 0 0 1-2.4 2.4H4.5A2.4 2.4 0 0 1 2.1 9V4.6zM4.5 4a.6.6 0 0 0-.6.6V9a.6.6 0 0 0 .6.6h4.3a.6.6 0 0 0 .6-.6V4.6a.6.6 0 0 0-.6-.6H4.5z" clip-rule="evenodd"/><path fill="currentColor" d="M5.7 16.76a.5.5 0 0 1 .5-.5h.825a.5.5 0 0 1 .5.5v.824a.5.5 0 0 1-.5.5H6.2a.5.5 0 0 1-.5-.5v-.825z"/><path fill="currentColor" fill-rule="evenodd" d="M4.5 12.622a2.4 2.4 0 0 0-2.4 2.4v4.3a2.4 2.4 0 0 0 2.4 2.4h4.4a2.4 2.4 0 0 0 2.4-2.4v-4.3a2.4 2.4 0 0 0-2.4-2.4H4.5zm-.6 2.4a.6.6 0 0 1 .6-.6h4.4a.6.6 0 0 1 .6.6v4.3a.6.6 0 0 1-.6.6H4.5a.6.6 0 0 1-.6-.6v-4.3z" clip-rule="evenodd"/><path fill="currentColor" d="M16.2 6.3a.5.5 0 0 1 .5-.5h.83a.5.5 0 0 1 .5.5v.83a.5.5 0 0 1-.5.5h-.83a.5.5 0 0 1-.5-.5V6.3z"/><path fill="currentColor" fill-rule="evenodd" d="M15 2.2a2.4 2.4 0 0 0-2.4 2.4V9a2.4 2.4 0 0 0 2.4 2.4h4.4A2.4 2.4 0 0 0 21.8 9V4.6a2.4 2.4 0 0 0-2.4-2.4H15zm-.6 2.4A.6.6 0 0 1 15 4h4.4a.6.6 0 0 1 .6.6V9a.6.6 0 0 1-.6.6H15a.6.6 0 0 1-.6-.6V4.6z" clip-rule="evenodd"/><path fill="currentColor" d="M14.4 14.522a.1.1 0 0 1 .1-.1h1.65a.1.1 0 0 1 .1.1v2.044c0 1.05.85 1.9 1.9 1.9h1.65a1.9 1.9 0 0 0 1.9-1.9v-3.944h-1.8v3.944a.1.1 0 0 1-.1.1h-1.65a.1.1 0 0 1-.1-.1v-2.044a1.9 1.9 0 0 0-1.9-1.9H14.5a1.9 1.9 0 0 0-1.9 1.9v7.2h1.8v-7.2z"/><path fill="currentColor" d="M16.115 20.4a.5.5 0 0 1 .5-.5h.795a.5.5 0 0 1 .5.5v.795a.5.5 0 0 1-.5.5h-.795a.5.5 0 0 1-.5-.5V20.4zm4.09-.5a.5.5 0 0 0-.5.5v.795a.5.5 0 0 0 .5.5H21a.5.5 0 0 0 .5-.5V20.4a.5.5 0 0 0-.5-.5h-.795z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataQualityCircle = {
  name: 'IconQualityCircle',
  content: '<g fill="currentColor"><path d="M8.736 9.832h3.588c-.06.288-.12.576-.192.876H9.66v4.2h1.092v-3.144h4.476v3.132h1.092v-4.188h-3.036c.072-.288.132-.576.204-.876h3.852V8.776h-3.672c.036-.264.072-.528.096-.804l-1.14-.144c-.036.312-.072.624-.12.948H8.736v-.888c2.976-.048 5.676-.288 8.076-.696l-.564-1.02c-2.52.468-5.388.72-8.604.756v3.816c-.072 2.376-.492 4.248-1.26 5.592l.792.84c.984-1.608 1.5-3.744 1.56-6.432v-.912zm5.028 4.704-.576.852a16.93 16.93 0 0 1 3.54 1.848l.624-.984a18.378 18.378 0 0 0-3.588-1.716zm-1.08-2.388c-.132 1.14-.528 2.016-1.188 2.64-.66.612-1.692 1.08-3.084 1.416l.612 1.056c1.548-.432 2.7-1.032 3.444-1.788.744-.744 1.176-1.836 1.32-3.252l-1.104-.072z"/><path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 2a9 9 0 1 1 0 18 9 9 0 0 1 0-18z"/></g>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataQualityCircleSolid = {
  name: 'IconQualityCircleSolid',
  content: '<path fill="currentColor" d="M11.462 7.75c-1.208.092-2.468.15-3.783.174v.548h3.695l.088-.721z"/><path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm15.655-6.354.817 1.49-.208.035a49.923 49.923 0 0 1-3.563.472l.439.055-.015.146c-.02.206-.049.42-.08.628h3.916v1.548h-4.178l-.125.545h3.237v4.876h-1.097a19.3 19.3 0 0 1 2.104 1.113l.13.08-.919 1.442-.128-.087a17.36 17.36 0 0 0-3.776-1.972l-.178-.066.845-1.269.11.038c.445.154.877.32 1.296.495v-3.102H9.863v3.264c.165-.112.316-.23.45-.353.67-.62 1.087-1.519 1.227-2.702l.017-.141 1.61.111-.016.154c-.158 1.555-.634 2.775-1.473 3.614-.844.844-2.12 1.504-3.823 1.976l-.111.03-.888-1.521.196-.048c1.147-.277 2.046-.627 2.714-1.056H8.25v-4.876h2.722l.126-.545h-3.42v.79c-.065 2.94-.627 5.296-1.712 7.068l-.102.166-1.16-1.209.055-.097C5.56 15.325 6 13.352 6.066 10.804V6.498l.148-.002c3.504-.039 6.615-.311 9.334-.83l.107-.02z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataQuestionCircle = {
  name: 'IconQuestionCircle',
  content: '<path fill="currentColor" d="M12.054 18.34a1.242 1.242 0 1 0 0-2.484 1.242 1.242 0 0 0 0 2.484zM8.3 9.7a3.7 3.7 0 1 1 5.813 3.038c-.029.021-.064.05-.106.084-.12.1-.28.247-.438.431-.33.385-.569.835-.569 1.307h-2c0-1.148.57-2.048 1.05-2.608a5.739 5.739 0 0 1 .819-.78l-.004-.008a1.82 1.82 0 0 0 .08-.05l.011-.009.072-.052.009-.006A1.69 1.69 0 0 0 13.7 9.7a1.7 1.7 0 1 0-3.4 0h-2z"/><path fill="currentColor" fill-rule="evenodd" d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zm-2 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataQuestionCircleSolid = {
  name: 'IconQuestionCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0-17a3.7 3.7 0 0 0-3.7 3.7h2a1.7 1.7 0 1 1 2.737 1.347l-.009.006-.072.052-.01.008a1.82 1.82 0 0 1-.081.051l.004.007a5.739 5.739 0 0 0-.818.78C11.57 12.513 11 13.413 11 14.56h2c0-.472.24-.922.57-1.307a3.722 3.722 0 0 1 .543-.515A3.69 3.69 0 0 0 15.7 9.7 3.7 3.7 0 0 0 12 6zm.054 12.34a1.242 1.242 0 1 0 0-2.484 1.242 1.242 0 0 0 0 2.484z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataQuestionComment = {
  name: 'IconQuestionComment',
  content: '<path fill="currentColor" d="M11.852 16.727a1.196 1.196 0 1 0 0-2.392 1.196 1.196 0 0 0 0 2.392zM8.2 8.6a3.6 3.6 0 1 1 5.654 2.957c-.026.02-.06.046-.098.078a3.556 3.556 0 0 0-.417.41c-.314.368-.54.793-.54 1.235h-2c0-1.118.556-1.993 1.021-2.536a5.555 5.555 0 0 1 .797-.76l-.003-.006.073-.046.012-.009.07-.05.01-.007A1.59 1.59 0 0 0 13.4 8.6a1.6 1.6 0 0 0-3.201 0h-2z"/><path fill="currentColor" fill-rule="evenodd" d="M6.2 1.4a5 5 0 0 0-5 5v8.453a5 5 0 0 0 5 5h2.19l2.34 2.457a1.5 1.5 0 0 0 2.171 0l2.348-2.466 2.65-.052a5 5 0 0 0 4.901-4.999V6.4a5 5 0 0 0-5-5H6.2zm-3 5a3 3 0 0 1 3-3h11.6a3 3 0 0 1 3 3v8.393a3 3 0 0 1-2.94 3l-3.067.06a1 1 0 0 0-.704.31l-2.274 2.387-2.273-2.387a1 1 0 0 0-.724-.31H6.2a3 3 0 0 1-3-3V6.4z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataQuestionCommentSolid = {
  name: 'IconQuestionCommentSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.2 6.4a5 5 0 0 1 5-5h11.6a5 5 0 0 1 5 5v8.393a5 5 0 0 1-4.901 5l-2.65.051-2.347 2.466a1.5 1.5 0 0 1-2.173 0l-2.34-2.457H5.2a5 5 0 0 1-5-5V6.4zM10.8 5a3.6 3.6 0 0 0-3.6 3.6h2a1.6 1.6 0 1 1 2.578 1.266l-.01.007c-.017.012-.04.03-.07.05l-.011.009a1.58 1.58 0 0 1-.073.046l.003.007a5.555 5.555 0 0 0-.797.76c-.465.542-1.02 1.417-1.02 2.535h2c0-.442.225-.867.54-1.234a3.556 3.556 0 0 1 .514-.49A3.59 3.59 0 0 0 14.4 8.6a3.6 3.6 0 0 0-3.6-3.599zm1.248 10.531a1.196 1.196 0 1 1-2.392 0 1.196 1.196 0 0 1 2.392 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataRecommendSquare = {
  name: 'IconRecommendSquare',
  content: '<path fill="currentColor" d="M13.604 6.783h-2.913V6H9.214v.783H6.395v1.34h2.819v.797h1.298c-.09.202-.18.405-.28.617H6.617v1.34h2.809c-.82 1.111-1.914 2.112-3.28 3.002l-.045.029.906 1.204.039-.027c.465-.32.92-.663 1.35-1.019V18.2h1.412v-5.5c.51-.566.945-1.182 1.33-1.822h6.698v-1.34h-6.042c.069-.177.138-.362.207-.546l.02-.056-1.33-.252v-.56h2.915v.809h1.476v-.81h2.82v-1.34h-2.82V6h-1.476v.783z"/><path fill="currentColor" d="m17.049 12.512.02-.015v-1.041h-5.803v1.327h3.61c-.47.284-.835.514-1.094.692l-.022.015v.524h-3.39v1.38h3.39v1.137c0 .109-.03.186-.08.236-.049.05-.125.08-.233.08-.361 0-.84-.04-1.451-.092l-.073-.006.421 1.425h1.635c.404 0 .718-.103.93-.318.213-.215.315-.534.315-.946v-1.516h2.663v-1.38h-2.663v-.133c.693-.516 1.297-.968 1.825-1.369z"/><path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataRecommendSquareSolid = {
  name: 'IconRecommendSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm7.564-.65H9.84v.783h2.613V5.85h1.777v.783h2.819v1.64H14.23v.81h-1.777v-.81H9.841v.287l1.382.261-.083.223-.129.343h5.974v1.64H10.22a11.785 11.785 0 0 1-1.264 1.73v5.593H7.245v-3.969c-.36.287-.734.565-1.115.827l-.158.109-1.088-1.447.18-.117c1.253-.817 2.272-1.726 3.058-2.725H5.466v-1.64h3.67l.145-.318H8.064v-.796H5.245v-1.64h2.819V5.85zm2.052 5.456h6.103v1.265l-.08.06c-.48.366-1.025.774-1.641 1.233h2.539v1.68h-2.663v1.366c0 .435-.108.798-.358 1.05-.25.254-.609.364-1.037.364h-1.747l-.515-1.743.292.025c.613.052 1.084.09 1.437.09.08 0 .114-.021.128-.035.014-.014.036-.048.036-.13v-.987H9.22v-1.68h3.39v-.453l.087-.06a18 18 0 0 1 .646-.418h-3.227v-1.627z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataRecommendation = {
  name: 'IconRecommendation',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 8.6a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8zM10.4 12a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 .3a3.6 3.6 0 0 1 3.348 2.275 10.002 10.002 0 0 1 6.338 11.92 3.6 3.6 0 0 1-4.075 5.783A9.958 9.958 0 0 1 12 22a9.958 9.958 0 0 1-5.343-1.545 3.6 3.6 0 0 1-4.294-5.775A10.01 10.01 0 0 1 2 12c0-4.35 2.777-8.049 6.652-9.425A3.601 3.601 0 0 1 12 .3zm0 2a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM4 12a8.001 8.001 0 0 1 4.513-7.202 3.601 3.601 0 0 0 6.974 0 8.001 8.001 0 0 1 4.376 8.683 3.6 3.6 0 0 0-3.82 5.423A7.96 7.96 0 0 1 12.001 20a7.958 7.958 0 0 1-4.076-1.115 3.6 3.6 0 0 0-3.692-4.967A8.02 8.02 0 0 1 4 12zm15.1 3.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM3 17.5a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataRedo = {
  name: 'IconRedo',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12.19 2.802c0-1.637 2.008-2.424 3.12-1.224l7.61 8.21a1.8 1.8 0 0 1 0 2.447l-7.61 8.21c-1.112 1.2-3.12.413-3.12-1.224v-2.94c-4.23.888-6.938 3.537-8.381 5.416-.524.682-1.349.6-1.767.44-.411-.157-1.137-.674-.984-1.59.7-4.18 1.782-7.55 3.682-9.973 1.78-2.267 4.207-3.617 7.45-4.104V2.802zm2 .51v4.95l-.902.087c-3.256.318-5.427 1.488-6.974 3.46-1.354 1.725-2.29 4.137-2.959 7.337 1.956-2.088 5.123-4.46 9.71-5.039l1.126-.141v4.746l7.136-7.7-7.136-7.7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataRedoSolid = {
  name: 'IconRedoSolid',
  content: '<path fill="currentColor" d="M12.19 2.802c0-1.637 2.008-2.424 3.12-1.224l7.61 8.21a1.8 1.8 0 0 1 0 2.447l-7.61 8.21c-1.112 1.2-3.12.413-3.12-1.223V16.28c-4.237.89-6.94 3.54-8.381 5.416-.524.682-1.349.6-1.767.44-.411-.157-1.137-.674-.984-1.59.763-4.555 1.98-8.156 4.223-10.612 1.734-1.897 4-3.028 6.91-3.465V2.802z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataReport = {
  name: 'IconReport',
  content: '<path fill="currentColor" d="M18 17H6v-2h12v2z"/><path fill="currentColor" fill-rule="evenodd" d="M8 7a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H8zm0 2h8v2H8V9z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M1.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm5-3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3h-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataReportBookmark = {
  name: 'IconReportBookmark',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h4v-2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v5h2V6a5 5 0 0 0-5-5H5z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="2" d="M5 13h5M5 8h10"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M12.79 14.553a.4.4 0 0 0-.396.379l-.362 6.955a.4.4 0 0 0 .542.394l3.208-1.223a.4.4 0 0 1 .3.006l2.765 1.183a.4.4 0 0 0 .557-.388l-.36-6.976a.4.4 0 0 0-.403-.38l-5.851.05z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataReportBookmarkSolid = {
  name: 'IconReportBookmarkSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1 6a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v6.185a1.994 1.994 0 0 0-.84-.185h-6.32a2 2 0 0 0-1.993 1.834l-.666 8c-.036.424.063.826.26 1.166H6a5 5 0 0 1-5-5V6zm15 3H6V7h10v2zm-5 5H6v-2h5v2z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M21.03 14.837a1.3 1.3 0 0 0-1.31-1.234l-5.462.047a1.3 1.3 0 0 0-1.287 1.233l-.338 6.556a1.3 1.3 0 0 0 1.765 1.28l2.784-1.072 2.37 1.024a1.3 1.3 0 0 0 1.814-1.26l-.337-6.574z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataReportCheck = {
  name: 'IconReportCheck',
  content: '<path fill="currentColor" d="M6 10h12V8H6v2zm12 6h-4v-2h4v2zM7.847 17.546l3.983-3.903-1.26-1.286-2.674 2.621-1.242-1.312-1.308 1.237 2.501 2.643z"/><path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataReportCheckSolid = {
  name: 'IconReportCheckSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zM17 10H5V8h12v2zm0 6h-4v-2h4v2zm-6.17-2.357-3.983 3.903-2.5-2.643 1.307-1.237 1.242 1.312 2.674-2.62 1.26 1.285z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataReportSearch = {
  name: 'IconReportSearch',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h4v-2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v5h2V6a5 5 0 0 0-5-5H5z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="2" d="M5 13h5M5 8h10"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M18.738 17.37a3.37 3.37 0 1 1-6.738 0 3.37 3.37 0 0 1 6.738 0z" clip-rule="evenodd"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.8" d="m17.706 20.02 2.53 2.529"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataReportSearchSolid = {
  name: 'IconReportSearchSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 6a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v7.666A6.667 6.667 0 0 0 10.666 23H5a5 5 0 0 1-5-5V6zm5 2h10V6H5v2zm0 5h5v-2H5v2z" clip-rule="evenodd"/><path fill="currentColor" d="M16.772 20.082a1.313 1.313 0 0 1-.333.168 1.283 1.283 0 1 1 .333-.169z"/><path fill="currentColor" fill-rule="evenodd" d="M13.771 14.523a5 5 0 1 1 4.458 8.954 5 5 0 0 1-4.458-8.954zm3.503 7.001 1.165 1.165 1.06-1.061-.555-.555-.556-.556a2.785 2.785 0 0 0 .428-1.484 2.783 2.783 0 1 0-1.542 2.491z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataReportSettings = {
  name: 'IconReportSettings',
  content: '<path stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" stroke-width="2" d="M10.5 22H5a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v4.5"/><path stroke="currentColor" stroke-width="2" d="M5.5 14.2h5m-5-5h9m4.894 5.648 1.366 2.344c.303.52.303 1.154.008 1.665l-1.347 2.334a1.66 1.66 0 0 1-1.447.825l-2.713-.01a1.707 1.707 0 0 1-1.466-.847l-1.365-2.344a1.659 1.659 0 0 1-.008-1.665l1.347-2.334c.295-.51.844-.828 1.446-.825l2.713.01a1.707 1.707 0 0 1 1.466.847z"/><circle cx="16.6" cy="18" r="1.4" fill="currentColor"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataReportSettingsSolid = {
  name: 'IconReportSettingsSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 6a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v6.679a3.064 3.064 0 0 0-1.497-.398l-3.076-.011a3.014 3.014 0 0 0-2.626 1.502l-1.528 2.646a3.014 3.014 0 0 0 .012 3.026l1.548 2.658c.206.354.478.657.795.898H5a5 5 0 0 1-5-5V6zm14 0H5v2h9V6zm-4 5H5v2h5v-2z" clip-rule="evenodd"/><path fill="currentColor" d="M18.04 17.994a1.215 1.215 0 1 1-2.43 0 1.215 1.215 0 0 1 2.43 0z"/><path fill="currentColor" fill-rule="evenodd" d="m21.102 16.85-1.152-1.978a2.284 2.284 0 0 0-1.963-1.133l-2.289-.01a2.243 2.243 0 0 0-1.954 1.12l-1.137 1.968a2.243 2.243 0 0 0 .009 2.252l1.152 1.977a2.284 2.284 0 0 0 1.963 1.134l2.289.009a2.243 2.243 0 0 0 1.954-1.119l1.137-1.969a2.243 2.243 0 0 0-.01-2.252zm-1.5.873-1.152-1.977a.548.548 0 0 0-.47-.272l-2.288-.008a.507.507 0 0 0-.445.25l-1.136 1.969a.507.507 0 0 0 .005.51l1.152 1.978c.097.166.277.27.47.27l2.288.01c.19 0 .357-.1.444-.25l1.137-1.97a.507.507 0 0 0-.005-.51z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataReportSolid = {
  name: 'IconReportSolid',
  content: '<path fill="currentColor" d="M15 9H7v2h8V9z"/><path fill="currentColor" fill-rule="evenodd" d="M.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zM5 9a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V9zm12 8H5v-2h12v2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataReportStamp = {
  name: 'IconReportStamp',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h4v-2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v5h2V6a5 5 0 0 0-5-5H5z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="2" d="M5 13h5M5 8h10"/><path stroke="currentColor" stroke-width="1.8" d="M13.508 16.401a2.309 2.309 0 0 1 2.317-2.301 2.309 2.309 0 0 1 2.317 2.301 2.309 2.309 0 0 1-2.317 2.301 2.309 2.309 0 0 1-2.316-2.3zM12 22h7.8m-3.9-3.8v3"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataReportStampSolid = {
  name: 'IconReportStampSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h5.666A6.667 6.667 0 0 1 20 13.666V6a5 5 0 0 0-5-5H5zm0 7h10V6H5v2zm0 5h5v-2H5v2z" clip-rule="evenodd"/><path fill="currentColor" d="M16 18.6a.797.797 0 0 0 .255-.042l.006-.002a.799.799 0 1 0-.726-1.407.799.799 0 0 0 .204 1.407l.006.002c.08.027.166.042.255.042z"/><path fill="currentColor" fill-rule="evenodd" d="M14.003 14.415a5 5 0 1 1 3.994 9.17 5 5 0 0 1-3.994-9.17zm-.617 6.335v1.5H18.5v-1.5h-1.75v-.775a2.282 2.282 0 0 0 .458-.217 2.3 2.3 0 0 0 .7-.675A2.296 2.296 0 0 0 16 15.5a2.293 2.293 0 0 0-1.088.274 2.3 2.3 0 0 0 .339 4.201v.775h-1.864z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataReportStar = {
  name: 'IconReportStar',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h4v-2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v5h2V6a5 5 0 0 0-5-5H5z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="2" d="M5 13h5M5 8h10"/><path stroke="currentColor" stroke-width="1.8" d="M15.5 20.963 13.26 22.2a.3.3 0 0 1-.442-.31l.432-2.647-1.842-1.888a.3.3 0 0 1 .17-.507l2.531-.386 1.12-2.384a.3.3 0 0 1 .543 0l1.119 2.384 2.532.386a.3.3 0 0 1 .17.507l-1.843 1.888.432 2.646a.3.3 0 0 1-.441.311L15.5 20.963z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataReportStarSolid = {
  name: 'IconReportStarSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 6a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v7.856A6.5 6.5 0 0 0 10.856 23H5a5 5 0 0 1-5-5V6zm15 2H5V6h10v2zm-5 5H5v-2h5v2z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M11 19a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm5 1.975-1.494.826a.2.2 0 0 1-.294-.207l.288-1.765-1.228-1.259a.2.2 0 0 1 .113-.337l1.688-.258.746-1.59a.2.2 0 0 1 .362 0l.746 1.59 1.688.258a.2.2 0 0 1 .113.337L17.5 19.83l.288 1.764a.2.2 0 0 1-.294.207L16 20.975z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataReportTrendSettings = {
  name: 'IconReportTrendSettings',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h4v-2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v5h2V6a5 5 0 0 0-5-5H5z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="2" d="m18.337 15.107 1.327 2.278c.29.497.29 1.103.008 1.59l-1.31 2.27c-.281.487-.806.79-1.381.788l-2.637-.01a1.631 1.631 0 0 1-1.401-.81l-1.328-2.278a1.584 1.584 0 0 1-.008-1.59l1.31-2.27c.282-.487.806-.79 1.382-.788l2.637.01a1.63 1.63 0 0 1 1.4.81z"/><circle cx="15.6" cy="18.2" r="1.4" fill="currentColor"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M4 9.858h2.667L8.698 13l2.667-7 1.968 3.858H16"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataReportTrendSettingsSolid = {
  name: 'IconReportTrendSettingsSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4 2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h6.774l-1.489-2.556a3.014 3.014 0 0 1-.012-3.026l1.528-2.646a3.014 3.014 0 0 1 2.626-1.502l3.076.011A3.064 3.064 0 0 1 18 12.68V6a4 4 0 0 0-4-4H4zm7.256 3.546a1 1 0 0 0-1.825.098L7.467 10.8l-.96-1.485a1 1 0 0 0-.84-.457H3v2h2.122l1.737 2.685a1 1 0 0 0 1.774-.187l1.865-4.895.945 1.851a1 1 0 0 0 .89.546H15v-2h-2.054l-1.69-3.312z" clip-rule="evenodd"/><path fill="currentColor" d="M16.04 17.994a1.215 1.215 0 1 1-2.43 0 1.215 1.215 0 0 1 2.43 0z"/><path fill="currentColor" fill-rule="evenodd" d="m19.102 16.85-1.152-1.978a2.284 2.284 0 0 0-1.963-1.133l-2.289-.01a2.243 2.243 0 0 0-1.954 1.12l-1.137 1.968a2.243 2.243 0 0 0 .009 2.252l1.152 1.977a2.284 2.284 0 0 0 1.963 1.134l2.289.009a2.243 2.243 0 0 0 1.954-1.119l1.137-1.969a2.243 2.243 0 0 0-.01-2.252zm-1.5.873-1.152-1.977a.548.548 0 0 0-.47-.272l-2.288-.008a.507.507 0 0 0-.445.25l-1.136 1.969a.507.507 0 0 0 .005.51l1.152 1.978c.097.166.277.27.47.27l2.288.01c.19 0 .357-.1.444-.25l1.137-1.97a.507.507 0 0 0-.005-.51z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataReportUser = {
  name: 'IconReportUser',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h4v-2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v5h2V6a5 5 0 0 0-5-5H5z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="2" d="M5 13h5M5 8h10"/><path stroke="currentColor" stroke-width="1.8" d="M19.826 23A3.913 3.913 0 1 0 12 23"/><path stroke="currentColor" stroke-width="1.8" d="M18.456 16.543a2.543 2.543 0 1 1-5.086 0 2.543 2.543 0 0 1 5.086 0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataReportUserSolid = {
  name: 'IconReportUserSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 6a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v7.666A6.667 6.667 0 0 0 10.666 23H5a5 5 0 0 1-5-5V6zm15 2H5V6h10v2zm-5 5H5v-2h5v2z" clip-rule="evenodd"/><path fill="currentColor" d="M15.16 17.946a.934.934 0 1 1 .988.933h-.108a.934.934 0 0 1-.88-.933z"/><path fill="currentColor" fill-rule="evenodd" d="M11 19a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm3.663.282a1.958 1.958 0 1 1 2.862 0 2.735 2.735 0 0 1 1.306 2.333h-1.024a1.713 1.713 0 1 0-3.426 0h-1.023c0-.987.522-1.852 1.305-2.333z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataRoad = {
  name: 'IconRoad',
  content: '<path fill="currentColor" d="M6.026 1.718H2.032v2h3.994a3 3 0 0 1 3 3.005L9 21.998l2 .004.025-15.276a5 5 0 0 0-5-5.008zm11.981 20.364H22v-2h-3.993a3 3 0 0 1-3-3.005l.025-15.275-2-.004-.025 15.276a5 5 0 0 0 5 5.008z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataRocketSolid = {
  name: 'IconRocketSolid',
  content: '<path fill="currentColor" d="M6.104 15.966c1.259 1.279 1.404 2.654.01 4.072-.865.878-2.265 1.406-4.191 1.632-.1.012-.2.011-.3 0a1.311 1.311 0 0 1-1.14-1.372l.007-.09.028-.228c.236-1.836.747-3.18 1.578-4.024 1.395-1.418 2.749-1.27 4.008.01zm11.533-13.44.217.066.213.07a1.83 1.83 0 0 1 1.128 1.14c.848 2.48.578 4.992-.79 7.482a13.866 13.866 0 0 1-2.163 2.914l-.243.248-.23.226-.007.07c-.16 1.491-1.291 3.464-3.376 6.015l-.181.22-.333.398a.768.768 0 0 1-1.3-.206l-.025-.07-1.166-3.72-.106-.074a18.515 18.515 0 0 1-1.867-1.523l-.29-.276-.284-.282a18.696 18.696 0 0 1-2.253-2.782l-.065-.1L.72 11.114a.793.793 0 0 1-.367-1.248l.045-.051.049-.046c3.122-2.727 5.426-4.08 7.076-3.967l.106.009.061.007.14-.14a13.96 13.96 0 0 1 2.352-1.898l.274-.17.252-.147c2.287-1.297 4.608-1.616 6.929-.937zm-6.998 5.238c-.95.95-.947 2.493.007 3.447a2.438 2.438 0 0 0 3.448.007c.95-.95.946-2.493-.008-3.447a2.438 2.438 0 0 0-3.447-.007z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataRotateAnticlockwise = {
  name: 'IconRotateAnticlockwise',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m10.957 2.938.816-.815L10.5.85 8.38 2.972a1.4 1.4 0 0 0 0 1.98l2.121 2.12L11.773 5.8l-1.041-1.041c.43-.035.966-.06 1.561-.052 1.55.024 3.406.283 4.895 1.139a9.51 9.51 0 0 1 3.146 2.916c.306.452.513.846.643 1.122a5.53 5.53 0 0 1 .165.389l.005.014v-.002L22 10c.854-.285.854-.286.853-.286v-.002l-.002-.004-.004-.012-.013-.037a7.37 7.37 0 0 0-.228-.54 10.201 10.201 0 0 0-.78-1.365 11.31 11.31 0 0 0-3.74-3.468c-1.876-1.079-4.089-1.353-5.765-1.378-.5-.008-.961.006-1.364.03zM6 8a5 5 0 0 0-5 5v5a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5v-5a5 5 0 0 0-5-5H6zm-3 5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataRotateAnticlockwiseSolid = {
  name: 'IconRotateAnticlockwiseSolid',
  content: '<path fill="currentColor" d="M9.5 7.073 7.38 4.95a1.4 1.4 0 0 1 0-1.98L9.5.852l1.273 1.272-.71.71c.378-.021.803-.032 1.26-.025 1.683.025 3.916.3 5.812 1.391a11.409 11.409 0 0 1 3.773 3.5c.368.544.623 1.025.788 1.377a7.412 7.412 0 0 1 .24.57l.006.017.004.013.002.004v.002s0 .002-.948.318l-.948.317v.002l-.004-.012a5.41 5.41 0 0 0-.162-.38 8.306 8.306 0 0 0-.635-1.109 9.41 9.41 0 0 0-3.113-2.885c-1.467-.844-3.303-1.102-4.846-1.125a16.366 16.366 0 0 0-1.467.044l.948.948L9.5 7.073z"/><path fill="currentColor" d="M0 13a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v5a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5v-5z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataRotateClockwise = {
  name: 'IconRotateClockwise',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m13.5 7.073 2.121-2.122a1.4 1.4 0 0 0 0-1.98l-2.12-2.12-1.274 1.272.71.71a17.846 17.846 0 0 0-1.259-.025c-1.683.025-3.916.3-5.812 1.39a11.41 11.41 0 0 0-3.774 3.5 10.3 10.3 0 0 0-.788 1.378 7.411 7.411 0 0 0-.245.587l-.005.012-.001.005v.002S1.051 9.684 2 10c.95.316.949.317.949.317l-.001.003.004-.013a5.425 5.425 0 0 1 .162-.38c.128-.272.333-.662.635-1.109a9.41 9.41 0 0 1 3.114-2.885c1.467-.844 3.302-1.102 4.846-1.126.553-.008 1.054.014 1.467.045l-.949.948L13.5 7.073zM18 8a5 5 0 0 1 5 5v5a5 5 0 0 1-5 5h-8a5 5 0 0 1-5-5v-5a5 5 0 0 1 5-5h8zm3 5a3 3 0 0 0-3-3h-8a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataRotateClockwiseSolid = {
  name: 'IconRotateClockwiseSolid',
  content: '<path fill="currentColor" d="m12.5 7.073 2.121-2.121a1.4 1.4 0 0 0 0-1.98L12.5.85l-1.273 1.273.71.71a17.875 17.875 0 0 0-1.26-.025c-1.683.025-3.916.3-5.812 1.391a11.41 11.41 0 0 0-3.773 3.5 10.3 10.3 0 0 0-.788 1.377 7.417 7.417 0 0 0-.232.549l-.007.02-.007.018-.004.013-.002.004v.002s0 .002.948.318c.949.316.948.317.948.317v.002l.004-.012a5.423 5.423 0 0 1 .162-.38c.127-.272.333-.662.635-1.109a9.41 9.41 0 0 1 3.113-2.885c1.467-.844 3.303-1.102 4.846-1.125.553-.009 1.054.013 1.467.044l-.948.948L12.5 7.073z"/><path fill="currentColor" d="M22 13a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5v-5z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataSave = {
  name: 'IconSave',
  content: '<path fill="currentColor" d="M6.5 17h11v-2h-11v2zm9.3-9.6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z"/><path fill="currentColor" fill-rule="evenodd" d="M8.857 1.5c-1.084 0-1.958 0-2.666.058-.728.06-1.369.185-1.96.487A5 5 0 0 0 2.044 4.23c-.302.592-.428 1.233-.487 1.961C1.5 6.9 1.5 7.773 1.5 8.857v6.286c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.233.428 1.961.487.708.058 1.582.058 2.666.058h6.286c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961.058-.708.058-1.582.058-2.666V8.857c0-1.084 0-1.958-.058-2.666-.06-.728-.185-1.369-.487-1.96a5 5 0 0 0-2.185-2.186c-.592-.302-1.232-.428-1.961-.487C17.1 1.5 16.227 1.5 15.143 1.5H8.857zM5 3.902a3 3 0 0 0-1.173 1.236c-.134.263-.226.611-.276 1.216-.05.617-.051 1.41-.051 2.546v6.2c0 1.137 0 1.929.051 2.546.05.605.142.953.276 1.216a3 3 0 0 0 1.311 1.311c.263.134.611.226 1.216.276.617.05 1.41.051 2.546.051h6.2c1.137 0 1.929 0 2.546-.051.605-.05.953-.142 1.216-.276a3 3 0 0 0 1.311-1.311c.134-.263.226-.611.276-1.216.05-.617.051-1.41.051-2.546V8.9c0-1.137 0-1.929-.051-2.546-.05-.605-.142-.953-.276-1.216A3 3 0 0 0 19 3.902v3.937c0 .527 0 .981-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031H9.162c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C5 8.82 5 8.365 5 7.839V3.902zm12-.385a63.997 63.997 0 0 0-1.9-.017H8.9c-.776 0-1.391 0-1.9.017V7.8c0 .577 0 .949.024 1.232.022.272.06.373.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C8.25 10 8.623 10 9.2 10h5.6c.577 0 .949 0 1.232-.024.272-.022.372-.06.422-.085a1 1 0 0 0 .437-.437c.025-.05.063-.15.085-.422C17 8.75 17 8.377 17 7.8V3.517z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSaveSolid = {
  name: 'IconSaveSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7.857 1.5h6.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961.058.708.058 1.582.058 2.666v6.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487-.708.058-1.582.058-2.666.058H7.857c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.961-.487a5 5 0 0 1-2.185-2.185c-.302-.592-.428-1.232-.487-1.961C.5 17.1.5 16.227.5 15.143V8.857C.5 7.773.5 6.9.558 6.191c.06-.728.185-1.369.487-1.96A5 5 0 0 1 3.23 2.044c.592-.302 1.233-.428 1.961-.487C5.9 1.5 6.773 1.5 7.857 1.5zM6 7.8V3.5H4v4.339c0 .527 0 .981.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.356.031h5.678c.527 0 .981 0 1.356-.03.395-.033.789-.104 1.167-.297a3 3 0 0 0 1.311-1.311c.193-.378.264-.772.296-1.167C18 8.82 18 8.365 18 7.839V3.5h-2v4.3c0 .577 0 .949-.024 1.232-.022.272-.06.373-.085.422a1 1 0 0 1-.437.437c-.05.025-.15.063-.422.085C14.75 10 14.377 10 13.8 10H8.2c-.577 0-.949 0-1.232-.024-.272-.022-.373-.06-.422-.085a1 1 0 0 1-.437-.437c-.025-.05-.063-.15-.085-.422C6 8.75 6 8.377 6 7.8zM5.5 17h11v-2h-11v2zm9.3-9.6a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataScan = {
  name: 'IconScan',
  content: '<path fill="currentColor" d="M1.6 6.5V8h2V6.5a3 3 0 0 1 3-3H17a3 3 0 0 1 3 3V8h2V6.5a5 5 0 0 0-5-5H6.6a5 5 0 0 0-5 5zm0 11V16h2v1.5a3 3 0 0 0 3 3H17a3 3 0 0 0 3-3V16h2v1.5a5 5 0 0 1-5 5H6.6a5 5 0 0 1-5-5zm0-4.5h20.6v-2H1.6v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSearch = {
  name: 'IconSearch',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.2 1.4c-5.412 0-9.8 4.388-9.8 9.8 0 5.412 4.388 9.8 9.8 9.8a9.76 9.76 0 0 0 6.187-2.2l3.473 3.42 1.403-1.426-3.462-3.408A9.76 9.76 0 0 0 21 11.2c0-5.412-4.388-9.8-9.8-9.8zm-7.8 9.8a7.8 7.8 0 1 1 15.6 0 7.8 7.8 0 0 1-15.6 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSearchDesktop = {
  name: 'IconSearchDesktop',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M15.5 5.5a3.8 3.8 0 0 0-2.954 6.19l-2.103 2.035 1.113 1.15 2.246-2.175A3.8 3.8 0 1 0 15.5 5.5zm-2.2 3.8a2.2 2.2 0 1 1 4.4 0 2.2 2.2 0 0 1-4.4 0z" clip-rule="evenodd"/><path fill="currentColor" d="M5.1 7.2h5V5.8h-5v1.4zm4 3.5h-4V9.3h4v1.4zm-4 3.5h3v-1.4h-3v1.4z"/><path fill="currentColor" fill-rule="evenodd" d="M7.462 2.3h9.076c.808 0 1.468 0 2.006.044.555.045 1.058.142 1.526.381a3.9 3.9 0 0 1 1.705 1.704c.239.47.335.971.38 1.527.045.537.045 1.198.045 2.006v4.476c0 .808 0 1.469-.044 2.006-.046.556-.142 1.058-.381 1.526a3.9 3.9 0 0 1-1.705 1.705c-.468.239-.97.336-1.526.381-.538.044-1.198.044-2.006.044H7.462c-.808 0-1.469 0-2.006-.044-.556-.045-1.058-.142-1.527-.381a3.9 3.9 0 0 1-1.704-1.705c-.239-.468-.336-.97-.381-1.526-.044-.537-.044-1.198-.044-2.006V7.962c0-.808 0-1.469.044-2.006.045-.556.142-1.058.38-1.527A3.9 3.9 0 0 1 3.93 2.725c.47-.239.971-.336 1.527-.381C5.993 2.3 6.654 2.3 7.462 2.3zm-1.86 1.838c-.444.036-.683.103-.856.19a2.1 2.1 0 0 0-.917.919c-.088.172-.155.411-.191.856C3.6 6.558 3.6 7.145 3.6 8v4.4c0 .855 0 1.442.038 1.897.036.445.103.683.19.856a2.1 2.1 0 0 0 .918.918c.173.088.412.155.857.191.455.037 1.042.038 1.897.038h9c.855 0 1.442 0 1.897-.038.445-.036.683-.103.856-.19a2.1 2.1 0 0 0 .918-.919c.088-.173.155-.411.19-.856.038-.455.039-1.042.039-1.897V8c0-.855 0-1.442-.038-1.897-.036-.445-.103-.684-.191-.856a2.1 2.1 0 0 0-.918-.918c-.173-.088-.412-.155-.856-.191C17.942 4.1 17.355 4.1 16.5 4.1h-9c-.855 0-1.442 0-1.897.038z" clip-rule="evenodd"/><path fill="currentColor" d="M20.9 21.7H3.1v-1.8h17.8v1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSearchDesktopSolid = {
  name: 'IconSearchDesktopSolid',
  content: '<path fill="currentColor" d="M14.5 7.1a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4z"/><path fill="currentColor" fill-rule="evenodd" d="M15.538 2.3H6.462c-.808 0-1.469 0-2.006.044-.556.045-1.058.142-1.527.381A3.9 3.9 0 0 0 1.225 4.43C.986 4.9.89 5.4.844 5.956.8 6.493.8 7.154.8 7.962v4.476c0 .808 0 1.469.044 2.006.045.556.142 1.058.381 1.527a3.9 3.9 0 0 0 1.704 1.704c.47.239.971.336 1.527.381.537.044 1.198.044 2.006.044h9.076c.808 0 1.469 0 2.006-.044.556-.045 1.058-.142 1.527-.381a3.9 3.9 0 0 0 1.704-1.704c.239-.47.336-.971.381-1.527.044-.537.044-1.198.044-2.006V7.962c0-.808 0-1.469-.044-2.006-.045-.556-.142-1.058-.381-1.527a3.9 3.9 0 0 0-1.704-1.704c-.47-.239-.971-.336-1.527-.381-.537-.044-1.198-.044-2.006-.044zm-4.838 7a3.8 3.8 0 1 1 2.102 3.4l-2.245 2.175-1.113-1.15 2.102-2.035A3.785 3.785 0 0 1 10.7 9.3zM4.1 7.2h5V5.8h-5v1.4zm4 3.5h-4V9.3h4v1.4zm-1 3.5h-3v-1.4h3v1.4z" clip-rule="evenodd"/><path fill="currentColor" d="M2.1 21.7h17.8v-1.8H2.1v1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataSearchHistory = {
  name: 'IconSearchHistory',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13.6 4.7a4.7 4.7 0 1 0 2.958 8.353l1.461 1.461 1.273-1.273-1.574-1.574A4.7 4.7 0 0 0 13.6 4.7zm-2.9 4.7a2.9 2.9 0 1 1 5.8 0 2.9 2.9 0 0 1-5.8 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M19.867 18.64A4.446 4.446 0 0 1 15.556 22H7a5 5 0 0 1-5-5V8.889A4.891 4.891 0 0 1 5.311 4.26 5.002 5.002 0 0 1 10 1h8a5 5 0 0 1 5 5v8c0 2.102-1.297 3.9-3.133 4.64zM5 6.703c-.612.53-1 1.313-1 2.186V17a3 3 0 0 0 3 3h8.556c.81 0 1.527-.394 1.972-1H10a5 5 0 0 1-5-5V6.703zM7 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3V6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSearchHistorySolid = {
  name: 'IconSearchHistorySolid',
  content: '<path fill="currentColor" d="M8.7 9.4a2.9 2.9 0 1 1 5.8 0 2.9 2.9 0 0 1-5.8 0z"/><path fill="currentColor" fill-rule="evenodd" d="M17.703 18.703A5.002 5.002 0 0 1 13 22H5a5 5 0 0 1-5-5V9a5.002 5.002 0 0 1 3.297-4.703A5.002 5.002 0 0 1 8 1h8a5 5 0 0 1 5 5v8a5.002 5.002 0 0 1-3.297 4.703zM3 6.763C2.386 7.314 2 8.112 2 9v8a3 3 0 0 0 3 3h8a2.99 2.99 0 0 0 2.236-1H8a5 5 0 0 1-5-5V6.764zM11.6 4.7a4.7 4.7 0 1 0 2.958 8.353l1.461 1.461 1.273-1.273-1.574-1.574A4.7 4.7 0 0 0 11.6 4.7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataSearchSolid = {
  name: 'IconSearchSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.2 1.4C4.788 1.4.4 5.788.4 11.2c0 5.412 4.388 9.8 9.8 9.8a9.76 9.76 0 0 0 6.187-2.2l3.473 3.419 1.403-1.425-3.462-3.408A9.76 9.76 0 0 0 20 11.2c0-5.412-4.388-9.8-9.8-9.8zM10 5a6 6 0 0 1 6 6h-2a4 4 0 0 0-4-4V5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataSettings = {
  name: 'IconSettings',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zM9.5 12a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M5.422 4.286a1 1 0 0 0-1.257.138A10.984 10.984 0 0 0 1.5 8.9a1 1 0 0 0 .4 1.126 2 2 0 0 1-.113 3.394l-.024.014a1 1 0 0 0-.489 1.09 11.047 11.047 0 0 0 2.514 4.916 1 1 0 0 0 1.331.15 2 2 0 0 1 3.137 1.975 1 1 0 0 0 .707 1.137c1.799.52 3.729.582 5.6.135a1 1 0 0 0 .746-1.185 2.001 2.001 0 0 1 3.3-1.906 1 1 0 0 0 1.4-.052 10.998 10.998 0 0 0 2.683-4.918 1 1 0 0 0-.631-1.181 2 2 0 0 1-.142-3.704 1 1 0 0 0 .536-1.227 11.053 11.053 0 0 0-3-4.636 1 1 0 0 0-1.19-.122l-.024.014a2 2 0 0 1-2.996-1.599 1 1 0 0 0-.774-.91 10.984 10.984 0 0 0-5.211.07 1 1 0 0 0-.748 1.02 2 2 0 0 1-3.089 1.784zM4.25 9.689a4.004 4.004 0 0 0-.624-.818A8.984 8.984 0 0 1 5.11 6.355a3.992 3.992 0 0 0 3.402-.282 3.992 3.992 0 0 0 1.946-2.805 8.985 8.985 0 0 1 2.921-.029 4.001 4.001 0 0 0 5.187 2.724 9.03 9.03 0 0 1 1.709 2.601 4.001 4.001 0 0 0 .253 6.485 9 9 0 0 1-1.422 2.63 3.996 3.996 0 0 0-3.844.085 3.996 3.996 0 0 0-1.996 3.286c-1 .14-2.011.109-2.988-.084a4 4 0 0 0-5.49-3.461 9.112 9.112 0 0 1-1.397-2.78 4.001 4.001 0 0 0 .858-5.036z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSettingsSolid = {
  name: 'IconSettingsSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M14.47 1.413a10.984 10.984 0 0 0-5.211.07 1 1 0 0 0-.748 1.02 2 2 0 0 1-3.089 1.783 1 1 0 0 0-1.257.138A10.984 10.984 0 0 0 1.5 8.9a1 1 0 0 0 .4 1.126 2 2 0 0 1-.113 3.394l-.024.014a1 1 0 0 0-.489 1.09 11.047 11.047 0 0 0 2.514 4.916 1 1 0 0 0 1.331.15 2 2 0 0 1 3.137 1.975 1 1 0 0 0 .707 1.137c1.799.52 3.729.582 5.6.135a1 1 0 0 0 .746-1.185 2.001 2.001 0 0 1 3.3-1.906 1 1 0 0 0 1.4-.052 10.998 10.998 0 0 0 2.683-4.918 1 1 0 0 0-.631-1.181 2 2 0 0 1-.142-3.704 1 1 0 0 0 .536-1.227 11.053 11.053 0 0 0-3-4.636 1 1 0 0 0-1.19-.122l-.024.014a2 2 0 0 1-2.996-1.599 1 1 0 0 0-.774-.91zm4.306 3.353zm1.155 13.481.023.02-.401.442a9.76 9.76 0 0 0 .378-.462zm-.65.76-.004-.003.004.003zm-5.34 2.943-.587.128a3.147 3.147 0 0 1-.007-.03c.199-.026.396-.059.594-.098zm-4.701-.207v-.002.002zm-4.704-2.965zm-2.286-4.47zm.205-5.113zm2.423-4.07zM9.51 2.452V2.45zM9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataShare = {
  name: 'IconShare',
  content: '<path fill="currentColor" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11h-2a9 9 0 1 1-9-9V1z"/><path fill="currentColor" d="M19.086 3.5H15v-2h5.5a2 2 0 0 1 2 2V9h-2V4.914l-6.793 6.793-1.414-1.414L19.086 3.5z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataShareAlt = {
  name: 'IconShareAlt',
  content: '<circle cx="12.1" cy="5.1" r="3.1" stroke="currentColor" stroke-width="2"/><circle cx="5.1" cy="18.1" r="3.1" stroke="currentColor" stroke-width="2"/><circle cx="19.1" cy="18.1" r="3.1" stroke="currentColor" stroke-width="2"/><path stroke="currentColor" stroke-linecap="square" stroke-width="2" d="M7 14.468 10.735 8M9 18h7"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataShareAltSolid = {
  name: 'IconShareAltSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.1 1a4.1 4.1 0 0 0-2.651 7.227l-3.397 5.884A4.1 4.1 0 1 0 8.102 19h5.997a4.102 4.102 0 0 0 8.101-.9 4.1 4.1 0 0 0-8.05-1.1h-6.1a4.1 4.1 0 0 0-1.224-1.963l3.422-5.926A4.1 4.1 0 1 0 11.1 1z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 23 24'
  },
  width: 23,
  height: 24
};

var dataShieldCheck = {
  name: 'IconShieldCheck',
  content: '<path fill="currentColor" d="m10.972 15.973 6.51-6.78-1.442-1.386-5.012 5.22-2.52-2.83-1.494 1.33 3.958 4.446z"/><path fill="currentColor" fill-rule="evenodd" d="M12.235 1.092a2 2 0 0 0-.996.007l-7.75 2.05A2 2 0 0 0 2 5.083v10.016c0 .831.344 1.635.978 2.201.856.764 2.451 2.15 4.073 3.349.81.598 1.646 1.166 2.413 1.589.72.396 1.545.762 2.279.762.725 0 1.567-.36 2.313-.752.797-.419 1.676-.983 2.534-1.579 1.717-1.194 3.427-2.575 4.349-3.34A2.949 2.949 0 0 0 22 15.054v-9.96a2 2 0 0 0-1.515-1.94l-8.25-2.062zm-.485 1.94L20 5.095v9.96c0 .293-.126.56-.338.735-.907.752-2.566 2.092-4.214 3.238-.826.575-1.63 1.087-2.322 1.451-.744.39-1.197.522-1.383.522-.178 0-.609-.126-1.314-.514-.657-.362-1.413-.872-2.189-1.445-1.548-1.146-3.09-2.483-3.93-3.233A.944.944 0 0 1 4 15.1V5.083l7.75-2.05z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataShieldCheckSolid = {
  name: 'IconShieldCheckSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.188 1.132a5 5 0 0 1 3.624 0l6.275 2.44A3 3 0 0 1 20 6.368v5.291a11 11 0 0 1-7.013 10.252l-2.262.88a2 2 0 0 1-1.45 0l-2.262-.88A11 11 0 0 1 0 11.66V6.37a3 3 0 0 1 1.913-2.797l6.275-2.44zm7.294 8.061-6.51 6.78-3.958-4.446 1.494-1.33 2.52 2.83 5.012-5.22 1.442 1.386z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataShieldCnySolid = {
  name: 'IconShieldCnySolid',
  content: '<g clip-path="url(#dls-c3815-a)"><path fill="currentColor" fill-rule="evenodd" d="M8.188 1.132a5 5 0 0 1 3.624 0l6.275 2.44A3 3 0 0 1 20 6.368v5.291a11 11 0 0 1-7.013 10.252l-2.262.88a2 2 0 0 1-1.45 0l-2.262-.88A11 11 0 0 1 0 11.66V6.37a3 3 0 0 1 1.913-2.797l6.275-2.44v-.001zM10 8.982l-2.747-3.14-1.506 1.317L7.797 9.5H5.5v2H9V13H5.5v2H9v2.4h2V15h3.5v-2H11v-1.5h3.5v-2h-2.296l2.049-2.341-1.506-1.318L10 8.981z" clip-rule="evenodd"/></g><defs><clipPath id="dls-c3815-a"><path fill="currentColor" d="M0 0h20v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataShieldEllipsisSolid = {
  name: 'IconShieldEllipsisSolid',
  content: '<g clip-path="url(#dls-f7370-a)"><path fill="currentColor" fill-rule="evenodd" d="M8.188 1.132a5 5 0 0 1 3.624 0l6.275 2.44A3 3 0 0 1 20 6.368v5.291a11 11 0 0 1-7.013 10.252l-2.262.88a2 2 0 0 1-1.45 0l-2.262-.88A11 11 0 0 1 0 11.66V6.37a3 3 0 0 1 1.913-2.797l6.275-2.44v-.001zM5 12.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" clip-rule="evenodd"/></g><defs><clipPath id="dls-f7370-a"><path fill="currentColor" d="M0 0h20v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataShieldTimesSolid = {
  name: 'IconShieldTimesSolid',
  content: '<g clip-path="url(#dls-257af-a)"><path fill="currentColor" fill-rule="evenodd" d="M8.188 1.132a5 5 0 0 1 3.624 0l6.275 2.44A3 3 0 0 1 20 6.368v5.291a11 11 0 0 1-7.013 10.252l-2.262.88a2 2 0 0 1-1.45 0l-2.262-.88A11 11 0 0 1 0 11.66V6.37a3 3 0 0 1 1.913-2.797l6.275-2.44v-.001zM6.5 7.086l3.5 3.5 3.5-3.5L14.914 8.5l-3.5 3.5 3.5 3.5-1.414 1.414-3.5-3.5-3.5 3.5L5.086 15.5l3.5-3.5-3.5-3.5L6.5 7.086z" clip-rule="evenodd"/></g><defs><clipPath id="dls-257af-a"><path fill="currentColor" d="M0 0h20v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataShieldUser = {
  name: 'IconShieldUser',
  content: '<path stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" stroke-width="2" d="M1 11.66V6.367a2 2 0 0 1 1.275-1.864l6.275-2.44a4 4 0 0 1 2.9 0l6.275 2.44A2 2 0 0 1 19 6.368v5.291a10 10 0 0 1-6.376 9.32l-2.262.88a1 1 0 0 1-.724 0l-2.262-.88A10 10 0 0 1 1 11.66z"/><path stroke="currentColor" stroke-width="1.8" d="M14 16.4a4 4 0 0 0-8 0"/><path stroke="currentColor" stroke-width="1.8" d="M12.6 9.8a2.6 2.6 0 1 1-5.2 0 2.6 2.6 0 0 1 5.2 0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataShieldUserSolid = {
  name: 'IconShieldUserSolid',
  content: '<path fill="currentColor" d="M10 8.1a1.7 1.7 0 0 0-.011 3.4h.022A1.7 1.7 0 0 0 10 8.1z"/><path fill="currentColor" fill-rule="evenodd" d="M8.188 1.132a5 5 0 0 1 3.624 0l6.275 2.44A3 3 0 0 1 20 6.368v5.291a11 11 0 0 1-7.013 10.252l-2.262.88a2 2 0 0 1-1.45 0l-2.262-.88A11 11 0 0 1 0 11.66V6.37a3 3 0 0 1 1.913-2.797l6.275-2.44zM6.5 9.8c0 .933.365 1.781.96 2.409a4.897 4.897 0 0 0-2.36 4.19h1.8a3.1 3.1 0 0 1 3.087-3.1h.025a3.1 3.1 0 0 1 3.088 3.1h1.8a4.897 4.897 0 0 0-2.36-4.19A3.5 3.5 0 1 0 6.5 9.8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataShieldWave = {
  name: 'IconShieldWave',
  content: '<path fill="currentColor" d="m13.615 10.251-1.897 4.54a1.1 1.1 0 0 1-1.93.187l-1.787-2.68H6.258v-2h2.814l1.448 2.172 2.185-5.229c.393-.941 1.745-.886 2.06.084l.968 2.972h2.008v2H15.08a1.1 1.1 0 0 1-1.046-.76l-.42-1.286z"/><path fill="currentColor" fill-rule="evenodd" d="M12.535 1.073a2 2 0 0 0-1.07 0l-8 2.222A2 2 0 0 0 2 5.222v10.229a2 2 0 0 0 .829 1.621l6.829 4.932a4 4 0 0 0 4.684 0l6.829-4.932A2 2 0 0 0 22 15.451V5.222a2 2 0 0 0-1.465-1.927l-8-2.222zM4 5.223 12 3l8 2.222v10.229l-6.829 4.932a2 2 0 0 1-2.342 0L4 15.45V5.222z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataShieldWaveSolid = {
  name: 'IconShieldWaveSolid',
  content: '<g clip-path="url(#dls-507bf-a)"><path fill="currentColor" fill-rule="evenodd" d="M10.235 1.092a2 2 0 0 0-.996.007l-7.75 2.05A2 2 0 0 0 0 5.083v10.016c0 .831.344 1.635.978 2.201.856.764 2.451 2.15 4.073 3.349.81.598 1.646 1.166 2.413 1.589.72.396 1.545.762 2.279.762.725 0 1.567-.36 2.313-.752.797-.419 1.676-.983 2.534-1.579 1.717-1.194 3.427-2.575 4.349-3.34A2.95 2.95 0 0 0 20 15.054v-9.96a2 2 0 0 0-1.515-1.94l-8.25-2.062zm-.516 13.737 1.896-4.54.42 1.287a1.1 1.1 0 0 0 1.045.76h2.662v-2h-2.008l-.968-2.973c-.316-.97-1.668-1.025-2.061-.083l-2.184 5.228-1.152-1.727-.297-.446H4.258v2h1.744l1.786 2.68a1.1 1.1 0 0 0 1.93-.186z" clip-rule="evenodd"/></g><defs><clipPath id="dls-507bf-a"><path fill="currentColor" d="M0 0h20v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataShoppingBag = {
  name: 'IconShoppingBag',
  content: '<path fill="currentColor" d="M7 7a5 5 0 1 0 10 0h-2a3 3 0 1 1-6 0H7z"/><path fill="currentColor" fill-rule="evenodd" d="M7.91 1a5 5 0 0 0-4.966 4.416l-1.412 12A5 5 0 0 0 6.498 23h11.004a5 5 0 0 0 4.966-5.584l-1.412-12A5 5 0 0 0 16.09 1H7.91zM4.93 5.65A3 3 0 0 1 7.91 3h8.18a3 3 0 0 1 2.98 2.65l1.411 12a3 3 0 0 1-2.98 3.35H6.499a3 3 0 0 1-2.98-3.35l1.413-12z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataShoppingBagSolid = {
  name: 'IconShoppingBagSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.944 5.416A5 5 0 0 1 6.91 1h8.18a5 5 0 0 1 4.966 4.416l1.412 12A5 5 0 0 1 16.502 23H5.498a5 5 0 0 1-4.966-5.584l1.412-12zM6 7a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0H6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataShoppingCart = {
  name: 'IconShoppingCart',
  content: '<path fill="currentColor" d="M1.5 3.5h1.696a1 1 0 0 1 .998.939l.577 9.368A5 5 0 0 0 9.76 18.5H22v-2H9.761a3 3 0 0 1-2.994-2.816l-.576-9.368A3 3 0 0 0 3.196 1.5H1.5v2z"/><path fill="currentColor" d="M8 5h11.301a1 1 0 0 1 .994 1.108l-.511 4.72a2 2 0 0 1-1.903 1.783L8.722 13l.085 1.998 9.159-.39a4 4 0 0 0 3.806-3.566l.512-4.72A3 3 0 0 0 19.3 3H8v2zm2 16a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataShoppingCartSolid = {
  name: 'IconShoppingCartSolid',
  content: '<path fill="currentColor" d="M2.196 3.5H.5v-2h1.696a3 3 0 0 1 2.995 2.816l.576 9.368A3 3 0 0 0 8.761 16.5H21v2H8.761a5 5 0 0 1-4.99-4.693L3.194 4.44a1 1 0 0 0-.998-.939z"/><path fill="currentColor" d="M8.275 3a1.5 1.5 0 0 0-1.496 1.614l.687 8.979a1.5 1.5 0 0 0 1.564 1.384l7.946-.361a4 4 0 0 0 3.795-3.565l.512-4.728A3 3 0 0 0 18.302 3H8.275zM9 21a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataShortVideo = {
  name: 'IconShortVideo',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0 2h7v2H4V4z" clip-rule="evenodd"/><path fill="currentColor" d="M4 17V9H2v8a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V9h-2v8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"/><path fill="currentColor" fill-rule="evenodd" d="M15 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V4zm5 0h-3v2h3V4zm-8.963 6.38A1.3 1.3 0 0 0 9 11.45v5.1a1.3 1.3 0 0 0 2.037 1.07l3.708-2.549a1.3 1.3 0 0 0 0-2.142l-3.708-2.55zM13.479 14 10.6 15.98v-3.96L13.479 14z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataShortVideoSolid = {
  name: 'IconShortVideoSolid',
  content: '<path fill="currentColor" d="M2 2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/><path fill="currentColor" fill-rule="evenodd" d="M2 9.5a2 2 0 0 0-2 2V17a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5v-5.5a2 2 0 0 0-2-2H2zm5.7 4c0-1.071 1.223-1.683 2.08-1.04l2.667 2a1.3 1.3 0 0 1 0 2.08l-2.667 2c-.857.643-2.08.031-2.08-1.04v-4z" clip-rule="evenodd"/><path fill="currentColor" d="M13 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V4z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataShrink = {
  name: 'IconShrink',
  content: '<path fill="currentColor" d="M16.75 8.66h4.586v2h-6a2 2 0 0 1-2-2v-6h2v4.586L21.5 1.082l1.414 1.414L16.75 8.66zm-8.086 8.094v4.586h2v-6a2 2 0 0 0-2-2h-6v2H7.25l-6.164 6.164L2.5 22.918l6.164-6.164z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSignOut = {
  name: 'IconSignOut',
  content: '<path fill="currentColor" d="M7.5 2a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h14v-2h-14a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h14V2h-14z"/><path fill="currentColor" d="M9.5 12.8h9.22l-2.654 2.867 1.468 1.359 3.555-3.841a2 2 0 0 0-.036-2.755l-3.537-3.628-1.432 1.396L18.62 10.8H9.5v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSkipBackward = {
  name: 'IconSkipBackward',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8 3.5H6v17h2v-7.42l9.733 7.007A.8.8 0 0 0 19 19.438V4.562a.8.8 0 0 0-1.267-.65L8 10.92V3.5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSkipForward = {
  name: 'IconSkipForward',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M16 3.5h2v17h-2v-7.42l-9.733 7.007A.8.8 0 0 1 5 19.438V4.562a.8.8 0 0 1 1.267-.65L16 10.92V3.5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSlidersSquare = {
  name: 'IconSlidersSquare',
  content: '<path fill="currentColor" d="M16.732 10a2 2 0 0 1-3.464 0H5V8h8.268a2 2 0 0 1 3.464 0H19v2h-2.268zM9 17a2 2 0 0 0 1.732-1H19v-2h-8.268a2 2 0 0 0-3.464 0H5v2h2.268A2 2 0 0 0 9 17z"/><path fill="currentColor" fill-rule="evenodd" d="M1 8a5 5 0 0 1 5-5h12a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V8zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSlidersSquareSolid = {
  name: 'IconSlidersSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 8a5 5 0 0 1 5-5h12a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V8zm14 3a2 2 0 0 0 1.732-1H18V8h-2.268a2 2 0 0 0-3.464 0H4v2h8.268A2 2 0 0 0 14 11zm-6 6a2 2 0 0 0 1.732-1H18v-2H9.732a2 2 0 0 0-3.464 0H4v2h2.268A2 2 0 0 0 8 17z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataSmiley = {
  name: 'IconSmiley',
  content: '<path fill="currentColor" d="M8.3 11.4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-8.315 4.353a1 1 0 1 0-1.789.894c.619 1.237 2.114 2.887 4.804 2.887 2.644 0 4.342-1.601 4.985-2.887a1 1 0 1 0-1.789-.894c-.357.714-1.422 1.78-3.196 1.78-1.728 0-2.633-1.017-3.015-1.78z"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSmileyComment = {
  name: 'IconSmileyComment',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.2 6.4a5 5 0 0 1 5-5h11.6a5 5 0 0 1 5 5v8.393a5 5 0 0 1-4.902 4.999l-2.649.052-2.348 2.465a1.5 1.5 0 0 1-2.172 0l-2.34-2.456h-2.19a5 5 0 0 1-5-5V6.4zm5-3a3 3 0 0 0-3 3v8.453a3 3 0 0 0 3 3h2.617a1 1 0 0 1 .725.31l2.273 2.387 2.274-2.387a1 1 0 0 1 .704-.31l3.066-.06a3 3 0 0 0 2.94-3V6.4a3 3 0 0 0-3-3H6.2zM12 14a5 5 0 0 1-5-5h2a3 3 0 1 0 6 0h2a5 5 0 0 1-5 5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSmileySolid = {
  name: 'IconSmileySolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 12C0 5.925 4.925 1 11 1s11 4.925 11 11-4.925 11-11 11S0 18.075 0 12zm8.8-2.1a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm7.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-9.656 3.906a1 1 0 0 1 1.341.447c.382.763 1.287 1.78 3.015 1.78 1.774 0 2.84-1.066 3.196-1.78a1 1 0 1 1 1.79.894c-.644 1.286-2.342 2.887-4.986 2.887-2.69 0-4.185-1.65-4.804-2.887a1 1 0 0 1 .448-1.341z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataSmileyStar = {
  name: 'IconSmileyStar',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 1c.55 0 1.09.04 1.619.118a6.952 6.952 0 0 0-.557 1.944 9 9 0 1 0 7.876 7.876 6.951 6.951 0 0 0 1.944-.557C22.96 10.91 23 11.45 23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zM9.25 9.25a1.65 1.65 0 1 1-3.3 0 1.65 1.65 0 0 1 3.3 0zM7.6 14.1a4.4 4.4 0 0 0 8.8 0H7.6zm11.7-5.085-.277.636a.57.57 0 0 1-1.05 0l-.278-.636A4.905 4.905 0 0 0 15.2 6.484l-.854-.38c-.462-.206-.462-.878 0-1.083l.807-.359a4.91 4.91 0 0 0 2.53-2.615l.285-.688a.57.57 0 0 1 1.059 0l.284.688a4.91 4.91 0 0 0 2.531 2.615l.807.359c.462.205.462.877 0 1.083l-.854.38a4.906 4.906 0 0 0-2.495 2.53z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSmileyStarSolid = {
  name: 'IconSmileyStarSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 1a11 11 0 0 1 1.21.066 7 7 0 0 0 9.725 9.725c.043.397.065.8.065 1.209 0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zM9.25 9.25a1.65 1.65 0 1 1-3.3 0 1.65 1.65 0 0 1 3.3 0zM12 18.5a4.4 4.4 0 0 1-4.4-4.4h8.8a4.4 4.4 0 0 1-4.4 4.4zm7.3-9.485-.277.636a.57.57 0 0 1-1.05 0l-.278-.636A4.905 4.905 0 0 0 15.2 6.484l-.854-.38c-.462-.206-.462-.878 0-1.083l.807-.359a4.91 4.91 0 0 0 2.53-2.615l.285-.688a.57.57 0 0 1 1.059 0l.284.688a4.91 4.91 0 0 0 2.531 2.615l.807.359c.462.205.462.877 0 1.083l-.854.38a4.906 4.906 0 0 0-2.495 2.53z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSort = {
  name: 'IconSort',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12.634 2.823a.8.8 0 0 0-1.268 0L6.063 9.712A.8.8 0 0 0 6.697 11h10.605a.8.8 0 0 0 .634-1.288l-5.302-6.889zm-1.268 18.354a.8.8 0 0 0 1.268 0l5.302-6.889A.8.8 0 0 0 17.302 13H6.697a.8.8 0 0 0-.634 1.288l5.303 6.889z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSortAlt = {
  name: 'IconSortAlt',
  content: '<path fill="currentColor" d="M16.5 21.8V4.214l4.793 4.793 1.414-1.414L17.914 2.8c-1.26-1.26-3.414-.368-3.414 1.414V21.8h2zm-9-19.6v17.586l-4.793-4.793-1.414 1.414L6.086 21.2c1.26 1.26 3.414.367 3.414-1.414V2.2h-2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSortAsc = {
  name: 'IconSortAsc',
  content: '<path fill="currentColor" d="M11.366 2.823a.8.8 0 0 1 1.268 0l5.303 6.889A.8.8 0 0 1 17.303 11H6.697a.8.8 0 0 1-.633-1.288l5.302-6.889z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSortDesc = {
  name: 'IconSortDesc',
  content: '<path fill="currentColor" d="M12.634 21.177a.8.8 0 0 1-1.268 0l-5.303-6.889A.8.8 0 0 1 6.697 13h10.605a.8.8 0 0 1 .634 1.288l-5.302 6.889z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSoundWave = {
  name: 'IconSoundWave',
  content: '<path fill="currentColor" d="M5 7h2v10H5V7zm-4 3h2v4H1v-4zm8-8h2v18H9V2zm4 2h2v18h-2V4zm4 3h2v10h-2V7zm4 3h2v4h-2v-4z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSparklesSolid = {
  name: 'IconSparklesSolid',
  content: '<path fill="currentColor" d="m13.392 6.225-.878 2.01a7.742 7.742 0 0 1-3.94 3.992l-2.416 1.072c-.768.341-.768 1.458 0 1.8l2.34 1.038a7.747 7.747 0 0 1 3.997 4.125l.89 2.142a.946.946 0 0 0 1.758 0l.889-2.142a7.747 7.747 0 0 1 3.997-4.125l2.34-1.039c.768-.34.768-1.458 0-1.799l-2.415-1.072a7.742 7.742 0 0 1-3.94-3.991l-.878-2.01a.946.946 0 0 0-1.744 0zM4.604 1.331l-.246.566a4.365 4.365 0 0 1-2.222 2.25l-.76.339a.53.53 0 0 0 0 .963l.718.319a4.368 4.368 0 0 1 2.253 2.326l.254.611a.507.507 0 0 0 .942 0l.253-.61A4.368 4.368 0 0 1 8.05 5.767l.718-.32a.53.53 0 0 0 0-.962l-.76-.338a4.365 4.365 0 0 1-2.222-2.251L5.54 1.33a.507.507 0 0 0-.935 0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSplit = {
  name: 'IconSplit',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 4h3v16H5v2h5V2H5v2zm14 16h-3V4h3V2h-5v20h5v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSquareRotation = {
  name: 'IconSquareRotation',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.5 8.6a1.9 1.9 0 0 0-1.9 1.9v3c0 1.05.85 1.9 1.9 1.9h3a1.9 1.9 0 0 0 1.9-1.9v-3a1.9 1.9 0 0 0-1.9-1.9h-3zm-.1 1.9a.1.1 0 0 1 .1-.1h3a.1.1 0 0 1 .1.1v3a.1.1 0 0 1-.1.1h-3a.1.1 0 0 1-.1-.1v-3z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 .3a3.6 3.6 0 0 1 3.348 2.275 10.002 10.002 0 0 1 6.338 11.92 3.6 3.6 0 0 1-4.075 5.783A9.958 9.958 0 0 1 12 22a9.958 9.958 0 0 1-5.343-1.545 3.6 3.6 0 0 1-4.294-5.775A10.01 10.01 0 0 1 2 12c0-4.35 2.777-8.049 6.652-9.425A3.601 3.601 0 0 1 12 .3zm0 2a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM4 12a8.001 8.001 0 0 1 4.513-7.202 3.601 3.601 0 0 0 6.974 0 8.001 8.001 0 0 1 4.376 8.683 3.6 3.6 0 0 0-3.82 5.423A7.96 7.96 0 0 1 12.001 20a7.958 7.958 0 0 1-4.076-1.115 3.6 3.6 0 0 0-3.692-4.967A8.021 8.021 0 0 1 4 12zm15.1 3.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM3 17.5a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSquareRotationSolid = {
  name: 'IconSquareRotationSolid',
  content: '<path fill="currentColor" d="M9.5 10.4a.1.1 0 0 0-.1.1v3a.1.1 0 0 0 .1.1h3a.1.1 0 0 0 .1-.1v-3a.1.1 0 0 0-.1-.1h-3z"/><path fill="currentColor" fill-rule="evenodd" d="M7.971 2.467a3.35 3.35 0 0 1 6.058 0C18.071 3.75 21 7.533 21 12c0 .964-.137 1.897-.391 2.78a3.35 3.35 0 0 1-3.757 5.33A9.954 9.954 0 0 1 11 22a9.954 9.954 0 0 1-5.57-1.694 3.35 3.35 0 0 1-3.99-5.366A9.999 9.999 0 0 1 1 12c0-4.467 2.929-8.25 6.971-9.533zm3.03-.417a1.85 1.85 0 1 0 0 3.7 1.85 1.85 0 0 0 0-3.7zM16.25 17a1.85 1.85 0 1 1 3.7 0 1.85 1.85 0 0 1-3.7 0zm-14.5.5a1.85 1.85 0 1 1 3.7 0 1.85 1.85 0 0 1-3.7 0zm5.85-7c0-1.05.85-1.9 1.9-1.9h3c1.05 0 1.9.85 1.9 1.9v3a1.9 1.9 0 0 1-1.9 1.9h-3a1.9 1.9 0 0 1-1.9-1.9v-3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataStamp = {
  name: 'IconStamp',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 3.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm5 3a4.986 4.986 0 0 1-1.558 3.627l.971 4.373H18a4 4 0 0 1 0 8H6a4 4 0 0 1 0-8h1.587l.972-4.373A5 5 0 1 1 17 6.5zm-6.698 5h3.396l.555 2.5H9.747l.555-2.5zM4 18.5a2 2 0 0 1 2-2h12a2 2 0 1 1 0 4H6a2 2 0 0 1-2-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataStampSolid = {
  name: 'IconStampSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10 1.5a5 5 0 0 0-3.441 8.627L5.587 14.5H4a4 4 0 0 0 0 8h12a4 4 0 0 0 0-8h-1.587l-.971-4.373A5 5 0 0 0 10 1.5zm-1.698 10h3.396l.555 2.5H7.747l.555-2.5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataStar = {
  name: 'IconStar',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.19 2.604c.72-1.534 2.9-1.534 3.62 0l2.051 4.37 4.666.712c1.61.246 2.267 2.209 1.13 3.374l-3.439 3.524.803 4.922c.269 1.648-1.48 2.88-2.941 2.073L12 19.324l-4.08 2.255c-1.46.808-3.21-.425-2.941-2.073l.803-4.922-3.439-3.524c-1.136-1.165-.48-3.128 1.13-3.374l4.666-.713 2.05-4.37zm1.81.85L9.496 8.788l-5.721.874 4.143 4.247-.965 5.918L12 17.038l5.047 2.79-.965-5.918 4.143-4.247-5.72-.874L12 3.453z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataStarDash = {
  name: 'IconStarDash',
  content: '<path fill="currentColor" d="M14.5 13.5h-5v2h5v-2z"/><path fill="currentColor" fill-rule="evenodd" d="M13.81 2.604c-.72-1.534-2.9-1.534-3.62 0l-2.051 4.37-4.666.712c-1.61.246-2.266 2.209-1.13 3.374l3.439 3.524-.803 4.922c-.269 1.648 1.48 2.88 2.941 2.073L12 19.324l4.08 2.255c1.46.808 3.21-.425 2.941-2.073l-.803-4.922 3.439-3.524c1.137-1.165.48-3.128-1.13-3.374l-4.666-.713-2.05-4.37zM9.496 8.789 12 3.453l2.504 5.336 5.721.874-4.143 4.247.965 5.918L12 17.038l-5.047 2.79.965-5.918-4.143-4.247 5.72-.874z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataStarDashSoild = {
  name: 'IconStarDashSoild',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m6.55 22.622 5.7-2.997 5.7 2.997a1 1 0 0 0 1.452-1.054l-1.089-6.348 4.612-4.496a1 1 0 0 0-.554-1.705l-6.374-.926-2.85-5.776a1 1 0 0 0-1.794 0l-2.85 5.776-6.374.926a1 1 0 0 0-.554 1.705l4.612 4.496-1.089 6.348a1 1 0 0 0 1.451 1.054zM8.5 11.5v2h7v-2h-7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataStarDashSolid = {
  name: 'IconStarDashSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m6.55 22.622 5.7-2.997 5.7 2.997a1 1 0 0 0 1.452-1.054l-1.089-6.348 4.612-4.496a1 1 0 0 0-.554-1.705l-6.374-.926-2.85-5.776a1 1 0 0 0-1.794 0l-2.85 5.776-6.374.926a1 1 0 0 0-.554 1.705l4.612 4.496-1.089 6.348a1 1 0 0 0 1.451 1.054zM8.5 11.5v2h7v-2h-7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataStarHalf = {
  name: 'IconStarHalf',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13.81 2.604c-.72-1.534-2.9-1.534-3.62 0l-2.051 4.37-4.666.712c-1.61.246-2.266 2.209-1.13 3.374l3.439 3.524-.803 4.922c-.269 1.648 1.48 2.88 2.941 2.073L12 19.324l4.08 2.255c1.46.808 3.21-.425 2.941-2.073l-.803-4.922 3.439-3.524c1.137-1.165.48-3.128-1.13-3.374l-4.666-.713-2.05-4.37zm-1.81.85 2.504 5.335 5.721.874-4.143 4.247.965 5.918L12 17.038V3.454z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataStarSolid = {
  name: 'IconStarSolid',
  content: '<path fill="currentColor" d="M13.345 2.466c-.55-1.115-2.14-1.115-2.69 0L8.25 7.339l-5.377.781c-1.23.179-1.722 1.69-.832 2.559l3.891 3.792-.918 5.356c-.21 1.225 1.076 2.16 2.176 1.581L12 18.88l4.81 2.528c1.1.579 2.386-.356 2.176-1.58l-.919-5.357 3.892-3.792c.89-.868.399-2.38-.832-2.559l-5.377-.781-2.405-4.873z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataStop = {
  name: 'IconStop',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM6.382 4.968a9 9 0 0 1 12.65 12.65L6.382 4.968zM4.968 6.382a9 9 0 0 0 12.65 12.65L4.968 6.382z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataStopSolid = {
  name: 'IconStopSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3.961 3.547A10.955 10.955 0 0 1 11 1c6.075 0 11 4.925 11 11 0 2.678-.957 5.131-2.547 7.039L3.961 3.547zM2.547 4.96A10.955 10.955 0 0 0 0 12c0 6.075 4.925 11 11 11 2.678 0 5.132-.957 7.04-2.547L2.546 4.961z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataStrikethrough = {
  name: 'IconStrikethrough',
  content: '<path fill="currentColor" d="M8.553 20.708c1.102.485 2.296.728 3.584.728.971 0 1.84-.13 2.604-.392.766-.28 1.42-.653 1.96-1.12a4.893 4.893 0 0 0 1.232-1.68 4.74 4.74 0 0 0 .448-2.044c0-.672-.102-1.26-.308-1.764a4.21 4.21 0 0 0-.466-.936H22v-2h-6.96c-.144-.07-.29-.136-.438-.2l-2.604-1.12c-.374-.15-.738-.308-1.092-.476a7.283 7.283 0 0 1-.98-.616 3.304 3.304 0 0 1-.729-.812c-.168-.317-.252-.7-.252-1.148 0-.84.308-1.493.924-1.96.635-.485 1.466-.728 2.492-.728.86 0 1.624.159 2.296.476a6.282 6.282 0 0 1 1.877 1.26l1.26-1.512c-.654-.672-1.447-1.213-2.38-1.624-.934-.43-1.951-.644-3.053-.644-.84 0-1.614.121-2.324.364a5.637 5.637 0 0 0-1.82 1.036c-.504.43-.905.943-1.204 1.54a4.495 4.495 0 0 0-.42 1.932c0 .672.112 1.27.336 1.792.224.504.514.943.868 1.316.355.373.756.69 1.204.952.102.06.203.117.304.172H2v2h11.677l.476.236c.374.187.691.401.952.644.28.224.495.504.644.84.168.317.252.71.252 1.176 0 .896-.336 1.624-1.008 2.184-.671.541-1.614.812-2.828.812a6.584 6.584 0 0 1-2.772-.616 7.925 7.925 0 0 1-2.296-1.68l-1.4 1.624a8.827 8.827 0 0 0 2.856 1.988z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSwitch = {
  name: 'IconSwitch',
  content: '<path fill="currentColor" d="M2.2 16.5h17.586l-4.793 4.793 1.414 1.414 4.793-4.793c1.26-1.26.368-3.414-1.414-3.414H2.2v2zm19.6-9H4.215l4.792-4.793-1.414-1.414L2.8 6.086C1.54 7.346 2.433 9.5 4.215 9.5H21.8v-2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSync = {
  name: 'IconSync',
  content: '<path fill="currentColor" d="M11.973 1C5.953 1 1.092 5.936 1.092 12h2c0-4.982 3.987-9 8.881-9 2.717 0 5.153 1.237 6.785 3.192l-.576.333a.5.5 0 0 0 .048.89l2.803 1.241a.5.5 0 0 0 .698-.391l.413-3.098a.5.5 0 0 0-.746-.499l-.887.512C18.521 2.638 15.438 1 11.973 1zm11.119 11c0 6.064-4.861 11-10.882 11-3.465 0-6.548-1.637-8.538-4.18l-.887.512a.5.5 0 0 1-.746-.5l.413-3.097a.5.5 0 0 1 .698-.391l2.804 1.24a.5.5 0 0 1 .047.89l-.576.334C7.057 19.764 9.493 21 12.21 21c4.894 0 8.882-4.018 8.882-9h2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSyncCircle = {
  name: 'IconSyncCircle',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 3c2.762 0 5 2.686 5 6s-2.238 6-5 6c-2.177 0-4.029-1.67-4.715-4l2.117.001c.519 1.195 1.488 2 2.598 2 1.657 0 3-1.792 3-4C15 9.79 13.657 8 12 8c-1.11 0-2.08.805-2.599 2h1.6L8.5 13 6 10h1.284C7.971 7.67 9.823 6 12 6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSyringe = {
  name: 'IconSyringe',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m20.838 14.475 1.415-1.415-2.122-2.12-2.807-2.808 3.182-3.182-1.414-1.414-3.182 3.182-2.85-2.85-2.121-2.121L9.525 3.16l1.414 1.414-6.718 6.718a4 4 0 0 0 0 5.657l.729.728-2.828 2.828 1.414 1.415 2.828-2.829.686.686a4 4 0 0 0 5.657 0l6.717-6.718 1.414 1.415zm-2.828-2.829-6.718 6.718a2 2 0 0 1-2.828 0l-2.828-2.829a2 2 0 0 1 0-2.828l6.717-6.718 5.657 5.657zM6.322 14.142l3.536 3.535 1.272-1.272-3.535-3.536-1.273 1.273z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataSyringesSolid = {
  name: 'IconSyringesSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m18.717 12.353 2.121 2.122 1.415-1.415-4.93-4.928 3.183-3.182-1.414-1.414-3.182 3.182-4.971-4.971L9.525 3.16l2.121 2.121L4.928 12a3 3 0 0 0 0 4.242l.729.729-3.536 3.535 1.414 1.414 3.536-3.535.686.686a3 3 0 0 0 4.242 0l6.718-6.718zm-8.86 5.324-3.535-3.535 1.273-1.273 3.535 3.536-1.273 1.272z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTag = {
  name: 'IconTag',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M9.028 7.17a3.502 3.502 0 1 0 3.502 6.067A3.502 3.502 0 0 0 9.028 7.17zm.454 3.783a1.498 1.498 0 1 1 2.594-1.498 1.498 1.498 0 0 1-2.594 1.498z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M9.236 1.921a4 4 0 0 0-4.858 2.805L2.956 9.86a3 3 0 0 0 .293 2.3l4.885 8.462a5 5 0 0 0 6.83 1.83l4.33-2.5a5 5 0 0 0 1.83-6.83L16.24 4.661a3 3 0 0 0-1.846-1.404L9.236 1.92zM6.306 5.26a2 2 0 0 1 2.428-1.402l5.158 1.336a1 1 0 0 1 .615.468l4.885 8.461a3 3 0 0 1-1.098 4.098l-4.33 2.5a3 3 0 0 1-4.098-1.098l-4.885-8.461a1 1 0 0 1-.098-.767L6.305 5.26z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTagSolid = {
  name: 'IconTagSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M3.148 9.932a2 2 0 0 0 .195 1.534L8.75 20.83a4 4 0 0 0 5.464 1.464l5.134-2.964a4 4 0 0 0 1.464-5.464l-5.407-9.365a2 2 0 0 0-1.23-.937L8.387 2.067A3 3 0 0 0 4.744 4.17L3.148 9.932zm8.517 1.648a2.5 2.5 0 1 0-2.5-4.33 2.5 2.5 0 0 0 2.5 4.33z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTeam = {
  name: 'IconTeam',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.5 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 2a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm1 3h-2a5 5 0 0 0-5 5v1h12v-1a5 5 0 0 0-5-5zm-2-2a7 7 0 0 0-7 7v3h16v-3a7 7 0 0 0-7-7h-2zm7.336-7.252c.913.812 1.225 1.676 1.246 2.531.021.9-.28 1.859-.731 2.783l-.41.842.813.464c2.316 1.324 3.3 3.284 3.64 5.24.345 1.991.01 3.956-.324 5.116l1.922.553c.386-1.34.785-3.626.372-6.01-.38-2.197-1.459-4.494-3.852-6.153.345-.878.594-1.863.57-2.883-.035-1.398-.581-2.79-1.918-3.978l-1.328 1.495z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataTeamSolid = {
  name: 'IconTeamSolid',
  content: '<g clip-path="url(#dls-28e38-a)"><path fill="currentColor" fill-rule="evenodd" d="M13 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0zM.5 19a7 7 0 0 1 7-7h2a7 7 0 0 1 7 7v3H.5v-3zM14.836 4.748c.913.812 1.225 1.676 1.246 2.531.021.9-.28 1.859-.731 2.783l-.41.842.813.464c2.316 1.324 3.3 3.284 3.64 5.24.345 1.991.01 3.956-.324 5.116l1.922.553c.386-1.34.785-3.626.372-6.01-.38-2.197-1.459-4.494-3.852-6.153.345-.878.594-1.863.57-2.883-.035-1.398-.581-2.79-1.918-3.978l-1.328 1.495z" clip-rule="evenodd"/></g><defs><clipPath id="dls-28e38-a"><path fill="currentColor" d="M0 0h22v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataTelephone = {
  name: 'IconTelephone',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.5 15.3a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0zm3.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M22.904 7.899c.144-2.049-.931-4.09-2.965-4.865-1.983-.756-4.924-1.634-7.94-1.634-3.153 0-6.071.96-7.935 1.744-1.75.736-2.727 2.445-2.805 4.218l-.028.64a3.649 3.649 0 0 0 2.966 3.744l-1.39 4.173C1.726 19.157 4.136 22.5 7.55 22.5h8.9c3.413 0 5.823-3.343 4.744-6.581l-1.389-4.165a3.791 3.791 0 0 0 3.07-3.457l.029-.398zm-3.678-2.996c1.098.418 1.774 1.56 1.683 2.855l-.029.399a1.79 1.79 0 0 1-1.905 1.66l-1.209-.082a1.424 1.424 0 0 1-1.328-1.42c0-.717-.482-1.374-1.218-1.547-.679-.159-2.06-.444-3.329-.444-1.269 0-2.65.285-3.329.444a1.583 1.583 0 0 0-1.218 1.547c0 .749-.58 1.37-1.328 1.42l-1.032.07A1.647 1.647 0 0 1 3.23 8.088l.028-.64c.05-1.128.655-2.072 1.582-2.461C6.584 4.254 9.221 3.4 11.999 3.4c2.666 0 5.345.785 7.227 1.503zm-1.531 6.832-.063-.004a3.424 3.424 0 0 1-3.178-3.085c-.677-.146-1.681-.322-2.563-.322-.881 0-1.886.176-2.562.322a3.424 3.424 0 0 1-3.02 3.07 1.007 1.007 0 0 1-.027.1l-1.578 4.735A3 3 0 0 0 7.55 20.5h8.9a3 3 0 0 0 2.846-3.949l-1.578-4.735a1.01 1.01 0 0 1-.023-.081z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTelephoneSolid = {
  name: 'IconTelephoneSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M21.904 7.899c.144-2.049-.931-4.09-2.965-4.865C16.956 2.278 14.016 1.4 11 1.4c-3.154 0-6.072.96-7.936 1.744C1.314 3.88.337 5.589.259 7.362l-.028.64a3.63 3.63 0 0 0 .995 2.667l3.282-.213A1.879 1.879 0 0 0 6.265 8.58c0-.633.428-1.208 1.073-1.355.752-.17 2.277-.475 3.662-.475 1.385 0 2.91.305 3.662.476a1.383 1.383 0 0 1 1.072 1.355c0 .99.77 1.81 1.758 1.875l3.322.215a3.775 3.775 0 0 0 1.061-2.374l.029-.398zm-20.098 8.02 1.29-3.868 1.51-.098a3.379 3.379 0 0 0 3.158-3.285C8.514 8.5 9.84 8.25 11 8.25c1.16 0 2.486.25 3.236.418a3.379 3.379 0 0 0 3.159 3.285l1.51.098 1.289 3.868c1.079 3.238-1.33 6.581-4.744 6.581h-8.9c-3.413 0-5.823-3.343-4.744-6.581zM9.5 15.3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm1.5-3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataTemplate = {
  name: 'IconTemplate',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 22.5a5 5 0 0 1-5-5v-11a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11zm-3-5a3 3 0 0 0 3 3H8v-11H3.5v8zm6.5-8v11h7.5a3 3 0 0 0 3-3v-8H10zm10.5-3v1h-17v-1a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTemplateSolid = {
  name: 'IconTemplateSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.5 22.5a5 5 0 0 1-5-5v-8H7v13H5.5zm3.5 0h7.5a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11a5 5 0 0 0-5 5v1h21v2H9v13z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataTextFlowerSquare = {
  name: 'IconTextFlowerSquare',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11zm10.236 11.746h2.618c.644 0 1.106-.14 1.414-.392.322-.28.56-1.148.7-2.604l-1.386-.448c-.056 1.022-.168 1.638-.336 1.848-.14.196-.364.294-.672.294h-1.918c-.308 0-.462-.196-.462-.574v-2.24c1.68-.938 3.136-2.03 4.382-3.276l-1.022-1.036c-.882.966-2.002 1.862-3.36 2.688V9.398h-1.47v3.906c-.7.336-1.47.672-2.282.994l.812 1.232c.49-.196.98-.42 1.47-.644v1.806c0 1.036.504 1.554 1.512 1.554zm-7.7-3.08a17.426 17.426 0 0 0 1.75-1.596v4.928H9.27v-6.762c.42-.616.77-1.274 1.05-1.946l-1.316-.63c-.742 1.736-1.876 3.262-3.416 4.55l.448 1.456zm2.73-8.54H5.91v1.372h2.856v1.036h1.442V7.998h3.598v1.036h1.442V7.998h2.856V6.626h-2.856V5.464h-1.442v1.162h-3.598V5.464H8.766v1.162z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTextFlowerSquareSolid = {
  name: 'IconTextFlowerSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm7.236 16.746h2.618c.644 0 1.106-.14 1.414-.392.322-.28.56-1.148.7-2.604l-1.386-.448c-.056 1.022-.168 1.638-.336 1.848-.14.196-.364.294-.672.294h-1.918c-.308 0-.462-.196-.462-.574v-2.24c1.68-.938 3.136-2.03 4.382-3.276l-1.022-1.036c-.882.966-2.002 1.862-3.36 2.688V9.398h-1.47v3.906c-.7.336-1.47.672-2.282.994l.812 1.232c.49-.196.98-.42 1.47-.644v1.806c0 1.036.504 1.554 1.512 1.554zm-7.7-3.08a17.426 17.426 0 0 0 1.75-1.596v4.928H9.27v-6.762c.42-.616.77-1.274 1.05-1.946l-1.316-.63c-.742 1.736-1.876 3.262-3.416 4.55l.448 1.456zm2.73-8.54H5.91v1.372h2.856v1.036h1.442V7.998h3.598v1.036h1.442V7.998h2.856V6.626h-2.856V5.464h-1.442v1.162h-3.598V5.464H8.766v1.162z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTextSquare = {
  name: 'IconTextSquare',
  content: '<path fill="currentColor" d="M11 9.2H7v-2h10v2h-4v8.6h-2V9.2z"/><path fill="currentColor" fill-rule="evenodd" d="M1.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm5-3a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3h-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTextSquareAltSolid = {
  name: 'IconTextSquareAltSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm5.257 4.332-.112-.145-1.882.68.242.276c.36.409.678.832.95 1.275H5.991V9.77h2.04a11.81 11.81 0 0 0 2.744 4.695c-1.285 1.028-2.896 1.79-4.83 2.288l-.327.084 1.002 1.646.183-.051c2.074-.586 3.848-1.504 5.306-2.748 1.376 1.106 3.075 2.036 5.094 2.793l.188.07 1.035-1.587-.295-.109c-1.855-.683-3.424-1.502-4.7-2.476 1.099-1.266 1.947-2.8 2.546-4.605h2.032V7.918h-5.005a11.584 11.584 0 0 0-1.247-2.086zm.336 7.366A10.037 10.037 0 0 1 9.875 9.77h4.169c-.463 1.313-1.117 2.457-1.951 3.428z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTextSquareSolid = {
  name: 'IconTextSquareSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1.5 6.5a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v11a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5v-11zm9.18 2.7H7V6.56h10V9.2h-3.68v8.6h-2.64V9.2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataThumbDown = {
  name: 'IconThumbDown',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M16.207 20.818c-.732.732-1.501 1.11-2.273 1.172a2.966 2.966 0 0 1-1.819-.462c-.867-.54-1.133-1.486-1.22-2.14l-.19-1.43a7.042 7.042 0 0 0-1.482-3.468 1.01 1.01 0 0 0-.79-.379H5a3 3 0 0 1-3-3v-6.5a3 3 0 0 1 3-3h12.286a4 4 0 0 1 3.907 3.144l1.255 5.73a3 3 0 0 1-2.911 3.642l-1.879.011c.124.663.242 1.537.242 2.473 0 2.201-1.197 3.71-1.693 4.207zm-.76-7.369-.003-.009-.395-1.285 4.475-.028a1 1 0 0 0 .97-1.214l-1.254-5.73a2 2 0 0 0-1.954-1.572H9v8.554a3.011 3.011 0 0 1 1.784 1.076 9.042 9.042 0 0 1 1.903 4.454l.19 1.428c.029.213.076.384.136.507a.453.453 0 0 0 .16.201.972.972 0 0 0 .598.166c.2-.016.547-.118 1.022-.593.287-.288 1.107-1.318 1.107-2.793 0-.834-.114-1.632-.231-2.229a12.225 12.225 0 0 0-.222-.933zM7 12.111v-8.5H5a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1h2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataThumbDownSolid = {
  name: 'IconThumbDownSolid',
  content: '<path fill="currentColor" d="M9.166 13.5c.646 0 1.25.323 1.607.86l.207.31a10.518 10.518 0 0 1 1.605 3.994l.248 1.398c.11.617.344 1.24.887 1.552.629.36 1.62.546 2.78-.614.392-.392 1.2-1.662 1.2-3.5s-.5-3.965-.5-3.965l2.792-.017a2.5 2.5 0 0 0 2.44-2.97l-1.11-5.8A4 4 0 0 0 17.393 1.5H10.2a2 2 0 0 0-2 2v9.034c0 .534.432.966.966.966zM4.2 13.326a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2h1.5a1 1 0 0 1 1 1v9.826a1 1 0 0 1-1 1H4.2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataThumbUp = {
  name: 'IconThumbUp',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M16.207 3.182c-.732-.733-1.501-1.11-2.273-1.173a2.967 2.967 0 0 0-1.819.463c-.867.54-1.133 1.486-1.22 2.14l-.19 1.43A7.042 7.042 0 0 1 9.222 9.51a1.01 1.01 0 0 1-.79.379H5a3 3 0 0 0-3 3v6.5a3 3 0 0 0 3 3h12.286a4 4 0 0 0 3.907-3.144l1.255-5.73a3 3 0 0 0-2.911-3.642l-1.879-.011c.124-.663.242-1.537.242-2.473 0-2.201-1.197-3.71-1.693-4.207zm-.76 7.369-.003.009-.395 1.285 4.475.028a1 1 0 0 1 .97 1.214l-1.254 5.73a2 2 0 0 1-1.954 1.572H9v-8.554a3.011 3.011 0 0 0 1.784-1.076 9.042 9.042 0 0 0 1.903-4.454l.19-1.428c.029-.213.076-.384.136-.507a.453.453 0 0 1 .16-.201.972.972 0 0 1 .598-.166c.2.016.547.118 1.022.593.287.287 1.107 1.318 1.107 2.793 0 .834-.114 1.632-.231 2.229a12.224 12.224 0 0 1-.222.933zM7 11.889H5a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1h2v-8.5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataThumbUpSolid = {
  name: 'IconThumbUpSolid',
  content: '<path fill="currentColor" d="M9.166 10.5c.646 0 1.25-.323 1.608-.86l.207-.311a10.52 10.52 0 0 0 1.604-3.993l.248-1.398c.11-.617.344-1.24.888-1.552.628-.36 1.62-.546 2.78.614.391.392 1.2 1.662 1.2 3.5s-.5 3.965-.5 3.965l2.791.017a2.5 2.5 0 0 1 2.44 2.97l-1.11 5.8a4 4 0 0 1-3.929 3.248H10.2a2 2 0 0 1-2-2v-9.034c0-.534.433-.966.966-.966zm-4.966.174a2 2 0 0 0-2 2V20.5a2 2 0 0 0 2 2h1.5a1 1 0 0 0 1-1v-9.826a1 1 0 0 0-1-1H4.2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTimes = {
  name: 'IconTimes',
  content: '<path fill="currentColor" d="m7.444 11.998-7 7 1.555 1.556 7-7 7 7L17.556 19l-7-7 7-7.001L16 3.442l-7 7-7.001-7L.443 4.998l7 7z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 18 24'
  },
  width: 18,
  height: 24
};

var dataTimesCircle = {
  name: 'IconTimesCircle',
  content: '<path fill="currentColor" d="m8.5 7.086 3.5 3.5 3.5-3.5L16.914 8.5l-3.5 3.5 3.5 3.5-1.414 1.414-3.5-3.5-3.5 3.5L7.086 15.5l3.5-3.5-3.5-3.5L8.5 7.086z"/><path fill="currentColor" fill-rule="evenodd" d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTimesCircleSolid = {
  name: 'IconTimesCircleSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zM7.086 8.5 8.5 7.086l3.5 3.5 3.5-3.5L16.914 8.5l-3.5 3.5 3.5 3.5-1.414 1.414-3.5-3.5-3.5 3.5L7.086 15.5l3.5-3.5-3.5-3.5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataToolbox = {
  name: 'IconToolbox',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6 5.4V6h-.6a4 4 0 0 0-4 4v8.6a4 4 0 0 0 4 4h13.2a4 4 0 0 0 4-4V10a4 4 0 0 0-4-4H18v-.6a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4zm4-2a2 2 0 0 0-2 2V6h8v-.6a2 2 0 0 0-2-2h-4zM5.4 8a2 2 0 0 0-2 2v2h17.2v-2a2 2 0 0 0-2-2H5.4zm15.2 6H3.4v4.6a2 2 0 0 0 2 2h13.2a2 2 0 0 0 2-2V14z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataToolboxSolid = {
  name: 'IconToolboxSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 6v-.6a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4V6h.6a4 4 0 0 1 4 4v8.6a4 4 0 0 1-4 4H4.4a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4H5zm2-.6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2V6H7v-.6zM19 14H3v-2h16v2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataToolsSolid = {
  name: 'IconToolsSolid',
  content: '<path fill="currentColor" d="m21.71 20.29-1.42 1.42a1 1 0 0 1-1.41 0L7 9.85A3.81 3.81 0 0 1 6 10a4 4 0 0 1-3.78-5.3l2.54 2.54.53-.53 1.42-1.42.53-.53L4.7 2.22A4 4 0 0 1 10 6a3.81 3.81 0 0 1-.15 1l11.86 11.88a1 1 0 0 1 0 1.41zM2.29 18.88a1 1 0 0 0 0 1.41l1.42 1.42a1 1 0 0 0 1.41 0l5.47-5.46-2.83-2.83M20 2l-4 2v2l-2.17 2.17 2 2L18 8h2l2-4-2-2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrackCut = {
  name: 'IconTrackCut',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v6h2v-6a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v6h2v-6a5 5 0 0 0-5-5h-11zm3.854 14.539 1.638-1.637 1.648 1.647a4.22 4.22 0 0 0 3.638 6.362 4.22 4.22 0 0 0 4.222-4.219 4.22 4.22 0 0 0-6.367-3.635l-1.648-1.647 4.422-4.418L16.414 7l-4.422 4.419-4.417-4.414-1.493 1.491 4.417 4.414-1.642 1.641a4.22 4.22 0 0 0-6.357 3.64 4.22 4.22 0 0 0 4.222 4.22 4.22 4.22 0 0 0 3.632-6.372zm-1.52 2.153a2.11 2.11 0 1 1-4.221-.002 2.11 2.11 0 0 1 4.22.002zm10.555 0a2.11 2.11 0 1 1-4.22-.002 2.11 2.11 0 0 1 4.22.002z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrackFrameLast = {
  name: 'IconTrackFrameLast',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13.998 2h1v5h-2V4h-8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8v-3h2v5h-10a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h9zm5 0v5h-1.999l3 3 3-3h-2V2h-2.001zm2.001 20v-5h2l-3-3-3 3h1.999v5h2.001zm-6-13h-2v2h2V9zm-2 4h2v2h-2v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrash = {
  name: 'IconTrash',
  content: '<path fill="currentColor" d="M8.45 1.45h7.1v2.1h-7.1v-2.1zm2.35 7.494v8.737h-2V8.944h2zm4.4 0h-2v8.737h2V8.944z"/><path fill="currentColor" fill-rule="evenodd" d="M2.3 4.7h19.4v2H20v10.8a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V6.7H2.3v-2zm3.7 2v10.8a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6.7H6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrashSolid = {
  name: 'IconTrashSolid',
  content: '<path fill="currentColor" d="M6.45 1.45h7.1v2.1h-7.1v-2.1z"/><path fill="currentColor" fill-rule="evenodd" d="M.3 4.7h19.4v2H18v10.8a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V6.7H.3v-2zm8.5 4.244v8.737h-2V8.944h2zm4.4 0v8.737h-2V8.944h2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataTravelEarthPlaneSolid = {
  name: 'IconTravelEarthPlaneSolid',
  content: '<path fill="currentColor" d="M20.677 12.923a.191.191 0 0 1-.185-.136l-1.09-3.558-1.302 1.106.015 1.924c0 .051-.019.1-.055.137l-.322.33a.193.193 0 0 1-.318-.067l-.698-1.808-1.872-.807a.193.193 0 0 1-.062-.312l.321-.33a.193.193 0 0 1 .148-.059l1.964.097 1.106-1.361-3.573-1.138a.193.193 0 0 1-.08-.32l.614-.628a.193.193 0 0 1 .157-.057l4.406.445L21.1 5.126c.497-.505.974-.584 1.214-.584h.003c.223 0 .42.066.527.174.26.26.247 1.004-.453 1.72l-.001.002L21.13 7.7l.353 4.387a.194.194 0 0 1-.055.151l-.614.628a.193.193 0 0 1-.137.058zm-6.922 9.606c-.404.047-.815.071-1.231.071a10.46 10.46 0 0 1-8.381-4.19h.001c.622-.366 1.067-.021 1.59.382.422.327.895.693 1.552.752 1.3.118 2.24-.193 3.143-1.134.197-.205.361-.443.526-.682.457-.663.92-1.334 2.094-1.327.915.006 1.478.472 2.094 1.048.168.157.244.288.3.385.101.177.138.24.543.139.887-.222 1.047-2.095 1.047-2.095s.867-2.008 1.778-2.096c.33-.032.323.378.313.843-.012.597-.026 1.285.67 1.252.991-.046 1.635-1.22 1.635-1.22s.78-2.19 1.44-1.647a.77.77 0 0 1 .087.082c-.388 4.238-3.3 7.745-7.22 9.007-.633.181-1.294.32-1.981.43z"/><path fill="currentColor" d="M19.736 4.277a10.44 10.44 0 0 0-7.212-2.878C6.738 1.4 2.048 6.09 2.048 11.876c0 1.036.15 2.037.43 2.982.075.015.153.027.234.034.98.084 1.997-.006 2.479-.438.524-.47.597-.964.663-1.414.078-.525.146-.991.91-1.292.762-.3 1.442.097 2.15.51.557.326 1.131.661 1.777.674 1.31.025 1.15-.901.952-2.058-.175-1.019-.38-2.216.358-3.102.533-.638 1.073-.848 1.59-1.048.556-.216 1.085-.42 1.552-1.134.59-.9 1.393-.846 2.25-.787.64.044 1.31.09 1.94-.26.159-.088.292-.177.403-.266z"/><path fill="currentColor" d="M12.103 15.348s-2.713 1.44-5.798 1.978C3.22 17.863.986 17.046 1 16.282c.012-.144.05-.313.117-.484.106-.272.286-.55.557-.742.353-.25.582-.153.582-.153s-.08.128-.122.293c-.127.497.1 1.324 3.957-.057 5.137-1.84 7.409-3.95 7.409-3.95s.924-.515 1.48-.315c.923.334 1.44 1.441.387 2.484-1.054 1.043-3.264 1.99-3.264 1.99zm-6.294.996c.104-.015.21-.032.316-.05 1.446-.252 2.821-.72 3.846-1.131a21.96 21.96 0 0 0 1.538-.688l.081-.041.019-.01.004-.002.038-.02.04-.017.003-.002.015-.006a9.905 9.905 0 0 0 .31-.142c.212-.099.504-.241.826-.414.67-.36 1.372-.798 1.785-1.207.167-.166.232-.294.257-.368a.239.239 0 0 0 .012-.14c-.014-.055-.077-.16-.234-.23a1.378 1.378 0 0 0-.292.07 2.73 2.73 0 0 0-.28.116l-.022.02c-.084.07-.206.17-.366.294-.319.247-.792.588-1.427.986-1.271.796-3.191 1.817-5.834 2.763-.221.08-.433.152-.635.22zm-3.53-.435a.17.17 0 0 0 .01-.005l-.01.007v-.002zm12.41-4.033h-.002z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTreasureChest = {
  name: 'IconTreasureChest',
  content: '<path fill="currentColor" d="M12.75 11.05h-1.5v2.7h1.5v-2.7z"/><path fill="currentColor" fill-rule="evenodd" d="M7 1.5a5 5 0 0 0-5 5v2.51c-.661.272-1 .993-1 1.59v2.8c0 .597.339 1.318 1 1.59v2.51a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5v-2.51c.662-.272 1-.993 1-1.59v-2.8c0-.597-.338-1.318-1-1.59V6.5a5 5 0 0 0-5-5H7zM4 15.1v2.4a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2.4h-3.91c-.097.9-.858 1.6-1.784 1.6H9.694c-.926 0-1.687-.7-1.784-1.6H4zm17-2h-4.9v-1.9c0-.1-.004-.2-.01-.3H21v2.2zm-1-4.2h-4.605A4.096 4.096 0 0 0 12 7.1a4.096 4.096 0 0 0-3.395 1.8H4V6.5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v2.4zm-17 2h4.91c-.006.1-.01.2-.01.3v1.9H3v-2.2zm9-2a2.3 2.3 0 0 0-2.3 2.3v3.7h4.6v-3.7A2.3 2.3 0 0 0 12 8.9z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTreasureChestSolid = {
  name: 'IconTreasureChestSolid',
  content: '<path fill="currentColor" d="M5 1.5a5 5 0 0 0-5 5V9h6.54A4.097 4.097 0 0 1 10 7.1c1.455 0 2.733.758 3.46 1.9H20V6.5a5 5 0 0 0-5-5H5zM0 13v-2h5.905a4.159 4.159 0 0 0-.005.2V13H0zm0 4.5V15h5.902c.05.947.832 1.7 1.792 1.7h4.612c.96 0 1.743-.753 1.792-1.7H20v2.5a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5zM20 13v-2h-5.905c.003.066.005.133.005.2V13H20z"/><path fill="currentColor" fill-rule="evenodd" d="M7.7 11.2a2.3 2.3 0 1 1 4.6 0v3.7H7.7v-3.7zm3.05 2.55v-2.7h-1.5v2.7h1.5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataTrendDesktop = {
  name: 'IconTrendDesktop',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m13.613 10.874-1.231 1.8a1.667 1.667 0 0 1-2.224.494l-1.081-.639-1.225 1.994-1.704-1.046 1.396-2.274a1.667 1.667 0 0 1 2.268-.562l1.095.647.929-1.357a2.9 2.9 0 1 1 1.777.944zM15.1 8a1.1 1.1 0 1 0-2.2 0 1.1 1.1 0 0 0 2.2 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M15.143 2H8.857C7.773 2 6.9 2 6.191 2.058c-.728.06-1.369.185-1.96.487A5 5 0 0 0 2.044 4.73c-.302.592-.428 1.233-.487 1.961C1.5 7.4 1.5 8.273 1.5 9.357v1.286c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.233.428 1.961.487C6.9 18 7.773 18 8.857 18h6.286c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961.058-.708.058-1.582.058-2.666V9.357c0-1.084 0-1.958-.058-2.666-.06-.728-.185-1.369-.487-1.96a5 5 0 0 0-2.185-2.186c-.592-.302-1.232-.428-1.961-.487C17.1 2 16.227 2 15.143 2zM5.138 4.327c.263-.134.611-.226 1.216-.276C6.971 4.001 7.764 4 8.9 4h6.2c1.137 0 1.929 0 2.546.051.605.05.953.142 1.216.276a3 3 0 0 1 1.311 1.311c.134.263.226.611.276 1.216.05.617.051 1.41.051 2.546v1.2c0 1.137 0 1.929-.051 2.546-.05.605-.142.953-.276 1.216a3 3 0 0 1-1.311 1.311c-.263.134-.611.226-1.216.276-.617.05-1.41.051-2.546.051H8.9c-1.137 0-1.929 0-2.546-.051-.605-.05-.953-.142-1.216-.276a3 3 0 0 1-1.311-1.311c-.134-.263-.226-.611-.276-1.216-.05-.617-.051-1.41-.051-2.546V9.4c0-1.137 0-1.929.051-2.546.05-.605.142-.953.276-1.216a3 3 0 0 1 1.311-1.311z" clip-rule="evenodd"/><path fill="currentColor" d="M3 21.8h18v-2H3v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrendDesktopSolid = {
  name: 'IconTrendDesktopSolid',
  content: '<path fill="currentColor" d="M14.1 8a1.1 1.1 0 1 0-2.2 0 1.1 1.1 0 0 0 2.2 0z"/><path fill="currentColor" fill-rule="evenodd" d="M14.143 2H7.857C6.773 2 5.9 2 5.191 2.058c-.728.06-1.369.185-1.961.487A5 5 0 0 0 1.045 4.73C.743 5.322.617 5.963.558 6.691.5 7.4.5 8.273.5 9.357v1.286c0 1.084 0 1.958.058 2.666.06.729.185 1.369.487 1.961a5 5 0 0 0 2.185 2.185c.592.302 1.233.428 1.961.487C5.9 18 6.773 18 7.857 18h6.286c1.084 0 1.958 0 2.666-.058.729-.06 1.369-.185 1.961-.487a5 5 0 0 0 2.185-2.185c.302-.592.428-1.232.487-1.961.058-.708.058-1.582.058-2.666V9.357c0-1.084 0-1.958-.058-2.666-.06-.728-.185-1.369-.487-1.96a5 5 0 0 0-2.185-2.186c-.592-.302-1.232-.428-1.961-.487C16.1 2 15.227 2 14.143 2zM13 5.1a2.9 2.9 0 1 1-.386 5.774l-1.232 1.8a1.667 1.667 0 0 1-2.224.495l-1.081-.64-1.225 1.994-1.704-1.046 1.396-2.274a1.667 1.667 0 0 1 2.268-.562l1.095.647.929-1.357A2.9 2.9 0 0 1 13 5.1z" clip-rule="evenodd"/><path fill="currentColor" d="M2 21.8h18v-2H2v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataTrendMonitor = {
  name: 'IconTrendMonitor',
  content: '<path fill="currentColor" d="M6 3.5h12v-2H6v2zm7.311 5.501a1 1 0 0 1 .945.545l1.69 3.312H18v2h-2.667a1 1 0 0 1-.89-.546l-.945-1.851-1.865 4.895a1 1 0 0 1-1.774.187l-1.737-2.685H6v-2h2.667a1 1 0 0 1 .84.457l.96 1.485 1.964-5.156a1 1 0 0 1 .88-.643z"/><path fill="currentColor" fill-rule="evenodd" d="M1.5 10a5 5 0 0 1 5-5h11a5 5 0 0 1 5 5v7.5a5 5 0 0 1-5 5h-11a5 5 0 0 1-5-5V10zm5-3a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3V10a3 3 0 0 0-3-3h-11z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrendMonitorSolid = {
  name: 'IconTrendMonitorSolid',
  content: '<path fill="currentColor" d="M5 3.5h12v-2H5v2z"/><path fill="currentColor" fill-rule="evenodd" d="M5.5 5a5 5 0 0 0-5 5v7.5a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5V10a5 5 0 0 0-5-5h-11zm6.811 4.001a1 1 0 0 1 .945.545l1.69 3.312H17v2h-2.667a1 1 0 0 1-.89-.546l-.945-1.851-1.865 4.895a1 1 0 0 1-1.774.187l-1.737-2.685H5v-2h2.667a1 1 0 0 1 .84.457l.96 1.485 1.964-5.156a1 1 0 0 1 .88-.643z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataTrendPages = {
  name: 'IconTrendPages',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m15.613 10.874-1.231 1.8a1.667 1.667 0 0 1-2.224.494l-1.081-.639-1.225 1.994-1.704-1.046 1.396-2.274a1.667 1.667 0 0 1 2.268-.562l1.095.647.929-1.357a2.9 2.9 0 1 1 1.777.944zM17.1 8a1.1 1.1 0 1 0-2.2 0 1.1 1.1 0 0 0 2.2 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M19.867 18.64A4.446 4.446 0 0 1 15.556 22H7a5 5 0 0 1-5-5V8.889A4.891 4.891 0 0 1 5.311 4.26 5.002 5.002 0 0 1 10 1h8a5 5 0 0 1 5 5v8c0 2.102-1.297 3.9-3.133 4.64zM5 6.703c-.612.53-1 1.313-1 2.186V17a3 3 0 0 0 3 3h8.556c.81 0 1.527-.394 1.972-1H10a5 5 0 0 1-5-5V6.703zM7 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3V6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrendPagesSolid = {
  name: 'IconTrendPagesSolid',
  content: '<path fill="currentColor" d="M15.1 8a1.1 1.1 0 1 0-2.2 0 1.1 1.1 0 0 0 2.2 0z"/><path fill="currentColor" fill-rule="evenodd" d="M17.703 18.703A5.002 5.002 0 0 1 13 22H5a5 5 0 0 1-5-5V9a5.002 5.002 0 0 1 3.297-4.703A5.002 5.002 0 0 1 8 1h8a5 5 0 0 1 5 5v8a5.002 5.002 0 0 1-3.297 4.703zM3 6.763C2.386 7.314 2 8.112 2 9v8a3 3 0 0 0 3 3h8a2.99 2.99 0 0 0 2.236-1H8a5 5 0 0 1-5-5V6.764zM14 5.1a2.9 2.9 0 1 1-.386 5.774l-1.232 1.8a1.667 1.667 0 0 1-2.224.495l-1.081-.64-1.225 1.994-1.704-1.046 1.396-2.274a1.667 1.667 0 0 1 2.268-.562l1.095.647.929-1.357A2.9 2.9 0 0 1 14 5.1z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataTrendReport = {
  name: 'IconTrendReport',
  content: '<rect width="18" height="20" x="1" y="2" stroke="currentColor" stroke-width="2" rx="4"/><path stroke="currentColor" stroke-width="2" d="M16 16.6H4m.2-3.3 3.056-3.497a.667.667 0 0 1 .942-.062l2.296 2.016c.278.243.7.215.943-.063L15.7 6.8"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataTrendReportSolid = {
  name: 'IconTrendReportSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 6a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V6zm16.454 1.457-4.263 4.894a1.667 1.667 0 0 1-2.356.157l-2.046-1.795-2.836 3.245-1.506-1.316 3.056-3.497a1.667 1.667 0 0 1 2.355-.156l2.045 1.795 4.043-4.64 1.508 1.313zM4 15.6h12v2H4v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataTrendStarSolid = {
  name: 'IconTrendStarSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.324 2A4.324 4.324 0 0 0 2 6.324v10.352A4.324 4.324 0 0 0 6.324 21h6.448A6.213 6.213 0 0 1 21 12.06V6.324A4.324 4.324 0 0 0 16.676 2H6.324zm1.837 4.37a.859.859 0 0 1 1.37-.072l2.75 3.278a.86.86 0 0 0 1.294.026l1.015-1.116a.859.859 0 0 1 1.242-.029l1.56 1.56 1.215-1.215-1.56-1.56a2.577 2.577 0 0 0-3.728.088l-.353.389-2.119-2.525a2.577 2.577 0 0 0-4.11.214l-3.45 5.111 1.425.961 3.45-5.11zM4 14.704h4.46V13H4v1.705zm14.842 5.575-.436 1h-.867l-.436-1a3.846 3.846 0 0 0-1.958-1.983l-1.2-.533v-.894l1.163-.516a3.85 3.85 0 0 0 1.986-2.05l.442-1.064h.873l.442 1.064a3.849 3.849 0 0 0 1.986 2.05L22 16.87v.894l-1.2.533a3.847 3.847 0 0 0-1.958 1.983z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrimLeft = {
  name: 'IconTrimLeft',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 4h2V2H5v2zm3 0h2V2H8v2zm2 3H8V5h2v2zm-2 3h2V8H8v2zm2 3H8v-2h2v2zm-2 3h2v-2H8v2zm2 3H8v-2h2v2zm-2 3h2v-2H8v2zm-1 0H5v-2h2v2zm12-2h-3V4h3V2h-5v20h5v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrimRight = {
  name: 'IconTrimRight',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 20h3V4H5V2h5v20H5v-2zm14 0h-2v2h2v-2zm-3 0h-2v2h2v-2zm-2-3h2v2h-2v-2zm2-3h-2v2h2v-2zm-2-3h2v2h-2v-2zm2-3h-2v2h2V8zm-2-3h2v2h-2V5zm2-3h-2v2h2V2zm1 0h2v2h-2V2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrophy = {
  name: 'IconTrophy',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 2h14v1.1h2.3a1.4 1.4 0 0 1 1.4 1.4v3.3a4.701 4.701 0 0 1-3.973 4.644A7.008 7.008 0 0 1 13 17.43V20h5v2H6v-2h5v-2.57a7.008 7.008 0 0 1-5.726-4.986A4.701 4.701 0 0 1 1.3 7.8V4.5a1.4 1.4 0 0 1 1.4-1.4H5V2zm0 2.9H3.1v2.9A2.9 2.9 0 0 0 5 10.523V4.9zm14 5.6v.023A2.901 2.901 0 0 0 20.9 7.8V4.9H19v5.6zM7 4v6.5a5 5 0 0 0 10 0V4H7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTrophySolid = {
  name: 'IconTrophySolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 2h14v1.1h2.3a1.4 1.4 0 0 1 1.4 1.4v3.3a4.701 4.701 0 0 1-3.974 4.644A7.008 7.008 0 0 1 13 17.43V20h5v2H6v-2h5v-2.57a7.008 7.008 0 0 1-5.727-4.986A4.701 4.701 0 0 1 1.3 7.8V4.5a1.4 1.4 0 0 1 1.4-1.4H5V2zm0 2.9H3.1v2.9A2.9 2.9 0 0 0 5 10.523V4.9zm14 5.6v.023A2.901 2.901 0 0 0 20.9 7.8V4.9H19v5.6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTruck = {
  name: 'IconTruck',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M1 6a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v1.5h2.586A2 2 0 0 1 20 8.086l2.414 2.414A2 2 0 0 1 23 11.914V17a2 2 0 0 1-1.63 1.966 3.251 3.251 0 0 1-6.23.034H9.559a3.251 3.251 0 0 1-6.24-.078A3.001 3.001 0 0 1 1 16V6zm20 7.3v3.017a3.248 3.248 0 0 0-5-.612V13.3h5zm-.314-1.7-2.1-2.1H16v2.1h4.686zM3.438 16.827A3.251 3.251 0 0 1 9.527 17H14V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 .438.827zM5.2 18.05a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0zm13.05-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTruckSolid = {
  name: 'IconTruckSolid',
  content: '<path fill="currentColor" d="M4 3.5h8.721a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H9a3 3 0 0 0-5.995-.17A3.001 3.001 0 0 1 1 15.5v-9a3 3 0 0 1 3-3zm13 12.6a3 3 0 0 1 4.8 2.4h.2a1 1 0 0 0 1-1v-4.3h-6v2.9zm5.414-4.686a2 2 0 0 1 .406.586H17v-2a1 1 0 0 1 1-1h1.172a2 2 0 0 1 1.414.586l1.828 1.828z"/><path fill="currentColor" d="M18.8 20.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM6 20.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTv = {
  name: 'IconTv',
  content: '<path fill="currentColor" d="M17 9v2.5h2V9h-2z"/><path fill="currentColor" fill-rule="evenodd" d="M15.4 1.586 11.986 5H9.414L6 1.586 4.586 3l2 2H5a5 5 0 0 0-5 5v7a5 5 0 0 0 5 5h12a5 5 0 0 0 5-5v-7a5 5 0 0 0-5-5h-2.186l2-2L15.4 1.586zM2 10a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataTvSolid = {
  name: 'IconTvSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.414 5h2.572L16.4 1.586 17.814 3l-2 2H18a5 5 0 0 1 5 5v7a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5v-7a5 5 0 0 1 5-5h1.586l-2-2L7 1.586 10.414 5zM18 9v2.5h2V9h-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTwoHearts = {
  name: 'IconTwoHearts',
  content: '<path fill="currentColor" d="M6.894 2.664A6.571 6.571 0 0 0 .73 9.574v.001c.222 4.042 2.9 6.133 5.303 8.008l.093.073.016.011a22.437 22.437 0 0 1 4.143 3.872 1 1 0 1 0 1.54-1.277 24.44 24.44 0 0 0-4.498-4.206c-2.497-1.95-4.432-3.529-4.6-6.59a4.571 4.571 0 0 1 4.267-4.805 4.389 4.389 0 0 1 2.972 1.11 1.6 1.6 0 0 0 2.24-.121 4.441 4.441 0 0 1 2.848-1.44l.072-.004a4.592 4.592 0 0 1 4.814 4.288 1 1 0 1 0 1.996-.13 6.592 6.592 0 0 0-6.917-6.155l-.123.008-.018.001a6.442 6.442 0 0 0-3.883 1.808 6.387 6.387 0 0 0-4.056-1.364h-.022l-.022.002z"/><path fill="currentColor" fill-rule="evenodd" d="M16.498 7.933a4.392 4.392 0 0 0-5.878 1.94v.001c-1.196 2.359-.358 4.427.33 6.126l.043.108.008.017c.46 1.022.787 2.097.976 3.2a1.7 1.7 0 0 0 .927 1.263l.01.005c.227.109.474.166.724.17h.026c.283-.004.559-.077.804-.21a12.575 12.575 0 0 1 3.179-1.163l.021-.004.155-.041c1.747-.462 3.87-1.023 5.038-3.288l.004-.008.004-.008a4.405 4.405 0 0 0-1.946-5.873l-.076-.038-.017-.007a4.314 4.314 0 0 0-2.532-.322 4.283 4.283 0 0 0-1.762-1.848l-.019-.01-.02-.01zm-3.665 7.39c-.729-1.803-1.182-3.06-.43-4.545a2.392 2.392 0 0 1 3.182-1.065 2.282 2.282 0 0 1 .98 1.107 1.682 1.682 0 0 0 1.934.98 2.315 2.315 0 0 1 1.488.136l.03.015a2.405 2.405 0 0 1 1.063 3.197c-.733 1.415-1.998 1.794-3.883 2.293-1.15.254-2.264.646-3.319 1.168a15.27 15.27 0 0 0-1.045-3.286z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataTwoHeartsSolid = {
  name: 'IconTwoHeartsSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M15.018 2.21a6.592 6.592 0 0 1 6.917 6.155c.016.233.026.456.03.667a5.981 5.981 0 0 0-.36-.2l-.01-.004-.102-.052-.042-.019a5.814 5.814 0 0 0-2.361-.521 5.782 5.782 0 0 0-1.826-1.594l-.047-.026-.049-.025a5.892 5.892 0 0 0-7.886 2.603v.002c-1.509 2.976-.431 5.624.243 7.281l.07.176.019.044.02.043c.405.903.695 1.854.863 2.83a3.2 3.2 0 0 0 1.378 2.151l-.05.02a3.391 3.391 0 0 1-.38.125 1.528 1.528 0 0 1-.248.043 1.114 1.114 0 0 1-.425-.044 1.01 1.01 0 0 1-.483-.32l-.005-.006a22.44 22.44 0 0 0-4.143-3.872l-.015-.011-.094-.073C3.63 15.708.951 13.617.73 9.575v-.001a6.571 6.571 0 0 1 6.165-6.91l.021-.002h.022a6.389 6.389 0 0 1 4.056 1.364 6.44 6.44 0 0 1 3.883-1.808l.019-.001.122-.008zm-4.939 18.82a.06.06 0 0 1 0-.002v.002z" clip-rule="evenodd"/><path fill="currentColor" d="M10.603 9.873a4.392 4.392 0 0 1 5.878-1.94l.02.01.019.01a4.281 4.281 0 0 1 1.761 1.848 4.312 4.312 0 0 1 2.532.322l.017.007.076.038a4.405 4.405 0 0 1 1.947 5.873l-.004.008-.004.008c-1.168 2.265-3.291 2.826-5.039 3.288l-.155.04-.02.005a12.575 12.575 0 0 0-3.18 1.163 1.733 1.733 0 0 1-.804.21h-.026a1.727 1.727 0 0 1-.723-.17l-.01-.005a1.7 1.7 0 0 1-.928-1.262 13.275 13.275 0 0 0-.975-3.2l-.008-.018-.044-.108c-.688-1.699-1.525-3.767-.33-6.126v-.001z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUnderline = {
  name: 'IconUnderline',
  content: '<path fill="currentColor" d="M7.6 12.4v-10H5.4v10a6.1 6.1 0 0 0 6.1 6.1h1a6.1 6.1 0 0 0 6.1-6.1v-10h-2.2v10a3.9 3.9 0 0 1-3.9 3.9h-1a3.9 3.9 0 0 1-3.9-3.9zM3 21.6h18v-2H3v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUndo = {
  name: 'IconUndo',
  content: '<path fill="currentColor" fill-rule="evenodd" d="m10 3.312-7.136 7.7 7.136 7.7v-4.746l1.125.141c4.588.579 7.755 2.951 9.71 5.039-.669-3.2-1.604-5.612-2.958-7.337-1.547-1.972-3.718-3.142-6.974-3.46L10 8.261v-4.95zM8.88 1.578C9.993.378 12 1.165 12 2.802V6.47c3.244.487 5.67 1.837 7.45 4.104 1.9 2.422 2.983 5.793 3.683 9.973.153.916-.573 1.433-.984 1.59-.418.16-1.243.242-1.767-.44-1.443-1.879-4.15-4.528-8.382-5.417v2.941c0 1.637-2.007 2.425-3.12 1.224l-7.61-8.21a1.8 1.8 0 0 1 0-2.447l7.61-8.21z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUndoSolid = {
  name: 'IconUndoSolid',
  content: '<path fill="currentColor" d="M12 2.802C12 1.165 9.993.378 8.88 1.578l-7.61 8.21a1.8 1.8 0 0 0 0 2.447l7.61 8.21c1.113 1.2 3.12.413 3.12-1.223V16.28c4.238.89 6.94 3.54 8.382 5.416.524.682 1.348.6 1.767.44.411-.157 1.137-.674.984-1.59-.763-4.555-1.98-8.156-4.224-10.612-1.733-1.897-4-3.028-6.909-3.465V2.802z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUnlink = {
  name: 'IconUnlink',
  content: '<path fill="currentColor" d="M14.296 4.818a3.4 3.4 0 1 1 4.808 4.809l-3.111 3.111 1.414 1.414 3.111-3.111a5.4 5.4 0 0 0-7.636-7.637L9.77 6.515l1.415 1.415 3.11-3.112zM9.77 18.96a3.4 3.4 0 1 1-4.808-4.808l3.111-3.111L6.66 9.627l-3.111 3.111a5.4 5.4 0 1 0 7.637 7.637l3.111-3.111-1.414-1.415L9.77 18.96zM9 2v3.692H7V2h2zM5.692 7H2v2h3.692V7zM15 22v-3.692h2V22h-2zm3.308-5H22v-2h-3.692v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUnlock = {
  name: 'IconUnlock',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12 3a4.5 4.5 0 0 0-4.5 4.5V9h11a3 3 0 0 1 3 3v6.5a4 4 0 0 1-4 4h-11a4 4 0 0 1-4-4V12a3 3 0 0 1 3-3V7.5a6.5 6.5 0 0 1 12.924-1h-2.035A4.502 4.502 0 0 0 12 3zm7.5 9a1 1 0 0 0-1-1h-13a1 1 0 0 0-1 1v6.5a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V12zM11 18v-4.5h2V18h-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUnlockSolid = {
  name: 'IconUnlockSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 8v1a3 3 0 0 0-3 3v7a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-7a3 3 0 0 0-3-3H7V8a5 5 0 0 1 9.771-1.5h2.068A7 7 0 0 0 5 8zm6 5.5v5h2v-5h-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUpdateWave = {
  name: 'IconUpdateWave',
  content: '<path fill="currentColor" d="m13.42 14.832-2.83-2.829-2.828 2.829-1.414-1.415 4.243-4.242 2.828 2.828 2.829-2.828 1.414 1.414-4.243 4.242z"/><path fill="currentColor" fill-rule="evenodd" d="M1.006 12.018H1v.015l.001.039.002.06c-.005.23-.002.368-.002.368h.015l.008.159c.017.334.05.798.113 1.137a11.345 11.345 0 0 0 3.616 6.367 11.204 11.204 0 0 0 13.765.887l-1.127-1.652a9.204 9.204 0 0 1-11.31-.73 9.345 9.345 0 0 1-2.978-5.242 7.836 7.836 0 0 1-.082-.871l-.003-.055h2.943l-3-6.5s-1 1.5-1.5 3c-.349 1.045-.435 2.334-.455 3.018zm19.93-.518h-2.942l3 6.5s1-1.5 1.5-3c.349-1.046.435-2.334.455-3.019h.006v-.014l-.002-.039-.001-.06c.005-.23.002-.368.002-.368h-.015l-.008-.159a9.534 9.534 0 0 0-.114-1.137 11.345 11.345 0 0 0-3.615-6.368A11.204 11.204 0 0 0 5.437 2.95l1.126 1.653a9.204 9.204 0 0 1 11.31.73 9.345 9.345 0 0 1 2.98 5.242c.035.191.063.533.08.871l.003.055z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUpgrade = {
  name: 'IconUpgrade',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M13.437 1.547a2 2 0 0 0-2.874-.002L3.715 8.608C2.485 9.876 3.384 12 5.15 12H7l.01 6.003a2 2 0 0 0 2 1.997h5.976a2 2 0 0 0 2-2.003L16.977 12h1.853c1.766 0 2.665-2.121 1.437-3.39l-6.83-7.063zM5.15 10l6.848-7.063L18.83 10h-3.854l.012 8H9.01L9 10H5.15z" clip-rule="evenodd"/><path fill="currentColor" d="M7 23h10v-2H7v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUpgradeSolid = {
  name: 'IconUpgradeSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M7.563 1.545a2 2 0 0 1 2.874.002l6.83 7.063c1.228 1.269.329 3.39-1.437 3.39h-1.852l.009 5.997a2 2 0 0 1-2 2.003H6.01a2 2 0 0 1-2-1.997L4.002 12H2.15C.384 12-.515 9.876.715 8.608l6.848-7.063zM4 23h10v-2H4v2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 18 24'
  },
  width: 18,
  height: 24
};

var dataUpload = {
  name: 'IconUpload',
  content: '<path fill="currentColor" d="M16.83 8.042 13 4.58V15h-2V4.54L7.175 8.039l-1.35-1.476 4.798-4.387a2 2 0 0 1 2.691-.007l4.857 4.39-1.342 1.484z"/><path fill="currentColor" d="M1.8 13v4a5 5 0 0 0 5 5h10.4a5 5 0 0 0 5-5v-4h-2v4a3 3 0 0 1-3 3H6.8a3 3 0 0 1-3-3v-4h-2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUploadDesktop = {
  name: 'IconUploadDesktop',
  content: '<path fill="currentColor" d="M11.855 7.62a.2.2 0 0 1 .29 0l1.992 2.096H13.6v4.59h1.6v-2.99h.777a.81.81 0 0 0 .587-1.368l-3.259-3.43a1.8 1.8 0 0 0-2.61 0l-3.259 3.43a.81.81 0 0 0 .588 1.368H8.8v2.947H12v-1.6h-1.6V9.716h-.536l1.991-2.097z"/><path fill="currentColor" fill-rule="evenodd" d="M2 7a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7zm5-3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7z" clip-rule="evenodd"/><path fill="currentColor" d="M20 21.5H4v-2h16v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUploadDesktopSolid = {
  name: 'IconUploadDesktopSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5 2a5 5 0 0 0-5 5v6a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5H5zm5.145 5.62a.2.2 0 0 0-.29 0L7.863 9.716H8.4v2.947H10v1.6H6.8v-2.947h-.777a.81.81 0 0 1-.587-1.368l3.259-3.43a1.8 1.8 0 0 1 2.61 0l3.259 3.43a.81.81 0 0 1-.587 1.368H13.2v2.99h-1.6v-4.59h.537L10.145 7.62z" clip-rule="evenodd"/><path fill="currentColor" d="M2 21.5h16v-2H2v2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataUser = {
  name: 'IconUser',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M12.125 1.7a5.875 5.875 0 0 0-3.62 10.503A9.253 9.253 0 0 0 2.8 20.75h2a7.25 7.25 0 1 1 14.5 0h2a9.252 9.252 0 0 0-5.609-8.506A5.875 5.875 0 0 0 12.125 1.7zM8.25 7.575a3.875 3.875 0 1 1 7.75 0 3.875 3.875 0 0 1-7.75 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserAuthorization = {
  name: 'IconUserAuthorization',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.825 2a5.875 5.875 0 0 0-3.62 10.503A9.253 9.253 0 0 0 1.5 21.05h2a7.25 7.25 0 0 1 10.316-6.572 5.526 5.526 0 0 1 1.595-1.42 9.235 9.235 0 0 0-1.02-.514A5.875 5.875 0 0 0 10.825 2zM6.95 7.875a3.875 3.875 0 1 1 7.75 0 3.875 3.875 0 0 1-7.75 0z" clip-rule="evenodd"/><path fill="currentColor" d="m23.7 15.913-1.4-1.426-4.95 4.862-2.401-2.712-1.498 1.326 3.799 4.288 6.45-6.338z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserBookmark = {
  name: 'IconUserBookmark',
  content: '<path fill="currentColor" d="M5 1.6A4.9 4.9 0 0 0 .1 6.5v11A4.9 4.9 0 0 0 5 22.4h7v-1.8H5a3.1 3.1 0 0 1-3.1-3.1v-11A3.1 3.1 0 0 1 5 3.4h10a3.1 3.1 0 0 1 3.1 3.1V12h1.8V6.5A4.9 4.9 0 0 0 15 1.6H5z"/><path fill="currentColor" fill-rule="evenodd" d="M7.1 6.07a2.945 2.945 0 0 0-2.318 4.763A4.025 4.025 0 0 0 3.07 14.13h1.86a2.17 2.17 0 1 1 4.34 0h1.86a4.025 4.025 0 0 0-1.713-3.298A2.945 2.945 0 0 0 7.099 6.07zM6.015 9.015a1.085 1.085 0 1 1 2.17 0 1.085 1.085 0 0 1-2.17 0z" clip-rule="evenodd"/><path fill="currentColor" d="M3.2 16.2h7.6v1.6H3.2v-1.6z"/><path fill="currentColor" fill-rule="evenodd" d="M14.1 13.1a1 1 0 0 0-1 1v6.712a1 1 0 0 0 1.56.829l2.027-1.369 1.685 1.048a1 1 0 0 0 1.528-.85V14.1a1 1 0 0 0-1-1h-4.8zm.8 6.207V14.9h3.2v4.131l-.903-.561a1 1 0 0 0-1.087.02l-1.21.817z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataUserBookmarkSolid = {
  name: 'IconUserBookmarkSolid',
  content: '<path fill="currentColor" d="M6.015 9.015a1.085 1.085 0 1 1 2.17 0 1.085 1.085 0 0 1-2.17 0z"/><path fill="currentColor" fill-rule="evenodd" d="M.1 6.5A4.9 4.9 0 0 1 5 1.6h10a4.9 4.9 0 0 1 4.9 4.9V12H14a2 2 0 0 0-2 2v8.4H5a4.9 4.9 0 0 1-4.9-4.9v-11zm7-.43a2.945 2.945 0 0 0-2.318 4.762A4.025 4.025 0 0 0 3.07 14.13h1.86a2.17 2.17 0 1 1 4.34 0h1.86a4.025 4.025 0 0 0-1.713-3.298A2.945 2.945 0 0 0 7.1 6.07zM3.2 16.2h7.6v1.6H3.2v-1.6z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M13.1 14.1a1 1 0 0 1 1-1h4.8a1 1 0 0 1 1 1v6.37a1 1 0 0 1-1.528.85l-1.685-1.048-2.027 1.369a1 1 0 0 1-1.56-.83V14.1zm0 0 .9 5.78v.01l-.9-5.79zm1.059 6.798-.003-.003.002-.002v.005z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataUserCard = {
  name: 'IconUserCard',
  content: '<rect width="20" height="17" x="1" y="3.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" rx="4"/><path stroke="currentColor" stroke-width="1.8" d="M11.087 16A3.043 3.043 0 1 0 5 16"/><path stroke="currentColor" stroke-width="1.8" d="M10.022 10.978a1.978 1.978 0 1 1-3.957 0 1.978 1.978 0 0 1 3.957 0z"/><path stroke="currentColor" stroke-width="2" d="M13.5 10H18m-4.5 4H18"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataUserCardSolid = {
  name: 'IconUserCardSolid',
  content: '<path fill="currentColor" d="M6.965 10.978a1.078 1.078 0 1 1 2.157 0 1.078 1.078 0 0 1-2.157 0z"/><path fill="currentColor" fill-rule="evenodd" d="M7.357 2.5h7.286c1.084 0 1.958 0 2.666.058.729.06 1.369.185 1.961.487a5 5 0 0 1 2.185 2.185c.302.592.428 1.233.487 1.961C22 7.9 22 8.773 22 9.857v4.286c0 1.084 0 1.958-.058 2.666-.06.729-.185 1.369-.487 1.961a5 5 0 0 1-2.185 2.185c-.592.302-1.232.428-1.961.487-.708.058-1.582.058-2.666.058H7.357c-1.084 0-1.958 0-2.666-.058-.728-.06-1.369-.185-1.961-.487A5 5 0 0 1 .545 18.77c-.302-.592-.428-1.232-.487-1.961C0 16.1 0 15.227 0 14.143V9.857C0 8.773 0 7.9.058 7.191c.06-.728.185-1.369.487-1.96A5 5 0 0 1 2.73 3.044c.592-.302 1.233-.428 1.961-.487C5.4 2.5 6.273 2.5 7.357 2.5zm.687 5.6a2.878 2.878 0 0 0-2.257 4.665A3.939 3.939 0 0 0 4.1 16h1.8a2.144 2.144 0 0 1 4.287 0h1.8a3.939 3.939 0 0 0-1.687-3.235A2.878 2.878 0 0 0 8.044 8.1zM18 11h-4.5V9H18v2zm0 4h-4.5v-2H18v2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataUserCircle = {
  name: 'IconUserCircle',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M14.472 12.177a3.955 3.955 0 1 0-4.887-.026A6.001 6.001 0 0 0 6 17.645h2a4 4 0 0 1 8 0h2a6.001 6.001 0 0 0-3.528-5.468zm-4.381-3.122a1.955 1.955 0 1 1 3.909 0 1.955 1.955 0 0 1-3.91 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0-2a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserCircleSolid = {
  name: 'IconUserCircleSolid',
  content: '<path fill="currentColor" d="M12.046 7a2.055 2.055 0 1 0 0 4.109 2.055 2.055 0 0 0 0-4.109z"/><path fill="currentColor" fill-rule="evenodd" d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zM8.191 9.055a3.855 3.855 0 1 1 6.083 3.145 5.902 5.902 0 0 1 3.626 5.445h-1.8a4.1 4.1 0 1 0-8.2 0H6.1a5.902 5.902 0 0 1 3.684-5.47 3.85 3.85 0 0 1-1.593-3.12z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserCombined = {
  name: 'IconUserCombined',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M16.54 11.008a3.5 3.5 0 1 0-5.079 0A4.897 4.897 0 0 0 9.1 15.2h1.8a3.1 3.1 0 1 1 6.2 0h1.8a4.897 4.897 0 0 0-2.361-4.191zM12.3 8.6a1.7 1.7 0 1 1 3.4 0 1.7 1.7 0 0 1-3.4 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M5.2 5.013c-.066.319-.1.649-.1.987v8a4.9 4.9 0 0 0 4.9 4.9h8c.338 0 .669-.034.987-.1l.781.21a3.8 3.8 0 0 0 .096-.477A4.901 4.901 0 0 0 22.9 14V6A4.9 4.9 0 0 0 18 1.1h-8a4.901 4.901 0 0 0-4.533 3.036c-.162.022-.32.055-.476.096l.209.78zM6.9 6A3.1 3.1 0 0 1 10 2.9h8A3.1 3.1 0 0 1 21.1 6v8a3.1 3.1 0 0 1-3.1 3.1h-8A3.1 3.1 0 0 1 6.9 14V6z" clip-rule="evenodd"/><path fill="currentColor" d="M4.05 4.622A3.915 3.915 0 0 0 2.622 6.05l1.558.901c.184-.319.45-.585.77-.77l-.902-1.558zM2.232 6.99A3.904 3.904 0 0 0 2.1 8v1.111h1.8V8c0-.19.025-.372.071-.544L2.232 6.99zM2.1 10.222v2.223h1.8v-2.223H2.1zm0 3.334v2.222h1.8v-2.222H2.1zm0 3.333V18c0 .348.046.686.132 1.01l1.74-.466A2.104 2.104 0 0 1 3.9 18v-1.111H2.1zm.523 3.062a3.914 3.914 0 0 0 1.426 1.427l.902-1.558a2.115 2.115 0 0 1-.77-.77l-1.558.901zm15.328 1.427a3.914 3.914 0 0 0 1.427-1.427l-1.558-.902a2.115 2.115 0 0 1-.77.77l.901 1.559zm-12.961.39A3.93 3.93 0 0 0 6 21.9h1.111v-1.8h-1.11c-.19 0-.373-.025-.545-.071l-.465 1.739zM16 21.9a3.93 3.93 0 0 0 1.01-.132l-.466-1.739A2.106 2.106 0 0 1 16 20.1h-1.11v1.8H16zm-7.778 0h2.223v-1.8H8.221v1.8zm3.334 0h2.222v-1.8h-2.222v1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserCombinedSolid = {
  name: 'IconUserCombinedSolid',
  content: '<path fill="currentColor" d="M12 6.9a1.7 1.7 0 0 0-.011 3.4h.022A1.7 1.7 0 0 0 12 6.9z"/><path fill="currentColor" fill-rule="evenodd" d="M3.1 6.102c-.118.056-.23.122-.334.198L1.707 4.845a3.885 3.885 0 0 1 1.76-.709A4.902 4.902 0 0 1 8 1.1h8A4.9 4.9 0 0 1 20.9 6v8a4.9 4.9 0 0 1-3.036 4.533 3.885 3.885 0 0 1-.709 1.76l-1.455-1.06a2.06 2.06 0 0 0 .198-.333H8A4.9 4.9 0 0 1 3.1 14V6.102zM8.5 8.6c0 .933.365 1.781.96 2.409a4.897 4.897 0 0 0-2.36 4.19h1.8a3.1 3.1 0 0 1 3.087-3.099h.025a3.1 3.1 0 0 1 3.088 3.1h1.8a4.897 4.897 0 0 0-2.36-4.191A3.5 3.5 0 1 0 8.5 8.6z" clip-rule="evenodd"/><path fill="currentColor" d="M2.3 6.766c-.251.346-.4.772-.4 1.234v2H.1V8c0-.856.277-1.65.745-2.293l1.456 1.06zM1.9 15v-4H.1v4h1.8zm0 1v2c0 .462.149.887.4 1.234L.846 20.293A3.886 3.886 0 0 1 .1 18v-2h1.8zM4 20.1c-.462 0-.887-.149-1.234-.4l-1.059 1.455A3.886 3.886 0 0 0 4 21.9h2v-1.8H4zm10 0c.463 0 .888-.149 1.234-.4l1.06 1.455A3.886 3.886 0 0 1 14 21.9h-2v-1.8h2zm-3 0H7v1.8h4v-1.8z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataUserFilter = {
  name: 'IconUserFilter',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M8.5 5.6a3.5 3.5 0 1 1 6.04 2.408A4.897 4.897 0 0 1 16.9 12.2h-1.8a3.1 3.1 0 1 0-6.2 0H7.1c0-1.776.945-3.332 2.36-4.191a3.488 3.488 0 0 1-.96-2.41zM12 3.9a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4z" clip-rule="evenodd"/><path fill="currentColor" d="M4 18.9v-1.8h16v1.8H4zm3 3v-1.8h10v1.8H7zM4 10a1 1 0 0 1 1-1h1.7V7H5a3 3 0 0 0-3 3v2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-2a3 3 0 0 0-3-3h-1.7v2H19a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserFilterSolid = {
  name: 'IconUserFilterSolid',
  content: '<path fill="currentColor" d="M12.6 5.6a2.6 2.6 0 1 1-5.2 0 2.6 2.6 0 0 1 5.2 0z"/><path fill="currentColor" d="M10 8.2a4 4 0 0 0-4 4h8a4 4 0 0 0-4-4z"/><path fill="currentColor" d="M6.252 7H3a3 3 0 0 0-3 3v2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-2a3 3 0 0 0-3-3h-3.252a3.99 3.99 0 0 1-.477.903 5.391 5.391 0 0 1 2.13 4.297v1.4H4.6v-1.4a5.39 5.39 0 0 1 2.128-4.297A3.99 3.99 0 0 1 6.252 7zM18 17.1v1.8H2v-1.8h16zm-3 3v1.8H5v-1.8h10z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataUserIntersection = {
  name: 'IconUserIntersection',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M14.467 12.131a2.9 2.9 0 1 0-3.933 0A3.898 3.898 0 0 0 8.6 15.5h1.8a2.1 2.1 0 1 1 4.2 0h1.8a3.898 3.898 0 0 0-1.933-3.369zM11.4 10a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M19.624 18.624A4.902 4.902 0 0 1 15 21.9H7A4.9 4.9 0 0 1 2.1 17V9a4.902 4.902 0 0 1 3.276-4.624A4.902 4.902 0 0 1 10 1.1h8A4.9 4.9 0 0 1 22.9 6v8a4.902 4.902 0 0 1-3.276 4.624zM5.1 6.55A3.095 3.095 0 0 0 3.9 9v8A3.1 3.1 0 0 0 7 20.1h8c.996 0 1.883-.47 2.45-1.2H10A4.9 4.9 0 0 1 5.1 14V6.55zM7.55 4.1A3.095 3.095 0 0 1 10 2.9h8A3.1 3.1 0 0 1 21.1 6v8c0 .996-.47 1.883-1.2 2.45V9A4.9 4.9 0 0 0 15 4.1H7.55zm-.648 1.802L7 5.9h8A3.1 3.1 0 0 1 18.1 9v8l-.001.099A3.226 3.226 0 0 1 18 17.1h-8A3.1 3.1 0 0 1 6.9 14V6c0-.033 0-.066.002-.098z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserIntersectionSolid = {
  name: 'IconUserIntersectionSolid',
  content: '<path fill="currentColor" d="M9.4 10a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0z"/><path fill="currentColor" fill-rule="evenodd" d="M13 21.9a4.902 4.902 0 0 0 4.624-3.276A4.902 4.902 0 0 0 20.9 14V6A4.9 4.9 0 0 0 16 1.1H8a4.902 4.902 0 0 0-4.624 3.276A4.902 4.902 0 0 0 .1 9v8A4.9 4.9 0 0 0 5 21.9h8zM1.9 9c0-.996.47-1.883 1.2-2.45V14A4.9 4.9 0 0 0 8 18.9h7.45A3.095 3.095 0 0 1 13 20.1H5A3.1 3.1 0 0 1 1.9 17V9zM8 2.9c-.996 0-1.882.47-2.45 1.2H13A4.9 4.9 0 0 1 17.9 9v7.45A3.094 3.094 0 0 0 19.1 14V6A3.1 3.1 0 0 0 16 2.9H8zm2.5 4.2a2.9 2.9 0 0 0-1.966 5.031A3.898 3.898 0 0 0 6.6 15.5h1.8a2.1 2.1 0 1 1 4.2 0h1.8a3.898 3.898 0 0 0-1.933-3.369A2.9 2.9 0 0 0 10.5 7.1z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataUserLabel = {
  name: 'IconUserLabel',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M14.54 11.809a3.5 3.5 0 1 0-5.079 0A4.897 4.897 0 0 0 7.1 16h1.8a3.1 3.1 0 1 1 6.2 0h1.8a4.897 4.897 0 0 0-2.361-4.191zM10.3 9.4a1.7 1.7 0 1 1 3.4 0 1.7 1.7 0 0 1-3.4 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M17.837 1.949a3 3 0 0 1 3.02 2.845l.728 14.154c.109 2.113-1.945 3.672-3.951 2.998l-5.32-1.786a1 1 0 0 0-.633-.001l-5.453 1.805c-2.003.663-4.047-.896-3.938-3.004l.729-14.072A3 3 0 0 1 5.99 2.043l11.846-.094zm1.022 2.948a1 1 0 0 0-1.007-.949l-11.845.095a1 1 0 0 0-.99.948l-.73 14.073a1 1 0 0 0 1.313 1l5.453-1.804a3 3 0 0 1 1.897.004l5.32 1.786a1 1 0 0 0 1.317-1L18.86 4.898z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserLabelSolid = {
  name: 'IconUserLabelSolid',
  content: '<path fill="currentColor" d="M10 7.7a1.7 1.7 0 0 0-.011 3.4h.022A1.7 1.7 0 0 0 10 7.7z"/><path fill="currentColor" fill-rule="evenodd" d="M15.836 1.949a3 3 0 0 1 3.02 2.845l.729 14.154c.109 2.113-1.945 3.672-3.951 2.998l-5.32-1.786a1 1 0 0 0-.633-.001l-5.453 1.805C2.225 22.627.181 21.067.29 18.96l.729-14.072A3 3 0 0 1 3.99 2.043l11.845-.094zM6.5 9.4c0 .933.365 1.781.96 2.409A4.897 4.897 0 0 0 5.1 16h1.8a3.1 3.1 0 0 1 3.087-3.1h.025A3.1 3.1 0 0 1 13.1 16h1.8a4.897 4.897 0 0 0-2.36-4.191A3.5 3.5 0 1 0 6.5 9.4z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataUserMobile = {
  name: 'IconUserMobile',
  content: '<rect width="16" height="20" x="1" y="2" stroke="currentColor" stroke-width="1.8" rx="4"/><path stroke="currentColor" stroke-linecap="square" stroke-width="1.6" d="M6.1 19h6"/><path stroke="currentColor" stroke-width="1.8" d="M13 15.7a4 4 0 1 0-8 0"/><path stroke="currentColor" stroke-width="1.8" d="M11.6 9.1a2.6 2.6 0 1 1-5.2 0 2.6 2.6 0 0 1 5.2 0z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 18 24'
  },
  width: 18,
  height: 24
};

var dataUserMobileSolid = {
  name: 'IconUserMobileSolid',
  content: '<path fill="currentColor" d="M9 7.4a1.7 1.7 0 0 0-.011 3.4h.022A1.7 1.7 0 0 0 9 7.4z"/><path fill="currentColor" fill-rule="evenodd" d="M.1 6A4.9 4.9 0 0 1 5 1.1h8A4.9 4.9 0 0 1 17.9 6v12a4.9 4.9 0 0 1-4.9 4.9H5A4.9 4.9 0 0 1 .1 18V6zm5.4 3.1c0 .933.365 1.781.96 2.409a4.897 4.897 0 0 0-2.36 4.19h1.8A3.1 3.1 0 0 1 8.987 12.6h.026a3.1 3.1 0 0 1 3.087 3.1h1.8a4.897 4.897 0 0 0-2.36-4.191A3.5 3.5 0 1 0 5.5 9.1zm7.4 9.1H5.3v1.6h7.6v-1.6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 18 24'
  },
  width: 18,
  height: 24
};

var dataUserSearch = {
  name: 'IconUserSearch',
  content: '<path fill="currentColor" d="M1.7 6.4v2h1.8v-2a3.1 3.1 0 0 1 3.1-3.1h2V1.5h-2a4.9 4.9 0 0 0-4.9 4.9zm20.6 0v2h-1.8v-2a3.1 3.1 0 0 0-3.1-3.1h-2V1.5h2a4.9 4.9 0 0 1 4.9 4.9zM1.7 15.6v2a4.9 4.9 0 0 0 4.9 4.9h2v-1.8h-2a3.1 3.1 0 0 1-3.1-3.1v-2H1.7z"/><path fill="currentColor" fill-rule="evenodd" d="M14.258 12.42a2.9 2.9 0 1 0-4.516 0A3.895 3.895 0 0 0 8.1 15.6h1.8a2.1 2.1 0 1 1 4.2 0h1.8a3.895 3.895 0 0 0-1.642-3.18zM10.9 10.6a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M4 12a8 8 0 1 1 14.32 4.906l3.308 3.308-1.415 1.414-3.307-3.308A8 8 0 0 1 4 12zm8-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserSearchSolid = {
  name: 'IconUserSearchSolid',
  content: '<path fill="currentColor" d="M.7 6.4v2h1.8v-2a3.1 3.1 0 0 1 3.1-3.1h2V1.5h-2A4.9 4.9 0 0 0 .7 6.4zm20.6 0v2h-1.8v-2a3.1 3.1 0 0 0-3.1-3.1h-2V1.5h2a4.9 4.9 0 0 1 4.9 4.9zM.7 17.6v-2h1.8v2a3.1 3.1 0 0 0 3.1 3.1h2v1.8h-2a4.9 4.9 0 0 1-4.9-4.9zm9.2-7a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0z"/><path fill="currentColor" fill-rule="evenodd" d="M3 12a8 8 0 1 1 14.32 4.906l3.308 3.307-1.415 1.415-3.307-3.308A8 8 0 0 1 3 12zm8-4.3a2.9 2.9 0 0 0-2.258 4.72A3.895 3.895 0 0 0 7.1 15.6h1.8a2.1 2.1 0 1 1 4.2 0h1.8a3.895 3.895 0 0 0-1.642-3.18A2.9 2.9 0 0 0 11 7.7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataUserSettings = {
  name: 'IconUserSettings',
  content: '<g clip-path="url(#dls-60856-a)"><circle cx="9.875" cy="6.875" r="4.125" stroke="currentColor" stroke-width="2"/><path fill="currentColor" fill-rule="evenodd" d="M13.246 22.2H4.375c-2.225 0-4.29-1.54-4.373-3.762v-.022L0 18.304v-.016c0-.372.035-.88.103-1.362.061-.437.17-1.015.384-1.418a3.929 3.929 0 0 1 1.466-1.526c.621-.377 1.352-.618 2.18-.753l1.43-.234c2.893-.472 5.132-.521 7.887-.147-.435.235-.806.59-1.063 1.035l-.465.804c-2.007-.178-3.796-.083-6.036.282l-1.431.234c-.644.105-1.116.277-1.466.49a1.93 1.93 0 0 0-.735.752c0 .002-.01.021-.024.062a2.096 2.096 0 0 0-.05.175 5.422 5.422 0 0 0-.097.523A8.506 8.506 0 0 0 2 18.281l.001.092c.04.884.95 1.827 2.374 1.827h7.356l.599 1.056c.224.395.541.717.916.944z" clip-rule="evenodd"/><path stroke="currentColor" stroke-width="1.8" d="m18.635 14.873.951 1.678a1.94 1.94 0 0 1-.014 1.923l-.978 1.693a1.936 1.936 0 0 1-1.658.974l-1.928.015a1.868 1.868 0 0 1-1.643-.948l-.951-1.678a1.938 1.938 0 0 1 .015-1.923l.977-1.692a1.938 1.938 0 0 1 1.658-.975l1.928-.015a1.868 1.868 0 0 1 1.643.948z"/><circle cx="16" cy="17.6" r="1.3" fill="currentColor"/></g><defs><clipPath id="dls-60856-a"><path fill="currentColor" d="M0 0h21v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataUserSettingsSolid = {
  name: 'IconUserSettingsSolid',
  content: '<path fill="currentColor" d="M9.875 1.75a5.125 5.125 0 1 0 0 10.25 5.125 5.125 0 0 0 0-10.25zm2.713 10.993c-2.377-.254-4.44-.17-7.024.252l-1.432.234c-.827.135-1.558.376-2.18.753a3.932 3.932 0 0 0-1.465 1.526c-.214.403-.323.98-.384 1.418-.068.481-.103.99-.103 1.362v.008l.002.131v.01C.085 20.66 2.15 22.2 4.375 22.2h7.943a2.908 2.908 0 0 1-.391-.537l-1.47-2.593a2.996 2.996 0 0 1 .022-2.972l1.511-2.617a3.05 3.05 0 0 1 .598-.738zM17.3 17.6a1.3 1.3 0 1 1-2.6 0 1.3 1.3 0 0 1 2.6 0z"/><path fill="currentColor" fill-rule="evenodd" d="M16.985 13.025a2.768 2.768 0 0 1 2.433 1.405l.952 1.677a2.838 2.838 0 0 1-.019 2.817l-.977 1.693a2.838 2.838 0 0 1-2.43 1.424l-1.929.015a2.768 2.768 0 0 1-2.433-1.404l-.95-1.678a2.838 2.838 0 0 1 .018-2.817l.977-1.693a2.838 2.838 0 0 1 2.43-1.424l1.928-.015zm.868 2.292a.968.968 0 0 0-.853-.492l-1.929.015a1.038 1.038 0 0 0-.885.524l-.978 1.693a1.039 1.039 0 0 0-.011 1.03l.951 1.677a.968.968 0 0 0 .853.492l1.929-.015c.356-.003.697-.198.885-.524l.977-1.693c.188-.326.188-.719.012-1.029l-.951-1.678z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 21 24'
  },
  width: 21,
  height: 24
};

var dataUserSolid = {
  name: 'IconUserSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.125 1.7a5.875 5.875 0 0 0-3.62 10.503A9.253 9.253 0 0 0 .8 20.75v1h18.5v-1a9.252 9.252 0 0 0-5.61-8.506A5.875 5.875 0 0 0 10.125 1.7z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataUserStar = {
  name: 'IconUserStar',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.875 1.75a5.125 5.125 0 1 0 0 10.25 5.125 5.125 0 0 0 0-10.25zM8.75 6.875a3.125 3.125 0 1 1 6.25 0 3.125 3.125 0 0 1-6.25 0z" clip-rule="evenodd"/><path fill="currentColor" d="M7.886 14.97c2.12-.347 3.835-.45 5.715-.31l1.603-.335.84-1.392c-3.036-.464-5.384-.443-8.48.062l-1.432.234c-.827.135-1.558.377-2.18.753a3.93 3.93 0 0 0-1.465 1.526c-.214.403-.323.981-.384 1.418-.068.481-.103.99-.103 1.362v.008l.002.131v.011C2.085 20.66 4.15 22.2 6.375 22.2h6.815l.21-2H6.375c-1.425 0-2.335-.943-2.374-1.827L4 18.281c0-.27.028-.68.083-1.076.028-.197.061-.377.097-.523a2.096 2.096 0 0 1 .074-.237c.155-.292.39-.544.735-.752.35-.213.822-.385 1.466-.49l1.431-.234z"/><path fill="currentColor" fill-rule="evenodd" d="M19.21 13.289a1.4 1.4 0 0 0-2.42 0l-.984 1.69-1.913.415a1.4 1.4 0 0 0-.747 2.3l1.303 1.46-.197 1.946a1.4 1.4 0 0 0 1.958 1.422l1.79-.788 1.79.788a1.4 1.4 0 0 0 1.958-1.422l-.197-1.946 1.303-1.46a1.4 1.4 0 0 0-.747-2.3l-1.912-.415-.985-1.69zm-1.938 2.749.728-1.25.728 1.25c.198.34.53.58.913.663l1.414.306-.964 1.079a1.4 1.4 0 0 0-.349 1.074l.146 1.438-1.324-.583a1.4 1.4 0 0 0-1.128 0l-1.324.583.146-1.438a1.4 1.4 0 0 0-.35-1.074l-.963-1.078 1.414-.307a1.4 1.4 0 0 0 .913-.663z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserSync = {
  name: 'IconUserSync',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.973 1C5.953 1 1.092 5.936 1.092 12h2c0-4.982 3.987-9 8.881-9a8.813 8.813 0 0 1 6.785 3.192l-.576.333a.5.5 0 0 0 .048.89l2.803 1.241a.5.5 0 0 0 .698-.391l.413-3.098a.5.5 0 0 0-.746-.499l-.887.512C18.521 2.638 15.44 1 11.973 1zm11.119 11c0 6.064-4.86 11-10.882 11-3.465 0-6.548-1.638-8.538-4.18l-.887.512a.5.5 0 0 1-.746-.5l.413-3.097a.5.5 0 0 1 .698-.391l2.804 1.24a.5.5 0 0 1 .047.89l-.576.334C7.057 19.763 9.493 21 12.21 21c4.894 0 8.882-4.018 8.882-9h2zm-11.103-.4h.022a1.7 1.7 0 1 0-.022 0zm-2.528.709a3.5 3.5 0 1 1 5.079 0A4.897 4.897 0 0 1 16.9 16.5h-1.8a3.1 3.1 0 0 0-3.087-3.1h-.026A3.1 3.1 0 0 0 8.9 16.5H7.1c0-1.777.945-3.332 2.36-4.191z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataUserSyncSolid = {
  name: 'IconUserSyncSolid',
  content: '<g fill="currentColor" clip-path="url(#dls-ed97b-a)"><path d="M.092 12c0-6.064 4.861-11 10.881-11 3.467 0 6.548 1.638 8.538 4.18l.887-.512a.5.5 0 0 1 .746.499l-.413 3.098a.5.5 0 0 1-.698.391L17.23 7.415a.5.5 0 0 1-.048-.89l.576-.333A8.813 8.813 0 0 0 10.973 3c-4.894 0-8.881 4.018-8.881 9h-2zM11.21 23c6.022 0 10.882-4.936 10.882-11h-2c0 4.982-3.988 9-8.882 9-2.717 0-5.153-1.237-6.785-3.192l.576-.334a.5.5 0 0 0-.047-.89l-2.804-1.24a.5.5 0 0 0-.698.391l-.413 3.097a.5.5 0 0 0 .746.5l.887-.512C4.662 21.362 7.745 23 11.21 23z"/><path d="M7.555 10.515a3.5 3.5 0 0 0 .906 1.794H8.46A4.895 4.895 0 0 0 6.1 16.5h9.8a4.895 4.895 0 0 0-2.36-4.191 3.5 3.5 0 1 0-5.985-1.794z"/></g><defs><clipPath id="dls-ed97b-a"><path fill="currentColor" d="M0 0h22v24H0z"/></clipPath></defs>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataUserTieba = {
  name: 'IconUserTieba',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M2.422 6.4a4.378 4.378 0 1 1 6.99 3.513c1.403.83 2.36 2.306 2.36 4.037v.002l.028 7.644-2 .008-.028-7.649v-.003c0-1.464-1.28-2.752-2.986-2.752-1.707 0-2.986 1.288-2.986 2.752V21.6h-2v-7.648c0-1.739.963-3.22 2.376-4.048A4.371 4.371 0 0 1 2.422 6.4zM6.8 3.978a2.422 2.422 0 1 0 0 4.844 2.422 2.422 0 0 0 0-4.844zM16.5 2.5V10h-.7a3 3 0 0 0-3 3v5.7a3 3 0 0 0 3 3h3.6a3 3 0 0 0 3-3V13a3 3 0 0 0-3-3h-.9V7.5H22v-2h-3.5v-3h-2zm-.7 9.5a1 1 0 0 0-1 1v5.7a1 1 0 0 0 1 1h3.6a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1h-3.6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataVideo = {
  name: 'IconVideo',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 8a5 5 0 0 1 5-5h8a5.002 5.002 0 0 1 4.902 4.008l1.184-.795c1.33-.89 3.114.062 3.114 1.662v8.215c0 1.614-1.813 2.563-3.14 1.644l-1.148-.796A5.002 5.002 0 0 1 13 21H5a5 5 0 0 1-5-5V8zm18 6.565V9.35l2.2-1.475v8.215L18 14.565zM5 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H5zm1.5 4.45a1 1 0 0 1 1.567-.824l3.708 2.55a1 1 0 0 1 0 1.648l-3.708 2.55a1 1 0 0 1-1.567-.825V9.451z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 23 24'
  },
  width: 23,
  height: 24
};

var dataVideoAdd = {
  name: 'IconVideoAdd',
  content: '<path fill="currentColor" d="M31.277 1.845v4.432h-4.432v2.4h4.432V13.2h2.4V8.677H38.2v-2.4h-4.523V1.845h-2.4z"/><path fill="currentColor" d="M4.2 11A4.8 4.8 0 0 1 9 6.2h14V3.8H9A7.2 7.2 0 0 0 1.8 11v18A7.2 7.2 0 0 0 9 36.2h22a7.2 7.2 0 0 0 7.2-7.2V17h-2.4v12a4.8 4.8 0 0 1-4.8 4.8H9A4.8 4.8 0 0 1 4.2 29V11z"/><path fill="currentColor" fill-rule="evenodd" d="M18.319 12.609c-1.35-.928-3.186.038-3.186 1.675v11.498c0 1.638 1.837 2.604 3.186 1.676l8.362-5.75a2.033 2.033 0 0 0 0-3.35l-8.362-5.75zm-.786 12.476V14.981l7.349 5.052-7.349 5.052z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 40 40'
  },
  width: 40,
  height: 40
};

var dataVideoCrop = {
  name: 'IconVideoCrop',
  content: '<path fill="currentColor" d="M5 16V1H3v2H1v2h2v11a5 5 0 0 0 5 5h9.5v-2H8a3 3 0 0 1-3-3z"/><path fill="currentColor" d="M21 21h2v-2h-2V8a5 5 0 0 0-5-5H6.5v2H16a3 3 0 0 1 3 3v15h2v-2z"/><path fill="currentColor" fill-rule="evenodd" d="M11.236 8.38A1.3 1.3 0 0 0 9.2 9.45v5.1a1.3 1.3 0 0 0 2.037 1.07l3.708-2.549a1.3 1.3 0 0 0 0-2.142l-3.709-2.55zM13.68 12l-2.88 1.98v-3.96L13.679 12z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataVideoCropSolid = {
  name: 'IconVideoCropSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M4 1v15a3 3 0 0 0 3 3h9.5v2H7a5 5 0 0 1-5-5V5H0V3h2V1h2zm18 20h-2v2h-2V8a3 3 0 0 0-3-3H5.5V3H15a5 5 0 0 1 5 5v11h2v2zM5.2 8.2a2 2 0 0 1 2-2h7.5a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2H7.2a2 2 0 0 1-2-2V8.2zM9 9.792a.9.9 0 0 1 1.416-.737l3.011 2.108a.9.9 0 0 1 0 1.474l-3.01 2.108A.9.9 0 0 1 9 14.008V9.792z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataVideoFilm = {
  name: 'IconVideoFilm',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M11.036 8.38A1.3 1.3 0 0 0 9 9.45v5.1a1.3 1.3 0 0 0 2.036 1.07l3.709-2.549a1.3 1.3 0 0 0 0-2.142l-3.709-2.55zm-.436 5.6v-3.96L13.479 12l-2.88 1.98z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M1.5 17.5a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11a5 5 0 0 0-5 5v11zm4.2 2.892A3.001 3.001 0 0 1 3.5 17.5v-1.2h2.2v4.092zM5.7 8.2V3.608A3.001 3.001 0 0 0 3.5 6.5v1.7h2.2zm0 1.6H3.5v4.9h2.2V9.8zm1.6 10.7h9.4v-17H7.3v17zm13.2-3a3 3 0 0 1-2.2 2.892V16.3h2.2v1.2zm-2.2-2.8V9.8h2.2v4.9h-2.2zm0-11.092V8.2h2.2V6.5a3 3 0 0 0-2.2-2.892z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataVideoFilmSolid = {
  name: 'IconVideoFilmSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M.5 5.5a4 4 0 0 1 4-4h13a4 4 0 0 1 4 4v13a4 4 0 0 1-4 4h-13a4 4 0 0 1-4-4v-13zm9.367 3.126a1 1 0 0 0-1.567.825v5.098a1 1 0 0 0 1.567.825l3.708-2.55a1 1 0 0 0 0-1.648l-3.708-2.55zM3.5 4a.5.5 0 0 0-.5.5V6a.5.5 0 0 0 .5.5H5a.5.5 0 0 0 .5-.5V4.5A.5.5 0 0 0 5 4H3.5zm0 4.5A.5.5 0 0 0 3 9v1.5a.5.5 0 0 0 .5.5H5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5H3.5zm-.5 5a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .5.5V15a.5.5 0 0 1-.5.5H3.5A.5.5 0 0 1 3 15v-1.5zm.5 4a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5H5a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5H3.5zm13-13A.5.5 0 0 1 17 4h1.5a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5H17a.5.5 0 0 1-.5-.5V4.5zm.5 4a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5H17zm-.5 5a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5V15a.5.5 0 0 1-.5.5H17a.5.5 0 0 1-.5-.5v-1.5zm.5 4a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5H17z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataVideoFrameFirst = {
  name: 'IconVideoFrameFirst',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M5.001 2v5h2l-3 3-3-3h2V2h2zm-2 20v-5H1l3-3 3 3H5v5H3zm7-20h-1v5h2V4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-8v-3h-2v5h10a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4h-9zm-1 7h2v2H9V9zm2 4H9v2h2v-2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataVideoHistory = {
  name: 'IconVideoHistory',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.514 6.143A1 1 0 0 0 9 7v6a1 1 0 0 0 1.514.857l5-3a1 1 0 0 0 0-1.714l-5-3zM13.056 10 11 11.234V8.766L13.056 10z" clip-rule="evenodd"/><path fill="currentColor" d="M9.5 18H6v-2h3.5v2zm1.5 0h7v-2h-7v2z"/><path fill="currentColor" fill-rule="evenodd" d="M7 1a5 5 0 0 0-5 5v12a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5H7zM4 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataVideoHistorySolid = {
  name: 'IconVideoHistorySolid',
  content: '<path fill="currentColor" d="M11.056 10 9 11.234V8.766L11.056 10z"/><path fill="currentColor" fill-rule="evenodd" d="M0 6a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v12a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V6zm8.514.143A1 1 0 0 0 7 7v6a1 1 0 0 0 1.514.857l5-3a1 1 0 0 0 0-1.714l-5-3zM4 18h3.5v-2H4v2zm12 0H9v-2h7v2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 20 24'
  },
  width: 20,
  height: 24
};

var dataVideoSolid = {
  name: 'IconVideoSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M0 8a5 5 0 0 1 5-5h8a5.002 5.002 0 0 1 4.902 4.008l1.963-1.317c.996-.668 2.335.046 2.335 1.246v10.108c0 1.21-1.36 1.922-2.354 1.233l-1.934-1.34A5.002 5.002 0 0 1 13 21H5a5 5 0 0 1-5-5V8zm6.7 1.45a1 1 0 0 1 1.567-.824l3.708 2.55a1 1 0 0 1 0 1.648l-3.708 2.55a1 1 0 0 1-1.567-.825V9.451z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 23 24'
  },
  width: 23,
  height: 24
};

var dataVideoUpload = {
  name: 'IconVideoUpload',
  content: '<path fill="currentColor" d="M18.185.83h2v2.955H23.2v2h-3.015V8.8h-2V5.785H15.23v-2h2.955V.83z"/><path fill="currentColor" d="M1 7a5 5 0 0 1 5-5h7v2H6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5.934h2V17a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V7z"/><path fill="currentColor" fill-rule="evenodd" d="M10.954 8.1C9.69 7.26 8 8.165 8 9.683v5.443c0 1.542 1.74 2.442 2.998 1.55l3.96-2.804a1.9 1.9 0 0 0-.045-3.13l-3.96-2.64zM10 14.933V9.869l3.682 2.454L10 14.932z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataVolume = {
  name: 'IconVolume',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.412 3.263c1.604-1.468 4.188-.33 4.188 1.844v13.786c0 2.174-2.584 3.312-4.188 1.844l-2.7-2.473H4.6a3 3 0 0 1-3-3V8.735a3 3 0 0 1 3-3h3.111l2.7-2.472zM12.6 5.107a.5.5 0 0 0-.838-.369L8.49 7.735H4.6a1 1 0 0 0-1 1v6.53a1 1 0 0 0 1 1h3.89l3.273 2.997a.5.5 0 0 0 .838-.37V5.108z" clip-rule="evenodd"/><path fill="currentColor" d="M17.472 12.322c0-.76-.474-1.7-1.866-2.814l1.187-1.483c1.572 1.257 2.58 2.686 2.58 4.297 0 1.611-1.008 3.04-2.58 4.298l-1.186-1.484c1.39-1.113 1.865-2.054 1.865-2.814z"/><path fill="currentColor" d="M18.028 6.772c1.97 1.97 2.833 3.817 2.833 5.55 0 1.733-.862 3.58-2.833 5.55l1.344 1.344c2.177-2.178 3.389-4.479 3.389-6.894s-1.212-4.716-3.39-6.894l-1.343 1.344z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataVolumeSolid = {
  name: 'IconVolumeSolid',
  content: '<path fill="currentColor" d="M9.412 3.263c1.604-1.468 4.188-.33 4.188 1.844v13.786c0 2.174-2.584 3.312-4.188 1.844l-2.7-2.472H3.6a3 3 0 0 1-3-3v-6.53a3 3 0 0 1 3-3h3.111l2.7-2.472zm10.449 9.059c0-1.733-.862-3.58-2.833-5.55l1.344-1.344c2.177 2.178 3.39 4.48 3.39 6.894 0 2.415-1.213 4.717-3.39 6.894l-1.344-1.343c1.97-1.97 2.833-3.817 2.833-5.55z"/><path fill="currentColor" d="M16.472 12.322c0-.759-.474-1.7-1.865-2.813l1.187-1.484c1.571 1.257 2.578 2.686 2.578 4.297 0 1.611-1.007 3.04-2.578 4.298l-1.187-1.484c1.39-1.113 1.865-2.054 1.865-2.814z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataWhirlpool = {
  name: 'IconWhirlpool',
  content: '<path fill="currentColor" d="M8 12.001V12H3l5 .001z"/><path fill="currentColor" fill-rule="evenodd" d="M10 12.002a2 2 0 0 0 4 0l2 .001a4 4 0 0 1-8-.002h2zm0 0V12h4v.003l-4-.001z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9 8.97 8.97 0 0 0-6.189 2.466A7.953 7.953 0 0 1 8.5 5c4.065 0 7.5 3.06 7.5 7h-2v-.003A2 2 0 0 0 10 12H8a4 4 0 0 1 3.809-3.996A5.812 5.812 0 0 0 8.5 7C5.385 7 3 9.312 3 12z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataWhirlpoolSolid = {
  name: 'IconWhirlpoolSolid',
  content: '<path fill="currentColor" d="M2.608 4.888A10.976 10.976 0 0 1 11 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 18.075 0 12c0-3.25 2.844-6 6.5-6 1.956 0 3.679.787 4.859 2.016A4 4 0 1 0 15 12c0-4.482-3.871-8-8.5-8-1.394 0-2.72.32-3.892.888z"/><path fill="currentColor" d="M11 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataWoman = {
  name: 'IconWoman',
  content: '<path fill="currentColor" d="M3.148 9.82a8.82 8.82 0 0 1 17.638 0v3.574c0 .64.263 1.492.527 2.162.343.872.05 1.944-.837 2.45l-2.554 1.46-.946-1.656 2.554-1.459.003-.003a.06.06 0 0 0 .009-.017.114.114 0 0 0-.004-.076c-.275-.7-.659-1.837-.659-2.86V9.818a6.912 6.912 0 1 0-13.824 0v3.575c0 1.054-.412 2.428-.687 3.244a.068.068 0 0 0 .002.048l.007.01c0 .001 0 .002.002.002l2.482 1.064-.752 1.752-2.481-1.063c-.957-.41-1.382-1.485-1.067-2.421.28-.833.587-1.933.587-2.636V9.82z"/><path fill="currentColor" fill-rule="evenodd" d="M11.205 4.813h1.525v.014l.002.064a8.437 8.437 0 0 0 .148 1.205c.154.775.455 1.737 1.035 2.574.494.714 1.36 1.084 2.22 1.26.41.083.788.116 1.066.127h.773v1.43a6.006 6.006 0 1 1-12.013 0v-1.43h.699c.232-.01.553-.043.914-.124.745-.168 1.607-.535 2.243-1.312.683-.835 1.034-1.788 1.213-2.551a7.106 7.106 0 0 0 .172-1.184c.002-.028.002-.05.002-.061v-.012zm-3.719 6.69a4.481 4.481 0 0 0 8.962.022 8.036 8.036 0 0 1-.618-.1c-1.01-.207-2.344-.695-3.17-1.887a7.447 7.447 0 0 1-.75-1.39c-.232.48-.53.97-.912 1.439-.925 1.13-2.143 1.62-3.088 1.834-.147.033-.289.06-.424.082z" clip-rule="evenodd"/><path fill="currentColor" d="M12.068 20.547c2.43.024 4.775.89 6.636 2.45l.003.003 1.227-1.462-.003-.003a12.39 12.39 0 0 0-14.17-1.232c-.55.318-1.077.68-1.576 1.083l1.198 1.485.002-.001a10.486 10.486 0 0 1 6.683-2.323z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataYaoSquare = {
  name: 'IconYaoSquare',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M6.5 1.5a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h11a5 5 0 0 0 5-5v-11a5 5 0 0 0-5-5h-11zm-3 5a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3v-11zm9.306-.604-1.85-.646-.076.155c-.844 1.746-1.583 3.07-2.218 3.978-.317.455-.604.799-.862 1.039-.26.242-.473.362-.642.396l-.187.038.338 1.796.173-.014a53.16 53.16 0 0 0 3.392-.37 45.167 45.167 0 0 1-2.59 2.72c-.475.421-.91.687-1.308.811l-.176.055.48 1.853.16-.011c3.133-.212 5.756-.54 7.866-.974.169.44.336.9.493 1.358l.058.17 1.743-.45-.068-.198c-.694-2.016-1.483-3.816-2.37-5.388l-.078-.138-1.684.556.11.204c.38.697.736 1.417 1.07 2.16a69.21 69.21 0 0 1-4.276.613c1.535-1.493 3.393-3.746 5.55-6.752l.134-.186-1.723-.853-.094.139a51.18 51.18 0 0 1-1.67 2.32c-.88.178-1.77.31-2.67.41.98-1.305 1.937-2.836 2.87-4.591l.105-.2z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataYingxiaotong = {
  name: 'IconYingxiaotong',
  content: '<path fill="currentColor" d="M3 3v2h12.5a4.5 4.5 0 1 1 0 9H9.286v2H15.5a6.5 6.5 0 1 0 0-13H3z"/><path fill="currentColor" d="M21 21v-2H8.5a4.5 4.5 0 1 1 0-9h6.214V8H8.5a6.5 6.5 0 1 0 0 13H21z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataYingxiaotongSolid = {
  name: 'IconYingxiaotongSolid',
  content: '<path fill="currentColor" d="M2 2.5v3h12.5a4 4 0 0 1 0 8H8.286v3H14.5a7 7 0 1 0 0-14H2z"/><path fill="currentColor" d="M20 21.5v-3H7.5a4 4 0 0 1 0-8h6.214v-3H7.5a7 7 0 1 0 0 14H20z"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataZoomIn = {
  name: 'IconZoomIn',
  content: '<path fill="currentColor" d="M6.785 10.282v1.8h3.497v3.568h1.8v-3.568h3.568v-1.8h-3.568V6.785h-1.8v3.497H6.785z"/><path fill="currentColor" fill-rule="evenodd" d="M11.2 1.4c-5.412 0-9.8 4.388-9.8 9.8 0 5.412 4.388 9.8 9.8 9.8a9.76 9.76 0 0 0 6.187-2.2l3.473 3.419 1.403-1.425-3.462-3.408A9.76 9.76 0 0 0 21 11.2c0-5.412-4.388-9.8-9.8-9.8zm-7.8 9.8a7.8 7.8 0 1 1 15.6 0 7.8 7.8 0 0 1-15.6 0z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataZoomInSolid = {
  name: 'IconZoomInSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.2 1.4C4.788 1.4.4 5.788.4 11.2c0 5.412 4.388 9.8 9.8 9.8a9.76 9.76 0 0 0 6.187-2.2l3.473 3.419 1.403-1.425-3.462-3.408A9.76 9.76 0 0 0 20 11.2c0-5.412-4.388-9.8-9.8-9.8zm-.918 8.882V6.786h1.8v3.496h3.568v1.8h-3.568v3.568h-1.8v-3.568H5.785v-1.8h3.497z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

var dataZoomOut = {
  name: 'IconZoomOut',
  content: '<path fill="currentColor" d="M6.786 10.282h8.864v1.8H6.786v-1.8z"/><path fill="currentColor" fill-rule="evenodd" d="M1.4 11.2c0-5.412 4.388-9.8 9.8-9.8 5.412 0 9.8 4.388 9.8 9.8a9.76 9.76 0 0 1-2.199 6.186l3.462 3.408-1.403 1.425-3.473-3.419A9.76 9.76 0 0 1 11.2 21c-5.412 0-9.8-4.388-9.8-9.8zm9.8-7.8a7.8 7.8 0 1 0 0 15.6 7.8 7.8 0 0 0 0-15.6z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24'
  },
  width: 24,
  height: 24
};

var dataZoomOutSolid = {
  name: 'IconZoomOutSolid',
  content: '<path fill="currentColor" fill-rule="evenodd" d="M10.2 1.4C4.788 1.4.4 5.788.4 11.2c0 5.412 4.388 9.8 9.8 9.8a9.76 9.76 0 0 0 6.187-2.2l3.473 3.419 1.403-1.425-3.462-3.408A9.76 9.76 0 0 0 20 11.2c0-5.412-4.388-9.8-9.8-9.8zm-4.414 8.882h8.864v1.8H5.785v-1.8z" clip-rule="evenodd"/>',
  attributes: {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 22 24'
  },
  width: 22,
  height: 24
};

export { dataAbTest, dataAbTestSolid, dataAbstract, dataAbstractSolid, dataAcademicCap, dataAcademicCapSolid, dataAdDeliveryCircleSolid, dataAddPauseSquare, dataAdjust, dataAfterSquare, dataAfterSquareSolid, dataAi, dataAiBubble, dataAiBubbleSolid, dataAlignBottom, dataAlignCenter, dataAlignLeft, dataAlignRight, dataAlignTop, dataAndroid, dataAnticlockwise, dataAppStore, dataApps, dataAppsSettings, dataAppsSettingsSolid, dataAppsSolid, dataArrowCurveDownRightSolid, dataArrowCurveUpRightSolid, dataArrowDown, dataArrowDownLeft, dataArrowDownRight, dataArrowDownSolid, dataArrowLeft, dataArrowLeftSolid, dataArrowRight, dataArrowRightSolid, dataArrowToBottom, dataArrowToTop, dataArrowToTopSoild, dataArrowToTopSolid, dataArrowUUpLeft, dataArrowUUpRight, dataArrowUp, dataArrowUpSolid, dataAsterisk, dataAttribute, dataAttributeSolid, dataAudio, dataAudioSolid, dataBabyBottle, dataBabyBottleSolid, dataBackground, dataBackgroundSolid, dataBackgroundSwitchSolid, dataBarChart, dataBarChartAlt, dataBarChartAltSolid, dataBarChartSolid, dataBarChartSquare, dataBarChartSquareSolid, dataBeforeSquare, dataBeforeSquareSolid, dataBell, dataBellSolid, dataBold, dataBook, dataBookBookmark, dataBookBookmarkCheckSolid, dataBookBookmarkSolid, dataBookOpen, dataBookSolid, dataBookmark, dataBookmarkSolid, dataBooksBookmark, dataBooksBookmarkSolid, dataBox, dataBoxSolid, dataBrush, dataBuilding, dataBuildingSolid, dataBulb, dataBulbDash, dataBulbDashSolid, dataBulbSolid, dataBulbTrendSolid, dataBullseye, dataBullseyeHit, dataBullseyeHitSolid, dataCalendar, dataCalendarCny, dataCalendarCnySolid, dataCalendarHeart, dataCalendarHeartSolid, dataCalendarSolid, dataCamera, dataCameraAdd, dataCameraAddSolid, dataCameraSolid, dataCar, dataCarSolid, dataCardSolid, dataCaretDown, dataCaretLeft, dataCaretRight, dataCaretUp, dataCaretsOpposite, dataCellphone, dataCellphoneSolid, dataChat, dataChatSolid, dataCheck, dataCheckCircle, dataCheckCircleSolid, dataCheckDesktop, dataCheckDesktopSolid, dataCheckSquare, dataCheckSquareSolid, dataChevronDoubleDown, dataChevronDoubleLeft, dataChevronDoubleRight, dataChevronDoubleUp, dataChevronDown, dataChevronLeft, dataChevronLeftCircle, dataChevronLeftCircleSolid, dataChevronRight, dataChevronRightCircle, dataChevronRightCircleSolid, dataChevronUp, dataCircleExtend, dataCircleExtendSolid, dataCircleRotation, dataCircleRotationSolid, dataClock, dataClockSolid, dataClockwise, dataCloudUploadSolid, dataCnyCircle, dataCnyCircleSolid, dataCnyRefund, dataCnyWallet, dataCnyWalletSolid, dataCoin, dataCoinDiamond, dataCoinDiamondSolid, dataCoinSolid, dataColorPalette, dataColorPaletteSolid, dataCompass, dataCompassSolid, dataComponent, dataComponentSolid, dataCopy, dataCopySolid, dataCouponMinus, dataCouponMinusSolid, dataCouponPercent, dataCouponPercentSolid, dataCrop, dataCropSolid, dataCrown, dataCrownSolid, dataCube, dataCubeEye, dataCubeEyeSolid, dataCubeSolid, dataCurveSquare, dataCurveSquareSolid, dataCustomer, dataCustomerService, dataCustomerSettings, dataCustomerSettingsSolid, dataCustomerSolid, dataCut, dataCutSolid, dataData, dataDataMarket, dataDataMarketSolid, dataDataSolid, dataDatabase, dataDatabaseSolid, dataDecreaseWidth, dataDesktop, dataDesktopSolid, dataDetailList, dataDetailListSolid, dataDiamond, dataDiamondSolid, dataDollarCircle, dataDollarCircleSolid, dataDoubleCircle, dataDoubleCircleSolid, dataDownload, dataDragIndicator, dataEdit, dataEditSolid, dataElement, dataElementSolid, dataEllipsis, dataEllipsisCircle, dataEllipsisCircleSolid, dataEllipsisVertical, dataEnglishComment, dataEnglishCommentSolid, dataEnvelope, dataEnvelopeOpen, dataEnvelopeOpenSolid, dataEnvelopeSolid, dataExcellentBookmark, dataExcellentBookmarkSolid, dataExclamationCircle, dataExclamationCircleSolid, dataExclamationTriangle, dataExclamationTriangleSolid, dataExpand, dataExpandAlt, dataExpandSquare, dataExpandSquareSolid, dataExternalLink, dataEye, dataEyeBright, dataEyeBrightSolid, dataEyeSlash, dataEyeSlashSolid, dataEyeSolid, dataEyeTracking, dataEyeTrackingSolid, dataEyedropper, dataFastForward, dataFastRewind, dataFeed, dataFeedSolid, dataFeedbackSolid, dataFile, dataFileAdd, dataFileAddSolid, dataFileEdit, dataFileEditSolid, dataFileError, dataFileErrorSolid, dataFileSolid, dataFilm, dataFilmSolid, dataFilter, dataFilterSolid, dataFireSolid, dataFitWidth, dataFlag, dataFlagSolid, dataFolder, dataFolderDownload, dataFolderDownloadSolid, dataFolderOpen, dataFolderOpenSolid, dataFolderSolid, dataFont, dataFontSize, dataFourDots, dataFourQuarterCircles, dataFourQuarterCirclesSolid, dataFrowningFace, dataFrowningFaceSolid, dataFullCircle, dataFullCircleSolid, dataFullscreen, dataFullscreenExit, dataGallery, dataGallerySolid, dataGamepad, dataGamepadSolid, dataGateway, dataGatewaySolid, dataGift, dataGiftSolid, dataGirl, dataGirlSolid, dataGradeCircle, dataGradeCircleSolid, dataHamburger, dataHammerSolid, dataHeadphones, dataHeadphonesSolid, dataHeart, dataHeartCancel, dataHeartCancelSolid, dataHeartHandshakeSolid, dataHeartSolid, dataHeteronymSquare, dataHexagonSolid, dataHierarchy, dataHierarchySolid, dataHighSquare, dataHighSquareSolid, dataHome, dataHomeAltSolid, dataHomeSolid, dataHospital, dataHospitalSolid, dataHourglass, dataHourglassSolid, dataHouse, dataHouseSolid, dataIdCard, dataIdCardBack, dataIdCardBackSolid, dataIdCardSolid, dataIdCircle, dataIdSquare, dataImage, dataImageAdd, dataImageDesktopSolid, dataImageSolid, dataImageStar, dataImageStarSolid, dataImageUpload, dataImport, dataIndent, dataInfoCircle, dataInfoCircleSolid, dataInfoflow, dataIntelligence, dataIntelligenceSolid, dataIntelligentPrompt, dataInvoice, dataInvoiceSolid, dataItalic, dataKeyCommand, dataKeyDelete, dataKeyShift, dataKeyboard, dataLandingPageSolid, dataLayer, dataLayerSolid, dataLayout, dataLayoutSolid, dataLetterSpacing, dataLightning, dataLightningSolid, dataLineChart, dataLineChartAlt, dataLineChartAltSolid, dataLineChartSolid, dataLineHeight, dataLink, dataLinkAlt, dataLinkAltSolid, dataListChecked, dataListOrdered, dataListUnordered, dataLoading, dataLocation, dataLocationCopy, dataLocationCopySolid, dataLocationPin, dataLocationPinSolid, dataLocationSolid, dataLock, dataLockSolid, dataLongVideo, dataLongVideoSolid, dataLowSquare, dataLowSquareSolid, dataMagicWand, dataMagicWandSolid, dataMagnet, dataMagnetSolid, dataMarket, dataMarketSolid, dataMediaAdd, dataMedicalKit, dataMedicalKitSolid, dataMediumSquare, dataMediumSquareSolid, dataMenu, dataMigrate, dataMigrateSolid, dataMiniAppBaidu, dataMiniAppBaiduSolid, dataMiniAppWechat, dataMinimize, dataMinus, dataMinusCircle, dataMinusCircleSolid, dataMobileApp, dataMobileAppSolid, dataMotionGraphics, dataMove, dataMovieSolid, dataMusic, dataMusicSolid, dataMute, dataMuteSolid, dataNeutralFace, dataNeutralFaceSolid, dataOneToOne, dataOneToOneSolid, dataOrder, dataOrderSolid, dataOutdent, dataOutstanding, dataOutstandingSolid, dataPackageUpload, dataPackageUploadSolid, dataPaintBucket, dataPaintBucketSolid, dataPaperClip, dataPaperPlane, dataPaperPlaneSend, dataPaperPlaneSendSolid, dataPaperPlaneSolid, dataPaste, dataPasteImageSolid, dataPasteSolid, dataPath, dataPathSolid, dataPause, dataPauseCircle, dataPauseCircleSolid, dataPenWrite, dataPenWriteSolid, dataPencil, dataPencilSolid, dataPhone, dataPhoneCall, dataPhoneCallSolid, dataPhoneEye, dataPhoneEyeSolid, dataPhoneSolid, dataPieChart, dataPieChartSolid, dataPinSlant, dataPinSolid, dataPlay, dataPlayCircle, dataPlayCircleSolid, dataPlus, dataPlusCircle, dataPlusCircleSolid, dataPlusSquare, dataPlusSquareSolid, dataPowerOff, dataPrinterSolid, dataPuzzlePiece, dataPuzzlePieceSolid, dataPvShield, dataPvShieldSolid, dataQACommentSolid, dataQrcode, dataQualityCircle, dataQualityCircleSolid, dataQuestionCircle, dataQuestionCircleSolid, dataQuestionComment, dataQuestionCommentSolid, dataRecommendSquare, dataRecommendSquareSolid, dataRecommendation, dataRedo, dataRedoSolid, dataReport, dataReportBookmark, dataReportBookmarkSolid, dataReportCheck, dataReportCheckSolid, dataReportSearch, dataReportSearchSolid, dataReportSettings, dataReportSettingsSolid, dataReportSolid, dataReportStamp, dataReportStampSolid, dataReportStar, dataReportStarSolid, dataReportTrendSettings, dataReportTrendSettingsSolid, dataReportUser, dataReportUserSolid, dataRoad, dataRocketSolid, dataRotateAnticlockwise, dataRotateAnticlockwiseSolid, dataRotateClockwise, dataRotateClockwiseSolid, dataSave, dataSaveSolid, dataScan, dataSearch, dataSearchDesktop, dataSearchDesktopSolid, dataSearchHistory, dataSearchHistorySolid, dataSearchSolid, dataSettings, dataSettingsSolid, dataShare, dataShareAlt, dataShareAltSolid, dataShieldCheck, dataShieldCheckSolid, dataShieldCnySolid, dataShieldEllipsisSolid, dataShieldTimesSolid, dataShieldUser, dataShieldUserSolid, dataShieldWave, dataShieldWaveSolid, dataShoppingBag, dataShoppingBagSolid, dataShoppingCart, dataShoppingCartSolid, dataShortVideo, dataShortVideoSolid, dataShrink, dataSignOut, dataSkipBackward, dataSkipForward, dataSlidersSquare, dataSlidersSquareSolid, dataSmiley, dataSmileyComment, dataSmileySolid, dataSmileyStar, dataSmileyStarSolid, dataSort, dataSortAlt, dataSortAsc, dataSortDesc, dataSoundWave, dataSparklesSolid, dataSplit, dataSquareRotation, dataSquareRotationSolid, dataStamp, dataStampSolid, dataStar, dataStarDash, dataStarDashSoild, dataStarDashSolid, dataStarHalf, dataStarSolid, dataStop, dataStopSolid, dataStrikethrough, dataSwitch, dataSync, dataSyncCircle, dataSyringe, dataSyringesSolid, dataTag, dataTagSolid, dataTeam, dataTeamSolid, dataTelephone, dataTelephoneSolid, dataTemplate, dataTemplateSolid, dataTextFlowerSquare, dataTextFlowerSquareSolid, dataTextSquare, dataTextSquareAltSolid, dataTextSquareSolid, dataThumbDown, dataThumbDownSolid, dataThumbUp, dataThumbUpSolid, dataTimes, dataTimesCircle, dataTimesCircleSolid, dataToolbox, dataToolboxSolid, dataToolsSolid, dataTrackCut, dataTrackFrameLast, dataTrash, dataTrashSolid, dataTravelEarthPlaneSolid, dataTreasureChest, dataTreasureChestSolid, dataTrendDesktop, dataTrendDesktopSolid, dataTrendMonitor, dataTrendMonitorSolid, dataTrendPages, dataTrendPagesSolid, dataTrendReport, dataTrendReportSolid, dataTrendStarSolid, dataTrimLeft, dataTrimRight, dataTrophy, dataTrophySolid, dataTruck, dataTruckSolid, dataTv, dataTvSolid, dataTwoHearts, dataTwoHeartsSolid, dataUnderline, dataUndo, dataUndoSolid, dataUnlink, dataUnlock, dataUnlockSolid, dataUpdateWave, dataUpgrade, dataUpgradeSolid, dataUpload, dataUploadDesktop, dataUploadDesktopSolid, dataUser, dataUserAuthorization, dataUserBookmark, dataUserBookmarkSolid, dataUserCard, dataUserCardSolid, dataUserCircle, dataUserCircleSolid, dataUserCombined, dataUserCombinedSolid, dataUserFilter, dataUserFilterSolid, dataUserIntersection, dataUserIntersectionSolid, dataUserLabel, dataUserLabelSolid, dataUserMobile, dataUserMobileSolid, dataUserSearch, dataUserSearchSolid, dataUserSettings, dataUserSettingsSolid, dataUserSolid, dataUserStar, dataUserSync, dataUserSyncSolid, dataUserTieba, dataVideo, dataVideoAdd, dataVideoCrop, dataVideoCropSolid, dataVideoFilm, dataVideoFilmSolid, dataVideoFrameFirst, dataVideoHistory, dataVideoHistorySolid, dataVideoSolid, dataVideoUpload, dataVolume, dataVolumeSolid, dataWhirlpool, dataWhirlpoolSolid, dataWoman, dataYaoSquare, dataYingxiaotong, dataYingxiaotongSolid, dataZoomIn, dataZoomInSolid, dataZoomOut, dataZoomOutSolid };
//# sourceMappingURL=index.js.map
